(function() {
    'use strict';

    var currentDate = new Date();

    angular.module('babycompy.constants', []);
    angular.module('babycompy.common', []);
    angular.module('babycompy.selectLocation', []);
    angular.module('babycompy.menu', []);
    angular.module('babycompy.ruler', []);
    angular.module('babycompy.pager', []);

    angular.module('babycompy.userProfile', ['babycompy.base', 'babycompy.medics.answers']);

    angular.module('babycompy.base', ['babycompy.constants', 'babycompy.common', 'ui.router']);

    angular.module('babycompy.categories.common', ['babycompy.base']);
    angular.module('babycompy.content.common', ['babycompy.base']);
    angular.module('babycompy.mainSlider', ['babycompy.base']);
    angular.module('babycompy.comments', ['babycompy.base']);

    // upgrowth
    angular.module('babycompy.content.upgrowth', ['babycompy.categories.common', 'babycompy.content.common']);
    angular.module('babycompy.content.upgrowth.article', ['babycompy.categories.common', 'babycompy.content.common']);

    angular.module('babycompy.doctorSearch', ['babycompy.selectLocation', 'babycompy.pager', 'ngSanitize', 'ui.select']);

    // main app module
    angular.module('babycompy', ['babycompy.constants', 'babycompy.common', 'babycompy.base',
        'babycompy.authentication', 'babycompy.selectLocation', 'babycompy.menu', 'babycompy.ruler', 'babycompy.userProfile',
        'babycompy.categories.common', 'babycompy.content.common', 'babycompy.loadMore',
        'babycompy.content.upgrowth', 'babycompy.content.upgrowth.article',
        'babycompy.content.algorithms',
        'babycompy.content.food',
        'babycompy.content.search',
        'babycompy.content.medicine',
        'babycompy.content.aboutUs',
        'babycompy.content.contentCategories',
        'babycompy.content.favorites',
        'babycompy.authentication.profile',
        'babycompy.authentication.doctorsProfile',
        'babycompy.content.news', 'babycompy.medics',
        'babycompy.pager', 'babycompy.clinics', 'babycompy.doctorSearch',
        'babycompy.seo',
        'babycompy.mainSlider',
        'vcRecaptcha',
        'babycompy.notFound',
        'babycompy.comments',
        'babycompy.mobileApps',
        'ngResource', 'ngSanitize','ui.tinymce', 'ui.router', 'mgcrea.ngStrap', 'pascalprecht.translate', 'ngFacebook', 'googleplus',
        'angularUtils.directives.uiBreadcrumbs', 'ui.timepicker', 'ngCookies'
    ])

    .run(['$rootScope', '$window', 'modalService', '$translate', '$state', 'authService', '$timeout', function($rootScope, $window, modalService, $translate, $state, authService, $timeout) {

            NProgress.configure({ trickleRate: 0.1, trickleSpeed: 200 });
            NProgress.configure({ easing: 'ease', speed: 500 });
            NProgress.configure({ showSpinner: false });

            $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
                NProgress.start();
                if (!authService.isLoggedIn() && !$rootScope.confirmedRedirect) {
                    if (fromState.name === 'index.algorithms.group.algorithm.step' && toState.name !== 'index.algorithms.group.algorithm.step') {
                        e.preventDefault();
                        modalService.open({
                            template: 'app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html',
                            controller: 'algorithmConfirmModalController as c',
                            show: true,
                            backdrop: 'static'
                        }).result.then(function() {
                            $rootScope.confirmedRedirect = true;
                            $state.go(toState.name, toParams);
                            $rootScope.confirmedRedirect = false;
                        }.bind(this));
                    }
                }
            });

            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                NProgress.done();
            });


            $rootScope.$on('$stateChangeError', function($event, state, params, from, fromParams, error) {
                NProgress.done();
                if (error.status == "404") {
                    $window.location.href = "/notFound";
                }
                if (error.data.metadata.errorCode === 403002) {
                    modalService.showErrorAlert({
                        title: $translate.instant('algorithms.error'),
                        message: $translate.instant('algorithms.unpublished')
                    });
                }

                if (error.data.metadata.errorCode === 403003) {
                    modalService.showErrorAlert({
                        title: $translate.instant('algorithms.error'),
                        message: $translate.instant('algorithms.structureChanged')
                    });
                }

                if (error.data.metadata.errorCode === 410000) {
                    modalService.showErrorAlert({
                        title: $translate.instant('algorithms.error'),
                        message: $translate.instant('algorithms.deleted')
                    });
                }

                console.error(error.message || error.data);
            });

            $rootScope.$on('$stateChangeSuccess', function() {
                $window.scrollTo(0, 0);
            });

            // add safeApply function to $scope
            $rootScope.constructor.prototype.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            $rootScope.$state = $state;
        }])
        .controller('appController', ['$rootScope', '$window', 'seoService',
            function($rootScope, $window, seoService) {

                function AppController() {
                    $rootScope.currentDate = currentDate;
                }

                AppController.prototype.title = function() {
                    return seoService.title();
                };

                AppController.prototype.description = function() {
                    return seoService.description();
                };

                AppController.prototype.keywords = function() {
                    return seoService.keywords();
                };

                AppController.prototype.ogTitle = function() {
                    return seoService.ogTitle();
                };

                AppController.prototype.ogDescription = function() {
                    return seoService.ogDescription();
                };

                AppController.prototype.ogImage = function() {
                    return seoService.ogImage();
                };

                AppController.prototype.ogFbAppId = function() {
                    return seoService.ogFbAppId();
                }

                return new AppController();
            }
        ]);
})();

function FFInlineSVGFix() {
    "use strict";
    /**
     * Current URL, without the hash
     */
    var baseUrl = window.location.href
        .replace(window.location.hash, "");

    /**
     *  Find all `use` elements with a namespaced `href` attribute, e.g.
     *  <use xlink:href="#some-id"></use>
     *
     *  See: http://stackoverflow.com/a/23047888/796152
     */
    [].slice.call(document.querySelectorAll("use[*|href]"))
        /**
         * Filter out all elements whose namespaced `href` attribute doesn't
         * start with `#` (i.e. all non-relative IRI's)
         *
         * Note: we're assuming the `xlink` prefix for the XLink namespace!
         */
        .filter(function(element) {
            return (element.getAttribute("xlink:href").indexOf("#") === 0);
        })
        /**
         * Prepend `window.location` to the namespaced `href` attribute value,
         * in order to make it an absolute IRI
         *
         * Note: we're assuming the `xlink` prefix for the XLink namespace!
         */
        .forEach(function(element) {
            element.setAttribute("xlink:href", baseUrl + element.getAttribute("xlink:href"));
        });

  // This is polyfill for object-fit [IE]
  if ('objectFit' in document.documentElement.style === false) {
    Array.prototype.forEach.call(document.querySelectorAll('img[data-object-fit]'), function (image) {
      image.style.background = 'url("' + image.getAttribute('data-ng-src') + '") no-repeat 50% / cover';
      image.src = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'' + image.width + '\' height=\'' + image.height + '\'%3E%3C/svg%3E';
    });
  }

}
//https://bugzilla.mozilla.org/show_bug.cgi?id=1121708
//https://bugs.webkit.org/show_bug.cgi?id=140488
(function(document, window) {
    //if (navigator.userAgent.indexOf("Firefox") > 0) {
    document.documentElement.addEventListener('DOMNodeInserted', FFTimeouter, false);
    //}
    var timeoutId = null;

    function FFTimeouter() {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(FFInlineSVGFix, 100);
    }
})(document, window);

(function() {
    angular.module('babycompy.content.common')
        .service('algorithmHistoryEmailResource', ['baseApiService', function(baseApiService) {
            var algorithmHistoryEmailResource = baseApiService.extend({

                sendRecommendationsByEmail: function(body) {
                    var params = {
                        controller: 'algorithmSaves',
                        action: 'email'
                    };
                    return this.resource.post(params, body).$promise;
                }
            })

            return new algorithmHistoryEmailResource('algorithmHistoryEmailResource');
        }])
})();

(function() {
    angular.module('babycompy.content.common')
        .controller('algorithmEmailController', ['$scope', '$state', '$stateParams', 'authService', 'currentUserService', 'algorithmHistoryEmailResource', 'localStorageService', 'app', 'algorithmService',
            function($scope, $state, $stateParams, authService, currentUserService, algorithmHistoryEmailResource, localStorageService, appConstants, algorithmService) {

                var algorithmEmailController = Class.extend({

                    init: function() {
                        this.wrongEmailFormat = false;
                        this.emailSent = false;
                        this.email = (!!authService.isLoggedIn()) ? currentUserService.get().email : '';
                        algorithmService.getById($stateParams.algorithmUuid).then(function(response) {
                            this.userAlgorithm = response.content.userAlgorithm;
                        }.bind(this));
                    },

                    sendUserEmail: function() {
                        if (!this.email) {
                            return;
                        }

                        var requestBody = {};
                        requestBody.step = $state.params.stepUuid;
                        requestBody.time = moment().toISOString().replace('Z', '');
                        requestBody.email = this.email;

                        if (!!authService.isLoggedIn()) {
                            requestBody.userAlgorithm = this.userAlgorithm;
                        } else {
                            requestBody.recommendations = [];
                            var recommendationsStorage = localStorageService.get(appConstants.algorithmLocalStorageKey).recommendations;
                            recommendationsStorage.forEach(function(recommendation) {
                                requestBody.recommendations.push(recommendation.uuid);
                            });
                        }
                        algorithmHistoryEmailResource.sendRecommendationsByEmail(requestBody).then(function(response) {
                            this.email_sent = true;
                        }.bind(this), function(response) {
                            if (response.data.metadata.errorCode === 400400) {
                                this.wrongEmailFormat = true;
                            }
                        }.bind(this));
                    }
                });

                return new algorithmEmailController();
            }
        ])
})();

(function () {
    'use strict';
    angular.module('babycompy.content.algorithms', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function() {
    angular.module('babycompy.content.algorithms')
        .controller('algorithmConfirmModalController', ['$modalService',
         function($modalService) {
            var algorithmConfirmModalController = Class.extend({
                ok: function () {
                    $modalService.close();
                },
                
                close: function () {
                    $modalService.dismiss();
                }
            });
            
            return new algorithmConfirmModalController();
        }])
})();

(function () {
    'use strict';

    angular.module('babycompy.content.food.productsCategories.products', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.food.productsCategories.products.article'
    ]);
})();
(function (angular) {
    angular.module('babycompy.content.food.productsCategories.products')
        .directive('productsList', ['$state', 'contentCategoriesService', function ($state, contentCategoriesService) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    categories: '=',
                    pagingParameters: '=?',
                    loadMore: '=',
                    hideImage: '=?',
                    nestedStateName: '@',
                    paramName: '@',
                    pagingTotal: '=?',
                    usePaging: '=?',
                    listClass: '@',
                    selectedCategory: '=?'
                },
                templateUrl: 'app/components/content/food/productsCategories/productsCategories.template.html',

                link: function (scope, el, attrs) {

                    scope.$watch('categories', function (categories) {
                        if (!categories) {
                            return;
                        }

                        scope.readyCategories = scope.categories.map(function (category, index) {
                            if (category.childCount == 0) {
                                category.href = 'index.contentCategories.contentSubcategories.food.productsCategories.products.article({articleUUID: \'' +
                                    category.uuid + '\'})';
                            } else {
                                category.href = 'index.contentCategories.contentSubcategories.food.productsCategories.products({productCategoryUUID: \'' + category.uuid + '\'})';
                            }

                            return category;
                        });

                    });
                    scope.emitTransitionEvent = function (category) {
                        // var tansferObject = {
                        //     title: scope.selectedCategory,
                        //     selectedCategory: category,
                        //     allCategories : scope.categories
                        // }
                        // scope.$emit('productCategorySelected', tansferObject);
                    }
                }
            }
        }]);
})(angular);
(function() {
    angular.module('babycompy.content.food.productsCategories.products')
        .controller('productsDetailsController', ['baseCategoriesController', '$scope', 'allProductsCategories',
            'selectedCategory', 'customPaging', 'seoService', '$state',
            function(baseCategoriesController, $scope, allProductsCategories, selectedCategory, customPaging, seoService, $state) {
                // dependencies will be resolved during page load in the route definition

                var ProductsDetailsController = baseCategoriesController.extend({
                    init: function() {
                        if (!!!selectedCategory) {
                            $state.go('index.notFound');
                            return;
                        }

                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.allCategories = allProductsCategories.items;
                        this.titleName = selectedCategory.name;
                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.allCategories);
                        $scope.$emit('productCategorySelected', allProductsCategories);
                        $scope.$emit('switchSupplement', false);
                        seoService.title(this.titleName);
                    }
                });

                return new ProductsDetailsController($scope, allProductsCategories.items);
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('babycompy.content.food.productsCategories.products.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function () {
    angular.module('babycompy.content.food.productsCategories.products.article')
        .controller('articleControllerFood', ['baseContentController', '$scope', '$state', 'content', 'allProductsCategories', 'enums',
            'customPaging', 'selectedCategory', 'seoService',
            function (baseContentController, $scope, $state, content, allProductsCategories, enums, customPaging, selectedCategory, seoService) {
                // dependencies will be resolved during page load in the route definition

                var ArticleControllerFood = baseContentController.extend({
                    init: function () {
                        if(!!!selectedCategory) {
                            $state.go('index.notFound');
                            return;     
                        }
                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.content = content;
                        this.allCategories = allProductsCategories.items;
                        this.favoriteType = enums.selectFavoriteTypes.products;
                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.allCategories, content);
                        this.categoryName = selectedCategory.name;
                        seoService.title(selectedCategory.name, this.content.name);
                        seoService.description(this.content.name);
                    }
                });

                return new ArticleControllerFood($scope, content);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.food.productsCategories.products.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.productsCategories.products.article', {
            url: '/:articleUUID',
            views: {
                'content@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/products/articles/articleContent.html',
                    controller: 'articleControllerFood',
                    controllerAs: 'c'
                },
                'categories@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/products/articles/articleCategories.html',
                    controller: 'articleControllerFood',
                    controllerAs: 'c'
                }
            },

            resolve: {
                content: ['productsCategoriesResource', '$stateParams', function (productsCategoriesResource, $stateParams) {
                    return productsCategoriesResource.getProductArticle($stateParams.articleUUID).then(function (response) {
                        return response.content;
                    })
                }],

                //productsCategories: ['$stateParams', 'productsCategoriesResource',
                //    function ($stateParams, productsCategoriesResource) {
                //        return productsCategoriesResource.loadSubCategories($stateParams.articleUUID).then(function (response) {
                //            return response.content.items;
                //        });
                //    }]

            }
        });
    }
})();
(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories.trimesters.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function () {
    angular.module('babycompy.content.contentCategories.trimesters.article')
        .controller('timestersArticleController', ['baseContentCategoriesController', '$scope',
            'articleContent', 'parentCategories', '$state', '$filter', 'enums',
            function (baseContentCategoriesController, $scope, articleContent, parentCategories, $state, $filter, enums) {
                var TimestarsArticleController = baseContentCategoriesController.extend({

                    init: function () {
                        this._super.apply(this, arguments);
                        this.parentCategories = parentCategories;
                        this.notes = articleContent.notes;
                        this.favoriteType = enums.selectFavoriteTypes.diseases;
                        seoService.title(articleContent.parent.name, articleContent.name, articleContent.metaTags);
                        seoService.description(articleContent.name, articleContent.metaTags);
                        seoService.keywords(articleContent.metaTags);
                    }

                })

                return new TimestarsArticleController($scope, articleContent);

            }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.contentCategories.trimesters.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.calendar.trimesters.article', {
            url: '/:timesterArticleUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/contentCategories/pregnancyCalendar/trimesters/article/article.html',
                    controller: 'articleController',
                    controllerAs: 'c'
                },
                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller: 'trimestersArticleBreadcrumbController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                articleContent: ['contentCategoriesResource', '$stateParams', function (contentCategoriesResource, $stateParams) {
                    return contentCategoriesResource.loadSubCategories($stateParams.timesterArticleUUID, {pregnancyAges: $stateParams.weekNumber}).then(function (response) {
                        return response.content;
                    });
                }],

                parentCategories: ['articleContent', 'contentCategoriesResource', function (articleContent, contentCategoriesResource) {
                    if(!!articleContent.parent) {
                        var parentUuid = articleContent.parent.uuid;
                        return contentCategoriesResource.loadSubCategories(parentUuid).then(function (response) {
                            return response.content.childs;
                        });
                    } else {
                        return [];
                    }

                }],

                contentCategoriesService: ['contentCategoriesService', function (contentCategoriesService) {
                    return contentCategoriesService.load().then(function () {
                        return contentCategoriesService;
                    })
                }],

                week: ['$stateParams', 'pregancyAgesService', function ($stateParams, pregancyAgesService) {
                    return pregancyAgesService.load().then(function () {
                        return {
                            weekNumber: $stateParams.weekNumber,
                            number: pregancyAgesService.getWeekNumberByUuid($stateParams.weekNumber)
                        }
                    });

                }],

                pregancyCalendarUuid: ['$stateParams', function ($stateParams) {
                    return $stateParams.categoryUUID;
                }]
            }
        });
    }
})();
(function () {
    angular.module('babycompy.content.contentCategories.trimesters.article')
        .controller('trimestersArticleBreadcrumbController', ['baseController', '$scope',
            'articleContent', '$state', '$filter', 'contentCategoriesService', 'week', 'pregancyCalendarUuid',
            function (baseController, $scope, articleContent, $state, $filter, contentCategoriesService,
                      week, pregancyCalendarUuid) {
                var parentsArray = [],
                    state = '';

                var parentsChain = function (entity) {
                    if (!!entity.parent) {
                        if(entity.parent.uuid == pregancyCalendarUuid
                            || entity.parent.parent.uuid == pregancyCalendarUuid){
                            return parentsArray;
                        }

                        parentsArray.push({
                            name: entity.parent.name,
                            href: $state.href('index.contentCategories.contentSubcategories.calendar.trimesters.article'
                                , { timesterArticleUUID: entity.parent.uuid })
                        });
                        parentsChain(entity.parent);
                    }

                    return parentsArray;
                };

                var TrimestersBreadcrumbArticleController = baseController.extend({

                    init: function () {
                        this.arrayOfParents = [
                            {
                                name: $filter('translate')('main.main'),
                                href: '/'
                            },
                            {
                                name: $filter('translate')('menu.pregnancy'),
                                href: contentCategoriesService.getPregnancyLink().url
                            },
                            {
                                name: $filter('translate')('index.pregnancyCalendar'),
                                href: contentCategoriesService.getCalendarLink().url
                            },
                            {
                                name: String.format('{0} - {1}',
                                    week.number,
                                    $filter('translate')("pregnancy.weekSuffixFull", {weekNumber: week.number})),
                                href:  $state.href('index.contentCategories.contentSubcategories.calendar.trimesters', {weekNumber :week.weekNumber})
                            }
                        ];

                        this.arrayOfParents = this.arrayOfParents.concat(parentsChain(articleContent.parent || []).reverse());

                    }

                })

                return new TrimestersBreadcrumbArticleController($scope, articleContent);

            }]);
})();
angular.module('babycompy.content.common')
    .directive('substepList', ['$translate', '$q', '$compile', '$state', 'app',
        function($translate, $q, $compile, $state, appConstants) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    substeps: '=?',
                    api: '='
                },

                templateUrl: 'app/components/content/algorithms/algorithm/content/substeps/substepList.template.html',

                link: function(scope, el, attrs) {

                    scope.alphabetValue = function(index) {
                        var alphabet = $translate.instant('alphabet');
                        if (index >= alphabet.length) {
                            return alphabet[index % alphabet.length] + parseInt(index / alphabet.length);
                        } else {
                            return alphabet[index];
                        }
                    }
                }
            };

        }
    ]);

angular.module('babycompy.content.common')
    .directive('selectedRecommendation',['stepService',function(stepService) {

        return {
            restrict: 'E',
            replace: true,
            transclude: true,

            scope: {
                recommendation: '='
            },

            templateUrl: 'app/components/content/algorithms/algorithm/content/recommendationHistory/step.selectedRecommendation.template.html',

            link: function(scope, el, attrs) {
                scope.collapseRecommendation = function(recommendation) {
                    recommendation.collapsed = !recommendation.collapsed;
                    if (!recommendation.description) {
                        stepService.getRecommendation(recommendation.uuid).then(function(response) {
                            recommendation.description = response.content.description;
                        });
                    }
                };
            }
        };

    }]);
angular.module('babycompy.content.common')
    .directive('recommendationHistory', ['$state', '$modal', '$window', '$timeout', 'modalService', 'authService', 'algorithmService',
        function($state, $modal, $window, $timeout, modalService, authService, algorithmService) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    selectedRecommendations: '=?',
                    userAlgorithm: '=?',
                    step: '='
                },

                templateUrl: 'app/components/content/algorithms/algorithm/content/recommendationHistory/step.recommendationHistory.template.html',

                link: function(scope, el, attrs) {
                    scope.recommendationHistoryCollapse = false;
                    scope.wrongEmailFormat = false;
                    scope.emailSent = false;
                    var recommendationUuids = [];
                    scope.selectedRecommendations.forEach(function(recommendation) {
                        recommendationUuids.push(recommendation.uuid);
                    });
                    algorithmService.getRecommendationByUuids(recommendationUuids).then(function(response) {
                        scope.selectedecommendations = response.content.items;
                    });

                    scope.collapseRecommendationHistory = function() {
                        scope.recommendationHistoryCollapse = !scope.recommendationHistoryCollapse;
                    };

                    scope.openEmailModal = function() {
                        var algorithmEmailModal = $modal({
                            templateUrl: 'app/components/content/algorithms/algorithm/content/recommendationHistory/emailModal/step.recommendationHistoryEmail.modal.html',
                            controller: 'algorithmEmailController as c',
                            show: true
                        });
                    };

                    scope.closeModal = function() {
                        modalService.dismiss();
                    };

                    scope.printRecommendations = function() {
                        var printHtmlElement = '<body style="font-family: Roboto,sans-serif; font-size:12px; line-height: 20px;"><main class="main" style="padding:50px"><header class="header"><img src="http://babycompy.com/assets/images/emails/logo.png" style="max-width:193px" alt="BabyCompyLogo"></header><section>' +
                            '<div class="textBlock"><h1 style="font-size: 22px; color: #f7837c;">' + scope.step.name + '</h1><p>' + scope.step.description + '</p></div><hr style="width: 100%; height: 1px; background-color: #f4f4f4; margin: 20px 0; border: none;">';

                        scope.selectedecommendations.forEach(function(recommendation) {
                            printHtmlElement = printHtmlElement.concat('<div class="textBlock"><h4 style="color: #f7837c;">' + recommendation.name + '</h4>' + recommendation.description + '</div><hr style="width: 100%; height: 1px; background-color: #f4f4f4; margin: 20px 0; border: none;">');
                        });
                        printHtmlElement = printHtmlElement.concat('</section> <footer class="footer"> <div style="display: inline-block;"> <div class="title" style="padding-bottom: 5px;"> <img style="float: left; margin-right: 5px; margin-top: 2px;" src="http://dev.babycompy.com/assets/images/emails/home-office-ico.png" alt="icon"> Главный офис </div> Softarex Technologies, Inc. <br> 901 N. Pitt Street, Suite 170 <br> Alexandria, VA 22314 <br> Phone: +1 (703) 836 18 60 </div> <div style="display: inline-block; margin: 0 60px; vertical-align: top;"> <div class="title" style="padding-bottom: 5px;"> <img style="float: left; margin-right: 5px; margin-top: 2px;" src="http://dev.babycompy.com/assets/images/emails/questions-ico.png" alt="icon"> Общие вопросы </div> info@babycompy.com </div> <div style="display: inline-block; vertical-align: top"> <div class="title" style="padding-bottom: 5px;"> <img style="float: left; margin-right: 5px; margin-top: 2px;" src="http://dev.babycompy.com/assets/images/emails/support-ico.png" alt="icon"> Техническая поддержка </div> support@babycompy.com </div> <h4 style="color: #f7837c;">Наши сервисы на Вашем смартфоне!</h4> <a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;" target="_blank" href="https://play.google.com/store/apps/details?id=com.babycompy"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Application in Google Play" src="http://dev.babycompy.com/assets/images/emails/app-android.png"></a>&nbsp;&nbsp;<a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;" target="_blank" href="https://itunes.apple.com/us/app/mobile-security-cloud-mdm/id1113948225?mt=8"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Application in App Store" src="http://dev.babycompy.com/assets/images/emails/app-ios.png"></a> <h4 style="color: #f7837c;">BabyCompy в соцсетях </h4> <a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;color: #606060;font-weight: normal;text-decoration: underline;" target="_blank" href="https://vk.com/public113173950"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Follow on Vkontacte" src="http://dev.babycompy.com/assets/images/emails/social-link-vk.png"></a>&nbsp;&nbsp;&nbsp;<a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;color: #606060;font-weight: normal;text-decoration: underline;" target="_blank" href="http://www.facebook.com/BabyCompy"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Follow on Facebook" src="http://dev.babycompy.com/assets/images/emails/social-link-fb.png"></a>&nbsp;&nbsp;&nbsp;<a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;color: #606060;font-weight: normal;text-decoration: underline;" target="_blank" href="https://plus.google.com/b/113101394623533388254/"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Forward to Google Plus" src="http://dev.babycompy.com/assets/images/emails/social-link-gg.png"></a>&nbsp;&nbsp;&nbsp;<a style="-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;color: #606060;font-weight: normal;text-decoration: underline;" target="_blank" href="http://ok.ru/group/52828947153103"><img style="-ms-interpolation-mode: bicubic;border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" alt="Friend on Odnoklassniki" src="http://dev.babycompy.com/assets/images/emails/social-link-ya.png"></a>&nbsp; </footer> </main> </body>');

                        var printWindow = window.open('', 'PrintRecommendationsWindow', 'height=800,width=800,scrollbars');
                        printWindow.document.write('<script language="JavaScript" type="text/JavaScript">window.onload = function() { window.print(); }</script>')
                        printWindow.document.write(printHtmlElement);
                        printWindow.document.close();
                    }
                }
            };
        }
    ]);

angular.module('babycompy.content.common')
    .directive('stepRecommendation', ['stepService', function(stepService) {

        return {
            restrict: 'E',
            replace: true,
            transclude: true,

            scope: {
                recommendations: '=?',
                selectedRecommendations: '=?'
            },

            templateUrl: 'app/components/content/algorithms/algorithm/content/recommendation/step.recommendation.template.html',

            link: function(scope, el, attrs) {

                scope.$watch('selectedRecommendations', function(selectedRecommendations) {
                    if (!selectedRecommendations) {
                        return;
                    }

                    scope.requiredRecommendations = [];
                    scope.unneccessaryRecommendations = [];

                    if (scope.recommendations) {
                        scope.recommendations.forEach(function(item, i, arr) {
                            if (item.required) {
                                scope.requiredRecommendations.push(item);
                            } else {
                                if (scope.selectedRecommendations.length > 0) {
                                    item.checked = _isChecked(scope.selectedRecommendations, item);
                                }
                                scope.unneccessaryRecommendations.push(item);
                            }
                        });
                    }

                    scope.collapseRecommendation = function(recommendation) {
                        recommendation.collapsed = !recommendation.collapsed;
                        if (!recommendation.description) {
                            stepService.getRecommendation(recommendation.uuid).then(function(response) {
                                recommendation.description = response.content.description;
                            });
                        }
                    };
                });

                var _isChecked = function(chosenRecommendations, recommendation) {
                    var result = false;
                    chosenRecommendations.forEach(function(item, i, arr) {
                        if (recommendation.uuid === item.uuid) {
                            result = true;
                        }
                    });
                    return result;
                };

            }
        }
    }]);

angular.module('babycompy.content.common')
    .directive('stepArticle', ['$translate', '$q', '$compile', 'stepService',
        function($translate, $q, $compile, stepService) {
            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    articles: '=?'
                },

                templateUrl: 'app/components/content/algorithms/algorithm/content/article/step.article.template.html',

                link: function(scope, attrs) {
                    scope.collapseArticle = function(article) {
                        article.collapsed = !article.collapsed;
                        if (!article.description) {
                            stepService.getArticle(article.uuid).then(function(response) {
                                article.description = response.content.description;
                            });
                        }
                    };
                }
            };

        }
    ]);

(function () {
    'use strict';

    angular.module('babycompy.authentication.profile.edit', []);
    angular.module('babycompy.authentication.profile.children', ['ngCropper', 'flow', 'babycompy.base']);
    angular.module('babycompy.authentication.profile.resetPassword', []);
    angular.module('babycompy.authentication.profile.subscriptions', []);

    angular.module('babycompy.authentication.profile', [
        'babycompy.authentication.profile.edit',
        'babycompy.authentication.profile.children',
        'babycompy.authentication.profile.resetPassword',
        'babycompy.authentication.profile.subscriptions'
    ]);
})();

(function () {
    angular.module('babycompy.authentication.profile')
        .controller('profileAvatarModalController', ['$scope', 'baseController',
             '$q', '$timeout', '$modalService', 'cropperService', 'currentUserService',
            'updateProfileService', 'file',
            function ($scope, baseController, $q, $timeout,
                      $modalService, cropperService, currentUserService,
                      updateProfileService, file) {

                var ProfileAvatarModalController = baseController.extend({
                    init: function ($scope, resource) {
                        this._super($scope, resource);
                        this.avatarService = new cropperService({
                            autoCropArea: 0.7
                        });

                        this.showCropper();
                    },

                    save: function () {
                        this.avatarService.cropImage()
                            .then(function () {
                                return updateProfileService.updateImage(
                                    this.avatarService.croppedImage,
                                    this.avatarService.file.name)
                                }.bind(this))
                            .then(function (response) {
                                $modalService.close(response.content);
                            });
                    },

                    showCropper: function () {
                        this.avatarService.setImage(file).then(function () {
                            $timeout(function () {
                                $scope.$broadcast('show');
                            });
                        }.bind(this));
                    },


                    close: function () {
                        this.avatarService.file = null;
                        $scope.$broadcast('hide');
                        $modalService.dismiss();
                    }

                });

                return new ProfileAvatarModalController($scope, updateProfileService);
            }]);
})();
(function () {
    angular.module('babycompy.content.upgrowth.article')
        .controller('upgrowthArticleController', ['baseContentCategoriesController', '$scope',
            'articleContent', 'parentCategories', '$state', '$filter', 'aticleAgeParent', 'customPaging', 'enums', 'seoService',
            function (baseContentCategoriesController, $scope,
                      articleContent, parentCategories, $state, $filter, aticleAgeParent, customPaging, enums, seoService) {

                var UpgrowthArticleController = baseContentCategoriesController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.parentCategories = parentCategories;
                        this.favoriteType = enums.selectFavoriteTypes.articles;
                        this.customPaging = new customPaging();
                        this.notes = this.returnedContent.notes;
                        var current =  this.parentCategories.filter(function(item) {
                            return item.uuid === articleContent.uuid})[0];

                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset,
                            this.parentCategories, current);
                            
                        seoService.title(this.returnedContent.parent.name, articleContent.name, articleContent.metaTags);
                        seoService.description(articleContent.name, articleContent.metaTags);
                        seoService.keywords(articleContent.metaTags);
                    },

                    extractVisibleParent: function() {
                        return this.customPaging.extractVisibleSupplements();
                    }

                });

                return new UpgrowthArticleController($scope, articleContent);

            }]);
})();

(function () {
    angular.module('babycompy.content.upgrowth.article')
        .controller('upgrowthArticleBreadcrumbController', ['baseContentCategoriesController', '$scope',
            'categoryArticleContent', 'parentCategories', '$state', '$filter', 'aticleAgeParent',
            function (baseContentCategoriesController, $scope,
                categoryArticleContent, parentCategories, $state, $filter, aticleAgeParent) {

                var parentsArray = [];
                var parentsChain = function (entity) {


                    if (entity.uuid !== categoryArticleContent.uuid) {
                        parentsArray.push({
                            name: entity.name,
                            href: $state.href('index.upgrowth.categories.article',
                                { articleUUID: entity.uuid })
                        });

                        parentsChain(entity.parent);
                    } else {
                        parentsArray.push({
                            name: entity.name,
                            href: $state.href('index.upgrowth.categories',
                                { categoryUUID: entity.uuid })
                        });
                    }

                    return parentsArray;
                };

                var UpgrowthArticleBreadcrumb = baseContentCategoriesController.extend({

                    init: function () {
                        this._super.apply(this, arguments);
                        this.arrayOfParents = [{
                            name: $filter('translate')('main.main'),
                            href: '/'
                        }];

                        this.arrayOfParents.push({
                            name: aticleAgeParent.title,
                            href: $state.href('index.upgrowth', {
                                age: aticleAgeParent.childAges[0],
                                childAges: aticleAgeParent.childAges.length > 1
                                    ? aticleAgeParent.childAges : null
                            })
                        }
                        );

                        this.arrayOfParents = this.arrayOfParents
                            .concat(parentsChain(categoryArticleContent).reverse());
                    }
                });

                return new UpgrowthArticleBreadcrumb($scope, categoryArticleContent);

            }]);
})();

(function () {
    'use strict';

    angular.module('babycompy.content.upgrowth.categories.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.upgrowth.categories.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.upgrowth.categories.article', {
            url: '/:articleUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/upgrowth/categories/article/article.html',
                    controller: 'upgrowthArticleController',
                    controllerAs: 'c'
                },

                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller: 'upgrowthArticleBreadcrumbController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                articleContent: ['contentCategoriesResource', '$stateParams', function (contentCategoriesResource, $stateParams) {
                    var childAges = $stateParams.childAges || [$stateParams.age];
                    return contentCategoriesResource.loadSubCategories($stateParams.articleUUID,  {childAges: childAges}).then(function (response) {

                        //TODO: ArtemP: remove after childExists support in API
                        response.content.childs.forEach(function(item){
                            item.childExists = item.hasChilds;
                        });

                        return response.content;
                    });
                }],
                parentCategories: ['articleContent', 'contentCategoriesResource', function (articleContent, contentCategoriesResource) {
                    var parentUuid = articleContent.parent.uuid;
                    return contentCategoriesResource.loadSubCategories(parentUuid).then(function (response) {

                        //TODO: ArtemP: remove after childExists support in API
                        response.content.childs.forEach(function(item){
                            item.childExists = item.hasChilds;
                        });

                        return response.content.childs;
                    });

                }]
            },

            breadcrumb: ""
        });
    }
})();

(function () {
    'use strict';

   angular.module('babycompy.content.medicine.medicineCategories.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function () {
    angular.module('babycompy.content.medicine.medicineCategories.article')
        .controller('medicineCategoriesArticleController', ['baseContentController', '$scope',
            'content', 'medicines', 'customPaging', 'enums', 'pregancyAges', 'childAges', '$translate', 'similar', 'seoService', 'selectedCategory',
        function (baseContentController, $scope, content, medicines, customPaging, enums,
                  pregancyAges, childAges, $translate, similar, seoService, selectedCategory) {
            // dependencies will be resolved during page load in the route definition

            var MedicineCategoriesArticleController = baseContentController.extend({
                init: function() {
                    var offset = 0,
                        limit = 10;

                    this.categories = medicines;
                    this.customPaging = new customPaging();
                    this.pagingParameters = this.customPaging.getPagingParameters(limit, offset,
                        this.categories, content);
                    this._super.apply(this, arguments);

                    this.pregancyAges = pregancyAges;
                    this.similar = similar;
                    this.favoriteType = enums.selectFavoriteTypes.medicine;
                    seoService.title(selectedCategory.parent.name, content.name);
                    seoService.description(content.name);
                },

                extractVisibleSupplements: function() {
                    return this.customPaging.extractVisibleSupplements();
                },

                compatibilityAlertType: function(){
                    return this.content.compatibility ?
                        enums.alertType.success :
                        enums.alertType.warning;
                },


                hasPregancyAgeLimitation: function(){
                    return pregancyAges.lowLimit
                        || pregancyAges.topLimit ?
                        enums.alertType.warning :
                        enums.alertType.success;
                },

                hasChildAgeLimitation: function(){
                    return childAges.lowLimit
                    || childAges.topLimit ?
                        enums.alertType.warning :
                        enums.alertType.success;
                },

                getPregancyAgeText: function(){
                    if(!pregancyAges.lowLimit && !pregancyAges.topLimit){
                        return 'medicine.pregancy.noLimitations';
                    }

                    if(pregancyAges.lowLimit && !pregancyAges.topLimit){
                        return 'medicine.pregancy.lowLimit';
                    }

                    if(!pregancyAges.lowLimit && pregancyAges.topLimit){
                        return 'medicine.pregancy.topLimit';
                    }

                    return 'medicine.pregancy.rangeLimit';
                },


                getChildAgeText: function(){
                    var lowLimit, topLimit;

                    if(!childAges.lowLimit && !childAges.topLimit){
                        return $translate.instant('medicine.age.noLimitations');
                    }

                    if(childAges.lowLimit && !childAges.topLimit){
                        lowLimit = this._getAgeTitle(childAges.lowLimit);

                        return  $translate.instant('medicine.age.lowLimit', {lowLimit: lowLimit});
                    }

                    if(!childAges.lowLimit && childAges.topLimit){
                        topLimit = this._getAgeTitle(childAges.topLimit);

                        return $translate.instant('medicine.age.topLimit', {topLimit: topLimit});
                    }

                    lowLimit = this._getAgeTitle(childAges.lowLimit);
                    topLimit = this._getAgeTitle(childAges.topLimit);

                    return  $translate.instant('medicine.age.rangeLimit', {
                        lowLimit: lowLimit,
                        topLimit: topLimit
                    });
                },

                _getAgeTitle: function (childAge) {
                    switch (childAge.ageType) {
                        case enums.ageType.newBorn:
                            return $translate.instant('medicine.age.newBorn');
                        case enums.ageType.months:
                            return $translate.instant('medicine.age.monthCount', {month: childAge.age});
                        case enums.ageType.years:
                            return $translate.instant('medicine.age.yearsCount', {years: childAge.age});
                    }
                }

            });

            return new MedicineCategoriesArticleController($scope, content);
        }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.medicine.medicineCategories.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medicine.medicineCategories.article', {
            url: '/:articleUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/medicine/medicineCategories/article/article.html',
                    controller: 'medicineCategoriesArticleController',
                    controllerAs: 'c'
                },

                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller: 'medicineCategoriesBreadcrumbController',
                    controllerAs: 'c'
                }
            },

            resolve: {
                content: ['$stateParams', 'medicineResource', function ($stateParams, medicineResource) {
                    return medicineResource.loadArticle($stateParams.articleUUID).then(function (response) {
                        return response.content;
                    });
                }],

                pregancyAges : ['pregancyAgesService', 'content', function(pregancyAgesService, content){
                    return pregancyAgesService.load().then(function(){
                        return {
                            lowLimit: content.pregnancyAgeStartUuid ?
                                pregancyAgesService.getWeekNumberByUuid(content.pregnancyAgeStartUuid) : null,

                            topLimit: content.pregnancyAgeEndUuid ?
                                pregancyAgesService.getWeekNumberByUuid(content.pregnancyAgeEndUuid) : null
                        }
                    })

                }],

                childAges: ['upgrowthService', 'profileChildAgesService', 'content', function(upgrowthService, profileChildAgesService, content){
                    return profileChildAgesService.load().then(function(){
                        return {
                            lowLimit:content.childAgeStartUuid ? upgrowthService.getAgeType([content.childAgeStartUuid]) : null,
                            topLimit: content.childAgeEndUuid ? upgrowthService.getAgeType([content.childAgeEndUuid]) : null
                        }
                    });
                }],

                selectedCategory: ['subCategories', '$stateParams', 'parentCategories', 'content',
                    function (subCategories, $stateParams, parentCategories, content) {
                    var selected = parentCategories.filter(function (c) {
                        return c.uuid === $stateParams.categoryUUID
                    })[0];

                    subCategories.name = selected.name;
                    subCategories.uuid = selected.uuid;

                    return {name: content.name, uuid: content.uuid, parent: subCategories};
                }],

                similar: [ 'medicineResource', '$stateParams', function(medicineResource, $stateParams){
                    return medicineResource.similar($stateParams.articleUUID).then(function (response) {
                        return response.content.items;
                    });
                }],

                translate: ['$translate', function($translate) {
                    return $translate.onReady()
                }]

            }
        });
    }
})();
(function () {
    'use strict';

    angular.module('babycompy.content.food.supplements', [
        'babycompy.loadMore',
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function () {
    angular.module('babycompy.content.food.supplements')
        .controller('supplementsCategoriesDetailsController', ['baseContentController', '$scope', 'details', 'allCategories',
            'customPaging', 'seoService', '$translate',
            function (baseContentController, $scope, details, allCategories, customPaging, seoService, $translate) {
                // dependencies will be resolved during page load in the route definition

                var SupplementsCategoriesDetailsController = baseContentController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.allCategories = allCategories;
                        this.scope.$emit('supplementCategorySelected', details.name);


                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.allCategories);
                        $translate('food.supplement').then(function (translations) {
                            seoService.title(translations, this.content.name);
                            seoService.description(this.content.name);
                        }.bind(this));
                        $scope.$emit('switchSupplement', true);
                    }
                });

                return new SupplementsCategoriesDetailsController($scope, details);
            }]);
})();

(function () {
    angular.module('babycompy.content.food.productsCategories.products')
        .controller('productsController', ['baseCategoriesController', '$scope', '$state', 'productsCategories', 'selectedCategory', 'seoService', '$translate', 
            function (baseCategoriesController, $scope, $state, productsCategories, selectedCategory, seoService, $translate) {
                // dependencies will be resolved during page load in the route definition

                var ProductsController = baseCategoriesController.extend({
                    init: function () {
                        if(!!!selectedCategory) {
                            $state.go('index.notFound');
                            return;     
                        }
                        this._super.apply(this, arguments);
                        this.toggleSupplement = false;
                        $translate('food.name').then(function (translations) {
                            seoService.title(translations, selectedCategory.name);
                            seoService.description(selectedCategory.name);
                        }.bind(this));
                        $scope.$emit('switchSupplement', false);
                    },
                });

                return new ProductsController($scope, productsCategories);
            }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.food.productsCategories.products')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.productsCategories.products', {
            url: '/:productCategoryUUID',
            views: {
                'content@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/products/details/details.html',
                    controller: 'productsDetailsController',
                    controllerAs: 'c'
                },
                'productsCategory@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/productsCategories.html',
                    controller: 'productsCategoriesController',
                    controllerAs: 'c'
                }
            },

            resolve: {
                allProductsCategories: ['$stateParams', 'productsCategoriesResource', function ($stateParams, productsCategoriesResource) {
                    return productsCategoriesResource.loadSubCategories($stateParams.productCategoryUUID).then(function (response) {
                        return response.content;
                    });
                }],

                selectedCategory: ['productsCategories', '$stateParams', function (productsCategories, $stateParams) {
                    return productsCategories.filter(function (c) {
                        return c.uuid === $stateParams.productCategoryUUID;
                    })[0];
                }],

                productsCategories: ['$stateParams', 'productsCategoriesResource', 'allProductsCategories',
                    function ($stateParams, productsCategoriesResource, allProductsCategories) {
                        if (allProductsCategories.parent) {
                            return productsCategoriesResource.loadSubCategories(allProductsCategories.parent.uuid).then(function (response) {
                                return response.content.items;
                            });
                        } else {
                            return productsCategoriesResource.loadCategories().then(function (response) {
                                return response.content.items.map(function (item, index) {
                                    item.iconIndex = index;
                                    return item;
                                });
                            });
                        }
                    }]
            },

            breadcrumb: '{{selectedCategory.name}}'
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories.calendar', [
        'babycompy.content.common'
    ]);
})();
angular.module('babycompy.content.contentCategories.calendar')
    .directive('trimestersList', ['$filter', 'pregancyAgesService', function ($filter, pregancyAgesService) {
        return {
            restrict: 'E',
            scope: {
                weekNumber: '='
            },
            templateUrl: 'app/components/content/contentCategories/pregnancyCalendar/trimestersList/trimestersList.template.html',

            controller: ['$scope', function ($scope) {
                pregancyAgesService.load().then(function (pregancyAges) {
                    $scope.trimesters = [];

                    pregancyAges.forEach(function (pregancyAge) {
                        if (!$scope.trimesters[pregancyAge.trimester]) {
                            $scope.trimesters[pregancyAge.trimester] = [];
                        }

                        $scope.trimesters[pregancyAge.trimester].push(pregancyAge)

                    });

                    $scope.formatWeekName = function (week) {
                        return String.format('{0}-{1}',
                            week.weekNumber,
                            $filter('translate')("pregnancy.weekSuffix", {weekNumber:  week.weekNumber}));
                    };

                    $scope.formatTrimesterName = function (trimestrNumber) {
                        return String.format('{0}-{1}',
                            trimestrNumber,
                            $filter('translate')("pregnancy.trimesterSuffix", {trimester:  trimestrNumber}) );
                    }
                    
                    var selectedTrimester = $scope.trimesters.filter(function (weeks) {
                        return !!(weeks.filter(function(item) {return item.weekNumber === +$scope.weekNumber})[0]);
                       // return weeks.indexOf($scope.weekNumber) >= 0;
                    })[0];

                    $scope.activePanel = $scope.trimesters.indexOf(selectedTrimester);

                    // we have only 14 icons, which corresponding to weeks using rule below
                    // key is icon number, array is range of matching weeks
                    var ranges = {
                        1: [1, 1],
                        2: [2, 2],
                        3: [3, 3],
                        4: [4, 4],
                        5: [5, 5],
                        6: [6, 6],
                        7: [7, 7],
                        8: [8, 9],
                        9: [10, 13],
                        10: [14, 17],
                        11: [18, 24],
                        12: [25, 30],
                        13: [31, 36],
                        14: [37, 42]
                    };

                    $scope.trimesterIconClassName = function (week) {
                        week = week.weekNumber;

                        for (var key in ranges) {
                            if (ranges[key][0] <= week && week <= ranges[key][1]) {
                                week = key;
                                break;
                            }
                        }

                        return 'week' + week.toString().padLeft('0', 2);
                    }

                });
            }]
        }
    }]);

(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories.trimesters', [
        'babycompy.content.common',
        'babycompy.content.contentCategories.trimesters.article'
    ]);
})();
/* global angular */
(function (angular) {
    angular.module('babycompy.content.contentCategories.trimesters')
        .factory('trimestersResource', ['categoriesResource', function (categoriesResource) {

            var TrimestersCalendarResource = categoriesResource.extend({
                _setupCustomActions: function () {
                    var o = this._super();
                    o.loadWeekArticles = {
                        method: 'GET',
                        params: {
                            action: 'calendar'
                        }
                    };

                    o.pregnancyCalendar = {
                        method: 'GET',
                        params: {
                            controller: 'pregnancyCalendar'
                        }
                    }

                    return o;
                },
                
                loadWeekArticles: function(week) {
                    return this.resource.loadWeekArticles({
                        week: week
                    }).$promise;
                },

                search:function(pregnancyAges){
                    return this.get({
                        controller: 'pregnancyCalendar',
                        pregnancyAges: pregnancyAges
                    });
                },

                getSimilarArticles: function(week, excludedSections){
                    return this.resource.pregnancyCalendar({
                        pregnancyAges: [week],
                        excludedSections: excludedSections,
                        content: true
                    }).$promise;
                }
            });

            return new TrimestersCalendarResource('pregnancy');
        }]);
})(angular);
(function () {
    angular.module('babycompy.content.contentCategories.trimesters')
        .controller('trimestersController', ['baseContentCategoriesController', '$scope',
            'articleContent', 'categories', 'weekNumber', '$state', '$filter', 'similarCategories', 'enums', 'seoService',

        function (baseContentCategoriesController, $scope, articleContent, categories,
                  weekNumber, $state, $filter, similarCategories, enums, seoService) {

            var TrimestersCalendarController = baseContentCategoriesController.extend({

                init: function() {
                    this._super.apply(this, arguments);
                    this.weekNumber = weekNumber;
                    this.parentCategories = categories;
                    this.similarCategories = similarCategories;
                    this.favoriteType = enums.selectFavoriteTypes.articles;
                    this.notes = articleContent.notes;
                    seoService.title(articleContent.parent.name, articleContent.name, articleContent.metaTags);
                    seoService.description(articleContent.name, articleContent.metaTags);
                    seoService.keywords(articleContent.metaTags);
                },

                isTrimestersListOpened: function() {
                    return $state.is('index.contentCategories.trimesters');
                },

                categoryTitle: function(weekNumber) {
                    return String.format('{0}-{1}',
                    weekNumber,
                    $filter('translate')("pregnancy.weekSuffixFull", {weekNumber: weekNumber}));
                }
            });

            return new TrimestersCalendarController($scope, articleContent);
        }]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.content.contentCategories.trimesters')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.calendar.trimesters', {
            url: '/weeks/:weekNumber',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/contentCategories/pregnancyCalendar/trimesters/trimesters.html',
                    controller: 'trimestersController',
                    controllerAs: 'c'
                },
            },
            resolve: {
                categories: ['trimestersResource', '$stateParams', function(trimestersResource, $stateParams) {
                    return trimestersResource.search([$stateParams.weekNumber]).then(function(response) {
                        return response.content.items;
                    });
                }],

                pregancyAges: ['pregancyAgesService', function(pregancyAgesService) {
                    return pregancyAgesService.load().then(function() {
                        return pregancyAgesService;
                    })
                }],

                weekNumber: ['$stateParams', 'pregancyAges', function($stateParams, pregancyAges) {
                    return pregancyAges.getWeekNumberByUuid($stateParams.weekNumber);
                }],

                articleContent: ['contentCategoriesResource', '$stateParams', 'pregancyAges',
                    function(contentCategoriesResource, $stateParams, pregancyAges) {
                        var pregnancyAge = pregancyAges.getFromCache($stateParams.weekNumber);
                        var pregnancyAgeSectionUuid = !!pregnancyAge ? pregnancyAge.sectionUuid : 'bad_uuid';
                        return contentCategoriesResource.loadSubCategories(pregnancyAgeSectionUuid)
                            .then(function(response) {
                                return response.content;
                            });
                    }],

                similarCategories: ['trimestersResource', '$stateParams', 'pregancyAges', 'articleContent', function(trimestersResource, $stateParams, pregancyAges, articleContent) {
                    return trimestersResource.getSimilarArticles($stateParams.weekNumber, [articleContent.parent.uuid, articleContent.uuid]).then(function(response) {
                        return response.content.items;
                    });
                }]
            },

            breadcrumb: '{{ "pregnancy.breadcrumbs.calendar" | translate }}'
        });
    }
})();

(function () {
    angular.module('babycompy.content.contentCategories.calendar')
        .service('pregancyAgesService', ['$q', 'pregnancyCalendarResource',
            'singleRequestService',
            function ($q, pregnancyCalendarResource, singleRequestService) {

                var PregancyAgesService = singleRequestService.extend({
                    getFromResource: function () {
                        return pregnancyCalendarResource.getPregnancyAges();
                    },

                    _setEntity: function (result) {
                        this.entity = result.content.items;
                        this.ageCache = {};
                        this.weekSectionsCache = {};
                        this.entity.forEach(function(item, index){
                            this.ageCache[item.uuid] = item;
                            this.weekSectionsCache[item.sectionUuid] = item;
                            item.weekNumber = index + 1;
                        }, this);
                    },

                    getFromCache: function(uuid){
                        return  this.ageCache[uuid];
                    },

                    getFromSectionsCache: function(uuid){
                        return  this.weekSectionsCache[uuid];
                    },

                    getWeekNumberByUuid: function(weekUuid){
                        for(var i = 0; i<this.entity.length; ++i){
                            if(this.entity[i].uuid === weekUuid){
                                return i + 1;
                            }
                        }
                    }
                });

                return new PregancyAgesService();
            }]);
})();

/* global angular */
(function (angular) {
    angular.module('babycompy.content.contentCategories.calendar')
        .factory('pregnancyCalendarResource', ['contentResource', function (contentResource) {

                var PregnancyCalendarResource = contentResource.extend({
                    _setupCustomActions: function() {
                        var o = this._super();
                        o.welcomeText = {
                            method: 'GET',
                            isObject: true,
                            params: {
                                id: 'calendar',
                                action: 'welcome'
                            }
                        };

                        o.getPregnancyAges = {
                            method: 'GET',
                            isObject: true,
                            params: {
                                controller: 'dictionaries',
                                action: 'pregnancyAges'
                            }
                        };
                        
                        return o;
                    },

                    loadWelcomeText: function() {
                        return this.resource.welcomeText().$promise;
                    },

                    getPregnancyAges: function(){
                        return this.resource.getPregnancyAges().$promise;
                    }
                });

                return new PregnancyCalendarResource('pregnancy');
            }]);
})(angular);
angular.module('babycompy.content.contentCategories.calendar')
    .directive('calendarLinks', ['$compile', 'pregancyAgesService',
        function ($compile, pregancyAgesService) {
            return {
                restrict: 'A',
                compile: function () {
                    return function (scope, el, attributes) {
                        pregancyAgesService.load().then(function (pregancyAges) {
                            angular.element(el).find('a.pregnancy-сalendar-week').each(function (index, el) {
                                el.setAttribute('ui-sref', 'index.contentCategories.contentSubcategories.calendar.trimesters({ weekNumber: \'' + pregancyAges[index].uuid + '\'})');

                                $compile(el)(scope);
                            });
                        });

                    }
                }
            }
        }]);

(function() {
    angular.module('babycompy.content.contentCategories.calendar')
        .controller('pregnancyCalendarController', ['baseContentController', '$scope', 'welcomeText', 'parentRootCategories',
            'calendarServerName', 'pregnancyUuid', 'seoService', 'responseContent',
            function(baseContentController, $scope, welcomeText, parentRootCategories, calendarServerName, pregnancyUuid, seoService, responseContent) {
                // dependencies will be resolved during page load in the route definition

                var PregnancyCalendarController = baseContentController.extend({

                    init: function() {
                        this._super.apply(this, arguments);
                        this.rootCategories = this.getCategoriesWithLinks();
                        seoService.title(responseContent.name, this.content.name, welcomeText.metaTags);
                        seoService.description(this.content.name, welcomeText.metaTags);
                        seoService.keywords(welcomeText.metaTags);
                    },

                    getCategoriesWithLinks: function() {
                        var categories = parentRootCategories.map(function(category) {
                            if (category.name.indexOf(calendarServerName) >= 0) {
                                category.href = String.format('index.contentCategories.contentSubcategories.calendar({{categoryUUID : \'{0}\'}})',
                                    pregnancyUuid);
                                return category;
                            }
                            category.href = 'index.contentCategories.contentSubcategories.article({ categoryUUID: \'' + pregnancyUuid + '\',' +
                                'articleUUID:\''+  category.uuid + '\'})';
                            return category;
                        });
                        return categories;
                    }
                });

                return new PregnancyCalendarController($scope, welcomeText);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.contentCategories.calendar')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        // !!Important this is part of contentSubcategories
        $stateProvider.state('index.contentCategories.contentSubcategories.calendar', {
            url: '/calendar',
            views: {
                'content@index.contentCategories': {
                    templateUrl: 'app/components/content/contentCategories/pregnancyCalendar/calendar/calendar.html',
                    controller: 'pregnancyCalendarController',
                    controllerAs: 'c'
                },
            },
            resolve: {
                welcomeText: ['contentCategoriesResource', '$stateParams', 'calendarServerName', function (contentCategoriesResource, $stateParams, calendarServerName) {
                    return contentCategoriesResource.loadSubCategories($stateParams.categoryUUID).then(function (response) {
                        var calendarSection = response.content.childs.filter(function(item) {
                            return item.name.indexOf(calendarServerName) >= 0;
                        })[0];
                        // get calendar category with metaTags
                        return contentCategoriesResource.getSectionsContent(calendarSection.uuid).then(function (response) {
                            return response.content;
                        });
                    })
                }],
                
                parentRootCategories: ['contentCategoriesResource', 'contentCategoriesService',  function (contentCategoriesResource, contentCategoriesService) {
                    return contentCategoriesService.getCategories().then(function () {
                        return contentCategoriesResource.getSectionsContent(contentCategoriesService.getLink('pregnancy').uuid).then(function (categories) {
                            return categories.content.childs;
                        })
                    })
                }],

                calendarServerName: ['$translate', function($translate){
                    return $translate('menu.serverNames.calendar');
                }],

                pregnancyUuid: ['contentCategoriesService', function(contentCategoriesService){
                    return contentCategoriesService.getCategories().then(function () {
                        return contentCategoriesService.getPregnancyLink().uuid;
                    });
                }]

            },
            breadcrumb: '{{ "pregnancy.breadcrumbs.calendar" | translate }}'
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories.contentSubcategories.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function () {
    angular.module('babycompy.content.contentCategories.contentSubcategories.article')
        .controller('articleController', ['baseContentCategoriesController', '$scope',
            'articleContent', 'parentCategories', '$state', '$filter', 'enums', 'customPaging', 'seoService', 'week',
            function (baseContentCategoriesController, $scope, articleContent,
                parentCategories, $state, $filter, enums, customPaging, seoService, week) {
                var parentsArray = [],
                    state = '';

                var parentsChain = function (entity) {
                    if (entity.parent !== null) {
                        if (entity.parent.parent === null) {
                            state = 'index.contentCategories.contentSubcategories';
                        } else {
                            state = 'index.contentCategories.contentSubcategories.article';
                        }
                        parentsArray.push({
                            name: entity.parent.name,
                            href: $state.href(state, { articleUUID: entity.parent.uuid })
                        });
                        parentsChain(entity.parent);
                    }

                    return parentsArray;
                };

                var ArticleController = baseContentCategoriesController.extend({

                    init: function () {
                        var limit = 10,
                            offset = 0;

                        this._super.apply(this, arguments);
                        this.parentCategories = parentCategories;
                        this.arrayOfParents = parentsChain(this.returnedContent).reverse();
                        this.notes = articleContent.notes;

                        if(!!articleContent.parent) {
                            seoService.title(articleContent.parent.name, articleContent.name, articleContent.metaTags);
                        } else {
                            seoService.title(articleContent.name, articleContent.name, articleContent.metaTags)
                        }
                        seoService.description(articleContent.name, articleContent.metaTags);
                        seoService.keywords(articleContent.metaTags);

                        // TODO: change type.
                        this.favoriteType = enums.selectFavoriteTypes.articles;
                        this.arrayOfParents.unshift({
                            name: $filter('translate')('main.main'),
                            href: '/'
                        });

                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset,
                            this.parentCategories, this.returnedContent);
                        this.weekNumber = week.number;
                    }
                });

                return new ArticleController($scope, articleContent);

            }]);
})();

(function () {
  'use strict';

  angular
    .module('babycompy.content.contentCategories.contentSubcategories.article')
    .config(['$stateProvider', config]);

  /** @ngInject */
  function config($stateProvider) {

    $stateProvider.state('index.contentCategories.contentSubcategories.article', {
      url: '/:articleUUID',
      views: {
        'content@index': {
          templateUrl: 'app/components/content/contentCategories/contentSubcategories/article/article.html',
          controller: 'articleController',
          controllerAs: 'c'
        },
        'breadcrumbs@index': {
          templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
          controller: 'articleController',
          controllerAs: 'c'
        }
      },
      resolve: {
        articleContent: ['contentCategoriesResource', '$stateParams', function (contentCategoriesResource, $stateParams) {
          return contentCategoriesResource.loadSubCategories($stateParams.articleUUID).then(function (response) {
            return response.content;
          });
        }],
        parentCategories: ['articleContent', 'contentCategoriesResource', function (articleContent, contentCategoriesResource) {
          var parentUuid = articleContent.parent.uuid;
          return contentCategoriesResource.loadSubCategories(parentUuid).then(function (response) {
            return response.content.childs;
          });

        }],
        week: ['$stateParams', 'pregancyAgesService', function ($stateParams, pregancyAgesService) {
          return pregancyAgesService.load().then(function () {
            return {
              weekNumber: $stateParams.weekNumber,
              number: pregancyAgesService.getWeekNumberByUuid($stateParams.weekNumber)
            }
          });

        }],
      }
    });
  }
})();

(function () {
    "use strict"
    angular.module('babycompy.content.common')
        .directive('categoriesHeader', function () {
            return {
                scope: {
                    contentName: '=',
                    icon: '=?'
                },
                replace: true,
                transclude: {
                    'title': '?headerTitle'
                },
                templateUrl: 'app/components/content/common/categories/header/header.html'
            };
        })
})();
(function () {
    "use strict"
    angular.module('babycompy.content.common')
        .directive('categoriesFooter', function () {
            return {
                scope: {
                    contentName: '='
                },
                link: function (scope, elem) {
                    angular.element(elem).addClass('block-footer');
                },
                replace: true,
                transclude: true,
                templateUrl: 'app/components/content/common/categories/footer/footer.html'
            };
        })
})();
(function () {
    'use strict';
    angular
        .module('babycompy.content.algorithms')
        .config(['$stateProvider', config]);
    function config($stateProvider) {
        $stateProvider.state('index.algorithms.group', {
            url: '/group/:groupUuid',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/algorithms/groups/detail/groups.detail.template.html',
                    controller: 'groupController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                groupDetail: ['groupService','$stateParams', function (groupService,$stateParams) {
                    return groupService.getById($stateParams.groupUuid).then(function (response) {
                        return response.content;
                    });
                }],
                lightGroups: ['groupService','$stateParams', function (groupService,$stateParams) {
                    return groupService.getLightGroups().then(function (response) {
                        return response.content;
                    });
                }],
            },
            breadcrumb: "{{groupDetail.name}}"
        });
    }
})();

(function () {
    angular.module('babycompy.content.algorithms')
        .controller('groupController', ['baseContentController', '$scope', '$translate', 'seoService', '$state', 'lightGroups','groupDetail','customPaging',
            function (baseContentController, $scope, $translate, seoService, $state, lightGroups,groupDetail,customPaging) {

                var groupController = baseContentController.extend({
                    init: function () {
                        if(!groupDetail){
                            return;
                        }
                        var offset = 0,
                            limit = 10;
                        this._super.apply(this, arguments);
                        this.groups = lightGroups.items;
                        this.description = lightGroups.description;
                        this.group = groupDetail;
                        if(groupDetail.algorithms) {
                            this.algorithms = groupDetail.algorithms;
                        } else {
                            this.algorithms = [];
                        }
                        seoService.title(this.group.name);
                        seoService.description(this.group.description);

                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.groups,this.group);
                    }
                });
                return new groupController($scope);
            }]);
})();

(function() {
    angular.module('babycompy.content.common')
        .factory('stepService', ['stepResource', function(stepResource) {
            function stepService() {}
            stepService.prototype.getById = function(algorithmUuid,stepUuid) {
                return stepResource.retreiveStep(algorithmUuid,stepUuid);
            };
            stepService.prototype.getArticle = function(articleUuid) {
                return stepResource.retreiveArticle(articleUuid);
            };
            stepService.prototype.getRecommendation = function(recommendationUuid) {
                return stepResource.retreiveRecommendation(recommendationUuid);
            };
            return new stepService();
        }]);
})(angular);

"use strict";
(function(angular) {
    angular.module('babycompy.categories.common')
        .factory('stepResource', ['baseApiService', function(baseApiService) {

            var stepResource = baseApiService.extend({

                _setupCustomActions: function() {
                    return {
                        'get': {
                            method: 'GET',
                            isObject: true,
                            url: '/:apiPrefix/:apiVersion/:controller/:algorithmId/steps/:stepUuid'
                        },
                        'getArticle': {
                            method: 'GET',
                            isObject: true,
                            url: '/:apiPrefix/:apiVersion/:controller/:articleUuid'
                        }
                    }
                },
                retreiveStep: function(algorithmUuid, stepUuid) {
                    var params = {
                        controller: 'algorithms',
                        algorithmId: algorithmUuid,
                        stepUuid: stepUuid
                    };
                    return this.resource.get(params).$promise;
                },
                retreiveArticle: function(articleUuid) {
                    var params = {
                        controller: 'articles',
                        articleUuid: articleUuid,
                    };
                    return this.resource.getArticle(params).$promise;
                },
                retreiveRecommendation: function(recommendationUuid) {
                    var params = {
                        controller: 'recommendations',
                        articleUuid: recommendationUuid,
                    };
                    return this.resource.getArticle(params).$promise;
                }
            });

            return new stepResource('algorithms');
        }]);
})(angular);

"use strict";
(function() {
    angular.module('babycompy.content.algorithms')
        .controller('stepController', ['$rootScope', 'baseContentController', 'seoService', '$state', 'modalService', 'currentStep', 'algorithmDetail', 'authService', 'algorithmService', 'algorithmSavesService', '$scope', '$translate', 'localStorageService', 'app', 'currentUserService',
            function($rootScope, baseContentController, seoService, $state, modalService, currentStep, algorithmDetail, authService, algorithmService, algorithmSavesService, $scope, $translate, localStorageService, appConstants, currentUserService) {

                var stepController = baseContentController.extend({

                    init: function() {
                        this._super.apply(this, arguments);
                        this.button_clicked = false; // on load disable
                        this.restart_close_active = false; // on error enable end/restart buttons

                        //if algorithm was deleted
                        if (algorithmDetail === null) {
                            modalService.showErrorAlert({
                                title: $translate.instant('algorithms.error'),
                                message: $translate.instant('algorithms.deleted')
                            }).then(function() {
                                $state.go('index.algorithms', {}, {reload: true});
                            });
                        }


                      currentUserService.load().then(function (user) {
                        this.user = user;

                        //if step is missing (was deleted)
                        if (currentStep === null) {
                          modalService.showErrorAlert({
                            title: $translate.instant('algorithms.error'),
                            message: $translate.instant('algorithms.structureChanged')
                          });
                          this.button_clicked = true;
                          this.restart_close_active = true;
                        }

                        this.algorithmDetail = algorithmDetail;
                        this.step = currentStep === null ? {name: $translate.instant('algorithms.structureChanged')} : currentStep.step;
                        this.continue = !!(this.step.redirect || (this.step.substeps && this.step.substeps.length === 1));
                        this.logged = !!authService.isLoggedIn() && this.user && !this.user.doctor;
                        this.back = this.logged ? algorithmDetail.userStepsCount > 1 : localStorageService.get(appConstants.algorithmLocalStorageKey).steps.length > 1;
                        this.lastStep = !!this.step.substeps && this.step.substeps.length == 0 && this.step.redirect == null;

                        //if structure has been changed
                        if (!!currentStep && !this.logged && moment(currentStep.lastStructureChange).isAfter(localStorageService.get(appConstants.algorithmLocalStorageKey).start)) {
                          modalService.showErrorAlert({
                            title: $translate.instant('algorithms.error'),
                            message: $translate.instant('algorithms.structureChanged')
                          });
                          this.button_clicked = true;
                          this.restart_close_active = true;
                        }

                        //Check for recommendations (were they already selected)
                        if (!!this.step.recommendations && this.step.recommendations.length > 0) {
                          if (this.logged) {
                            algorithmService.getUserRecommendationsForStep(algorithmDetail.userAlgorithm, this.step.uuid).then(function(response) {
                              this.selectedRecommendations = response.content.items;
                            }.bind(this));
                          } else {
                            this.selectedRecommendations = localStorageService.get(appConstants.algorithmLocalStorageKey).recommendations ?
                              localStorageService.get(appConstants.algorithmLocalStorageKey).recommendations : [];
                          }
                        }

                        //Recommendation history
                        if (this.step.showPlan) {
                          if (this.logged) {
                            algorithmService.getAllUserRecommendations(algorithmDetail.userAlgorithm).then(function(response) {
                              this.allSelectedRecommendations = response.content.items;
                            }.bind(this));
                          } else {
                            this.allSelectedRecommendations = localStorageService.get(appConstants.algorithmLocalStorageKey).recommendations ?
                              localStorageService.get(appConstants.algorithmLocalStorageKey).recommendations : [];
                          }
                        }
                        this.api = controlsAPI(this);

                        seoService.title(algorithmDetail.name);
                        seoService.description(algorithmDetail.description);
                      }.bind(this));
                    }

                });

              var currentUser;

              currentUserService.load().then(function (user) {
                currentUser = user;
              });

                function controlsAPI(that) {

                    var _onStructureChanged = function() {
                        modalService.showErrorAlert({
                            title: $translate.instant('algorithms.error'),
                            message: $translate.instant('algorithms.structureChanged')
                        });
                        that.restart_close_active = true;
                        that.button_clicked = true;
                    };

                    var _onUnpublished = function() {
                        modalService.showErrorAlert({
                            title: $translate.instant('algorithms.error'),
                            message: $translate.instant('algorithms.unpublished')
                        }).then(
                            function() {
                                $rootScope.confirmedRedirect = true;
                                $state.go('index.algorithms', {}, { reload: true });
                                $rootScope.confirmedRedirect = false;
                            },
                            function() {
                                $rootScope.confirmedRedirect = true;
                                $state.go('index.algorithms', {}, { reload: true });
                                $rootScope.confirmedRedirect = false;
                            });
                    };

                    var _onErrorResponse = function(error) {
                        if (error.data.metadata.errorCode === 403003) {
                            _onStructureChanged();
                        }
                        if (error.data.metadata.errorCode === 403002 || error.data.metadata.errorCode === 404101) {
                            _onUnpublished();
                        }
                    }

                    var restartCloseActive = function() {
                        return that.restart_close_active;
                    }

                    var buttonClicked = function() {
                        return that.button_clicked;
                    };

                    var emailSent = function() {
                        return that.email_sent;
                    };

                    var moveForward = function() {
                        if (that.button_clicked) {
                            return;
                        }
                        that.button_clicked = true;
                        var nextStep = (that.step.redirect) ? that.step.redirect : that.step.substeps[0].uuid;

                        if (!!authService.isLoggedIn() && !currentUser.doctor ) { // logged
                            var requestBody = {};
                            requestBody.userAlgorithm = that.algorithmDetail.userAlgorithm;
                            requestBody.nextStep = nextStep;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            requestBody.recommendations = [];
                            angular.forEach(angular.element('#recommendations :checked'), function(item) {
                                requestBody.recommendations.push(angular.element(item).val());
                            });
                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(function(response) {
                                $state.go('index.algorithms.group.algorithm.step', { stepUuid: response.content.step.uuid }, { reload: true });
                            }.bind(that), _onErrorResponse);
                        } else { // not logged - save progress into localStorage
                            var algorithmStorage = localStorageService.get(appConstants.algorithmLocalStorageKey);
                            algorithmStorage.steps.push(nextStep);
                            var resultRecommendations = [];
                            if (algorithmStorage.recommendations) {
                                algorithmStorage.recommendations.forEach(function(item, i, arr) {
                                    if (item.step !== that.step.uuid) {
                                        resultRecommendations.push(item);
                                    }
                                });
                            }
                            angular.forEach(angular.element('#recommendations :checked'), function(item) {
                                var recommendation = {};
                                recommendation.uuid = angular.element(item).val();
                                recommendation.step = that.step.uuid;
                                recommendation.name = angular.element(item).data('name');
                                resultRecommendations.push(recommendation);
                            });
                            algorithmStorage.recommendations = resultRecommendations;
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $state.go('index.algorithms.group.algorithm.step', { stepUuid: nextStep }, { reload: true });
                        }
                    };

                    var moveBackwards = function() {
                        if (that.button_clicked) {
                            return;
                        }
                        that.button_clicked = true;
                        if (!!authService.isLoggedIn() && !currentUser.doctor ) { // logged in
                            var requestBody = {};
                            requestBody.userAlgorithm = that.algorithmDetail.userAlgorithm;
                            requestBody.nextStep = that.step.parent;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(function(response) {
                                $state.go('index.algorithms.group.algorithm.step', { stepUuid: response.content.step.uuid }, { reload: true });
                            }.bind(that), _onErrorResponse);
                        } else { // not logged - save progress into localStorage
                            var algorithmStorage = localStorageService.get(appConstants.algorithmLocalStorageKey);
                            algorithmStorage.steps.pop();
                            var nextStep = algorithmStorage.steps[algorithmStorage.steps.length - 1];
                            var resultRecommendations = [];
                            if (algorithmStorage.recommendations) {
                                algorithmStorage.recommendations.forEach(function(item, i, arr) {
                                    if (item.step !== that.step.uuid) {
                                        resultRecommendations.push(item);
                                    }
                                });
                            }
                            algorithmStorage.recommendations = resultRecommendations;
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $state.go('index.algorithms.group.algorithm.step', { stepUuid: nextStep }, { reload: true });
                        }
                    };

                    var moveToSubstep = function(uuid) {
                        if (that.button_clicked) {
                            return;
                        }
                        that.button_clicked = true;
                        if (!!authService.isLoggedIn() && !currentUser.doctor ) { // logged
                            var requestBody = {};
                            requestBody.userAlgorithm = that.algorithmDetail.userAlgorithm;
                            requestBody.nextStep = uuid;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            requestBody.recommendations = [];
                            angular.forEach(angular.element('#recommendations :checked'), function(item) {
                                requestBody.recommendations.push(angular.element(item).val());
                            });

                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(function(response) {
                                $state.go('index.algorithms.group.algorithm.step', { stepUuid: response.content.step.uuid }, { reload: true });
                            }.bind(this), _onErrorResponse);
                        } else { // not logged - save progress into localStorage
                            var algorithmStorage = localStorageService.get(appConstants.algorithmLocalStorageKey);
                            var currentStepUuid = $state.params.stepUuid;
                            if (!!algorithmStorage) {
                                algorithmStorage.steps.push(uuid);
                            } else {
                                var algorithmStorage = {};
                                algorithmStorage.steps = [];
                                algorithmStorage.steps.push(uuid);
                            }
                            var resultRecommendations = [];
                            if (algorithmStorage.recommendations) {
                                algorithmStorage.recommendations.forEach(function(item, i, arr) {
                                    if (item.step !== currentStepUuid) {
                                        resultRecommendations.push(item);
                                    }
                                });
                            }
                            angular.forEach(angular.element('#recommendations :checked'), function(item) {
                                var recommendation = {};
                                recommendation.uuid = angular.element(item).val();
                                recommendation.step = currentStepUuid;
                                recommendation.name = angular.element(item).data('name');
                                resultRecommendations.push(recommendation);
                            });
                            algorithmStorage.recommendations = resultRecommendations;
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $state.go('index.algorithms.group.algorithm.step', { stepUuid: uuid }, { reload: true });

                        }
                    };

                    var finishAlgorithm = function() {
                        if (!!authService.isLoggedIn() && !currentUser.doctor ) {
                            algorithmService.finishAlgorithm(that.algorithmDetail.userAlgorithm).then(function(response) {
                                $state.go('index.algorithms', {}, { reload: true });
                                algorithmSavesService.onFinishAlgorithm();
                            }.bind(that));
                        } else {
                            var algorithmStorage = localStorageService.get(appConstants.algorithmLocalStorageKey);
                            algorithmStorage = {};
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $rootScope.confirmedRedirect = true;
                            $state.go('index.algorithms', {}, { reload: true });
                            $rootScope.confirmedRedirect = false;
                        }
                    };

                    var restartAlgorithm = function() {
                        if (!!authService.isLoggedIn() && !currentUser.doctor ) {
                            algorithmService.restartAlgorithm(that.algorithmDetail.userAlgorithm).then(function(response) {
                                $state.go('index.algorithms.group.algorithm.step', { stepUuid: response.content.step.uuid }, { reload: true });
                            }.bind(that), _onErrorResponse);
                        } else {
                            var algorithmStorage = localStorageService.get(appConstants.algorithmLocalStorageKey);
                            var nextStep = algorithmStorage.steps[0];
                            algorithmStorage = {};
                            algorithmStorage.steps = [nextStep];
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $state.go('index.algorithms.group.algorithm.step', { stepUuid: nextStep }, { reload: true });
                        }
                    };

                    var saveAlgorithm = function() {
                        if (that.button_clicked) {
                            return;
                        }
                        that.button_clicked = true;
                        if (!!authService.isLoggedIn() && !currentUser.doctor ) {
                            var requestBody = {};
                            requestBody.userAlgorithm = that.algorithmDetail.userAlgorithm;
                            requestBody.nextStep = $state.params.stepUuid;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            requestBody.recommendations = [];
                            angular.forEach(angular.element('#recommendations :checked'), function(item) {
                                requestBody.recommendations.push(angular.element(item).val());
                            });
                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(function(response) {
                                $state.go('index.algorithms', {}, { reload: true });
                            }.bind(that), _onErrorResponse);
                        } else {
                            $state.go('index.algorithms', {}, { reload: true });
                        }
                    };

                    return {
                        moveForward: moveForward,
                        moveBackwards: moveBackwards,
                        moveToSubstep: moveToSubstep,
                        finishAlgorithm: finishAlgorithm,
                        restartAlgorithm: restartAlgorithm,
                        saveAlgorithm: saveAlgorithm,
                        continue: that.continue,
                        back: that.back,
                        logged: that.logged,
                        button_clicked: buttonClicked,
                        last_step: that.lastStep,
                        restart_close_active: restartCloseActive
                    };
                };

                return new stepController($scope);
            }
        ]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.content.algorithms')
        .config(['$stateProvider', config]);

    function config($stateProvider) {
        $stateProvider.state('index.algorithms.group.algorithm.step', {
            url: '/step/:stepUuid',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/algorithms/algorithm/step/step.template.html',
                    controller: 'stepController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                currentStep: ['stepService', '$stateParams', function(stepService, $stateParams) {
                    return stepService.getById($stateParams.algorithmUuid, $stateParams.stepUuid).then(
                        function(response) {
                            return response.content;
                        },
                        function(error) {
                            if (error.data.metadata.errorCode === 404101) {
                                return null;
                            }
                        }
                    );
                }],
                algorithmDetail: ['algorithmService', '$stateParams', function(algorithmService, $stateParams) {
                    return algorithmService.getById($stateParams.algorithmUuid).then(
                        function(response) {
                            return response.content;
                        },
                        function(error) {
                            if (error.data.metadata.errorCode === 404101) {
                                return null;
                            }
                        }
                    );
                }]
            }
        });
    }
})();

angular.module('babycompy.content.common')
    .directive('stepHeader', ['modalService', '$translate', '$q', '$compile',
        function(modalService, $translate, $q, $compile) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    title: '=',
                    api: '=',
                    algorithm: '='
                },

                templateUrl: 'app/components/content/algorithms/algorithm/navigation/step.header.template.html',

                link: function(scope, el, attrs) {
                    scope.confirmDeletingHistory = function(restart) {
                        modalService.open({
                            scope: scope,
                            template: 'app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html',
                            controller: 'algorithmConfirmModalController as c',
                            show: true,
                            backdrop: 'static'
                        }).result.then(function() {
                            if (restart) {
                                scope.api.restartAlgorithm();
                            } else {
                                scope.api.finishAlgorithm();
                            }
                        }.bind(this));
                    }
                }
            }
        }
    ]);

angular.module('babycompy.content.common')
    .directive('algorithmControls', ['$translate', '$q', '$compile', '$state', 'modalService',
        function($translate, $q, $compile, $state, modalService) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    api: '=',
                    algorithm: '='
                },

                templateUrl: 'app/components/content/algorithms/algorithm/navigation/controls.template.html',

                link: function(scope, el, attrs) {
                    scope.confirmDeletingHistory = function(restart) {
                        modalService.open({
                            scope: scope,
                            template: 'app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html',
                            controller: 'algorithmConfirmModalController as c',
                            show: true,
                            backdrop: 'static'
                        }).result.then(function() {
                            if (restart) {
                                scope.api.restartAlgorithm();
                            } else {
                                scope.api.finishAlgorithm();
                            }
                        }.bind(this));
                    }
                }
            }
        }
    ]);

(function () {
  'use strict';

  angular
    .module('babycompy.authentication.doctorsProfile', [])
    .config(['$stateProvider', config]);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('index.profile.doctor', {
      url: '/doctor',
      views: {
        'content-wrapper@': {
          templateUrl: 'app/components/authentication/profile/doctorsProfile/doctorsProfile.html',
          controller: 'doctorsProfileController as c'
        }
      },

      resolve: {
        currentUser: ['currentUserService', '$state', function (currentUserService, $state) {
          return currentUserService.load().then(function (user) {
            if (user == null) {
              $state.go('index.login');
              return;
            }

            return currentUserService.get();
          });
        }]
      }
    })
      .state('index.profile.doctor.edit', {
        url: '/edit',
        parent: 'index.profile.doctor',
        views: {
          'content-wrapper@': {
            templateUrl: 'app/components/authentication/profile/doctorsProfile/edit/doctorsProfile-edit.html',
            controller: 'doctorsProfileController as c'
          }
        }
      })
      .state('index.profile.doctor.achievements', {
        url: '/achievements',
        parent: 'index.profile.doctor',
        views: {
          'content-wrapper@': {
            templateUrl: 'app/components/authentication/profile/doctorsProfile/edit/doctorsProfile-achievements.html',
            controller: 'doctorsProfileController as c'
          }
        }
      })
      .state('index.profile.doctor.settings', {
        url: '/settings',
        parent: 'index.profile.doctor',
        views: {
          'content-wrapper@': {
            templateUrl: 'app/components/authentication/profile/doctorsProfile/settings/doctorsProfile-settings.html',
            controller: 'doctorSettingsController as c'
          }
        }
      });
  }
})();

angular.module('babycompy.authentication.doctorsProfile')
  .controller('doctorSettingsController', ['$scope', 'doctorsProfileResource', 'modalService', 'currentUserService','$translate', 'modalService', '$filter',
    function ($scope, doctorsProfileResource, modalService, currentUserService, $translate, modalService, $filter) {
      this.data = {
        oldPassword: '',
        newPassword: ''
      };

      currentUserService.load().then(function (user) {
        this.hidden = user.hidden;
        this.status = user.status;
      }.bind(this));

      this.showSaveAlert = function() {
        var messageText = $translate.instant('userProfile.profileSaved');
        modalService.showSuccessAlert(messageText);
        $scope.changePassword.$setPristine();
      };

      this.hideProfile = function () {
        this.hidden = !this.hidden;

        currentUserService.user.hidden = angular.copy(this.hidden);
        doctorsProfileResource.delete().then(function () {
          modalService.showSuccessAlert($filter('translate')('userProfile.profileSaved'));
        });
      };

      this.changePassword = function () {
        if (!this.data.oldPassword || !this.data.newPassword) {
          return;
        } else if (!this.data.repeatPassword) {
          this.data.repeatPassword = $scope.changePassword.repeatPassword.$viewValue;
          if(this.data.repeatPassword !== this.data.newPassword) {
            return;
          }
        }

        doctorsProfileResource.put({action: 'password'}, this.data).then(function(response) {
          this.showSaveAlert();
          this.invalidOldPassord = false;
          this.data = {};
          $scope.changePassword.$submitted = false;
        }.bind(this), function(response) {
          if (response.data.metadata.errorCode === 400005) {
            this.invalidOldPassord = true;
          }
        }.bind(this));
      };

}]);

(function () {
    angular.module('babycompy.authentication.profile.children')
        .controller('profileChildrenEditController', ['$scope', 'baseEditController',
            'currentUserService',
            'profileChildrenResource',
            'profileChildrenService',
            '$modal', '$q',
            '$timeout', '$filter', 'oldEntity', '$modalService', 'cropperService', 'profileService',
            'modalService', '$translate',
            function ($scope, baseEditController, currentUserService, profileChildrenResource,
                      profileChildrenService, $modal, $q, $timeout, $filter, oldEntity,
                      $modalService, cropperService, profileService, modalService,
                      $translate) {

                var ProfileChildrenController = baseEditController.extend({
                    init: function ($scope, resource) {
                        this._super($scope, resource);

                        this.formName = 'childEditForm';
                        this.avatarService = new cropperService({
                            autoCropArea: 0.4,
                        });
                        this.fileWrapper = {
                            fileAdded: this.fileAdded.bind(this)
                        }

                      $scope.$on('avatarChanged',function () {
                        $scope.childEditForm.$setDirty();
                      }.bind(this));
                    },

                    save: function () {
                        this.scope[this.formName].$setSubmitted();
                        this._super();
                    },

                    _loadDataInternal: function () {
                        var entity = oldEntity ? angular.copy(oldEntity, {}) : {};

                        this.birthDate = entity.birthDate ? new Date(entity.birthDate) : null;

                        this._setEntity(this._postLoad(entity));

                        return $q.when(entity);
                    },

                    removeAvatar: function () {
                        this.entity.avatar = null;
                        this.avatarService.croppedImage = null;
                        this.scope[this.formName].$setDirty();
                    },

                    editAvatar: function () {
                        this.fileWrapper.openFile();
                    },

                    fileAdded: function ($event, flowFile) {
                        var file = flowFile.file[0];
                        profileService.checkUploadingImage(file).then(function(){
                            this.avatarService.setImage(file).then(function () {
                                this.imageEdit = true;
                                $timeout(function () {
                                    $scope.$broadcast('show');
                                });
                            }.bind(this));
                        }.bind(this), function(reason){
                            modalService.showErrorAlert({
                                title: $translate.instant('userProfile.avatarUpload'),
                                message: reason.message
                            });
                        });
                    },

                    _saveInternal: function (entity) {
                        //just create/update entity
                        if (!this.avatarService.croppedImage) {
                            return this.resource.save(entity);
                        }

                        //create with image
                        if (!this.entity.uuid) {
                            return this.resource.saveWithImage(this.avatarService.croppedImage, entity,
                                this.avatarService.file.name);
                        }

                        //update image and then entity itself
                        return this.resource.updateImage(this.avatarService.croppedImage, entity.uuid,
                            this.avatarService.file.name)
                            .then(function (response) {
                                entity.avatar = response.content.avatar;
                                return this.resource.save(entity);
                            }.bind(this));
                    },

                    applyImage: function () {
                        this.avatarService.cropImage().then(function () {
                            this.imageEdit = false;
                            $scope.$broadcast('hide');
                        }.bind(this));
                    },

                    cancelImage: function () {
                        this.avatarService.file = null;
                        this.imageEdit = false;
                        $scope.$broadcast('hide');
                    },

                    _preSave: function (entity) {
                        entity.birthDate = $filter('date')(this.birthDate, 'yyyy-MM-dd');
                        return $q.when(entity);
                    },

                    _afterSave: function (entity) {
                        this.scope.entity = entity;
                        $modalService.close(entity);
                    },

                    close: function () {
                        $modalService.dismiss();
                    }

                });

                return new ProfileChildrenController($scope, profileChildrenResource);
            }]);
})();

;(function () {
    'use strict';

    angular.module('babycompy.medics.answers.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.medics.answers.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medics.answers.article', {
            url: '/:articleUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/medics/answers/article/article.html',
                    controller: 'answersArticleController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                articleContent: ['medicAnswersResource', '$stateParams', function(medicAnswersResource, $stateParams) {
                    return medicAnswersResource.get({ id: $stateParams.articleUUID }).then(function(response) {
                        return response.content;
                    });
                }],

                parentCategories: ['articleContent', 'medicAnswersResource', '$stateParams',
                    function(articleContent, medicAnswersResource, $stateParams) {
                        return medicAnswersResource.getByRubric({}, { id: $stateParams.rubricUUID }).then(function(response) {
                            return response.content.items;
                        });

                    }],

                selectedRubric: ['medicRubricsService', '$stateParams',
                    function(medicRubricsService, $stateParams) {
                        return medicRubricsService.load().then(function(response) {
                            return response.content.items.filter(function(c) {
                                return c.uuid === $stateParams.rubricUUID
                            })[0];
                        });
                    }],

                user: ['currentUserService', function(currentUserService) {
                    return currentUserService.load().then(function(user) {
                        return user;
                    });
                }]
            },

            breadcrumb: "", //"{{selectedRubric.name}}"
        });
    }
})();

(function () {
    angular.module('babycompy.medics.answers.article')
        .controller('answersArticleController', ['baseController', '$scope', 'seoService',
            'articleContent', 'modalService', '$translate', 'customPaging', 'parentCategories', 'user', 'enums', '$state','currentUserService',
            function (baseController, $scope, seoService,
                      articleContent, modalService, $translate, customPaging, parentCategories, user, enums, $state,currentUserService) {


                var AnswersArticleController = baseController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.user = user;
                        this.favoriteType = enums.selectFavoriteTypes.medicAnswers;
                        this.content = articleContent;
                        this.parentCategories = parentCategories;
                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.
                        getPagingParameters(limit, offset, this.parentCategories, articleContent);

                        this.doctor = articleContent.doctor || {};
                        $translate("medic.info.doctorsName", {
                            firstName: this.doctor.firstName,
                            lastName: this.doctor.lastName,
                            patronymic: this.doctor.patronymic
                        }).then(function(translate){
                            this.doctorName = translate;
                        }.bind(this));

                         $translate('medic.info.title').then(function(translations){
                            seoService.title(translations, articleContent.name);
                            seoService.description(articleContent.name);
                        })

                      currentUserService.load(function (user) {
                        this.user = user;
                      }.bind(this));

                    },

                     askDoctor: function() {
                        if (!currentUserService.get()) {
                            modalService.showLoginModal($scope).result.then(function() {
                                modalService.showQuestionModal($scope);
                            });
                        } else {
                            modalService.showQuestionModal($scope);
                        }

                    },

                    extractVisibleSupplements: function() {
                        return this.customPaging.extractVisibleSupplements();
                    }
                });

                return new AnswersArticleController($scope, articleContent);
            }]);
})();

(function () {
    'use strict';

    angular.module('babycompy.doctorSearch',
        [
            'babycompy.doctors.details',
            'babycompy.pager',
            'ngSanitize',
            'ui.select'
        ]);
})();

angular.module('babycompy.doctorSearch')
    .directive('selectDoctorDepartment', ['doctorDepartmentResource', function (doctorDepartmentResource) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                value: '=',
                placeholder: '@'
            },
            templateUrl: 'app/components/doctorSearch/search/selectDoctorDepartment/selectDoctorDepartment.html',
            controller: ['$scope', 'doctorDepartmentResource', function ($scope, doctorDepartmentResource) {
                (function () {
                    doctorDepartmentResource.get()
                        .then(function (response) {
                            $scope.values = response.content.items;
                        }.bind(this));
                })();
            }]
        }
    }]);

(function () {
    angular.module('babycompy.doctorSearch')
        .factory('doctorDepartmentResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var doctorDepartmentResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.get = {
                        method: 'GET'
                    }

                    return o;
                }
            })
            return new doctorDepartmentResource(resources.doctorDepartments);
        }])
})();
(function () {
    angular.module('babycompy.base')
        .factory('resourceWrapper', ['$resource', '$q', function ($resource, $q) {

            var resourceWrapper = Class.extend({

                init: function (url, params, actions) {
                    this.promiseId = 0;
                    this.promises = {};

                    var action;
                    var addedActions = {};
                    //proxy default actions
                    for (action in $resource.prototype.DEFAULT_ACTIONS) {
                        addedActions[action] = $resource.prototype.DEFAULT_ACTIONS[action];
                    }

                    //add/replace proxy with custom actions
                    for (action in actions) {
                        addedActions[action] = actions[action];
                    }

                    for (action in addedActions) {
                        this[action] = this._makeCancelable.bind(this, action);
                    }

                    this.resource = $resource(url, params, addedActions);
                },

                _makeCancelable: function (action) {
                    var id = this.promiseId++;
                    this.promises[id] = $q.defer();

                    // drop first argument - action name and leave only action params
                    var resource = this.resource[action].apply(this.resource[action], Array.prototype.slice.call(arguments, 1));
                    resource.timeout = this.promises[id].promise;

                    resource.$promise.then(function (promiseId) {
                        this.promises[promiseId] = null;
                    }.bind(this, id));

                    return resource;
                },

                clearAll: function () {
                    for (var promiseId in this.promises) {
                        if (this.promises[promiseId]) {
                            this.promises[promiseId].resolve();
                            this.promises[promiseId] = null;
                        }
                    }
                }

            });

            return resourceWrapper;
        }])
})();
(function () {
    angular.module('babycompy.base')
        .factory('baseApiService', ['resourceWrapper', 'ApiUrl', 'app',
            function (resourceWrapper, ApiUrl, app) {

                var baseApiService = Class.extend({
                    _baseUrl: '/:apiPrefix/:apiVersion/:controller/:id/:action',
                    _filterHeaderName: 'Filter-Query',

                    init: function (resource) {
                        if (!resource || resource === '') {
                            throw new Error('Resource must be defined');
                        }

                        this.resourceName = resource;
                        this.resource = new resourceWrapper(this._buildUrl(),
                            this._setupParameters(),
                            this._setupCustomActions());
                    },

                    _setupCustomActions: function () {
                        return {
                            'get': {
                                isObject: true
                            },
                            'getDefault': {
                                method: 'GET',
                                isObject: true,
                                params: {
                                    id: app.newEntityPath
                                }
                            },
                            'post': {
                                method: 'POST',
                                isObject: true
                            },
                            'put': {
                                method: 'PUT',
                                isObject: true
                            },
                            'delete': {
                                method: 'DELETE',
                                isObject: true
                            },
                            'exists': {
                                method: 'GET',
                                isObject: true,
                                url: '/:apiPrefix/:apiVersion/:controller/:fieldName/:value/exists'
                            }
                        };
                    },

                    _setupParameters: function () {
                        return {
                            controller: this.resourceName,
                            apiVersion: ApiUrl.version,
                            apiPrefix: ApiUrl.apiPrefix
                        };
                    },

                    _buildUrl: function () {
                        return this._baseUrl;
                    },

                    buildCustomUrl: function (controller, id, action) {
                        return this._baseUrl.
                            replace(':apiPrefix', ApiUrl.apiPrefix).
                            replace(':apiVersion', ApiUrl.version).
                            replace(':controller', controller).
                            replace(':id', id).
                            replace(':action', action);
                    },

                    get: function (params, search) {
                        return this.resource.get(this._prepareSearchParameters(params, search)).$promise;
                    },

                    // no overload here, so use another named fn
                    getById: function (id) {
                        if (id) {
                            return this.resource.get({ id: id }).$promise;
                        }
                    },

                    save: function (entity) {
                        if (!entity.uuid) {
                            return this._postInternal(entity);
                        } else {
                            return this._putInternal(entity);
                        }
                    },

                    post: function (url, entity) {
                      return this.resource.post(url, entity).$promise;
                    },

                    getDefault: function () {
                        return this.resource.getDefault().$promise;
                    },

                    'delete': function (id) {
                        if (id) {
                            return this.resource.delete({ id: id }).$promise;
                        }
                    },

                    exists: function(field, value){
                        return this.resource.exists({
                            fieldName: field,
                            value: value
                        }).$promise;
                    },

                    _postInternal: function (entity) {
                        return this.resource.post(entity).$promise;
                    },

                    _putInternal: function (entity) {
                        return this.resource.put({ id: entity.uuid }, entity).$promise;
                    },

                    put: function (url, entity) {
                      var o = url || {};

                      return this.resource.put(o, entity).$promise;
                    },

                    clearAll: function () {
                        this.resource.clearAll();
                    },

                    _buildFilterQuery: function (search) {
                        return filterQueryBuilder;
                    },

                    _prepareSearchParameters: function (params, search) {
                        if (search && Object.keys(search).length > 0) {
                            params = $.extend(true, params, search);
                        }

                        if (params && params.order && params.order !== '') {
                            params.$orderby = params.order;
                            delete params.order;
                        }

                        return params;
                    }
                });

                return baseApiService;
            }])
})();

(function (params) {
    angular.module('babycompy.base')
        .service('shareButtonsService', ['shareConstants', '$location', '$facebook', function (shareConstants, $location, $facebook) {
            var shareButtonsService = function () {
                var popup = function (url) {
                    window.open(url, '', shareConstants.popupParams);
                };

                var currentDomainName = $location.protocol() + '://' + $location.host();

                return {
                    facebook: function (articleUrl, title, description) {
                        $facebook.ui({
                            display: 'popup',
                            method: 'share',
                            href: articleUrl,
                            message: description,
                            title: title,
                            picture: 'http://babycompy.com/assets/images/social/facebook_600x315.png'
                        }).then(function (response) {
                        })

                    },
                    vkontakte: function (articleUrl, title, description) {
                        url = shareConstants.vkontakteUrl;
                        url += 'url=' + encodeURIComponent(articleUrl);
                        url += '&noparse=false';
                        url += '&description=' + encodeURIComponent(description);
                        url += '&title=' + encodeURIComponent(title);
                        url += '&image=' + encodeURIComponent(currentDomainName + '/assets/images/social/BabyCompy_Social.png');
                        popup(url);
                    },
                    googlePlus: function (articleUrl) {
                        url = shareConstants.googlePlusUrl;
                        url += encodeURIComponent(articleUrl);
                        popup(url);
                    },
                    odnoklassniki: function (purl, description) {
                        url = shareConstants.odnoklassnikiUrl;
                        url += '&st._surl=' + encodeURIComponent(purl);
                        url += '&st.comments=' + encodeURIComponent(description);
                        popup(url);
                    }
                }
            };

            return shareButtonsService();

        }])
        .constant('shareConstants', {
            popupParams: 'toolbar=0,status=0,width=620,height=500',
            facebookUrl: 'http://www.facebook.com/sharer.php?',
            vkontakteUrl: 'http://vkontakte.ru/share.php?',
            googlePlusUrl: 'https://plus.google.com/share?url=',
            odnoklassnikiUrl: 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1'
        });
})();

(function () {
    "use strict"
    angular.module('babycompy.base')
        .directive('shareButtons', ['favoritesService', '$location', 'shareButtonsService', '$alert',
            '$translate', 'favoriteResource', 'enums', 'modalService', 'currentUserService',
            function (favoritesService, $location, shareButtonsService, $alert,
                $translate, favoriteResource, enums, modalService, currentUserService) {

                var showSuccessAlert = function (action) {
                    var showText = '';
                    if (action === enums.favoriteEvents.added) {
                        showText = $translate.instant('favoriteMenuTypes.onAddFavoriteMessage');
                    } else {
                        showText = $translate.instant('favoriteMenuTypes.onDeleteFavoriteMessage')
                    }
                    var successAlert = $alert(
                        {
                            container: 'header',
                            content: showText,
                            placement: 'top',
                            type: 'success',
                            templateUrl: 'app/components/core/templates/alertTemplate.html',
                            show: true,
                            duration: 3
                        });
                };

                return {
                    scope: {
                        showPlace: "@",
                        onlyStar: "=onlyStar",
                        article: '=article',
                        type: '=type',

                    },

                    link: function (scope, elem) {
                        var starClassName = scope.onlyStar ? 'a.add-bookmarks' : 'a.block-add-bookmarks';
                        scope.selected = false;
                        scope.selectFavorite = function () {
                            var button = angular.element(elem.find(starClassName)[0]);
                            var fixMobileAndMozilla = function () {
                                if (navigator.userAgent.search("Firefox") > -1) {
                                    angular.element(button).find('.icon').remove();
                                    angular.element(button).prepend('<svg class="icon star-o"> <use xlink:href="#star-o"></use></svg><svg class="icon star"><use xlink:href="#star"></use></svg>');
                                }
                                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(navigator.userAgent)) {
                                    if (scope.article.favorite != false) {
                                        angular.element(button).find('.icon').remove();
                                        angular.element(button).prepend('<svg style="display:inline-block !important" class="icon star-o"> <use xlink:href="#star-o"></use></svg>');
                                    } else {
                                        angular.element(button).find('.icon').remove();
                                        angular.element(button).prepend('<svg style="display:inline-block !important" class="icon star"><use xlink:href="#star"></use></svg>');
                                    }
                                }
                            }
                            currentUserService.load().then(function (user) {
                                if (user === null) {
                                    modalService.showLoginModal(scope);
                                    return;
                                }
                                if (button.hasClass('active')) {
                                    favoritesService.delete(scope.article.uuid).then(function (response) {
                                        button.removeClass('active');
                                        fixMobileAndMozilla();
                                        scope.article.favorite = false;
                                        showSuccessAlert(enums.favoriteEvents.deleted);
                                        return response;
                                    });
                                } else {
                                    favoriteResource.selectAsFavorite(scope.article.uuid, scope.type).then(function (response) {
                                        button.addClass('active');
                                        fixMobileAndMozilla();
                                        favoritesService.onAddFavorite();
                                        scope.article.favorite = true;
                                        showSuccessAlert(enums.favoriteEvents.added);
                                        return response;
                                    });
                                }
                            });

                            return false;
                        };
                        if (navigator.userAgent.search("Firefox") > -1) {
                            scope.$watch('article', function (newValue, oldValue) {
                                var button = angular.element(elem.find(starClassName)[0]);
                                angular.element(button).find('.icon').remove();
                                angular.element(button).prepend('<svg class="icon star-o"> <use xlink:href="#star-o"></use></svg><svg class="icon star"><use xlink:href="#star"></use></svg>');

                            });
                        }

                    },

                    controller: ['$scope', 'favoritesService', '$translate', function ($scope, favoritesService, $translate) {


                        var title = $scope.article.name,
                            description = $translate.instant('general.shareDescription');

                        $scope.shareVK = function () {
                            shareButtonsService.vkontakte($location.absUrl(), title, description);
                        };

                        $scope.shareFB = function () {
                            shareButtonsService.facebook($location.absUrl(), title, description);
                        };

                        $scope.shareOK = function () {
                            shareButtonsService.odnoklassniki($location.absUrl(), description);
                        };

                        $scope.shareGooglePlus = function () {
                            shareButtonsService.googlePlus($location.absUrl());
                        };

                    }],

                    templateUrl: 'app/components/core/directives/shareButtons/shareButtons.html',
                }
            }])
})();

angular.module('babycompy.base').directive('imageGalleryWrapper', ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            images: "=",
            altTitle: "=",
            galWidth:"@",
            galHeight: "@",
            scaleMode: "=?",
            aspectRatio: "=?"
        },
        templateUrl: 'app/components/core/directives/imageGalleryWrapper/imageGallery.html',
        link: function (scope, element, attr) {
            scope.$watch('images', function (imgArray) {
                if (imgArray && imgArray.length > 0) {
                    var defaultOptions;

                    if (imgArray.length == 1) {
                        defaultOptions = {
                            fade: false,
                            arrows: false,
                            buttons: false,
                            fullScreen: true,
                            shuffle: false,
                            thumbnailArrows: false,
                            autoplay: false,
                            touchSwipe: false,
                            fadeArrows: false,
                            aspectRatio: 1,
                            imageScaleMode: 'cover',
                            centerImage: true
                        };
                    } else {
                        defaultOptions = {
                            fade: false,
                            arrows: true,
                            buttons: false,
                            fullScreen: true,
                            shuffle: false,
                            thumbnailArrows: true,
                            autoplay: false,
                            touchSwipe: true,
                            fadeArrows: false,
                            aspectRatio: 1,
                            imageScaleMode: 'cover',
                            centerImage: true
                        };
                    }

                    defaultOptions.width = scope.galWidth;
                    defaultOptions.height = scope.galHeight;

                    if(!!scope.aspectRatio) {
                      defaultOptions.aspectRatio = scope.aspectRatio;
                    }

                    if(!!scope.scaleMode) {
                      defaultOptions.imageScaleMode = scope.scaleMode;
                    }

                    $timeout(function () {
                        angular.forEach(imgArray, function(image) {
                            if(!!!image.title) {
                                image.title = scope.altTitle;
                            }
                            if(!!!image.alt) {
                                image.alt = scope.altTitle;
                            }
                        });

                        var slidePro = element.sliderPro(defaultOptions);
                        //slider broke down swipe left if has only two images
                        //so make manual looping
                        var slider = slidePro.data('sliderPro');
                        if (imgArray.length === 2) {
                            var gotoSlideOr = slider.gotoSlide;
                            slider.gotoSlide = function (index) {
                                var selectedSlideIndex = slider.getSelectedSlide();
                                selectedSlideIndex = selectedSlideIndex == 0 ? 1 : 0;
                                gotoSlideOr.apply(slider, [(index == undefined ? selectedSlideIndex : index)])
                            }
                        }

                        // trigger full screen button
                        if(angular.element('.sp-full-screen-button').length > 0) {
                            var spSlides = angular.element('.sp-slides');

                            spSlides.addClass('sp-slides-pointer');
                            spSlides.on('dblclick', function () {
                                angular.element('.sp-full-screen-button').trigger('click');
                            })
                        }

                    }, 0);
                }
            });
        }
    };
}]);

(function () {
  "use strict";
  angular.module('babycompy.base')
    .directive('fbWidgetLike', ['$window', function ($window) {
        return {
          restrict: 'EA',
          scope: true,
          controller: ['$scope', '$element', '$attrs', '$rootScope', function (scope, element, attrs, $rootScope) {

            var FbWidget = function () {

              this.token = "babyCompy.fbWidgetLike";
              this.container = document.querySelectorAll(attrs.scrollElement)[0];

              $rootScope.$on('$stateChangeSuccess', function () {
                if (!this.checkStorage()) {
                  scope.fbLikeShow = true;
                }
              }.bind(this));

              angular.element($window).bind("load", function () {
                this.setShow();
              }.bind(this));

              angular.element($window).bind("scroll", function () {
                setTimeout(function () {
                  if (($window.pageYOffset + $window.innerHeight) >= this.container.getBoundingClientRect().height) {
                    scope.boolChangeClass = true;
                    scope.$apply();
                  }
                }.bind(this), 300)
              }.bind(this));

            };

            FbWidget.prototype.setShow = function () {
              scope.fbLikeShow = this.checkStorage() ? JSON.parse(localStorage.getItem(this.token)) : true;
            };

            FbWidget.prototype.checkStorage = function () {
              if ($window.localStorage) {
                return localStorage.getItem('babyCompy.fbWidgetLike') !== null;
              } else {
                return false;
              }
            };

            FbWidget.prototype.hide = function () {
              if ($window.localStorage) {
                scope.fbLikeShow = false;
                localStorage.setItem("babyCompy.fbWidgetLike", false);
              }
            };

            FbWidget.prototype.close = function () {
              scope.fbLikeShow = false;
              scope.boolChangeClass = false;
            };

            return new FbWidget();

          }],
          controllerAs: 'fbLike',
          templateUrl: 'app/components/core/directives/fbWidgetLike/fbWidgetLike.html'
        }
      }])
})();

(function () {
    angular.module('babycompy.base')
        .directive('birthdaySelect', ['birthdaySelectFactory', '$locale', function (birthdaySelectFactory, $locale) {

            return {
                require: 'ngModel',

                templateUrl: 'app/components/core/directives/birthdayDirective/birthdayTemplate.html',

                link: function (scope, element, attr, ctrl) {

                    ctrl.$render = function () {
                        if (ctrl.$modelValue && ctrl.$modelValue.getTime() != 0) {
                            var date = ctrl.$modelValue;
                            scope.birthYear = date.getFullYear();
                            scope.birthMonth = scope.months[date.getUTCMonth()];
                            scope.birthDay = date.getUTCDate();
                            var children = angular.element('#birthday-select').children();
                            for (var i = 0; i < children.length; i++) {
                                angular.element(children[i]).find('select').removeClass('empty');
                            }
                        }
                    };

                    scope.$watchGroup(['birthMonth', 'birthYear'], function (newValue, oldValue) {
                        for (var i = 0; i < scope.months.length; ++i) {
                            if (scope.months[i] === newValue[0]) {
                                break;
                            }
                        }

                        scope.dayRange = scope.setDaysInMonth(++i, newValue[1]);
                    });


                    ctrl.$validators.isNotInPast = function (modelValue, viewValue) {
                        if (!modelValue) {
                            return true;
                        }

                        return birthdaySelectFactory.isInPast(modelValue);
                    };

                    var datetime = $locale.DATETIME_FORMATS;
                    scope.yearsRange = birthdaySelectFactory.getYears();
                    scope.months = datetime.MONTH;

                    scope.onDataChange = function () {
                        if (scope.birthYear && scope.birthMonth && scope.birthDay) {
                            ctrl.$setViewValue(new Date(scope.birthYear, scope.months.indexOf(scope.birthMonth),
                                scope.birthDay, 1),
                                'onDataChange');
                        } else {
                            ctrl.$setViewValue(null);
                        }
                    };

                    scope.setDaysInMonth = function (selectedMonth, selectedYear) {

                        return birthdaySelectFactory.getDays(selectedMonth, selectedYear);
                    };
                }


            }
        }]);
})();
(function () {
    angular.module('babycompy.base')
        .factory('birthdaySelectFactory', [function () {

            var BirthdaySelectFactory = function () {
            };

            BirthdaySelectFactory.prototype.getDays = function (month, year) {
                var days = [],
                    zeroDay = 0;

                var daysInMoth;
                if (isNaN(year)) {
                    daysInMoth =  31;
                }else{
                    daysInMoth = new Date(year, month, 0).getDate()
                }

                while (days.length < daysInMoth) {
                    days.push(++zeroDay);
                }
                return days;
            };

            BirthdaySelectFactory.prototype.getYears = function () {
                var currentYear = new Date().getFullYear(),
                    years = [],
                    count = 100;

                while (count) {
                    years.push(currentYear--);
                    --count;
                }
                return years;
            };

            BirthdaySelectFactory.prototype.isInPast = function (selectedDate) {
                var currentDate = new Date();
                return currentDate.getTime() > selectedDate.getTime();
            };

            return new BirthdaySelectFactory();

        }])
})();
(function () {
    angular.module('babycompy.base')
        .directive('ageDisplay', ['$translate', '$parse', function ($translate, $parse) {

            return {
                restrict: 'A',

                link: function ($scope, tElement, attrs) {
                    attrs.$observe('ageDisplay', function (dateStr) {
                        if(dateStr){
                            var currDate = moment();
                            var date  = new Date(dateStr);
                            var monthCount = currDate.diff(date, 'month');
                            var text = '';
                            var yearsCount;
                            if(monthCount >= 12){
                                yearsCount = Math.floor(monthCount / 12);
                                monthCount = monthCount - 12 * yearsCount;
                                text = $translate.instant('general.yearsCount', {years: yearsCount}) + ' ';
                            }

                            if(monthCount > 0) {
                                text += $translate.instant('general.monthCount', {month: monthCount});
                            }

                            if(!yearsCount && monthCount == 0) {
                                var daysCount =  currDate.diff(date, 'days');;
                                text = $translate.instant('general.daysCount', {days: daysCount});
                            }

                            tElement.text(text);
                        }
                    });
                }
            }
        }]);
})();
(function (angular) {
  angular.module('babycompy.base')
    .directive('avatar', function () {
      return {
        restrict: 'E',
        scope: {
          photo: '='
        },
        templateUrl: 'app/components/core/directives/avatarDirective/avatar-template.html',
        link: function (scope, elem, attrs) {
          scope.noModal = typeof attrs.noModal !== 'undefined';

          scope.setPath = function () {
            if (scope.photo && typeof scope.photo == 'string') {
              if (scope.photo.indexOf("http") >= 0) {
                scope.avatarPath = scope.photo;
              } else {
                scope.avatarPath = "/api/v1/files/" + scope.photo;
              }
            } else {
              scope.avatarPath = "/assets/images/user-no-photo.png";
            }
          };

          scope.setPath();
        },
        controller: ['$scope', 'modalService', 'currentUserService', '$q', 'profileService', '$translate', '$rootScope', 'updateProfileService',
          function ($scope, modalService, currentUserService, $q, profileService, $translate, $rootScope, updateProfileService) {
            $scope.fileWrapper = {
              fileAdded: function ($event, flowFile) {
                var file = flowFile.file[0];
                profileService.checkUploadingImage(file).then(function () {
                  if ($scope.noModal) {
                    updateProfileService.updateImage(file, file.name).then(function (response) {
                      $scope.photo = response.content.uuid;
                      $scope.setPath();
                    });
                  } else {
                    $scope.showAvatarEditModal(file);
                  }
                }, function (reason) {
                  modalService.showErrorAlert({
                    title: $translate.instant('userProfile.avatarUpload'),
                    message: reason.message
                  });
                });
              }
            };

            $scope.removeAvatar = function () {
              $scope.photo = null;
              $rootScope.$broadcast('avatarChanged', null);
            };

            $scope.$on('avatar.delete', function (event, uuid) {
              updateProfileService.deleteImage(uuid);
            });

            $scope.editAvatar = function () {
              $scope.fileWrapper.openFile();
            };

            $scope.showAvatarEditModal = function (file) {
              modalService.open({
                scope: $scope,
                template: 'app/components/core/directives/avatarDirective/avatarModal/avatar.modal.html',
                controller: 'profileAvatarModalController as c',
                show: true,
                backdrop: 'static',
                resolve: {
                  file: function () {
                    return $q.when(file);
                  }
                }
              }).result.then(function (entity) {
                $scope.photo = entity.uuid;
                $scope.avatarPath = "/api/v1/files/" + $scope.photo;
                $rootScope.$broadcast('avatarChanged', entity.uuid);
              }.bind(this))
            }
          }]
      }
    });
})(angular);

angular.module('babycompy.base')
    .directive('appBadge', ['$cookies','$cookieStore','$state', function ($cookies, $cookieStore, $state) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                scope.showBadge = true;
                $cookieStore.get('appBadge') === undefined ? scope.key = true : scope.key = false;
                scope.closeBadge = function () {
                    scope.showBadge = false;
                    $cookieStore.put('appBadge', 'false');
                    scope.key = $cookieStore.get('appBadge');
                };
                scope.$on('$stateChangeSuccess', function () {

                    var headerHeight = angular.element('.header').innerHeight();
                    var promoBlockHeight = angular.element('.promo-block').innerHeight();
                    var heightUp = 0;
                    if ($state.is('index')) {
                        heightUp = promoBlockHeight + headerHeight + 54 + 83;
                    } else if ($state.includes('index.profile.user')) {
                        heightUp = promoBlockHeight + headerHeight + 390;
                    } else {
                        heightUp = headerHeight + 54 + 83;
                    }
                    element.css('top', heightUp);

                    var appBadgeTop = element.css('top');
                    $(window).scroll(function(){
                        if ($(this).scrollTop() > ((parseInt(appBadgeTop)) - headerHeight)){
                            element.css({'top': headerHeight, 'position':'fixed'})
                        } else {
                            element.css({'top': heightUp, 'position':'absolute'});
                        }

                    });
                });



            },
            templateUrl: 'app/components/core/directives/appBadge/appBadge.html'
        };
}]);

angular.module('babycompy.content.common')
    .directive('upgrowthCategoriesContent', ['categoriesContentService', 'upgrowthService',
        function (categoriesContentService, upgrowthService) {


            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    categories: '=',
                    nestedStateName: '@',
                    paramName: '@',
                    columnNumber: '=?',
                    order: '@'
                },

                templateUrl: 'app/components/content/upgrowth/directive/upgrowth.columns.html',

                link: function (scope, el, attrs) {

                    scope.emitTransitionEvent = function () {
                        scope.$emit('articleSelected');
                    }

                    var readyCategories = upgrowthService.processCategories(scope.categories, scope.nestedStateName, scope.paramName);

                    scope.rows = categoriesContentService.getRows(readyCategories, scope.order, undefined, true);

                }
            }
        }]);
(function () {
    'use strict';

    angular.module('babycompy.content.upgrowth.categories', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function () {
    angular.module('babycompy.content.upgrowth.categories')
        .controller('upgrowthCategoriesController', ['baseContentCategoriesController', '$scope',
            'categoryArticleContent', 'ageSearchResult', '$state', 'aticleAgeParent', 
            'customPaging', 'upgrowthService', 'enums', '$filter', 'seoService',
            function (baseContentCategoriesController, $scope,
                      categoryArticleContent, ageSearchResult, $state, aticleAgeParent,
                      customPaging, upgrowthService, enums, $filter, seoService) {

                var UpgrowthCategoriesController = baseContentCategoriesController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 10;

                        this._super.apply(this, arguments);
                        this.favoriteType = enums.selectFavoriteTypes.articles;
                        this.parentCategories = upgrowthService.processCategories(ageSearchResult.items);
                        this.arrayOfParents =[]; // parentsChain(this.returnedContent).reverse();
                        this.notes = categoryArticleContent.notes;
                        this.arrayOfParents.push({
                            name: $filter('translate')('main.main'),
                            href: '/'
                        });

                        this.arrayOfParents.push({
                            name: aticleAgeParent.title,
                            href: $state.href('index.upgrowth', {
                                age: aticleAgeParent.childAges[0],
                                childAges: aticleAgeParent.childAges.length > 1
                                    ? aticleAgeParent.childAges: null
                            })
                        });

                        this.customPaging = new customPaging();

                        var current =  this.parentCategories.filter(function(item) {
                            return item.uuid === categoryArticleContent.uuid})[0];

                        //upgrowthService.processCategories(categories);
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset,
                            this.parentCategories, current);
                        
                        if(!!this.returnedContent.parent && this.returnedContent.parent !== null) {
                            seoService.title(this.returnedContent.parent.name, categoryArticleContent.name, this.returnedContent.metaTags);
                        } else {
                            seoService.title(categoryArticleContent.name, categoryArticleContent.name, this.returnedContent.metaTags);
                        }
                        seoService.description(categoryArticleContent.name, this.returnedContent.metaTags);
                        seoService.keywords(this.returnedContent.metaTags);
                        
                    },

                    extractVisibleParent: function() {
                        return this.customPaging.extractVisibleSupplements();
                    }

                });

                return new UpgrowthCategoriesController($scope, categoryArticleContent);

            }]);
})();

angular.module('babycompy.content.upgrowth.categories')
    .directive('upgrowthCategoriesLeftSideList', [
        'upgrowthService', 'enums', '$translate', '$q',
        function (upgrowthService, enums, $translate, $q) {
            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    categories: '=',
                    pagingParameters: '=?',
                    loadMore: '=',

                    nestedStateName: '@',
                    paramName: '@',
                    pagingTotal: '=?',
                    usePaging: '=?',

                },
                templateUrl: 'app/components/content/upgrowth/categories/upgrowth.categories.template.html',

                link: function (scope, el, attrs) {
                    scope.$watch('categories', function (categories) {
                        if (!categories) {
                            return;
                        }

                        scope.readyCategories = upgrowthService.processCategories(categories);

                    });

                    scope.emitTransitionEvent = function () {
                        scope.$emit('articleSelected');
                    }
                }
            }
        }
    ]);
(function () {
    'use strict';

    angular
        .module('babycompy.content.upgrowth.categories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.upgrowth.categories', {
            url: '/:categoryUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/upgrowth/categories/categories.html',
                    controller: 'upgrowthCategoriesController',
                    controllerAs: 'c'
                },

                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller: 'upgrowthCategoriesController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                categoryArticleContent: ['contentCategoriesResource', '$stateParams', function (contentCategoriesResource, $stateParams) {
                    var childAges = $stateParams.childAges || [$stateParams.age];
                    return contentCategoriesResource.loadSubCategories(
                        $stateParams.categoryUUID, { childAges: childAges }).then(function (response) {

                            response.content.childs = response.content.childs.filter(function(item) {
                                item.childExists = item.hasChilds;
                                return !item.childExists;
                            });

                            return response.content;
                        });
                }],

                aticleAgeParent: ['$stateParams', 'upgrowthService',
                    function ($stateParams, upgrowthService) {
                        var childAges = $stateParams.childAges || [$stateParams.age];

                        return upgrowthService.getAgeTitle(childAges).then(function (title) {
                            return {
                                title: title,
                                childAges: childAges
                            };
                        })
                    }]
            },

            breadcrumb: ""
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.news', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'dotdotdot-angular',
        'babycompy.content.news.article'
    ]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.content.news').directive('newsBlock',
        ['newsService', function(newsService) {
            return {
                restrict: 'E',
                templateUrl: 'app/components/content/news/newsBlock/newsBlock.html',
                replace: true,

                link: function($scope) {
                    newsService.load().then(function(newsItems) {
                        $scope.news = newsItems.slice(0, 2);
                        $scope.more = newsItems[2];
                    })
                }
            }
        }]
        );

})();
(function () {
    'use strict';

    angular.module('babycompy.content.news.article', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function (angular) {
    angular.module('babycompy.content.news.article')
        .directive('newsCategoriesLeftSideList', [function () {
            return {
                restrict: 'E',
                replace: true,
                // transclude: true,
                scope: {
                    categories: '=',
                    pagingParameters: '=?',
                    loadMore: '=',

                    nestedStateName: '@',
                    paramName: '@',
                    pagingTotal: '=?',
                    usePaging: '=?',
                },
                templateUrl: 'app/components/content/news/article/newsCategoriesLeftSide.template.html',

                link: function (scope, el, attrs) {

                    scope.$watch('categories', function (categories) {
                        if (!categories) {
                            return;
                        }

                        scope.readyCategories = scope.categories.map(function (category) {
                            category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                            return category;
                        });
                    });

                    scope.emitTransitionEvent = function () {
                        scope.$emit('articleSelected');
                    };
                }
            }
        }]);

})(angular);

(function () {
    angular.module('babycompy.content.news.article')
        .controller('newsArticleController', ['baseContentCategoriesController', '$scope', '$translate', '$location',
            'articleContent', '$state', '$filter', 'newsItems', 'customPaging', 'enums', 'seoService',
            function (baseContentCategoriesController, $scope, $translate, $location, 
                articleContent, $state, $filter, newsItems, customPaging, enums, seoService) {

                var NewsArticleController = baseContentCategoriesController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 5;

                        this._super.apply(this, arguments);
                        this.content = articleContent.description || '';
                        this.article = articleContent;
                        this.images = articleContent.images;
                        this.date = articleContent.date
                        this.favoriteType = enums.selectFavoriteTypes.news;

                        this.parentCategories = newsItems;

                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset,
                            this.parentCategories,
                            articleContent);

                        $translate('news.news').then(function (translations) {
                            seoService.title(translations, articleContent.name, articleContent.metaTags);
                            seoService.description(articleContent.name, articleContent.metaTags);
                            seoService.keywords(articleContent.metaTags);
                            seoService.ogDescription($filter('htmlToPlaintext')(articleContent.description).substring(0, 300));
                            if(!!articleContent.images && articleContent.images.length > 0) {
                                seoService.ogImage($location.protocol() + '://' + $location.host() + '/api/v1/files/' + articleContent.images[0].link);
                            }
                        });

                    },

                    extractVisibleNews: function () {
                        return this.customPaging.extractVisibleSupplements();
                    }


                });

                return new NewsArticleController($scope, articleContent);

            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.news.article')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.news.article', {
            url: '/:uuid',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/news/article/news.article.html',
                    controller: 'newsArticleController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                articleContent: ['newsResource', '$stateParams', function (newsResource, $stateParams) {
                    return newsResource.getNews($stateParams.uuid).then(function (response) {
                        return response.content;
                    });
                }]
            }
        });
    }
})();

(function () {
    'use strict';

   angular.module('babycompy.content.medicine', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.medicine.medicineCategories'
        
    ]);
})();
angular.module('babycompy.content.medicine')
    .directive('medicineSearch', ['medicineResource', function (medicineResource) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                
            },
            templateUrl: 'app/components/content/medicine/medicineSearch/medicineSearch.template.html',

            controller: ['$scope', function($scope) {
                $scope.search = function(searchStr) {
                    return medicineResource.search(searchStr).then(function(response) {
                        $scope.searchResults = response.content.items;
                    });
                }
            }]
        }
    }]);
(function () {
    'use strict';

   angular.module('babycompy.content.medicine.medicineCategories', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.medicine.medicineCategories.article'
    ]);
})();
(function () {
    angular.module('babycompy.content.medicine.medicineCategories')
        .controller('medicineCategoriesController', ['baseCategoriesController', '$scope', 'parentCategories',
            'subCategories', 'customPaging', 'selectedCategory', 'medicines', '$translate', 'seoService',
            function (baseCategoriesController, $scope, parentCategories, subCategories,
                customPaging, selectedCategory, medicines, $translate, seoService) {
                // dependencies will be resolved during page load in the route definition

                var MedicineCategoriesController = baseCategoriesController.extend({
                    init: function () {
                        var offset = 0,
                            limitLeft = 10,
                            limitSubCategories = 10;

                        this.medicines = medicines;
                        this.subCategories = subCategories.items;
                        this.categories = parentCategories;
                        this.customPagingLeft = new customPaging();
                        this.customPagingSubCategories = new customPaging();
                        this.pagingParametersLeft = this.customPagingLeft.getPagingParameters(limitLeft, offset, parentCategories, selectedCategory);
                        this.pagingSubCategories = this.customPagingSubCategories.getPagingParameters(limitSubCategories, offset, this.subCategories);
                        this.titleName = selectedCategory.name;
                        $translate('medicine.knowMore').then(function (translations) {
                            seoService.title(translations, this.titleName);
                            seoService.description(this.titleName);
                        }.bind(this));

                        this._super.apply(this, arguments);
                    },

                    extractVisibleSupplements: function () {
                        return this.customPagingLeft.extractVisibleSupplements();
                    },

                    extractVisibleSubCategories: function () {
                        return this.customPagingSubCategories.extractVisibleSupplements();
                    }
                });

                return new MedicineCategoriesController($scope, subCategories);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.medicine.medicineCategories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medicine.medicineCategories', {
            url: '/:categoryUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/medicine/medicineCategories/medicineCategories.html',
                    controller: 'medicineCategoriesController',
                    controllerAs: 'c'
                },

                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller: 'medicineCategoriesBreadcrumbController',
                    controllerAs: 'c'
                }
            },

            resolve: {
                subCategories: ['$stateParams', 'medicineResource',
                    function ($stateParams, medicineResource) {
                        return medicineResource.loadSubCategories($stateParams.categoryUUID)
                            .then(function (response) {
                                return response.content;
                            });
                    }],

                medicines: ['$stateParams', 'medicineResource', 'subCategories',
                    function ($stateParams, medicineResource, subCategories) {
                        if (subCategories.items.length === 0) {
                            return medicineResource.medicines($stateParams.categoryUUID)
                                .then(function (response) {
                                    return response.content.items;
                                });
                        }

                        return [];
                    }],

                selectedCategory: ['subCategories', '$stateParams', 'parentCategories', function (subCategories, $stateParams, parentCategories) {
                    var selected = parentCategories.filter(function (c) {
                        return c.uuid === $stateParams.categoryUUID
                    })[0];

                    subCategories.name = selected.name;
                    subCategories.uuid = selected.uuid;

                    return subCategories;
                }],

                parentCategories: ['$stateParams', 'medicineResource', 'subCategories',
                    function ($stateParams, medicineResource, subCategories) {
                       if(subCategories.parent) {
                           return medicineResource.loadSubCategories(subCategories.parent.uuid)
                               .then(function (response) {
                                   return response.content.items;
                               });
                       }else{
                           return medicineResource.loadTopCategories().then(function (response) {
                               return response.content.items;
                           });
                       }
                    }]
            },

            breadcrumb: '{{selectedCategory.name}}'
        });
    }
})();

(function () {
    angular.module('babycompy.content.medicine.medicineCategories')
        .controller('medicineCategoriesBreadcrumbController', ['baseController', '$scope',
            'selectedCategory', '$state', '$filter', 'enums',
            function (baseController, $scope, selectedCategory, $state, $filter, enums) {
                var parentsArray = [],
                    state = '';

                var parentsChain = function (entity) {
                    if (entity !== null) {
                        parentsArray.push({
                            name: entity.name,
                            href: $state.href('index.medicine.medicineCategories',
                                { categoryUUID: entity.uuid })
                        });
                        parentsChain(entity.parent);
                    }

                    return parentsArray;
                };

                var MedicineCategoriesBreadcrumbController = baseController.extend({

                    init: function () {
                        this._super.apply(this, arguments);
                        this.arrayOfParents = [{
                            name: $filter('translate')('main.main'),
                            href: '/'
                        }];

                        this.arrayOfParents.push({
                            name: $filter('translate')('menu.medication'),
                            href: $state.href('index.medicine')
                        });

                        this.arrayOfParents =  this.arrayOfParents
                            .concat(parentsChain(selectedCategory.parent).reverse());
                    }

                });

                return new MedicineCategoriesBreadcrumbController($scope);
            }]);
})();
(function () {
    'use strict';

    // food & supplements
    angular.module('babycompy.content.food.supplementsCategories', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
    
    angular.module('babycompy.content.food', [
        'babycompy.content.food.supplementsCategories',
        'babycompy.content.food.supplements',
        'babycompy.content.food.supplements.supplement',
        'babycompy.content.food.productsCategories'
    ]);
})();
/* global angular */
(function (angular) {
    angular.module('babycompy.content.food.supplementsCategories')
        .factory('supplementsCategoriesResource', ['categoriesResource', function (categoriesResource) {

                var SupplementsCategoriesResource = categoriesResource.extend({
                    _setupCustomActions: function() {
                        var o = this._super();
                        
                        o.details = {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'detail'
                            }
                        };
                        
                        return o;
                    },
                    
                    details: function(uuid) {
                        return this.resource.details({id: uuid}).$promise;
                    }
                });

                return new SupplementsCategoriesResource('supplementsCategory');
            }]);
})(angular);
(function () {
    angular.module('babycompy.content.food.supplementsCategories')
        .controller('supplementsCategoriesController', ['baseCategoriesController', '$scope', 'supplementsCategories', 
        function (baseCategoriesController, $scope, supplementsCategories) {
            // dependencies will be resolved during page load in the route definition

            var SupplementsCategoriesController = baseCategoriesController.extend({
            });

            return new SupplementsCategoriesController($scope, supplementsCategories);
        }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.food.supplementsCategories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.supplementsCategories', {

            url: '/supplementsCategories',
            breadcrumb: '{{ "food.supplement" | translate }}',

            //'productsCategory@index.contentCategories.contentSubcategories.food': {
            //    templateUrl: 'app/components/content/food/productsCategories/productsCategories.html',
            //    controller: 'productsCategoriesController',
            //    controllerAs: 'c'
            //},
            //
            //'supplements@index.contentCategories.contentSubcategories.food': {
            //    templateUrl: 'app/components/content/food/supplementsCategories/supplementsCategories.html',
            //    controller: 'supplementsCategoriesController',
            //    controllerAs: 'c'
            //}
        });
    }
})();

/* global angular */
(function (angular) {
    angular.module('babycompy.content.food.supplements')
        .factory('supplementsResource', ['contentResource', function (contentResource) {

                var SupplementsResource = contentResource.extend({
                    _setupCustomActions: function() {
                        var o = this._super();
                        o.welcomeText = {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'welcome'
                            }
                        };

                        o.supplementProducts = {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'products'
                            }
                        };
                        
                        return o;
                    },
                    
                    loadWelcomeText: function() {
                        return this.resource.welcomeText().$promise;
                    },
                    
                    search: function(searchStr) {
                        return this.get({ query: searchStr });
                    },

                    searchWithCancel: function (searchStr) {
                        var request =  this.resource.get({ query: searchStr });
                        return {
                            $promise: request.$promise,
                            cancel: request.timeout
                        };
                    },

                    getSupplementProducts: function(productUuid){
                        return this.resource.supplementProducts({id: productUuid}).$promise;
                    }
                });

                return new SupplementsResource('supplements');
            }]);
})(angular);
(function () {
    angular.module('babycompy.content.food.supplements')
        .controller('supplementsController', ['baseCategoriesController', '$scope', 'supplementsCategories',
            'categoryListTitle',
            function (baseCategoriesController, $scope, supplementsCategories, categoryListTitle) {
                // dependencies will be resolved during page load in the route definition

                var SupplementsController = baseCategoriesController.extend({
                    init: function() {
                        this._super.apply(this, arguments);
                        this.categoryListTitle = categoryListTitle;
                        $scope.$emit('switchSupplement', true);
                    }
                });

                return new SupplementsController($scope, supplementsCategories);
            }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.food.supplements')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.supplementsCategories.supplements', {
            url: '/:supplementCategoryUUID/supplements',
            views: {
                'productsCategory@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/productsCategories.html',
                    controller: 'productsCategoriesController',
                    controllerAs: 'c'
                },
                'supplements@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/supplementsCategories/supplementsCategories.html',
                    controller: 'supplementsCategoriesController',
                    controllerAs: 'c'
                },
                'content@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/supplements/details/details.html',
                    controller: 'supplementsCategoriesDetailsController',
                    controllerAs: 'c'
                },
            },

            breadcrumb: '{{details.name}}',

            resolve: {
                allCategories: ['$stateParams', 'supplementsCategoriesResource', function ($stateParams, supplementsCategoriesResource) {
                    return supplementsCategoriesResource.loadSubCategories($stateParams.supplementCategoryUUID).then(function (response) {
                        return response.content.items;
                    });
                }],

                details: ['$stateParams', 'supplementsCategoriesResource', function ($stateParams, supplementsCategoriesResource) {
                    return supplementsCategoriesResource.details($stateParams.supplementCategoryUUID).then(function (response) {
                        return response.content;
                    });
                }],

                categoryListTitle: ['$translate', function ($translate) {
                    return $translate("food.supplement").then(function (result) {
                        return result;
                    });
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.food.supplements.supplement', ['babycompy.categories.common', 'babycompy.content.common']);
})();
(function () {
    angular.module('babycompy.content.food.supplements.supplement')
        .controller('supplementController', ['baseContentController', '$scope', 'content',
         'allCategories', 'customPaging','enums', 'categoryListTitle', 'supplementProducts', 'seoService',
        function (baseContentController, $scope, content, allCategories, customPaging, enums, categoryListTitle,
                  supplementProducts, seoService) {
            // dependencies will be resolved during page load in the route definition

            var SupplementController = baseContentController.extend({
                init: function() {
                    var offset = 0,
                        limit = 10;

                    this._super.apply(this, arguments);
                    this.customPaging = new customPaging();
                    this.allCategories = allCategories;
                    this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.allCategories, content);
                    this.favoriteType = enums.selectFavoriteTypes.supplements;
                    this.categoryListTitle = categoryListTitle;

                    this.supplementProducts = supplementProducts;
                    this.productsPaging = new customPaging();
                    this.supplementproductsPagingParameters = this.productsPaging
                        .getPagingParameters(limit, offset, this.supplementProducts);
                        
                    seoService.title(categoryListTitle, content.name);
                    seoService.description(content.name);

                },
                
                extractVisibleSupplements: function() {
                    return this.customPaging.extractVisibleSupplements();
                }
            });

            return new SupplementController($scope, content);
        }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.food.supplements.supplement')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement', {
            url: '/:supplementUUID',
            views: {
                'content@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/supplement/supplement.html',
                    controller: 'supplementController',
                    controllerAs: 'c'
                },

                'categories@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/supplement/supplements.html',
                    controller: 'supplementController',
                    controllerAs: 'c'
                },
            },
            breadcrumb: '{{content.name}}',

            resolve: {
                content: ['$stateParams', 'supplementsResource', function ($stateParams, supplementsResource) {
                    return supplementsResource.loadArticle($stateParams.supplementUUID).then(function (response) {
                        return response.content;
                    });
                }],

                supplementProducts: ['$stateParams', 'supplementsResource', function ($stateParams, supplementsResource) {
                    return supplementsResource.getSupplementProducts($stateParams.supplementUUID).then(function (response) {
                        return response.content.items;
                    });
                }],

                categoryListTitle: ['details', function (details) {
                    return details.name;
                }],
            },
        });
    }
})();

angular.module('babycompy.content.food')
    .directive('searchSupplement', ['supplementsResource', 'productsCategoriesResource', '$state', '$rootScope', 
        function(supplementsResource, productsCategoriesResource, $state, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            templateUrl: 'app/components/content/food/searchSupplement/searchSupplement.template.html',
            link: function(scope, element, attr) {
                angular.element('body').bind('click', function(event) {
                    var isClickedElementChildOfPopup = element
                        .find(event.target)
                        .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    if ($state.current.name.indexOf('index.contentCategories.contentSubcategories.food') >= 0) {
                        scope.$apply(function() {
                            scope.searchResults = [];
                            scope.tempSearchString = null;
                        });
                    }
                });

                $rootScope.$on('$stateChangeSuccess', function() {
                    scope.searchString = '';
                });
            },
            controller: ['$scope', function($scope) {
                $scope.showReset = false;
                $scope.isLoading = false;
                var request = null;

                var isSupplements = function(searchStr) {
                    return searchStr.match(/(^[\d]+$)|([EЕеe][\d]+)/);
                };

                var _redrawSearchIconInFirefox = function () {
                    if (navigator.userAgent.search("Firefox") > -1) {
                        var searchQuery = angular.element('#searchBox').val();
                        if(!!!searchQuery || $scope.showReset === null) {
                            angular.element('#resetButton').find('.icon').remove();
                        }else if(!!searchQuery || $scope.showReset == true) {
                            angular.element('#resetButton').find('.icon').remove();
                            angular.element('#resetButton').prepend('<svg class="icon"><use xlink:href="#close"></use></svg>');
                        }
                    } 
                };

                var _removeSearchIconInFirefox = function () {
                    if (navigator.userAgent.search("Firefox") > -1) {
                        angular.element('#resetButton').find('.icon').remove();
                    }
                };

                $scope.clearTextBox = function() {
                    angular.element('#searchBox').val('');
                };

                $scope.search = function(searchStr) {
                    $scope.tempSearchString = searchStr;
                    $scope.showReset = !!searchStr;
                    _redrawSearchIconInFirefox();
                    if (!searchStr) {
                        $scope.searchResults = [];
                        return;
                    }

                    var resource;
                    if (isSupplements(searchStr)) {
                        String.prototype.replaceAt = function(index, character) {
                            return this.substr(0, index) + character + this.substr(index + character.length);
                        }
                        if (!searchStr.match(/(^[\d]+$)/)) {
                            searchStr = searchStr.replaceAt(0, 'E');
                        }
                        $scope.requestType = 'supplements';
                        resource = supplementsResource;
                    } else {
                        $scope.requestType = 'products';
                        resource = productsCategoriesResource;
                    }

                    if (request) {
                        request.cancel.resolve();
                    }
                    $scope.isLoading = true;
                    request = resource.searchWithCancel(searchStr);


                    request.$promise.then(function(response) {
                        $scope.searchResults = response.content.items;
                        request = null;
                        angular.element('#searchResults').scrollTop(0);
                        $scope.isLoading = false;
                    });

                };

                $scope.reset = function(searchStr) {
                    _removeSearchIconInFirefox();
                    $scope.showReset = null;
                    $scope.searchString = null;
                    $scope.searchResults = [];
                };

            }]
        }
    }]);

 (function () {
     angular.module('babycompy.content.food.productsCategories', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.food.productsCategories.products'
    ]);
 }());
/* global angular */
(function (angular) {
    angular.module('babycompy.content.food.productsCategories')
        .factory('productsCategoriesResource', ['categoriesResource', function (categoriesResource) {

            var ProductsCategoriesResource = categoriesResource.extend({

                search: function (searchStr) {
                    return this.get({
                        controller: 'product/',
                        query: searchStr
                    });
                },

                getProducts: function (uuid) {
                    return this.get({
                        id: uuid,
                        action: 'products'
                    })
                },
                
                getProductArticle: function (uuid) {
                    return this.get({
                        controller: 'product',
                        id: uuid
                    })
                },

                searchWithCancel: function (searchStr) {
                    var request =  this.resource.get({
                        controller: 'product',
                        query: searchStr,
                        limit: 20
                    }
                    );
                    return {
                        $promise: request.$promise,
                        cancel: request.timeout
                    };
                },
            });

            return new ProductsCategoriesResource('productCategories');
        }]);
})(angular);
(function () {
    angular.module('babycompy.content.food.productsCategories')
        .controller('productsCategoriesController', ['baseCategoriesController', '$scope', 'productsCategories', 'seoService',
            function (baseCategoriesController, $scope, productsCategories, seoService) {
                // dependencies will be resolved during page load in the route definition

                var ProductsCategoriesController = baseCategoriesController.extend({
                    init: function () {
                        this._super.apply(this, arguments);
                        this.categories = productsCategories;
                    }
                });

                return new ProductsCategoriesController($scope, productsCategories);
            }]);
})();
angular.module('babycompy.content.common')
    .directive('productsCategoriesLeftSideList', ['$state', 'contentCategoriesService', function ($state, contentCategoriesService) {
        var categoryIcons = [
            'baby_food',
            'sweets',
            'kasha',
            'spaghetti',
            'milk',
            'meet',
            'drinks',
            'fruite',
            'polufabricaty',
            'sauce',
            'fish',
            'snack',
            'fastfood',
            'bread'
        ];

        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                categories: '=',
                pagingParameters: '=?',
                loadMore: '=',
                nestedStateName: '@',
                paramName: '@',
                pagingTotal: '=?',
                usePaging: '=?',
                listClass: '@'
            },
            templateUrl: 'app/components/content/food/productsCategories/productsCategories.template.html',

            link: function (scope, el, attrs) {

                scope.$watch('categories', function (categories) {
                    if (!categories) {
                        return;
                    }

                    scope.readyCategories = scope.categories.map(function (category, index) {
                        category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                        return category;
                    });

                });

                scope.emitTransitionEvent = function () {
                    scope.$emit('articleSelected');
                }
            }
        }
    }]);
(function () {
    'use strict';

    angular
        .module('babycompy.content.food.productsCategories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories.food.productsCategories', {

            url: '/productsCategories',
            breadcrumb: '{{ "food.supplement" | translate }}',

            'productsCategory@index.contentCategories.contentSubcategories.food': {
                templateUrl: 'app/components/content/food/productsCategories/productsCategories.html',
                controller: 'productsCategoriesController',
                controllerAs: 'c'
            },

            'breadcrumbs@index': {
                templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                controller: 'foodController',
                controllerAs: 'c'
            },
            resolve: {
                selectedCategory: ['productsCategories', '$stateParams', function (productsCategories, $stateParams) {
                    return productsCategories.filter(function (c) {
                        return c.uuid === $stateParams.productCategoryUUID;
                    })[0];
                }]
            },

        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.favorites', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
(function() {
    angular.module('babycompy.content.favorites')
        .controller('favoriteModalController', ['favoritesService', 'favoriteEntity', '$modalService',
         function(favoritesService, favoriteEntity, $modalService) {
            var FavoriteModalController = Class.extend({
                delete: function () {
                    favoritesService.delete(favoriteEntity.uuid).then(function () {
                        $modalService.close();
                    })
                },
                
                close: function () {
                    $modalService.dismiss();
                }
            });
            
            return new FavoriteModalController();
        }])
})();

(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories.contentSubcategories', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.contentCategories.contentSubcategories.article'
    ]);
})();
(function () {
    angular.module('babycompy.content.contentCategories.contentSubcategories')
        .controller('contentSubcategoriesController', ['baseContentCategoriesController', '$scope', 'responseContent', 'contentCategoriesResource', 'seoService',
            function (baseContentCategoriesController, $scope, responseContent, contentCategoriesResource, seoService) {

                var ContentSubcategoriesController = baseContentCategoriesController.extend({
                    init: function () {
                        this._super.apply(this, arguments);
                        this.notes = responseContent.notes;
                        if (responseContent.parent) {
                            contentCategoriesResource.getSectionsContent(responseContent.parent.uuid).then(function (response) {
                                this.rootParentCategories = response.content.childs;
                            }.bind(this));
                        } else {
                            this.rootParentCategories = [];
                        }
                        seoService.title(responseContent.name, responseContent.parent ? responseContent.parent.name : undefined, responseContent.metaTags);
                        seoService.description(responseContent.name, responseContent.metaTags);
                        seoService.keywords(responseContent.metaTags);
                    }
                });

                return new ContentSubcategoriesController($scope, responseContent);
            }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.content.contentCategories.contentSubcategories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories.contentSubcategories', {
            url: '/:categoryUUID',
            views: {
                'content': {
                    templateUrl: 'app/components/content/contentCategories/contentSubcategories/contentSubcategories.html',
                    controller: 'contentSubcategoriesController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                responseContent: ['contentCategoriesResource', '$stateParams', function (contentCategoriesResource, $stateParams) {
                    return contentCategoriesResource.loadSubCategories($stateParams.categoryUUID, $stateParams.childAges).then(function (response) {
                        return response.content;
                    })
                }]
            },
            breadcrumb: "{{responseContent.parent.name || responseContent.name }}"
        });
    }
})();

(function () {
    angular.module('babycompy.content.common')
        .factory('contentResource', ['baseApiService', function (baseApiService) {

            var ContentResource = baseApiService.extend({

                loadArticle: function (articleId) {
                    return this.getById(articleId);
                }
            });

            return ContentResource;
        }]);
})();
(function () {
    angular.module('babycompy.content.common')
        .factory('baseContentController', [function () {
            // dependencies will be resolved during page load in the route definition

            var BaseContentController = Class.extend({
                init: function($scope, content) {
                    this.content = content;
                    this.scope = $scope;
                    $scope.$emit('articleSelected');
                },

            });

            return BaseContentController;
        }]);
})();

angular.module('babycompy.content.common')
    .directive('contentLeftSideList', ['upgrowthService', 'enums', '$translate',
        '$q', '$compile', '$templateRequest',
        function (upgrowthService, enums, $translate, $q, $compile, $templateRequest) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,

                scope: {
                    categories: '=',
                    showAsAgeTags: '=?',
                    nestedStateName: '@',
                    paramName: '@',
                    pagingTotal: '=?',
                    usePaging: '=?',
                    pagingParameters: '=?'
                },

                templateUrl: 'app/components/content/common/categories/contentLeftSideList.template.html',

                link: function (scope, el, attrs) {

                    scope.$watch('categories', function (categories) {
                        if (!categories) {
                            return;
                        }

                        if (scope.showAsAgeTags) {
                            buildTagList(scope, el);
                        } else {
                            scope.readyCategories = scope.categories.map(function (category) {
                                category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                                category.normalizedName = category.name;
                                return category;
                            });
                        }
                    });

                    scope.emitTransitionEvent = function () {
                        scope.$emit('articleSelected');
                    }
                }
            };

            function buildTagList(scope, el) {
                $q.all([$translate.onReady(), upgrowthService.onReady()]).then(function () {

                    scope.readyCategories = scope.categories.map(function (category) {
                        category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';


                        if (category.sectionAttributes.sectionChildAges.length > 0) {
                            var childAges = Array.prototype.slice
                                .call(category.sectionAttributes.sectionChildAges)
                                .sort(function (a, b) {
                                    return a.childAge.hours - b.childAge.hours;
                                });

                            var childAge = upgrowthService.getAgeType(
                                childAges.map(function (item) {
                                    return item.childAge.uuid;
                                })
                            );

                            var normalizedName = '';

                            switch (childAge.ageType) {
                                case enums.ageType.ageRange:
                                    normalizedName = String.format("{0} - {1}",
                                        childAge.yearsStart.age,
                                        getSingleTranslation(childAge.yearsEnd));
                                    break;
                                default:
                                    normalizedName = getSingleTranslation(childAge);
                                    break;
                            }

                            category.normalizedName = normalizedName;
                        } else {
                            category.normalizedName = category.name;
                        }

                        return category;
                    });
                });
            };

            function getSingleTranslation(childAge) {
                switch (childAge.ageType) {
                    case enums.ageType.newBorn:
                        return $translate.instant('general.newBorn');
                    case enums.ageType.months:
                        return $translate.instant('general.monthCount', {month: childAge.age});
                    case enums.ageType.years:
                        return $translate.instant('general.yearsCount', {years: childAge.age});
                }
            };
        }]);
/* global angular */
(function (angular) {
    angular.module('babycompy.categories.common')
        .factory('categoriesResource', ['baseApiService', function (baseApiService) {

            var CategoriesResource = baseApiService.extend({
                loadSubCategories: function(uuid, search) {
                    search = search || {};
                    search.id = uuid;
                    
                    return this._load(search);
                },
                
                loadCategories: function(search) {
                    return this._load(search);
                },
                
                _load: function(search) {
                    search = search || {};
                                        
                    return this.get(search);
                }
            });

            return CategoriesResource;
        }]);
})(angular);
angular.module('babycompy.content.common')
    .directive('categoriesLeftSideList', ['$state', 'contentCategoriesService', 'customPaging', function ($state, contentCategoriesService, customPaging) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                categories: '=',
                pagingParameters: '=?',
                loadMore: '=?',

                nestedStateName: '@',
                parentParamName: '@',
                paramName: '@',
                pagingTotal: '=?',
                usePaging: '=?',
                listClass: '@',
                defaultBehavour: '=?',
                pregnancyCalendar: '=?'
            },
            templateUrl: 'app/components/content/common/categories/categories.template.html',

            link: function (scope, el, attrs) {

                scope.$watch('categories', function (categories) {
                    if (!categories) {
                        return;
                    }
                    contentCategoriesService.load().then(function () {
                        scope.readyCategories = scope.categories.map(function (category) {
                            var specialLink = contentCategoriesService.getSpecialLink(category.name, category.uuid);

                            if (specialLink) {
                                angular.extend(category, specialLink);
                                return category;
                            }

                            if (scope.parentParamName) {
                                category.href = scope.nestedStateName + '({' + (scope.parentParamName || 'uuid') + ': \'' + category.parent.uuid + '\','
                                    + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                            } else {
                                category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                            }

                            return category;
                        });
                        if (scope.pregnancyCalendar) {
                            var offset = 0, limit = 10;
                            scope.customPaging = new customPaging();
                            scope.allCategories = scope.readyCategories;
                            scope.pagingParameters = scope.customPaging.getPagingParameters(limit, offset, scope.readyCategories);
                            scope.usePaging = scope.readyCategories.length > limit;
                            scope.readyCategories = scope.customPaging.visibleData;
                            scope.loadMore = scope.customPaging.loadMore;
                            scope.$watch('customPaging.visibleData', function (newValue, oldValue) {
                                scope.readyCategories = newValue;
                                scope.usePaging = scope.readyCategories.length < scope.allCategories.length;
                            });
                        }
                    });

                });
                
                scope.emitTransitionEvent = function () {
                    scope.$emit('articleSelected');
                }
            }
        }
    }]);
(function () {
    angular.module('babycompy.categories.common')
        .factory('baseCategoriesController', [function () {
            // dependencies will be resolved during page load in the route definition

            var BaseCategoriesController = Class.extend({
                init: function ($scope, categories, categoriesResource) {
                    this.scope = $scope;
                    this.categories = categories;
                    $scope.$on('articleSelected', function () {
                        this.wasArticleSelected = true;
                    }.bind(this))
                }
            });

            return BaseCategoriesController;
        }]);
})();
; (function () {
    angular.module('babycompy.content.common')
        .factory('categoriesContentService', [function () {
            var lengthThreshold = 20,
                columnRule = {
                    0: 4,
                    0.3: 3,
                    0.7: 2,
                    1: 1
                },
                totalColumns = 12,
                defaultColumnsCount = 3;


            function CategoriesContentService() {
            }


            CategoriesContentService.prototype.getColumnSize = function (columnsCount) {
                return (totalColumns / columnsCount);
            };

            CategoriesContentService.prototype.getRows = function (readyCategories, order, predefinedColumnNumber, alphabetSort) {
                var columnsCount = predefinedColumnNumber ? predefinedColumnNumber : this.matchTemplate(readyCategories, defaultColumnsCount);

                if (!alphabetSort) {
                    return readyCategories;
                }

                var buckets = Object.create(null);

                if (order) {
                    readyCategories.sort();
                }

                readyCategories.forEach(function (category) {
                    if (!(category.name[0] in buckets)) {
                        buckets[category.name[0]] = [];
                    }
                    buckets[category.name[0]].push(category);
                });

                var letters = Object.keys(buckets),
                    rows = [];

                for (var letter = 0, l = letters.length; letter < l; ++letter) {
                    var idx = Math.floor(letter / columnsCount);
                    if (!rows[idx]) {
                        rows[idx] = {
                            columns: [],
                            columnSize: this.getColumnSize(columnsCount)
                        };
                    }

                    rows[idx].columns.push(buckets[letters[letter]]);
                }

                return rows;
            };

            CategoriesContentService.prototype.matchTemplate = function (categories, customColumnNumber) {
                var columnsCount = customColumnNumber;

                var exceedsLengthThresholdCount = categories.filter(function (c) {
                    return c.name.length > lengthThreshold;
                }).length;

                var longStringsPercentage = exceedsLengthThresholdCount / categories.length;

                var ranges = Object.keys(columnRule).map(function (n) { return +n; }).sort(),
                    start = null,
                    end = null;

                for (var r = 0; r < ranges.length - 1; ++r) {
                    start = ranges[r];
                    end = ranges[r + 1];
                    if ((start <= longStringsPercentage && longStringsPercentage <= end) && !customColumnNumber) {
                        columnsCount = columnRule[ranges[r + 1]];
                        break;
                    }

                }
                if (customColumnNumber !== undefined) {
                    columnsCount = customColumnNumber;
                }
                // if we have less than 30% of long strings, we can use X-col template

                return columnsCount;
            };



            return new CategoriesContentService();
        }]);
})(angular);
angular.module('babycompy.content.common')
    .directive('categoriesContentList', ['categoriesContentService', 'contentCategoriesService', 'customPaging',
        function (categoriesContentService, contentCategoriesService, customPaging) {

            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    categories: '=',
                    nestedStateName: '@',
                    paramName: '@',
                    parentParamName: '@',
                    columnNumber: '=?',
                    order: '@',
                    alphabetSort: '=',
                    notMore: '='
                },

                templateUrl: 'app/components/content/common/categories/x.columns.html',

                link: function (scope, el, attrs) {

                    scope.emitTransitionEvent = function () {
                        scope.$emit('articleSelected');
                    };

                    contentCategoriesService.load().then(function () {
                        scope.readyCategories = scope.categories.map(function (category) {
                            var specialLink = contentCategoriesService.getSpecialLink(category.name, category.uuid);
                            if (specialLink) {
                                angular.extend(category, specialLink);
                                return category;
                            }

                            if (scope.parentParamName) {
                                category.href = scope.nestedStateName + '({' + (scope.parentParamName || 'uuid') + ': \'' + category.parent.uuid + '\','
                                    + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                            } else {
                                category.href = scope.nestedStateName + '({' + (scope.paramName || 'uuid') + ': \'' + category.uuid + '\'})';
                            }

                            return category;
                        });
                        
                        if (!scope.notMore) {
                            var offset = 0, limit = 10;
                            scope.customPaging = new customPaging();
                            scope.allCategories = scope.readyCategories;
                            scope.pagingParameters = scope.customPaging.getPagingParameters(limit, offset, scope.readyCategories);
                            scope.usePaging = scope.readyCategories.length > limit;
                            scope.readyCategories = scope.customPaging.visibleData;
                            scope.loadMore = scope.customPaging.loadMore;
                            scope.$watch('customPaging.visibleData', function (newValue, oldValue) {
                                if (scope.readyCategories != undefined) {
                                    scope.readyCategories = newValue;
                                    scope.usePaging = scope.readyCategories.length < scope.allCategories.length;
                                    scope.rows = categoriesContentService.getRows(scope.readyCategories, scope.order, scope.columnNumber, scope.alphabetSort);
                                }
                            });
                        }
                        
                        scope.rows = categoriesContentService.getRows(scope.readyCategories, scope.order, scope.columnNumber, scope.alphabetSort);

                    });

                }
            }
        }]);
(function() {
    angular.module('babycompy.content.common')
        .factory('groupService', ['groupResource', function(groupResource) {
            function groupService() {}

            groupService.prototype.getAllGroups = function() {
                return groupResource.loadDetailedGroups();
            };

            groupService.prototype.getById = function(id) {
                return groupResource.retreiveGroup(id);
            };

            groupService.prototype.getLightGroups = function() {
                return groupResource.getLightGroups();
            };

            groupService.prototype.getSavedAlgorithms = function() {
                return groupResource.getSavedAlgorithms();
            };

            return new groupService();
        }]);
})(angular);

(function(angular) {
    angular.module('babycompy.categories.common')
        .factory('groupResource', ['baseApiService', function(baseApiService) {

            var groupResource = baseApiService.extend({

                _setupCustomActions: function() {
                    return {
                        'details': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                controller: 'groups',
                                action: 'detail'
                            }
                        },
                        'light': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                controller: 'groups'
                            }
                        },
                        'get': {
                            method: 'GET',
                            isObject: true
                        }
                    }
                },

                loadDetailedGroups: function() {
                    return this.resource.details().$promise;
                },

                getLightGroups: function() {
                    return this.resource.light().$promise;
                },

                retreiveGroup: function(id) {
                    var params = {
                        controller: 'groups',
                        action: 'detail',
                        id: id
                    };
                    return this.resource.get(params).$promise;
                },
                getSavedAlgorithms: function() {
                    var params = {
                        controller: 'algorithmSaves',
                        action: 'user'
                    };
                    return this.resource.get(params).$promise;
                }
            });

            return new groupResource('groups');
        }]);
})(angular);

(function() {
    angular.module('babycompy.content.algorithms')
        .controller('algorithmStartConfirmModalController', ['$modalService', '$translate', '$state', 
         function($modalService, $translate, $state) {
            var algorithmStartConfirmModalController = Class.extend({
                message: $translate.instant('algorithms.unauthAlgorithmStartConfirm.message'),

                login: function () {
                    $modalService.dismiss();
                    $state.go('index.login');
                },

                register: function () {
                    $modalService.dismiss();
                    $state.go('index.signUp.user');
                },

                ok: function () {
                    $modalService.close();
                },
                
                close: function () {
                    $modalService.dismiss();
                }
            });
            
            return new algorithmStartConfirmModalController();
        }])
})();

(function() {
    angular.module('babycompy.content.common')
        .factory('algorithmService', ['algorithmResource', function(algorithmResource) {
            function algorithmService() {
                this.userAlgorithm = null;
            }

            algorithmService.prototype.getById = function(id) {
                return algorithmResource.retreiveAlgorithm(id);
            };

            algorithmService.prototype.restartAlgorithm = function(algorithmUuid) {
                return algorithmResource.restartAlgorithm(algorithmUuid, moment().toISOString());
            };

            algorithmService.prototype.finishAlgorithm = function(algorithmUuid) {
                return algorithmResource.finishAlgorithm(algorithmUuid);
            };

            algorithmService.prototype.saveAlgorithm = function(algorithmUuid, body) {
                return algorithmResource.startAlgorithm(algorithmUuid, body);
            };

            algorithmService.prototype.getAllUserRecommendations = function(userAlgorithmUuid) {
                return algorithmResource.getAllUserRecommendations(userAlgorithmUuid);
            };

            algorithmService.prototype.getUserRecommendationsForStep = function(userAlgorithmUuid, stepUuid) {
                return algorithmResource.getUserRecommendationsForStep(userAlgorithmUuid, stepUuid);
            };

            algorithmService.prototype.sendRecommendationsByEmail = function(body) {
                return algorithmResource.sendRecommendationsByEmail(body);
            };

            algorithmService.prototype.getRecommendationByUuids = function(body) {
                return algorithmResource.getRecommendationByUuids(body);
            };

            return new algorithmService();
        }]);
})(angular);

(function () {
    angular.module('babycompy.content.algorithms')
        .service('algorithmSavesService', ['$q', 'singleRequestService', 'EventTarget',
            function ($q, singleRequestService, EventTarget) {

                var algorithmSavesService = singleRequestService.extend({
                    init: function () {
                        this._super();
                        this.eventTarget = new EventTarget();
                    },

                    onStartAlgorithm: function() {
                        this.eventTarget.fire('onStartAlgorithm');
                    },

                    onFinishAlgorithm: function() {
                        this.eventTarget.fire('onFinishAlgorithm');
                    }

                });

                return new algorithmSavesService();
            }]);
})();

"use strict";
(function(angular) {
    angular.module('babycompy.categories.common')
        .factory('algorithmResource', ['baseApiService', function(baseApiService) {

            var algorithmResource = baseApiService.extend({

                _setupCustomActions: function() {
                    return {
                        'get': {
                            method: 'GET',
                            isObject: true
                        },
                        'post': {
                            method: 'POST',
                            isObject: true,
                            url: '/:apiPrefix/:apiVersion/:controller/:id/:action'
                        },
                        'delete': {
                            method: 'DELETE',
                            isObject: true,
                            url: '/:apiPrefix/:apiVersion/:controller/:id/:action'
                        },
                        'getWithStep': {
                            method: 'GET',
                            isObject: true,
                            url: '/:apiPrefix/:apiVersion/:controller/:userAlgorithmUuid/step/:stepUuid/:action'
                        }
                    };
                },

                retreiveAlgorithm: function(id) {
                    var params = {
                        controller: 'algorithms',
                        id: id,
                        web: true
                    };
                    return this.resource.get(params).$promise;
                },

                restartAlgorithm: function(id, time) {
                    var params = {
                        controller: 'algorithmSaves',
                        action: 'restart',
                        id: id,
                        restartTime: time
                    };
                    return this.resource.delete(params).$promise;
                },

                finishAlgorithm: function(id) {
                    var params = {
                        controller: 'algorithmSaves',
                        action: 'delete',
                        id: id
                    };
                    return this.resource.delete(params).$promise;
                },

                startAlgorithm: function(id,body) {
                    var params = {
                        controller: 'algorithms',
                        action: 'save',
                        id: id
                    };
                    return this.resource.post(params,body).$promise;
                },

                getUserRecommendationsForStep: function(userAlgorithmUuid, stepUuid) {
                    var params = {
                        controller: 'algorithmSaves',
                        userAlgorithmUuid: userAlgorithmUuid,
                        stepUuid: stepUuid,
                        action: 'recommendations'
                    };
                    return this.resource.getWithStep(params).$promise; 
                },

                getAllUserRecommendations: function(userAlgorithmUuid) {
                    var params = {
                        controller: 'algorithmSaves',
                        id: userAlgorithmUuid,
                        action: 'recommendations',
                        web: true 
                    };
                    return this.resource.get(params).$promise;
                },

                getRecommendationByUuids: function(recommendatioUuids) {
                    var params = {
                        controller: 'algorithmSaves',
                        action: 'selectedRecommendations'
                    };
                    return this.resource.post(params, {recommendations: recommendatioUuids}).$promise;
                }
            });

            return new algorithmResource('algorithms');
        }]);
})(angular);

"use strict";
(function() {
    angular.module('babycompy.content.algorithms')
        .controller('algorithmController', ['baseContentController', '$scope', '$translate', 'modalService',
            'seoService', '$state', 'groupDetail', 'algorithmDetail', 'enums', 'customPaging', 'algorithmService', 'algorithmSavesService', 'authService', 'localStorageService', 'app', 'currentUserService',
            function(baseContentController, $scope, $translate, modalService,
                seoService, $state, groupDetail, algorithmDetail, enums, customPaging, algorithmService, algorithmSavesService, authService, localStorageService, appConstants, currentUserService) {

                var algorithmController = baseContentController.extend({
                    init: function() {
                        var offset = 0,
                            limit = 10;
                        this._super.apply(this, arguments);
                        this.algorithms = groupDetail.algorithms;
                        this.currentAlgorithm = algorithmDetail;
                        this.titleName = algorithmDetail.name;
                        this.favoriteType = enums.selectFavoriteTypes.algorithms;
                        this.nestedState = 'index.algorithms.group.algorithm.step' + '({' + 'stepUuid' + ': \'' + this.currentAlgorithm.firstStep + '\'})';

                        this.customPaging = new customPaging();
                        this.allCategories = groupDetail.algorithms;
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.allCategories, algorithmDetail);
                        this.userAlgorithm = this.currentAlgorithm.userAlgorithm;

                      currentUserService.load().then(function (user) {
                        this.user = user;
                      }.bind(this));
                    },

                    startAlgorithm: function() {
                        if (authService.isLoggedIn() && !this.user.doctor && this.userAlgorithm == undefined) {
                            var requestBody = {};
                            requestBody.nextStep = this.currentAlgorithm.firstStep;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(function(response) {
                                $state.go('index.algorithms.group.algorithm.step', { stepUuid: this.currentAlgorithm.firstStep });
                                algorithmSavesService.onStartAlgorithm();
                            }.bind(this));
                        } else {

                          if (this.user && this.user.doctor) {
                            var algorithmStorage = {};
                            algorithmStorage.steps = [];
                            algorithmStorage.steps.push(this.currentAlgorithm.firstStep);
                            algorithmStorage.start = moment().toISOString().replace('Z', '');
                            localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                            $state.go('index.algorithms.group.algorithm.step', { stepUuid: this.currentAlgorithm.firstStep });
                          } else {
                            modalService.open({
                              template: 'app/components/content/algorithms/algorithm/confirmStartModal/algorithm.startAlgorithmConfirm.modal.template.html',
                              controller: 'algorithmStartConfirmModalController as c',
                              show: true,
                              backdrop: 'static'
                            }).result.then(function() {
                              var algorithmStorage = {};
                              algorithmStorage.steps = [];
                              algorithmStorage.steps.push(this.currentAlgorithm.firstStep);
                              algorithmStorage.start = moment().toISOString().replace('Z', '');
                              localStorageService.set(appConstants.algorithmLocalStorageKey, algorithmStorage);
                              $state.go('index.algorithms.group.algorithm.step', { stepUuid: this.currentAlgorithm.firstStep });
                            }.bind(this));
                          }
                        }
                    },

                    continueAlgorithm: function() {
                        if (authService.isLoggedIn() && this.userAlgorithm != undefined) {
                            var requestBody = {};
                            requestBody.userAlgorithm = this.userAlgorithm;
                            requestBody.nextStep = this.currentAlgorithm.userStep;
                            requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                            algorithmService.saveAlgorithm($state.params.algorithmUuid, requestBody).then(
                                function(response) {
                                    $state.go('index.algorithms.group.algorithm.step', { stepUuid: this.currentAlgorithm.userStep });
                                }.bind(this),
                                function(error) {
                                    if (error.data.metadata.errorCode === 404101) {
                                        modalService.showErrorAlert({
                                            title: $translate.instant('algorithms.error'),
                                            message: $translate.instant('algorithms.saveDeleted')
                                        }).then(function() {
                                            $state.reload();
                                        });
                                    }
                                }
                            );
                        }
                    }


                });
                return new algorithmController($scope);
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('babycompy.content.algorithms')
        .config(['$stateProvider', config]);

    function config($stateProvider) {
        $stateProvider.state('index.algorithms.group.algorithm', {
            url: '/algorithm/:algorithmUuid',
            views: {
                'subContent': {
                    templateUrl: 'app/components/content/algorithms/algorithm/algorithm.template.html',
                    controller: 'algorithmController',
                    controllerAs: 'c'
                },
                'sideMenu': {
                  templateUrl: 'app/components/content/algorithms/algorithm/algorithm-list.template.html',
                  controller: 'algorithmController',
                  controllerAs: 'c'
                }
                
            },
            resolve: {
                groupDetail: ['groupService', '$stateParams', function(groupService, $stateParams) {
                    return groupService.getById($stateParams.groupUuid).then(function(response) {
                        return response.content;
                    });
                }],
                algorithmDetail: ['algorithmService', '$stateParams', function(algorithmService, $stateParams) {
                    return algorithmService.getById($stateParams.algorithmUuid).then(function(response) {
                        return response.content;
                    });
                }],
            },
            breadcrumb: "{{algorithmDetail.name}}"
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.clinics.search',
        [
            'babycompy.selectLocation',
            'babycompy.pager',
            'ngSanitize',
            'ui.select'
        ]);
})();

angular.module('babycompy.clinics.search')
    .directive('selectClinicType', ['clinicTypeResource', function (clinicTypeResource) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                value: '=',
                placeholder: '@'
            },
            templateUrl: 'app/components/clinics/search/selectClinicType/selectClinicType.html',
            controller: ['$scope', 'clinicTypeResource', function ($scope, clinicTypeResource) {
                (function () {
                    clinicTypeResource.get()
                        .then(function (response) {
                            $scope.values = response.content.items;
                        }.bind(this));
                })();
            }]
        }
    }]);

(function () {
    angular.module('babycompy.clinics.search')
        .factory('clinicTypeResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var clinicTypeResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.get = {
                        method: 'GET'/*,
                        params: {
                            action: 'search'
                        }*/
                    }

                    return o;
                }
            })
            return new clinicTypeResource(resources.healthFacilitiesTypes);
        }])
})();
angular.module('babycompy.clinics.search')
    .directive('selectClinicDepartment', ['clinicDepartmentResource', function (clinicDepartmentResource) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                value: '=',
                placeholder: '@'
            },
            templateUrl: 'app/components/clinics/search/selectClinicDepartment/selectClinicDepartment.html',
            controller: ['$scope', 'clinicDepartmentResource', function ($scope, clinicDepartmentResource) {
                (function () {
                    clinicDepartmentResource.get()
                        .then(function (response) {
                            $scope.values = response.content.items;
                        }.bind(this));
                })();
            }]
        }
    }]);

(function () {
    angular.module('babycompy.clinics.search')
        .factory('clinicDepartmentResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var clinicDepartmentResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.get = {
                        method: 'GET'
                    }

                    return o;
                }
            })
            return new clinicDepartmentResource(resources.facilitiesDepartments);
        }])
})();
angular.module('babycompy.clinics.search')
    .directive('searchClinicService', ['clinicServiceResource', function (clinicServiceResource) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                searchFormParameters: '=',
                required: '@',
                placeholder: '@'
            },

            templateUrl: 'app/components/clinics/search/searchClinicService/searchClinicService.html',

            controller: ['$scope', 'clinicServiceResource', function ($scope, clinicServiceResource) {
                $scope.items = [];

                $scope.search = function (query) {
                    return clinicServiceResource.search(query)
                        .then(function (response) {
                            $scope.items = response.content.items;
                        }.bind(this));
                };

                $scope.clear = function($event) {
                    $event.stopPropagation();
                    $scope.searchFormParameters.service = undefined;
                };
            }]
        }
    }]);
(function () {
    angular.module('babycompy.clinics.search')
        .factory('clinicServiceResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var clinicServiceResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.search = {
                        method: 'GET'
                    }

                    return o;
                },

                search: function (query) {
                    return this.resource.search({ query: query }).$promise;
                },
            })
            return new clinicServiceResource(resources.services);
        }])
})();
(function () {
    'use strict';

    angular.module('babycompy.authentication.signUp', []);
    angular.module('babycompy.authentication.login', []);
    angular.module('babycompy.authentication', [
        'babycompy.authentication.signUp',
        'babycompy.authentication.login',
        'babycompy.authentication.profile'
    ]);
})();
angular.module('babycompy.authentication.signUp')
  .service('vkClient', ['$http', '$window', '$stateParams', 'VKConstants',
    function ($http, $window, $stateParams, VKConstants) {
    function VkClient() {
    }

    VkClient.prototype.initAuth = function () {
      $window.location.href = String
        .format(VKConstants.authUrlTemplate,
          VKConstants.appId,
          $window.location.href.split('?')[0],
          VKConstants.apiVersion
        );
    };

    VkClient.prototype.getUserInfo = function (accessToken, userId) {
      if (accessToken !== undefined && userId !== undefined) {
        return $http.get(VKConstants.currentUser, {
          params: {
            access_token: accessToken,
            user_id: userId,
            fields: 'photo_100'
          }
        });
      }
    };

    VkClient.prototype.getAccessToken = function (code) {
      if (code !== undefined) {
        return $http.get(VKConstants.tokenUrl, {
          params: {
            client_id: VKConstants.appId,
            client_secret: VKConstants.appSecret,
            redirect_uri: $window.location.href.split('?')[0],
            code: code
          }
        });
      }
    };

    return new VkClient();
  }])
  .constant('VKConstants', {
    apiVersion: '5.42',
    appId: '5367578',
    appSecret: '7pFgalFmlW864zmFHnrS',
    authUrlTemplate: "https://oauth.vk.com/authorize?client_id={0}&display=page&redirect_uri={1}&scope=email,offline&response_type=code&v={2}&state=vk",
    tokenUrl: '/vk/accessToken', //"https://oauth.vk.com/access_token",
    currentUser: '/vk/currentUser' //"https://api.vk.com/method/users.get"
  });

angular.module('babycompy.authentication.signUp')
  .service('okClient', ['$window', '$http', '$stateParams', '$q', 'OKConstants',
    function ($window, $http, $stateParams, $q, OKConstants) {
      function OkClient() {
      }

      OkClient.prototype.initAuth = function () {
        $window.location.href = String.format(
          OKConstants.authUrlTemplate,
          OKConstants.appId,
          $window.location.href.split('?')[0]
        );
      };

      OkClient.prototype.getUserInfo = function (code) {
        if (code !== undefined) {
          return $http.post(OKConstants.tokenUrl,
            $.param({
              'code': code,
              'redirect_uri': $window.location.href.split('?')[0],
              'grant_type': 'authorization_code',
              'client_id': OKConstants.appId,
              'client_secret': OKConstants.appSecret
            }),
            {
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }
          ).then(function (response) {
            var accessToken = response.data.access_token;
            if (accessToken) {
              var sig = this.generateOKSignature('json', OKConstants.methods.currentUser, accessToken);
              return $http.get(OKConstants.apiBaseUrl, {
                params: {
                  'method': OKConstants.methods.currentUser,
                  'access_token': accessToken,
                  'application_key': OKConstants.appPublic,
                  'format': 'json',
                  'sig': sig
                }
              })
            } else {
              return $q.reject("Failed to fetch access token")
            }
          }.bind(this))
        }
      };

      OkClient.prototype.generateOKSignature = function (format, methodName, accessToken) {
        var MD5 = new Hashes.MD5();
        var hashedSecret = MD5.hex(accessToken + OKConstants.appSecret);
        var source = String.format(OKConstants.methodSigTemplate, OKConstants.appPublic, format, methodName, hashedSecret);
        return MD5.hex(source).toLowerCase();
      };

      return new OkClient();
    }])
  .constant('OKConstants', {
    appId: "1246756096",
    appPublic: 'CBAOPQELEBABABABA',
    appSecret: '228E47420CEF70D3A4CCA603',
    authUrlTemplate: "https://connect.ok.ru/oauth/authorize?client_id={0}&scope=VALUABLE_ACCESS&response_type=code&redirect_uri={1}",
    tokenUrl: "http://api.odnoklassniki.ru/oauth/token.do",
    apiBaseUrl: "http://api.odnoklassniki.ru/fb.do",
    methodSigTemplate: "application_key={0}format={1}method={2}{3}",
    methods: {
      currentUser: "users.getCurrentUser"
    }
  });

(function () {
    angular.module('babycompy.authentication.profile.children')
        .service('doctorsSpecsService', ['$q', 'doctorsSignUpResource',
            'singleRequestService',
            function ($q, doctorsSignUpResource, singleRequestService) {

                var DoctorsSpecsService = singleRequestService.extend({
                    getFromResource: function () {
                        return doctorsSignUpResource.getSpecializations();
                    },

                    _setEntity: function (result) {
                        this.entity = result.content.items;
                    }
                });

                return new DoctorsSpecsService();
            }]);
})();

angular.module('babycompy.authentication.signUp')
    .service('doctorsSignUpResource', ['baseApiService', '$facebook', 'GooglePlus',
        function (baseApiService, $facebook, GooglePlus) {
            var DoctorsSignUp = baseApiService.extend({
                _setupCustomActions: function () {
                    return {
                        'signUp': {
                            method: 'POST',
                            isObject: true,
                            params: {
                                action: 'signUp'
                            }
                        },

                        'specializations': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                controller: 'dictionaries',
                                action: 'specializations'
                            }

                        },
                    }
                },

                userSignUp: function (user) {
                    return this.resource.signUp({
                        firstName: user.firstName,
                        lastName: user.lastName,
                        patronymic: user.patronymic,

                        facility: user.department.uuid,
                        department: user.specialization.uuid,

                        email: user.email,
                        avatar: null,
                        password: user.password,

                        country: user.country.uuid,
                        region: user.region.uuid,
                        city: user.city.uuid

                    }).$promise;
                },

                getSpecializations: function () {
                    return this.resource.specializations().$promise;
                }


            });
            return new DoctorsSignUp('doctors');
        }]);


angular.module('babycompy.authentication.signUp')
    .controller('doctorsSignUpController', ['$q', '$scope', '$state',
        'baseController', 'doctorsSignUpResource',
        'clinicResource',
        'doctorsSpecsService','modalService', '$translate', 'applicationLifecycle',
        function ($q, $scope, $state, baseController, doctorsSignUpResource, clinicResource, doctorsSpecsService, modalService, $translate, applicationLifecycle) {

            var DoctorSignUpController = baseController.extend({

                init: function () {
                    this._super.apply(this, arguments);
                    this.user = {};
                    this.emailExist = false;

                    $scope.$watch(function () {
                        return this.user.city;
                    }.bind(this), this.updateClinicsList.bind(this));

                    doctorsSpecsService.load().then(function (items) {
                        this.specs = items;
                    }.bind(this));

                },

                updateClinicsList: function (city) {
                    if (!city) {
                        return;
                    }

                    this.user.department = null;
                    clinicResource.get({}, {
                        country: this.user.country.uuid,
                        region: this.user.region.uuid,
                        city: this.user.city.uuid
                    }).then(function (response) {
                        this.clinics = response.content.items;
                    }.bind(this))
                },

                register: function () {
                    if (!this.user.department || !this.entity.termsOfUse) {
                        return;
                    }


                    this.isRegistering = true;
                    this.resource.userSignUp(this.user).then(function (response) {
                        if (response.metadata.code == 200) {
                            $q.all([
                                $translate('authentication.signUp.successTitle'),
                                $translate('authentication.signUp.registerSuccess')
                            ]).then(function (translations) {
                                this.opts = {};
                                this.opts.title = translations[0];
                                this.opts.message = translations[1];
                                modalService.showSuccessSignUpAlert(this.opts);
                                applicationLifecycle.loggedIn();
                            }.bind(this));
                        }
                    }, function (response) {
                        if (response.data.metadata.errorCode === 400404) {
                            this.emailExist = true;
                        }
                    }.bind(this)).finally(function () {
                        this.isRegistering = false;
                    }.bind(this))
                }

            });
            return new DoctorSignUpController($scope, doctorsSignUpResource);
        }]);

(function () {
    'use strict';

    angular
        .module('babycompy.authentication.profile.subscriptions')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('index.profile.subscriptions', {
            url: '/subscriptions',
            views: {
                'profile-view': { templateUrl: 'app/components/authentication/profile/subscriptions/subscriptions.html' }
            }
        });
    }
})();

(function() {
    angular.module('babycompy.authentication.profile.resetPassword')
        .service('resetPasswordResource', ['baseApiService', function(baseApiService) {

            var ResetPasswordResource = baseApiService.extend({
                _setupCustomActions: function () {
                    return {
                        changePassword: {
                            method: 'POST',
                            isObject: true,
                            params: {
                                action: 'changePassword'
                            }
                        }
                    }
                },
                
                changePassword: function(oldPass, newPass){
                    return this.resource.changePassword({
                        oldPassword: oldPass,
                        newPassword: newPass
                    }).$promise
                }
                
            });

            return new ResetPasswordResource('users');
        }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.authentication.profile.resetPassword')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('index.profile.user.resetPassword', {
            url: '/changePassword',
            views: {
                'profile-view': {
                    templateUrl: 'app/components/authentication/profile/resetPassword/resetPassword.html',
                    controller: 'resetPasswordController as c'
                }
            }
        });
    }
})();

(function() {
    angular.module('babycompy.authentication.profile.resetPassword')
        .controller('resetPasswordController', ['$scope', 'resetPasswordResource', '$alert', '$translate', 'modalService',
            function($scope, resetPasswordResource, $alert, $translate, modalService) {

                var ResetPasswordController = function() {
                    this.data = {};
                };

                ResetPasswordController.prototype.changePassword = function() {

                    if (!this.data.oldPassword || !this.data.newPassword) {
                        return;
                    } else if (!this.data.repeatPassword) {
                        this.data.repeatPassword = $scope.changePassword.repeatPassword.$viewValue;
                        if(this.data.repeatPassword !== this.data.newPassword) {
                            return;
                        }
                    }
                    
                    resetPasswordResource.changePassword(this.data.oldPassword, this.data.newPassword).then(function(response) {
                        this.showSaveAlert();
                        this.invalidOldPassord = false;
                        this.data = {};
                        $scope.changePassword.$submitted = false;
                    }.bind(this), function(response) {
                        if (response.data.metadata.errorCode === 400005) {
                            this.invalidOldPassord = true;
                        }
                    }.bind(this));
                };

                ResetPasswordController.prototype.oldPasswordChange = function() {
                    this.invalidOldPassord = false;
                };

                ResetPasswordController.prototype.showSaveAlert = function() {
                    var messageText = $translate.instant('userProfile.profileSaved');
                    modalService.showSuccessAlert(messageText);
                }

                return new ResetPasswordController();
            }]);
})();
(function () {
    angular.module('babycompy.authentication.profile')
        .controller('profileEditController', ['$scope', 'baseEditController', 'currentUser',
            'updateProfileService', '$modal', '$q', '$filter', '$alert', '$translate', 'currentUserService', 'seoService','$rootScope',
            function ($scope, BaseEditController, currentUser, updateProfileService, $modal,
                $q, $filter, $alert, $translate, currentUserService, seoService, $rootScope) {

                var ProfileEditController = BaseEditController.extend({

                    init: function ($scope, resource) {
                        this._super($scope, resource);
                        this.formName = 'profileForm';
                        updateProfileService.getPregnancyAges().then(function (response) {
                            this.pregnancyAges = response.content.items;
                        }.bind(this));
                        $translate('userProfile.myProfile').then(function (translations) {
                            seoService.title(translations);
                            seoService.description(translations);
                        });
                        this.confirmUnsavedChangesMsgKey = 'general.confirmUnsavedChanges';

                      $scope.$on('avatarChanged', function (e, uuid) {
                        this.entity.avatar = uuid;
                        if (!$scope.profileForm.$dirty) $scope.profileForm.$setDirty();
                      }.bind(this))
                    },

                    _getDefaultEntity: function () {
                        this.countryLabel = true;
                        this.regionLabel = true;
                        this.cityLabel = true;

                        var entityCopy = angular.copy(currentUser);

                        this.birthDate = new Date(entityCopy.birthDate);
                        return $q.when(entityCopy);
                    },

                    _saveInternal: function (entity) {

                        return updateProfileService.updateProfile(entity);
                    },

                    _postSave: function (entity) {
                        $.extend(true, currentUser, entity);
                        this._showSaveAlert();
                      currentUserService.onChangeAvatar(this.entity.avatar)

                        return $q.when(entity);
                    },

                    _preSave: function (entity) {
                        entity.birthDate = $filter('date')(this.birthDate, 'yyyy-MM-dd');
                        if (entity.pregnancyAge != currentUser.pregnancyAge) {
                            entity.updatingPregnancy = true;
                        }

                      if (this.old.avatar && (this.old.avatar !== this.entity.avatar)) {
                        $rootScope.$broadcast('avatar.delete', this.old.avatar);
                      }
                        return $q.when(entity);
                    },

                    _isEntityChanged: function () {
                        //prevent image overwriting
                        this.old.avatar = this.entity.avatar = currentUser.avatar;
                        return this._super();
                    },

                    _showSaveAlert: function () {
                        var myAlert = $alert(
                            {
                                container: 'header',
                                content: $translate.instant('userProfile.profileSaved'),
                                placement: 'top',
                                type: 'success',
                                templateUrl: 'app/components/core/templates/alertTemplate.html',
                                show: true,
                                duration: 3
                            });
                    }

                });


                return new ProfileEditController($scope);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.authentication.profile.edit')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('index.profile.user.edit', {
            url: '/edit',
            views: {
                'profile-view': {
                    templateUrl: 'app/components/authentication/profile/edit/profile.edit.html',
                    controller: 'profileEditController as c'
                }
            },
            resolve:{
                currentUser: ['currentUserService', function(currentUserService){
                    return currentUserService.load();
                }]
            }
        });
    }
})();

(function () {
  angular.module('babycompy.authentication.doctorsProfile')
    .service('doctorsProfileResource', ['baseApiService', function (baseApiService) {
      var doctorsProfileResource = baseApiService.extend({
          _setupCustomActions: function () {
            var o = this._super();

            o.delete = {
              method: 'DELETE',
              isObject: true,
              params: {
                action: 'hidden'
              }
            }

            return o;
          },

          delete: function () {
            return this.resource.delete().$promise;
          }
        })
        ;
      return new doctorsProfileResource('doctors');
    }]);
})();

(function () {
  angular.module('babycompy.authentication.doctorsProfile')
    .controller('doctorsProfileController', ['$scope', 'baseEditController', 'doctorsProfileResource', 'currentUserService',
      '$modal', '$filter', '$log', '$rootScope', 'updateProfileService',
      function ($scope, baseEditController, doctorsProfileResource, currentUserService, $modal, $filter, $log, $rootScope, updateProfileService) {

        var doctorsProfileController = baseEditController.extend({
          init: function ($scope, resource) {
            this._super($scope, resource);
            this._getUser();
            this._getSpecs();
            this._getCountries();
            this._watchChanges();
            this._watchClinicModal();
            this.confirmUnsavedChangesMsgKey = 'general.confirmUnsavedChanges';

            $scope.timePickerOptions = {
              asMoment: true,
              timeFormat: 'H:i',
              show2400: true,
              step: 30
            };

            $scope.tinymceOptions = {
              mode: "exact",
              plugins: 'paste link',
              default_link_target: "_blank",
              toolbar: 'bold italic bullist removeformat link styleselect',
              fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
              language: "ru",
              language_url: "/app/translations/locale-ru_tiny.js",
              menubar: false,
              statusbar: false,
              baseURL: '/bower_components/tinymce',
              valid_elements: 'h2[style="font-style"],h3[style="font-style"],' +
              'span[style="font-style"],' +
              'strong/b,' +
              'br,' +
              'ul,' +
              'li,' +
              'p,' +
              'em,' +
              'a[href|title|target]',
              valid_styles: {
                "*": "font-size, color"
              },
              style_formats: [
                {title: 'Мелкий', inline: 'span', styles: {color: 'rgb(135, 135, 135)', fontSize: '12px'}},
                {title: 'Нормальный', inline: 'span', styles: {color: 'rgb(102, 102, 102)', fontSize: '14px'}},
                {title: 'Большой', inline: 'span', styles: {color: 'rgb(247, 131, 124)', fontSize: '18px'}},
                {title: 'Огромный', inline: 'span', styles: {color: 'rgb(247, 131, 124)', fontSize: '24px'}}
              ],
              content_style: ".mce-content-body h2, .mce-content-body h3 {color: #f7837c} .mce-content-body { font-family: 'Roboto', sans-serif; font-size: 14px; color: #666; background: transparent} .mce-content-body > p{margin:0} ul {margin: 5px 0}",
              gecko_spellcheck: true,
              browser_spellcheck: true,
              resize: false,
              paste_postprocess: function (pl, o) {
                // $log.debug($(o.node).text());
                o.node.innerHTML = o.node.innerHTML.replace(/  +/g, ' ');
              },
              setup: function (ed) {
                ed.on("keydown", function () {
                  // EditorNotifyService.notify();
                });
              }
            };

            $scope.tabs = [
              {title: 'doctorProfile.facilities'},
              {title: 'doctorProfile.achievementsAndPublications'},
              {title: 'doctorProfile.articles'},
              {title: 'doctorProfile.comments', counter: 1}
            ];

            $scope.$on('comment.total', function (e, total) {

              $scope.tabs[3].counter = total;
            });
          },

          emailPattern: /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
          activeTab: 'doctorProfile.facilities',
          clinicsOffset: 0,

          _isEntityChanged: function () {
            return $scope.$state.is('index.profile.doctor.edit') && this.dataChanged;
          },

          _watchChanges: function () {
            $scope.$watch(function () {
              return this.content;
            }.bind(this), function (newValue, oldValue) {
              if (angular.equals(this.initialData, this.content)) {
                if (this.dataChanged) this.dataChanged = false;
              }  else {
                if (!this.dataChanged) this.dataChanged = true;
              }
            }.bind(this), true);
          },

          _getUser: function () {
            currentUserService.load().then(function (user) {
              this.content = angular.copy(user);
              this.initialData = angular.copy(this.content);
              this.specializations = user.specializations.map(function (specialization) {
                return specialization.name;
              }).join(", ");
            }.bind(this));
          },

          workTimeModal: {
            actions: $modal({
              templateUrl: 'app/components/authentication/profile/doctorsProfile/modals/workTime.html',
              show: false,
              animation: "am-fade-and-scale",
              scope: $scope,
              placement: "center"
            })
          },

          clinicsModal: {
            actions: $modal({
              templateUrl: 'app/components/authentication/profile/doctorsProfile/modals/clinics-modal.html',
              show: false,
              animation: "am-fade-and-scale",
              scope: $scope,
              placement: "center body-scroll"
            })
          },
          specsModal: {
            actions: $modal({
              templateUrl: 'app/components/authentication/profile/doctorsProfile/modals/specs-modal.html',
              show: false,
              animation: "am-fade-and-scale",
              scope: $scope,
              placement: "center body-scroll"
            })
          },

          removeClinic: function (index) {
            this.content.healthFacilities.splice(index, 1);
            this._updateItem();
          },

          editClinic: function (index, clinic) {
            this.showTime = true;
            this.currentClinic = {index: index};

            if (!clinic.doctorFacilityWorkTime || clinic.doctorFacilityWorkTime.length === 0) {
              this.currentClinic.worktime = [];
              this._defaultWorkingHours(this.currentClinic.worktime);

            } else {
              this.currentClinic.worktime = angular.copy(clinic.doctorFacilityWorkTime);
              this.currentClinic.worktime.sort(function (a, b) {
                return a.day - b.day;
              });
            }

            this.currentClinic.worktime.forEach(function (item) {
              item.startTime = moment(item.startTime, 'HH:mm');
              item.endTime = moment(item.endTime, 'HH:mm');
            }.bind(this));

            this.hideWorkinghours = false;
            this.workTimeModal.actions.show();
          },

          _prepareData: function () {
            if (!this.content.phones.length) return;

            this.content.phones.forEach(function (item, i, arr) {
              if (item.name === '' && item.phone === '') arr.splice(i, 1);
            });
          },

          _defaultWorkingHours: function (mass) {
            for (var i = 0; i < 7; i++) {
              mass.push(
                {
                  day: i,
                  endTime: "00:00",
                  holiday: false,
                  index: i,
                  name: null,
                  startTime: "00:00",
                  uuid: null
                }
              );
            }
          },

          saveClinicTime: function () {
            this.loading = true;
            this.showTime = false;

            this.workTimeModal.actions.hide();
            this.currentClinic.worktime.forEach(function (item, i) {
              item.startTime = item.startTime.format ? item.startTime.format('HH:mm') : $filter('date')(item.startTime, 'HH:mm');
              item.endTime = item.endTime.format ? item.endTime.format('HH:mm') : $filter('date')(item.endTime, 'HH:mm');
            }.bind(this));
            this.content.healthFacilities[this.currentClinic.index].doctorFacilityWorkTime = this.currentClinic.worktime;

            this._updateItem();
          },

          openSpecModal: function () {
            this._refactorSpecs();
            this.specsModal.actions.show();
          },

          _refactorSpecs: function () {
            var newSpecs = {};

            if (this.content.specializations && this.content.specializations.length !== 0) {
              this.content.specializations.forEach(function (s) {
                newSpecs[s.uuid] = s.name;
              });

              this.itemSpecializations = newSpecs;
            }
          },

          _getSpecs: function () {
            this.resource['get']({controller: 'dictionaries', action: 'specializations'}).then(function (resp) {
              this.specs = resp.content.items;
            }.bind(this), function (error) {
              $log.error(error);
            });
          },

          setSpec: function (spec) {
            var s = this.itemSpecializations;

            s[spec.uuid] ? delete s[spec.uuid] : s[spec.uuid] = spec.name;
          },

          saveSpecs: function () {
            this.specsModal.actions.hide();

            var newMass = [];
            for (var prop in this.itemSpecializations) {
              if (!this.itemSpecializations[prop]) continue;

              newMass.push({
                name: this.itemSpecializations[prop],
                uuid: prop
              });
            }

            this.content.specializations = angular.copy(newMass);
          },

          _isValid: function () {
            var isValid = true;
            this.validation = {
              country: false,
              region: false,
              city: false
            };
            this.achievementsTooLong = false;
            this.aboutTooLong = false;
            this.articlesTooLong = false;
            this.emailExists = false;
            this.phoneDublicated = false;
            if (!this.content.country) this.validation.country = true;
            if (!this.content.region) this.validation.region = true;
            if (!this.content.city) this.validation.city = true;

            if (
              !this.content.country ||
              !this.content.region ||
              !this.content.city ||
              $scope.dataForm && $scope.dataForm.$invalid ||
              this.dateError ||
              this.content.specializations == 0
            ) {
              isValid = false;
            }


            if (this.content.autobiography && $filter('htmlToPlaintext')(this.content.autobiography).length > 3000) {
              this.aboutTooLong = true;
              isValid = false;
            }

            if (this.content.achievements && $filter('htmlToPlaintext')(this.content.achievements).length > 25000) {
              this.achievementsTooLong = true;
              isValid = false;
            }

            if (this.content.articles && $filter('htmlToPlaintext')(this.content.articles).length > 25000) {
              this.articlesTooLong = true;
              isValid = false;
            }

            if (this._hasDuplicates()) {
              this.phoneDublicated = true;
              isValid = false;
            }

            return isValid;
          },

          _hasDuplicates: function () {
            if (!this.content.phones) return false;

            var valuesSoFar = Object.create(null), result = false;

            this.content.phones.forEach(function (item) {
              var value = item.phone;
              if (value in valuesSoFar) {
                result = true;
              }
              valuesSoFar[value] = true;
            });

            return result;
          },

          _getCountries: function () {
            this.resource['get']({controller: 'countries'}).then(function (resp) {
              this.countries = resp.content.items;
            }.bind(this), function (error) {
              $log.error(error);
            });
          },

          _updateItem: function () {
            if (this.initialData.photo && (this.initialData.photo !== this.content.photo)) {
              $rootScope.$broadcast('avatar.delete', this.initialData.photo);
            }

            angular.copy(this.content, this.initialData);
            this.dataChanged = false;
            this.showPreloader = true;
            this.resource.put({action: 'profile'}, this.content).then(function (resp) {
              this.showPreloader = false;
              currentUserService.set(angular.copy(this.content));
              currentUserService.onChangeAvatar();
              $scope.$state.go('index.profile.doctor');
            }.bind(this), function (error) {
              this.showPreloader = false;

              if (error.data.metadata.errorCode === 400404) {
                this.emailExists = true;
              }
            }.bind(this));
          },

          removePhone: function (index) {
            this.content.phones.splice(index, 1);
          },

          addPhone: function () {
            if (!this.content.phones) this.content.phones = [];

            this.content.phones.push({phone: "", name: ""});
          },

          openClinics: function () {
            this.filterClinic = {
              name: '',
              type: '',
              country: this.content.country && this.content.country.uuid
            };

            if (this.clinics) {
              this.clinicsModal.actions.show();
            } else {
              this.clinicsModal.actions.show();
              this.getClinics({filter: this.filterClinic});
              this._getClinicTypes();
            }
          },

          hideClinic: function (uuid) {
            var result = true;

            if (this.content.healthFacilities && this.content.healthFacilities.length > 0) {
              this.content.healthFacilities.forEach(function (doc) {
                if (doc.uuid !== uuid) return;
                result = false;
              });
            }

            return result;
          },

          getClinics: function (options) {
            var that = this;
            var params = {};

            if (options && options.addOffset) {
              this.clinicsOffset = this.clinicsOffset + 10;
              params.offset = this.clinicsOffset;
            }

            if (options && options.filter) {
              params.name = options.filter.name;
              params.type = options.filter.type;
              params.country = options.filter.country;
            }

            params.controller = 'healthFacilities';
            params.action = 'search';
            params.limit = 10;

            if (that.currentTotal && params.offset && that.currentTotal < params.offset) return;

            this.clinicsLoading = true;
            that.resource['get'](params).then(function (resp) {
              if (options && options.addOffset) {
                that.clinics = that.clinics.concat(resp.content.items);
              } else {
                that.clinics = resp.content.items;
              }

              that.currentTotal = resp.content.total;
              that.clinicsLoading = false;

              $scope.$emit('doctors.clinicsFound');
            });
          },

          addClinic: function (item) {
            if (!this.content.healthFacilities) this.content.healthFacilities = [];
            var clinic = angular.copy(item);
            delete clinic.worktime;

            this.resource.get({controller: 'healthFacilities', action: 'profile', id: item.uuid}).then(function (resp) {
              if (!resp.content.worktime) resp.content.worktime = [];
              clinic.doctorFacilityWorkTime = resp.content.worktime;
              this._defaultWorkingHours(clinic.doctorFacilityWorkTime);
              this.content.healthFacilities.push(clinic);
              this.clinicsModal.actions.hide();

              this._updateItem();
            }.bind(this));
          },

          _watchClinicModal: function () {
            $scope.$watchCollection(function () {
              return this.filterClinic;
            }.bind(this), function (newValue, oldValue) {
              if (angular.equals(newValue, oldValue)) return;

              this.getClinics({filter: this.filterClinic});
            }.bind(this));
          },

          dateChanged: function () {
            if (moment(this.content.birthday) > moment()) {
              this.dateError = true;
            } else {
              this.dateError = false;
            }
          },

          _getClinicTypes: function () {
            this.resource.get({controller: 'healthFacilityTypes'}).then(function (resp) {
              this.cliicTypes = resp.content.items;
            }.bind(this));
          },

          submit: function () {
            this.submited = true;
            if (!this._isValid()) return;

            this._prepareData();
            this._updateItem();
          },

          cancel: function () {
            this.content = angular.copy(this.initialData);
            $scope.$state.go('index.profile.doctor');
          }
        });


        return new doctorsProfileController($scope, doctorsProfileResource);
      }]);
})();

(function () {
    angular.module('babycompy.authentication.profile.children')
        .service('profileChildrenService', ['profileChildrenResource', 'singleRequestService', 'applicationLifecycle',
            function (profileChildrenResource, singleRequestService, ApplicationLifecycle) {

                var ProfileChildrenService = singleRequestService.extend({
                    init: function(){
                        this._super();
                        ApplicationLifecycle.onBeforeLogout(this._onLogout.bind(this));
                        ApplicationLifecycle.onLoggedIn(this._onLogout.bind(this));
                    },

                    getFromResource: function () {
                        return profileChildrenResource.get.apply(profileChildrenResource, arguments);
                    },

                    _setEntity: function (result) {
                        this.entity = result;
                    },

                    delete: function (uuid) {
                        var items = this.entity.content.items,
                            index = -1,
                            i;

                        for (var i = 0; i < items.length; i++) {
                            if (items[i].uuid === uuid) {
                                index = i;
                                break;
                            }
                        }

                        if (index != -1) {
                            items.splice(index, 1);
                        }

                        return profileChildrenResource.delete(uuid);
                    },

                    _onLogout: function(){
                        this.entity = null;
                    }

                });

                return new ProfileChildrenService();
            }]);
})();

/* global angular */
(function (angular) {
    angular.module('babycompy.authentication.profile.children')
        .factory('profileChildrenResource', ['baseApiService',
            'fileService', function (baseApiService, fileService) {

                var ProfileChildrenResource = baseApiService.extend({
                    _setupCustomActions: function () {
                        var o = this._super();
                        o.saveWithImage = {
                            method: 'POST',
                            params: {
                                expand: undefined,
                                controller: 'children',
                                action: 'avatar'
                            },
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            },
                            url: '/:apiPrefix/:apiVersion/:controller/:action/:id',
                        };

                        o.getChildAges = {
                            method: 'GET',
                            params: {
                                expand: undefined,
                                controller: 'dictionaries',
                                action: 'childAges'
                            },
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        };


                        return o;
                    },

                    saveWithImage: function (dataUrl, entity, fileName) {
                        var fd = new FormData();
                        var content = fileService.base64UriToFile(dataUrl);
                        fd.append('file', content, fileName);
                        fd.append('entity', JSON.stringify(entity));

                        return this.resource.saveWithImage({}, fd).$promise;
                    },

                    updateImage: function (dataUrl, id, fileName) {
                        var fd = new FormData();
                        var content = fileService.base64UriToFile(dataUrl);
                        fd.append('file', content, fileName);

                        return this.resource.saveWithImage({id: id}, fd).$promise;
                    },

                    _putInternal: function (entity) {
                        return this.resource.put(entity).$promise;
                    },

                    getChildAges: function (entity) {
                        return this.resource.getChildAges(entity).$promise;
                    }

                });

                return new ProfileChildrenResource('children');

            }]);
})(angular);

(function () {
    angular.module('babycompy.authentication.profile.children')
        .controller('profileChildrenController', ['$scope', 'baseListController',

            'updateProfileService',
            'profileChildrenService',
            'modalService', '$q', '$filter', '$translate', 'profileChildrenResource',
            function ($scope, baseListController, updateProfileService,
                      profileChildrenService, modalService, $q, $filter, $translate, profileChildrenResource) {

                var ProfileChildrenController = baseListController.extend({


                    onAttachedToDOM: function () {
                        return this.loadData();
                    },

                    showChildrenModal: function (item) {
                        modalService.open({
                            scope: $scope,
                            template: 'app/components/authentication/profile/children/edit/children.modal.html',
                            controller: 'profileChildrenEditController as c',
                            show: true,
                            backdrop: 'static',
                            locals: {
                                oldEntity: item
                            }
                        }).result.then(this._updateProfile.bind(this, item));
                    },

                    _dataRetrievalFunctionName: function () {
                        return 'load';
                    },

                    _updateProfile: function (oldEntity, newEntity) {
                        if (oldEntity) {
                            angular.extend(oldEntity, newEntity);
                        } else {
                            this.data.push(newEntity);
                        }
                    },

                    _getDeleteMessage: function (item) {
                        var msg = $translate.instant('userProfile.deleteChildMessage', {name: item.firstName});

                        return $q.when({
                            message: msg,
                            title: $translate.instant('userProfile.deleteChildTitle')
                        });
                    },

                    _onDeleteSuccess: function () {
                        return $q.when({});
                    },
                });

                return new ProfileChildrenController($scope, profileChildrenService);
            }]);
})();
(function () {
    'use strict';

    angular
        .module('babycompy.authentication.profile.children')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('index.profile.user.children', {
            url: '/children',
            views: {
                'profile-view': {
                    templateUrl: 'app/components/authentication/profile/children/children.html',
                    controller: 'profileChildrenController as c'
                }
            }
        });
    }
})();

(function () {
    angular.module('babycompy.authentication.profile.children')
        .service('profileChildAgesService', ['$q', 'profileChildrenResource',
            'singleRequestService',
            function ($q, profileChildrenResource, singleRequestService) {

                var ProfileChildAgesService = singleRequestService.extend({
                    getFromResource: function () {
                        return profileChildrenResource.getChildAges();
                    },

                    _setEntity: function (result) {
                        this.entity = result.content.items;
                        this.childAgeCache = {};
                        this.entity.forEach(function(item){
                            this.childAgeCache[item.uuid] = item;
                        }, this);
                    },

                    getFromCache: function(uuid){
                        return   this.childAgeCache[uuid];
                    }
                });

                return new ProfileChildAgesService();
            }]);
})();

(function () {
    angular.module('babycompy.authentication.login')
        .controller('forgotPasswordController', ['changePasswordResource', '$scope', function (changePasswordResource, $scope) {
            
            var forgotPasswordController = Class.extend({
                
                init: function () {
                    this.emailNotFound = false;
                    this.changedPass = false;
                },
                
                changePasswordResource: function (email) {
                    if(!email){
                        return;
                    }
                    changePasswordResource.changePassword(email).then(function (response) {
                        this.changedPass = true;
                    }.bind(this), function (response) {
                        if(response.data.metadata.errorCode === 400400){
                            this.emailNotFound = true;
                        }
                    }.bind(this));
                        
                }                    
                
            })
            
            return new forgotPasswordController();
        }])
        
})();
 
(function () {
    angular.module('babycompy.authentication.login')
        .service('changePasswordResource', ['baseApiService', function (baseApiService) {
            var ChangePasswordResource = baseApiService.extend({
                _setupCustomActions: function () {
                    return {
                        'changePassword': {
                            method: 'POST',
                            isObject: true
                        }
                    }
                },
                changePassword: function (inputedEmail) {
                    return this.resource.changePassword({
                        email : inputedEmail
                    }).$promise
                }
            })
            return new ChangePasswordResource('restorePassword')
        }])
})();
MessageFormat.locale.zh=function(n){return "other"}

MessageFormat.locale.vi=function(n){return "other"}

MessageFormat.locale.ur=function(n){return n===1?"one":"other"}

MessageFormat.locale.uk = function (n) {
  if ((n % 10) == 1 && (n % 100) != 11) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 4 &&
      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.tr=function(n){return "other"}

MessageFormat.locale.tl=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.th=function(n){return "other"}

MessageFormat.locale.te=function(n){return n===1?"one":"other"}

MessageFormat.locale.ta=function(n){return n===1?"one":"other"}

MessageFormat.locale.sw=function(n){return n===1?"one":"other"}

MessageFormat.locale.sv=function(n){return n===1?"one":"other"}

MessageFormat.locale.sr = function (n) {
  if ((n % 10) == 1 && (n % 100) != 11) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 4 &&
      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.sq=function(n){return n===1?"one":"other"}

MessageFormat.locale.sl = function (n) {
  if ((n % 100) == 1) {
    return 'one';
  }
  if ((n % 100) == 2) {
    return 'two';
  }
  if ((n % 100) == 3 || (n % 100) == 4) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.sk = function (n) {
  if (n == 1) {
    return 'one';
  }
  if (n == 2 || n == 3 || n == 4) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.shi = function(n) {
  if (n >= 0 && n <= 1) {
    return 'one';
  }
  if (n >= 2 && n <= 10 && n == Math.floor(n)) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.ru = function (n) {
  if ((n % 10) == 1 && (n % 100) != 11) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 4 &&
      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.ro = function (n) {
  if (n == 1) {
    return 'one';
  }
  if (n === 0 || n != 1 && (n % 100) >= 1 &&
      (n % 100) <= 19 && n == Math.floor(n)) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.pt=function(n){return n===1?"one":"other"}

MessageFormat.locale.pl = function (n) {
  if (n == 1) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 4 &&
      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 10) === 0 || n != 1 && (n % 10) == 1 ||
      ((n % 10) >= 5 && (n % 10) <= 9 || (n % 100) >= 12 && (n % 100) <= 14) &&
      n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.or=function(n){return n===1?"one":"other"}

MessageFormat.locale.no=function(n){return n===1?"one":"other"}

MessageFormat.locale.nl=function(n){return n===1?"one":"other"}

MessageFormat.locale.mt = function (n) {
  if (n == 1) {
    return 'one';
  }
  if (n === 0 || ((n % 100) >= 2 && (n % 100) <= 4 && n == Math.floor(n))) {
    return 'few';
  }
  if ((n % 100) >= 11 && (n % 100) <= 19 && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.ms=function(n){return "other"}

MessageFormat.locale.mr=function(n){return n===1?"one":"other"}

MessageFormat.locale.mo = function (n) {
  if (n == 1) {
    return 'one';
  }
  if (n === 0 || n != 1 && (n % 100) >= 1 &&
      (n % 100) <= 19 && n == Math.floor(n)) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.ml=function(n){return n===1?"one":"other"}

MessageFormat.locale.mk=function(n){return (n%10)==1&&n!=11?"one":"other"}

MessageFormat.locale.lv = function (n) {
  if (n === 0) {
    return 'zero';
  }
  if ((n % 10) == 1 && (n % 100) != 11) {
    return 'one';
  }
  return 'other';
};

MessageFormat.locale.lt = function (n) {
  if ((n % 10) == 1 && ((n % 100) < 11 || (n % 100) > 19)) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 9 &&
      ((n % 100) < 11 || (n % 100) > 19) && n == Math.floor(n)) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.ln=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.lag = function (n) {
  if (n === 0) {
    return 'zero';
  }
  if (n > 0 && n < 2) {
    return 'one';
  }
  return 'other';
};

MessageFormat.locale.ko=function(n){return "other"}

MessageFormat.locale.kn=function(n){return "other"}

MessageFormat.locale.ja=function(n){return "other"}

MessageFormat.locale.iw=function(n){return n===1?"one":"other"}

MessageFormat.locale.it=function(n){return n===1?"one":"other"}

MessageFormat.locale.is=function(n){return n===1?"one":"other"}

MessageFormat.locale["in"]=function(n){return "other"}

MessageFormat.locale.id=function(n){return "other"}

MessageFormat.locale.hu=function(n){return "other"}

MessageFormat.locale.hr = function (n) {
  if ((n % 10) == 1 && (n % 100) != 11) {
    return 'one';
  }
  if ((n % 10) >= 2 && (n % 10) <= 4 &&
      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.hi=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.he=function(n){return n===1?"one":"other"}

MessageFormat.locale.gu=function(n){return n===1?"one":"other"}

MessageFormat.locale.gsw=function(n){return n===1?"one":"other"}

MessageFormat.locale.gl=function(n){return n===1?"one":"other"}

MessageFormat.locale.ga=function(n){return n==1?"one":(n==2?"two":"other")}

MessageFormat.locale.fr=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.fil=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.fi=function(n){return n===1?"one":"other"}

MessageFormat.locale.fa=function(n){return "other"}

MessageFormat.locale.eu=function(n){return n===1?"one":"other"}

MessageFormat.locale.et=function(n){return n===1?"one":"other"}

MessageFormat.locale.es=function(n){return n===1?"one":"other"}

MessageFormat.locale.en=function(n){return n===1?"one":"other"}

MessageFormat.locale.el=function(n){return n===1?"one":"other"}

MessageFormat.locale.de=function(n){return n===1?"one":"other"}

MessageFormat.locale.da=function(n){return n===1?"one":"other"}

MessageFormat.locale.cy = function (n) {
  if (n === 0) {
    return 'zero';
  }
  if (n == 1) {
    return 'one';
  }
  if (n == 2) {
    return 'two';
  }
  if (n == 3) {
    return 'few';
  }
  if (n == 6) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.cs = function (n) {
  if (n == 1) {
    return 'one';
  }
  if (n == 2 || n == 3 || n == 4) {
    return 'few';
  }
  return 'other';
};

MessageFormat.locale.ca=function(n){return n===1?"one":"other"}

MessageFormat.locale.br = function (n) {
  if (n === 0) {
    return 'zero';
  }
  if (n == 1) {
    return 'one';
  }
  if (n == 2) {
    return 'two';
  }
  if (n == 3) {
    return 'few';
  }
  if (n == 6) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.bn=function(n){return n===1?"one":"other"}

MessageFormat.locale.bg=function(n){return n===1?"one":"other"}

MessageFormat.locale.ar = function(n) {
  if (n === 0) {
    return 'zero';
  }
  if (n == 1) {
    return 'one';
  }
  if (n == 2) {
    return 'two';
  }
  if ((n % 100) >= 3 && (n % 100) <= 10 && n == Math.floor(n)) {
    return 'few';
  }
  if ((n % 100) >= 11 && (n % 100) <= 99 && n == Math.floor(n)) {
    return 'many';
  }
  return 'other';
};

MessageFormat.locale.am=function(n){return n===0||n==1?"one":"other"}

MessageFormat.locale.af=function(n){return n===1?"one":"other"}

;(function () {
    'use strict';

    angular.module('babycompy.medics', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.medics.answers'
    ]);

})();

(function () {
    angular.module('babycompy.medics')
        .controller('questionModalController', ['$scope', 'baseEditController',
            '$modal', '$q',
            '$timeout', '$filter', 'medicQuestionResource', '$modalService',
            function ($scope, baseEditController,
                      $modal, $q, $timeout, $filter, medicQuestionResource, $modalService) {

                var QuestionModalController = baseEditController.extend({
                    init: function ($scope, resource) {
                        this._super($scope, resource);
                    },

                    _getDefaultEntity: function () {
                        return $q.when({
                            questionDate:(new Date()).toISOString().replace('Z', '')
                        });
                    },

                    save: function () {
                        this.scope[this.formName].$setSubmitted();
                        this._super();
                    },

                    _afterSave: function (entity) {
                        $modalService.close(entity);
                    },

                    close: function(){
                        $modalService.dismiss();
                    }

                });

                return new QuestionModalController($scope, medicQuestionResource);
            }]);
})();
(function (angular) {
    angular.module('babycompy.medics')
        .factory('medicQuestionResource', ['baseApiService', 'resources',
            function (baseApiService, resources) {

            var MedicQuestionResource = baseApiService.extend({


            });

            return new MedicQuestionResource(resources.questions);
        }]);
})(angular);
;(function () {
    'use strict';

    angular.module('babycompy.medics.answers', [
        'babycompy.medics.answers.article',
        'babycompy.categories.common',
        'babycompy.content.common',
        'pascalprecht.translate'
    ]);
})();

(function () {
    angular.module('babycompy.medics.answers')
        .service('medicAnswersService', ['$q', 'medicAnswersResource', 'singleRequestService', 'applicationLifecycle',
            function ($q, medicAnswersResource, singleRequestService, ApplicationLifecycle) {

                var MedicAnswersService = singleRequestService.extend({
                    init: function () {
                        this._super();
                        ApplicationLifecycle.onBeforeLogout(this._onLogout.bind(this));
                    },

                    getFromResource: function () {
                        return medicAnswersResource.getForCurrentUser.apply(medicAnswersResource, arguments);
                    },

                    _setEntity: function (result) {
                        this.entity = result;
                    },

                    delete: function (uuid) {
                        var items = this.entity.content.items,
                            index = -1,
                            i;

                        for (var i = 0; i < items.length; i++) {
                            if (items[i].uuid === uuid) {
                                index = i;
                                break;
                            }
                        }

                        if (index != -1) {
                            items.splice(index, 1);
                        }

                        return medicAnswersResource.delete(uuid);
                    },

                    _onLogout: function () {
                        this.entity = null;
                    },

                    get: function () {
                        return this.entity.content.items;
                    },

                    getUnreadVisible: function () {
                        return this.entity.content.items.filter(function (item) {
                            return !item.read && !item.hidden;
                        })
                    },

                    hideAnswer: function (answer) {
                        var items = this.entity.content.items,
                            index = items.indexOf(answer);

                        if (index >= 0) {
                            items[index].hidden = true;
                        }

                        return medicAnswersResource.hide(answer.uuid);
                    },

                    markAsRead: function (answer) {
                        var items = this.entity.content.items,
                            index = items.indexOf(answer);

                        if (index >= 0) {
                            items[index].hidden = true;
                        }

                        return medicAnswersResource.markAsRead(answer.uuid);
                    }

                });

                return new MedicAnswersService();
            }]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.medics.answers')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medics.answers', {
            url: '/answers/:rubricUUID',
            views: {
                'content@index': {
                    templateUrl: 'app/components/medics/answers/medics.answers.html',
                    controller: 'medicsAnswersController',
                    controllerAs: 'c'
                }
            },

            resolve: {
                rubrics: ['medicRubricsService', function(medicRubricsService) {
                    return medicRubricsService.load().then(function(response) {
                        return response.content.items;
                    });
                }],

                selectedRubric: ['medicRubricsService', '$stateParams',
                    function(medicRubricsService, $stateParams) {
                        return medicRubricsService.load().then(function(response) {
                            return response.content.items.filter(function(c) {
                                return c.uuid === $stateParams.rubricUUID
                            })[0];
                        });
                    }],

                user: ['currentUserService', function(currentUserService) {
                    return currentUserService.load().then(function(user) {
                        return user;
                    });
                }]
            },

            breadcrumb: "{{selectedRubric.name}}"
        });
    }
})();
(function () {
    angular.module('babycompy.medics.answers')
        .controller('medicsAnswersController', ['$scope', 'modalService',
            'rubrics', '$state', '$filter',
            '$translate', 'baseListController', 'customPaging', 'selectedRubric',
            'medicAnswersResource', 'user','currentUserService',
            function ($scope, modalService,
                      rubrics, $state, $filter, $translate,
                      baseListController, customPaging, selectedRubric, medicAnswersResource, user,currentUserService) {

                var MedicsInfoController = baseListController.extend({

                    init: function () {
                        var offset = 0,
                            limitLeft = 10;

                        this._super.apply(this, arguments);
                        this.user = user;
                        this.rubrics = rubrics;
                        this.customPagingLeft = new customPaging();
                        this.pagingParametersLeft = this.customPagingLeft.getPagingParameters(
                            limitLeft, offset, this.rubrics, selectedRubric);
                        this.titleName = selectedRubric.name;

                        currentUserService.load(function (user) {
                          this.user = user;
                        }.bind(this));

                    },

                   askDoctor: function() {
                        if (!currentUserService.get()) {
                            modalService.showLoginModal($scope).result.then(function() {
                                modalService.showQuestionModal($scope);
                            });
                        } else {
                            modalService.showQuestionModal($scope);
                        }

                    },

                    extractVisibleRubric: function() {
                        return this.customPagingLeft.extractVisibleSupplements();
                    },

                    _dataRetrievalFunctionName: function () {
                        return 'getByRubric';
                    },

                    _applySearchParameters: function (params) {
                        params.id = selectedRubric.uuid;
                        return params;
                    },

                });

                return new MedicsInfoController($scope, medicAnswersResource);

            }]);
})();

(function () {
    'use strict';

    angular.module('babycompy.doctors.details', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function () {
    angular.module('babycompy.doctors.details')
        .controller('doctorDetailsController', ['baseController', '$scope',
            'responseContent', '$translate', 'enums', 'seoService',
            function (baseController, $scope, responseContent,
                $translate, enums, seoService) {

                var DoctorController = baseController.extend({
                    init: function ($scope) {
                        this._super.apply(this, arguments);

                        $translate('doctorsSearch.pageTitle').then(function (translations) {
                            seoService.title(translations, this.content.name);
                            seoService.description(this.content.name);
                        }.bind(this));

                        this.content = responseContent;
                        this.favoriteType = enums.selectFavoriteTypes.doctors;
                        this.facilityFavoriteType = enums.selectFavoriteTypes.clinics;
                        this.specializations = responseContent.specializations.map(function (specialization) {
                            return specialization.name;
                        }).join(", ");

                        this.titleName = responseContent.lastName;
                        $scope.tabs = [
                          {title: 'doctorProfile.facilities'},
                          {title: 'doctorProfile.achievementsAndPublications'},
                          {title: 'doctorProfile.articles'},
                          {title: 'doctorProfile.comments', counter: 1}
                        ];
                        activeTab: 'doctorProfile.facilities',
  
                        $scope.$on('comment.total', function (e, total) {
  
                          $scope.tabs[3].counter = total;
                        });
                    
                        this.content.images = [];   
                        if (this.content.photo) {
                            this.content.images.unshift({
                                link: this.content.photo
                            });
                        }
                    }
                });

                return new DoctorController($scope);
            }]);
})();



(function () {
    'use strict';

    angular
        .module('babycompy.doctors.details')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        /*
         * ToDo enable for dev
         * Home Doctors is in development, turn it off for Productions
         */
        return;

        $stateProvider.state('index.doctorSearch.details', {
            url: '/:uuid/details',
            views: {
                'content@index': {
                    templateUrl: 'app/components/doctorSearch/details/doctorDetails.html',
                    controller: 'doctorDetailsController',
                    controllerAs: 'c'
                },
                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller:  'doctorBreadcrumbController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                responseContent: ['$stateParams', 'doctorResource',
                    function ($stateParams, doctorResource) {
                        return doctorResource.getProfile($stateParams.uuid).then(function(response){
                            return response.content;
                        });
                    }]

            },

            breadcrumb: "{{responseContent.name}}"
        });

    }

})();

(function () {
    angular.module('babycompy.doctors.details')
        .controller('doctorBreadcrumbController', ['baseController', '$scope',
            'responseContent', '$translate', '$state', '$filter',
            function (baseController, $scope, responseContent,
                      $translate, $state, $filter) {

                var DoctorBreadcrumbController = baseController.extend({
                    init: function ($scope) {
                        this._super($scope);
                        this.arrayOfParents = [];

                        this.arrayOfParents.push({
                            name: $filter('translate')('main.main'),
                            href:  '/'
                        });

                        this.arrayOfParents.push({
                            name:  $filter('translate')('menu.doctors'),
                            href: $state.href('index.doctorSearch')
                        });
                    }

                });

                return new DoctorBreadcrumbController($scope);
            }]);
})();



angular.module('babycompy.base')
    .factory('singleRequestService', ['$q',
        function ($q) {

            var SingleRequestService = Class.extend({
                init: function () {
                    this.entity = null;
                    this._loading = false;
                    this._pendingPromises = [];
                },

                getFromResource: function () {
                    return null;
                },

                load: function () {
                    var pending = $q.defer();
                    if (this.entity == null) {
                        this._pendingPromises.push(pending);

                        if (this._loading === false) {
                            this._loading = true;
                            this.getFromResource.apply(this, arguments).then(function (result) {
                                this._loading = false;
                                this._setEntity(result);
                                this._resolve(this.entity);

                            }.bind(this)).finally(function () {
                                this._loading = false;
                            }.bind(this));
                        }
                    } else if (this._loading === false) {
                        pending.resolve(this.entity);
                    }

                    return pending.promise;
                },

                _resolve: function(entity){
                    for (var i = 0; i < this._pendingPromises.length; ++i) {
                        this._pendingPromises[i].resolve(entity);
                    }

                    this._pendingPromises = [];
                },

                _setEntity: function (result) {
                    this.entity = result.content;
                },

                set: function (entity) {
                    this.entity = entity;
                },

                get: function () {
                    return this.entity;
                }
            });

            return SingleRequestService;
        }]);

angular.module('babycompy.base')
    .factory('sessionStorageService', ['app', '$window', function (appConstants, $window) {

        function setItem(key, value) {
            var appStorage = JSON.parse($window.sessionStorage.getItem(appConstants.localStorageKey));
            if (!appStorage) {
                appStorage = {};
            }

            appStorage[key] = value;
            $window.sessionStorage.setItem(appConstants.localStorageKey, JSON.stringify(appStorage));
        }

        function getItem(key) {
            var appStorage = JSON.parse($window.sessionStorage.getItem(appConstants.localStorageKey));
            if (!appStorage) {
                appStorage = {};
            }

            return appStorage[key];
        }

        return {
            get: getItem,
            set: setItem
        };
    }]);
(function () {
    angular.module('babycompy.base')
        .service('modalService', ['$modal', '$q', '$rootScope',
            '$translate', '$alert','$state',
            function ($modal, $q, $rootScope, $translate, $alert,$state) {

                var ModalService = function () {
                };

                ModalService.prototype.open = function (options) {

                    options.locals = options.locals || {};
                    options.locals.$modalService = {
                        closeDefer: $q.defer(),
                        close: function (result) {
                            this.closeDefer.resolve(result);
                            modal.$scope.$hide();
                        },
                        dismiss: function (result) {
                            this.closeDefer.reject(result);
                            modal.$scope.$hide();
                        }
                    };

                    var modal = $modal(options);

                    return {
                        $modalService: options.locals.$modalService,
                        modal: modal,
                        result: options.locals.$modalService.closeDefer.promise
                    }
                };

                ModalService.prototype.showInfoAlert = function (opts) {
                    return this.showMessageAlert(opts, 'alert-info').result;
                };

                ModalService.prototype.showSuccessSignUpAlert = function (opts) {
                    opts = opts || {};
                    opts.scope = $rootScope.$new(true);

                    opts.scope.title = opts.title;
                    opts.scope.content = opts.message;
                    opts.scope.type = "success";
                    var options = angular.extend({
                        templateUrl: 'app/main/html/signUpModalSuccess.html',
                        backdrop: 'static'
                    }, opts);

                    var modal = this.open(options);

                    opts.scope.$close = function () {
                        $state.go("index");
                        modal.$modalService.close();
                    };
                    opts.scope.$dismiss = function () {
                        return false;
                    };
                    return modal;
                };

                ModalService.prototype.showErrorAlert = function (opts) {
                    return this.showMessageAlert(opts, 'alert-danger').result;
                };

                ModalService.prototype.showMessageAlert = function (opts, alertClass) {
                    opts = opts || {};
                    opts.scope = $rootScope.$new(true);

                    opts.scope.title = opts.title;
                    opts.scope.message = opts.message;
                    opts.scope.alertClass = alertClass;

                    return this.showAlert(opts).result;
                };

                ModalService.prototype.showAlert = function (opts) {
                    var options = angular.extend({
                        templateUrl: 'app/main/html/modalTpl.html',
                    }, opts);

                    var modal = this.open(options);

                    opts.scope.$close = modal.$modalService.close.bind(modal.$modalService);
                    opts.scope.$dismiss = modal.$modalService.dismiss.bind(modal.$modalService);

                    return modal;
                };

                ModalService.prototype.showLoginModal = function ($scope) {
                    return this.open({
                        scope: $scope.$new(true, $scope),
                        templateUrl: 'app/components/authentication/login/login.modal.html',
                        controller: 'LoginController as c',
                        show: true,
                        backdrop: 'static'
                    })
                };

                ModalService.prototype.showQuestionModal = function ($scope) {
                    return this.open({
                        scope: $rootScope.$new(true),
                        templateUrl: 'app/components/medics/questionModal/question.modal.html',
                        controller: 'questionModalController as c',
                        show: true,
                        backdrop: 'static'
                    }).result.then(function (entity) {
                        this.showInfoAlert({
                            scope: $scope.$new(true, $scope),
                            title: $translate.instant('medic.question.successSubmitTitle'),
                            message: $translate.instant('medic.question.successSubmitMessage')
                        })
                    }.bind(this))
                };

                ModalService.prototype.showSuccessAlert = function (showText) {
                    var text = showText || 'cat';
                    $alert({
                        container: 'header',
                        content: text,
                        placement: 'top',
                        type: 'success',
                        templateUrl: 'app/components/core/templates/alertTemplate.html',
                        show: true,
                        duration: 3
                    });
                }


                return new ModalService();

            }]);
})();

angular.module('babycompy.base')
    .factory('localStorageService', ['app', '$window', function (appConstants, $window) {

        function setItem(key, value) {
            var appStorage = JSON.parse($window.localStorage.getItem(appConstants.localStorageKey));
            if (!appStorage) {
                appStorage = {};
            }

            appStorage[key] = value;
            $window.localStorage.setItem(appConstants.localStorageKey, JSON.stringify(appStorage));
        }

        function getItem(key) {
            var appStorage = JSON.parse($window.localStorage.getItem(appConstants.localStorageKey));
            if (!appStorage) {
                appStorage = {};
            }

            return appStorage[key];
        }

        return {
            get: getItem,
            set: setItem
        };
    }]);
angular.module('babycompy.base')
    .service('fileService',['$q', function ($q) {

        var URL = (window.URL || window.webkitURL);

        function FileService() {

        }

        FileService.prototype.base64UriToFile = function (dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {type:mimeString});
        };

        FileService.prototype.fileToBase64Uri = function(file) {
            return URL.createObjectURL(file);
        };


        FileService.prototype.readAsText = function (file) {
            var deferred = $q.defer();
            

            var reader = new FileReader();
            reader.onload = function (event) {
                deferred.resolve(event.target.result);               
            };

            reader.onerror = function (event) {
                deferred.reject('Error reding file' + event.target.error.code);                
            };

            reader.readAsText(file);

            return deferred.promise;
        }

        FileService.prototype.disposeFile = function(blobUrl) {
            if(blobUrl && !(blobUrl instanceof File)) {
                try {
                    URL.revokeObjectURL(blobUrl);
                } catch (err) {
                    // nothing to do here
                }
            }
        };

        return new FileService();
    }]);
angular.module('babycompy.base')
    .factory('customPaging', ['loadMoreConstants', function (loadMoreConstants) {


        var CustomPaging = function () {
            this.loadedAllCategories = [];
            this.pagingParameters = {};
            this.visibleData = [];
            this.loadMore = this.loadMoreInternal.bind(this);
        };

        CustomPaging.prototype.getPagingParameters = function (limit, offset, allCategories, content) {
            var selectedItem;

            this.pagingParameters.limit = limit;
            this.pagingParameters.offset = offset;


            for (var i = 0; i < allCategories.length / this.pagingParameters.limit; i++) {
                this.loadedAllCategories[i * this.pagingParameters.limit] = allCategories.slice(this.pagingParameters.limit * i, (i + 1) * this.pagingParameters.limit);
            }

            if (content) {
                selectedItem = allCategories.filter(function (c) {
                    return c.uuid === content.uuid;
                })[0];
            }

            if (selectedItem) {
                this.pagingParameters.offset = Math.floor(allCategories.indexOf(selectedItem) / this.pagingParameters.limit) * this.pagingParameters.limit;
            }

            this.visibleData = this.loadedAllCategories[this.pagingParameters.offset];

            return this.pagingParameters;
        };

        CustomPaging.prototype.extractVisibleSupplements = function () {
            return this.loadedAllCategories[this.pagingParameters.offset];
        };

        CustomPaging.prototype.loadMoreInternal = function (offset, direction) {
            if (direction === loadMoreConstants.direction.top) {
                this.visibleData = this.loadedAllCategories[offset].concat(this.visibleData);
            } else {
                this.visibleData = this.visibleData.concat(this.loadedAllCategories[offset]);
            }
        };

        return CustomPaging;

    }]);
(function () {
  angular.module('babycompy.base')
    .service('currentUserService', ['$q', 'userProfileResource', 'authService', 'applicationLifecycle', 'profileService', 'updateProfileService', 'cropperService', 'EventTarget',
      function ($q, userProfileResource, authService, applicationLifecycle, profileService, updateProfileService, cropperService, EventTarget) {

        function CurrentUserService() {
          this.user = null;
          this._loading = false;
          this._pendingPromises = [];
          this.avatarService = new cropperService({
            autoCropArea: 0.7
          });
          this.eventTarget = new EventTarget();
          applicationLifecycle.onLoggedIn(this._onLogin.bind(this));
          applicationLifecycle.onBeforeLogout(this._onBeforeLogout.bind(this));
        }

        CurrentUserService.prototype.load = function () {
          var pending = $q.defer();
          if (this.user == null) {
            this._pendingPromises.push(pending);

            if (this._loading === false) {
              if (authService.isLoggedIn()) {
                this._loading = true;
                userProfileResource.getUserProfile().then(function (result) {
                  this.set(result.content);
                }.bind(this)).finally(function () {
                  this._loading = false;
                  for (var i = 0; i < this._pendingPromises.length; ++i) {
                    // resolved with user value or null, if loading failed
                    this._pendingPromises[i].resolve(this.user);
                  }

                  this._pendingPromises = [];
                }.bind(this));
              } else {
                pending.resolve(null);
              }
            }
          } else if (this._loading === false) {
            pending.resolve(this.user);
          }

          return pending.promise;
        };

        CurrentUserService.prototype.onChangeAvatar = function () {
          this.eventTarget.fire('onChangeAvatar');
        };

        CurrentUserService.prototype.set = function (user) {
          this.user = user;
        };

        CurrentUserService.prototype.get = function () {
          return this.user;
        };

        CurrentUserService.prototype._onLogin = function () {
          this.user = null;
          this.load();
        };


        CurrentUserService.prototype._onBeforeLogout = function () {
          this.user = null;
        };

        return new CurrentUserService();
      }]);
})();

angular.module('babycompy.base')
    .factory('cropperService', ['$q', 'EventTarget', 'Cropper', function ($q, EventTarget, Cropper) {

        var AvatarService = EventTarget.extend({
            init: function (opts) {
                this._super();

                this.flowAttrs = {
                    accept: 'image/*',
                    capture: 'camera'
                };

                this.croppedImage = '';
                this.cropAreaData = null;
                this.showEvent = 'show';
                this.hideEvent = 'hide';

                this.options = {
                    maximize: false,
                    aspectRatio: 1,
                    crop: function (dataNew) {
                        this.cropAreaData = dataNew;
                    }.bind(this),
                    zoomable: true,
                    autoCropArea: 0.9,
                    strict: true,
                    guides: false,
                    highlight: false,
                    dragCrop: false,
                    cropBoxMovable: false,
                    cropBoxResizable: false,
                    setSelect: [0, 0, 280, 280],
                    rotatable: false
                };

                angular.extend(this.options, opts || {});
            },

            /***
             *
             * @param file - File type
             */
            setImage: function (file) {
                this.file = file;
                var deferred = $q.defer();
                EXIF.getData(this.file, function (result) {
                    var orientation = EXIF.getTag(file, 'Orientation');
                    return Cropper.encode(file, orientation).then(function (dataUrl) {
                        this.dataUrl = dataUrl;
                        deferred.resolve(dataUrl);
                    }.bind(this));
                }.bind(this));

                return deferred.promise;
            },

            cropImage: function () {
                return Cropper.crop(this.file, this.cropAreaData, undefined, this.dataUrl)
                    .then(Cropper.encode)
                    .then(function (dataUrl) {
                        return this.croppedImage = dataUrl;
                    }.bind(this))
            },

            cropSocialImage: function (url) {
                return Cropper.makeSquare(url)
                    .then(Cropper.encode)
                    .then(function (dataUrl) {
                        return this.croppedImage = dataUrl;
                    }.bind(this))

            },
        });

        return AvatarService;
    }]);
(function () {
    angular.module('babycompy.base')
        .factory('contentCategoriesService', ['$state', 'contentCategoriesResource', '$q', '$filter', 'singleRequestService',
            '$translate',
            function ($state, contentCategoriesResource, $q, $filter, singleRequestService, $translate) {

                var categories = [],
                    linkTypes = {
                        calendar: 'calendar',
                        disease: 'disease',
                        pregnancy: 'pregnancy',
                        food: 'food',
                        supplementsCategories: 'supplementsCategories'
                    };

                var ContentCategoriesServece = singleRequestService.extend({
                    _categotiesSetting: function (categories, headlines) {
                        var result = [];
                        result = categories.map(function (response) {
                            return {
                                name: (function (title) {
                                    switch (title) {
                                        case headlines['menu.serverNames.disease']:
                                            return $filter('translate')('menu.disease');
                                        case headlines['menu.serverNames.pregnancy']:
                                            return $filter('translate')('menu.pregnancy');
                                        default:
                                            return title;
                                    }
                                })(response.content.name),

                                linkType: (function (title) {
                                    switch (title) {
                                        case headlines['menu.serverNames.disease']:
                                            return linkTypes.disease;
                                        case headlines['menu.serverNames.pregnancy']:
                                            return linkTypes.pregnancy;
                                        case headlines['menu.serverNames.food']:
                                            return linkTypes.food;
                                        default:
                                            return title;
                                    }
                                })(response.content.name),

                                links: response.content.childs.map(function (category) {
                                    var specialLink = this.buildSpecialLink(category.name, response.content.uuid, category.uuid);
                                    if(specialLink){
                                        angular.extend(category, specialLink);
                                    }else{
                                        category.href = String.format('index.contentCategories.contentSubcategories.article({{categoryUUID : \'{0}\', articleUUID : \'{1}\'}})',
                                            response.content.uuid, category.uuid);
                                    }

                                    return category;
                                }, this),

                                state: 'index.contentCategories.contentSubcategories({categoryUUID : \'' + response.content.uuid + '\'})',
                                url: $state.href('index.contentCategories.contentSubcategories', {categoryUUID: response.content.uuid}),
                                uuid: response.content.uuid
                            };
                        }, this);
                        return result;
                    },


                    getFromResource: function () {
                        return $translate([
                            'menu.serverNames.disease',
                            'menu.serverNames.pregnancy',
                            'menu.serverNames.calendar',
                            'menu.serverNames.supplements',
                            'menu.serverNames.food'
                        ]).then(function (headlines) {
                            this.serverKeys = headlines;

                            return contentCategoriesResource.getSections().then(function (response) {

                                var promisesArray = response.content.items.map(function (item) {
                                    return contentCategoriesResource.getSectionsContent(item.uuid);
                                });

                                return $q.all(promisesArray).then(function (response) {
                                    return this._categotiesSetting(response, headlines);
                                }.bind(this))
                            }.bind(this));
                        }.bind(this));
                    },

                    getCategories: function () {
                        return this.load();
                    },

                    _setEntity: function (result) {
                        this.entity = result;
                        this.links = [];
                        result.forEach(function (item) {
                            this.links.push(item);
                            this.links = this.links.concat(item.links);
                        }, this);
                    },

                    getLinks: function () {
                        return this.links;
                    },

                    getLink: function (linkType) {
                        return this.links.filter(function (item) {
                            return item.linkType == linkType;
                        })[0]
                    },

                    getPregnancyLink: function () {
                        return this.getLink(linkTypes.pregnancy);
                    },

                    getCalendarLink: function () {
                        return this.getLink(linkTypes.calendar);
                    },

                    getServerKey: function (keyName) {
                        return this.serverKeys[keyName];
                    },

                    getSpecialLink: function (name, categoryUUID, childCategoryUUID) {
                        if (name.indexOf(this.serverKeys['menu.serverNames.calendar']) >=0) {
                            return this.getLink( linkTypes.calendar);
                        }

                        if (name.indexOf(this.serverKeys['menu.serverNames.supplements']) >= 0
                        // check name length too
                        && this.serverKeys['menu.serverNames.supplements'].length === name.length) {
                            return this.getLink(linkTypes.supplementsCategories);
                        }

                        return null;
                    },

                    buildSpecialLink: function (name, categoryUUID, childCategoryUUID) {
                        if (name.indexOf(this.serverKeys['menu.serverNames.calendar']) >=0) {
                            return {
                                href: String.format('index.contentCategories.contentSubcategories.calendar({{categoryUUID : \'{0}\'}})', categoryUUID),
                                url: $state.href('index.contentCategories.contentSubcategories.calendar', {categoryUUID: categoryUUID}),
                                linkType: linkTypes.calendar,
                                name: name
                            };
                        }

                        if (name.indexOf(this.serverKeys['menu.serverNames.supplements']) >= 0
                        // check name length too
                        && this.serverKeys['menu.serverNames.supplements'].length === name.length) {
                            return {
                                href: String.format('index.contentCategories.contentSubcategories.food.supplementsCategories({{categoryUUID : \'{0}\'}})', categoryUUID),
                                url: $state.href('index.contentCategories.contentSubcategories.food.supplementsCategories', {categoryUUID: categoryUUID}),
                                linkType: linkTypes.supplementsCategories,
                                name: name
                            };
                        }

                        return null;
                    }

                });


                return new ContentCategoriesServece();
            }]);
})();

angular.module('babycompy.constants')
    .constant('resources', {
        users: 'users',
        musers: 'musers',
        enxadmins: 'enxadmins',
        madmins: 'madmins',
        consumers: 'consumers',

        algorithms: 'algorithms',
        roles: 'roles',
        explain: 'explain',
        menu: 'menu',
        auth: 'account',
        userProfile: 'userProfile',
        configurations: 'configurations',
        templates: 'templates',
        configurationImport: 'configurationImport',
        gateways: 'gateways',
        wakeUpCalendarItems: 'wakeUpCalendarItems',
        locations: 'locations',
        healthFacilities: 'healthFacilities',
        healthFacilitiesTypes: 'healthFacilitiesTypes',
        facilitiesDepartments: 'facilitiesDepartments',
        services: 'services',
        doctors: 'doctors',
        doctorDepartments: 'doctorDepartments',
        devices: 'devices',
        enums: 'enums',
        ftp: 'ftp',
        dashboard: 'dashboard',
        dataFormat: 'dataFormat',
        media: 'media',
        gatewayOwners: 'gatewayOwners',
        manufacturers: 'manufacturers',
        meterTypes: 'meterTypes',
        measurementUnits: 'measurementUnits',
        meters: 'meters',
        wmBusFrames: 'frames',
        unrecognizedFrames: 'wmbusFrames',
        reports: 'reports',
        termsOfService: 'termsOfService',
        questions: 'questions',
        answers: 'answers',

        meterMappings: 'meterMappings',
        constraints: 'constraints',

        companies: 'companies',
        departments: 'departments',
        jobRoles: 'jobRoles',
        occupations: 'occupations',

        dataRecordTypes: 'dataRecordTypes',
        childAges: 'childAges',
        dictionaries: 'dictionaries',
        news: 'news'
    })
    .constant('enums', {
        userRole: 'UserRole',
        configurationStatus: 'ConfigurationStatus',
        fileType: 'FileType',
        gprsConnectionTime: 'GPRSConnectionTime',
        gprsRunningMode: 'GPRSRunningMode',
        UserRole: 'UserRole',
        readingFrequency: 'ReadingFrequency',
        wmBusModeType: 'WMBusModeType',
        messageType: {
            success: 'success',
            error: 'error'
        },
        allowedExt: {
            'zip': 1,
            'xml': 1
        },
        selectFavoriteTypes: {
            articles: 0,
            medicine: 1,
            products: 2,
            supplements: 3,
            algorithms: 4,
            news: 5,
            clinics: 6,
            doctors: 7,
            medicAnswers: 8
        },
        selectFavoriteByType: {
            0: 'articles',
            1: 'medicine',
            2: 'products',
            3: 'supplements',
            4: 'algorithms',
            5: 'news',
            6: 'clinics',
            7: 'doctors',
            8: 'medicAnswers'
        },
        favoriteEvents: {
          added: "added",
          deleted: "deleted"  
        },
        ageType: {
            newBorn: 'newBorn',
            months: 'months',
            years: 'years',
            ageRange: 'ageRange'
        },
        alertType: {
            success: 'success',
            warning: 'warning',
            error: 'danger'
        },
        
        pageTypes: {
            whoWeAre: 0,
            aboutProject: 1,
            helpWithSite: 2,
            doctorsAndClinics: 3,
            advertiser: 4,
            confidentiality: 5,
            termsOfUse: 6,
            ourTeam: 7,
            nutritinalSupplements: 7
        }

    })
    .constant('webSocketConstants', {
        events: {
            added: 'ADD',
            list: 'LIST',
            deleted: 'REMOVE',
            updated: 'UPDATE'
        },
        entities: {
            locations: 'location'
        }
    })
    .constant('app', {
        localStorageKey: 'babycompy.localStorage',
        algorithmLocalStorageKey: 'algorithm',
        newEntityPath: 'new'
    }).constant('auth', {
        tokenHeaderName: 'X-Auth-Token'
    }).constant('entityTypes', {
        gateway: 'gateway',
        configuration: 'configuration',
        template: 'template',
        gwuuid: 'gwuuid',
        location: 'location'
    }).constant('routeParams', {
        parentId: 'puuid'
    }).constant('applicationEvents', {
        beforeLogout: 'beforeLogout',
        loggedIn: 'loggedIn'
    }).constant('facebook', {
        // productionKey  appId: '560258827477579',
        // devKey appId:'589969621173166',
        appId:'560258827477579',
        apiVersion: 'v2.5'
    }).constant('google', {
      clientId: '311666272029-ob13gl2mgif0dlsn2387s8pr9sthmpuh.apps.googleusercontent.com',
      apiKey: 'GAJ6UnYcG65hl15beqgnQ8iP'
    }).constant('openGraph', {
        defaultImage: 'http://babycompy.com/assets/images/social/BabyCompy_Social.png'
    });

angular.module('babycompy.common').service('compareObjects', [function () {
    return function () {
        var i, l, leftChain, rightChain;

        function compare2Objects(x, y) {
            var p;

            // remember that NaN === NaN returns false
            // and isNaN(undefined) returns true
            if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
                return true;
            }

            // Compare primitives and functions.     
            // Check if both arguments link to the same object.
            // Especially useful on step when comparing prototypes
            if (x === y) {
                return true;
            }

            // Works in case when functions are created in constructor.
            // Comparing dates is a common scenario. Another built-ins?
            // We can even handle functions passed across iframes
            if ((typeof x === 'function' && typeof y === 'function') ||
               (x instanceof Date && y instanceof Date) ||
               (x instanceof RegExp && y instanceof RegExp) ||
               (x instanceof String && y instanceof String) ||
               (x instanceof Number && y instanceof Number)) {
                return x.toString() === y.toString();
            }

            // At last checking prototypes as good a we can
            if (!(x instanceof Object && y instanceof Object)) {
                return false;
            }

            if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
                return false;
            }

            if (x.constructor !== y.constructor) {
                return false;
            }

            if (x.prototype !== y.prototype) {
                return false;
            }

            // check for infinitive linking loops
            if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
                return false;
            }

            // Quick checking of one object beeing a subset of another.
            // todo: cache the structure of arguments[0] for performance
            for (p in y) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }
            }

            for (p in x) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                }
                else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }

                switch (typeof (x[p])) {
                    case 'object':
                    case 'function':

                        leftChain.push(x);
                        rightChain.push(y);

                        if (!compare2Objects(x[p], y[p])) {
                            return false;
                        }

                        leftChain.pop();
                        rightChain.pop();
                        break;

                    default:
                        if (x[p] !== y[p]) {
                            return false;
                        }
                        break;
                }
            }

            return true;
        }

        if (arguments.length < 1) {
            throw new Error("Need two or more arguments to compare");
        }

        for (i = 1, l = arguments.length; i < l; i++) {

            leftChain = []; //todo: this can be cached
            rightChain = [];

            if (!compare2Objects(arguments[0], arguments[i])) {
                return false;
            }
        }

        return true;
    }
}]);
angular.module('babycompy.base')
    .factory('backService', ['$window', function ($window) {
        return {
            back: function () {
                // because first record is current page itself
                if (window.history.length > 1) {
                    $window.history.back();
                }
            }
        };
    }]);
angular.module('babycompy.base')
.factory('applicationLifecycle', ['applicationEvents', function (applicationEvents) {


    var handlers = Object.create(null);
    handlers[applicationEvents.beforeLogout] = [];
    
    handlers[applicationEvents.loggedIn] = [];

    function ApplicationLifecycle() {

    }

    ApplicationLifecycle.prototype.onBeforeLogout = function (handler) {
        handlers[applicationEvents.beforeLogout].push(handler);
    };

    ApplicationLifecycle.prototype.beforeLogout = function (handler) {
        handlers[applicationEvents.beforeLogout].forEach(function (v) {
            v();
        });
    };
    
    ApplicationLifecycle.prototype.onLoggedIn = function (handler) {
        handlers[applicationEvents.loggedIn].push(handler);
    };

    ApplicationLifecycle.prototype.loggedIn = function (a) {
        handlers[applicationEvents.loggedIn].forEach(function (v) {
            v(a);
        });
    };

    return new ApplicationLifecycle();
}]);

(function() {

  angular.module('babycompy.base')

    .service('AdSense', ['$location', '$rootScope', function($location, $rootScope) {
      this.currentHost = $location.host();
      this.isDevHost = (this.currentHost.indexOf('dev') >= 0 || this.currentHost.indexOf('loc') >= 0 || this.currentHost.indexOf('192') >= 0);
      this.scriptUrl = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
      this.scriptLoaded = false;
      this.isTest = false;
      this.throttleTO = 250;
      this.showPlaceholder = true;
      this.defaultOpts = {
        laziness: 1,
        onLoad: false
      };

      this.addClass = function(el, className) {
        if (el.classList) el.classList.add(className);
        else el.className += ' ' + className;
      };

      this.getOffset = function(el) {
        var rect = el.getBoundingClientRect();
        return {
          top: rect.top + document.body.scrollTop,
          left: rect.left + document.body.scrollLeft
        };
      };

      this.loadScript = function(url, callback) {
        var s = document.createElement('script');
        var head = document.getElementsByTagName('head')[0];
        s.src = url;
        s.async = true;
        s.addEventListener('load', function() {
          s.parentNode.removeChild(s);
          if (typeof callback === 'function')
            callback();
        }.bind(this));
        head.appendChild(s);
      };

      this.throttle = function(a, b) {
        var c, d;
        return function() {
          var e = this,
            f = arguments,
            g = +new Date;
          c && g < c + a ? (clearTimeout(d), d = setTimeout(function() {
            c = g, b.apply(e, f)
          }, a)) : (c = g, b.apply(e, f))
        }
      };

      this.adsToLoad = [];
      this.adsLoaded = [];
      this.adsPending = [];

      this.loadAd = function(ad) {
        if (!ad.clientWidth) return;

        (adsbygoogle = window.adsbygoogle || []).push({});

        var onLoadFn = ad._adsenseLoaderData.options.onLoad;

        ad.querySelector('iframe').addEventListener('load', function() {
          if (typeof onLoadFn === 'function') onLoadFn(ad);
          setTimeout(function () {
            this.showPlaceholder = false;
          }.bind(this), 0)
        }.bind(this));
      };

      this.initAds = function() {
        if (!this.adsToLoad.length) return true;

        var winScroll = window.pageYOffset,
          winHeight = window.innerHeight;

        this.adsToLoad.forEach(function(ad) {

          var offset = this.getOffset(ad).top,
            laziness = ad._adsenseLoaderData.options.laziness + 1;

          // if the element is too far below || too far above
          if (offset - winScroll > winHeight * laziness || winScroll - offset - ad.offsetHeight - (winHeight * laziness) > 0)
            return true;

          this.adsToLoad = this.removeAdFromList(this.adsToLoad, ad);
          ad._adsenseLoaderData.width = this.getAdWidth(ad);
          this.addClass(ad.children[0], 'adsbygoogle');
          this.adsLoaded.push(ad);

          if (typeof adsbygoogle !== 'undefined') this.loadAd(ad);
          else this.adsPending.push(ad);

          if (!this.scriptLoaded) {
            this.scriptLoaded = true;
            this.loadScript(this.scriptUrl, function() {
              this.adsPending.forEach(this.loadAd.bind(this));

            }.bind(this));
          }
        }.bind(this));
      };

      this.resizeAds = function() {
        if (!this.adsLoaded.length) return true;

        var anyNew = false;
        this.adsLoaded.forEach(function(ad) {
          if (ad._adsenseLoaderData.width != this.getAdWidth(ad)) {
            anyNew = true;
            this.adsLoaded = this.removeAdFromList(this.adsLoaded, ad);
            ad.innerHTML = ad._adsenseLoaderData.originalHTML;
            this.adsToLoad.push(ad);
          }
        }.bind(this));
        if (anyNew) this.initAds();
      };

      this.getAdWidth = function(ad) {
        return parseInt(window.getComputedStyle(ad, ':before').getPropertyValue('content').slice(1, -1) || 9999);
      };

      this.removeAdFromList = function(list, element) {
        return list.filter(function(entry) {
          return entry !== element;
        });
      };

      this.normalizeAdElement = function(ad, options) {
        ad._adsenseLoaderData = {
          originalHTML: ad.innerHTML,
          options: options
        };
        ad.adsenseLoader = function(method) {
          if (method == 'destroy') {
            this.adsToLoad = this.removeAdFromList(this.adsToLoad, ad);
            this.adsLoaded = this.removeAdFromList(this.adsLoaded, ad);
            this.adsPending = this.removeAdFromList(this.adsLoaded, ad);
            ad.innerHTML = ad._adsenseLoaderData.originalHTML;
          }
        }.bind(this);
        return ad;
      };

      this.extendObj = function(defaults, options) {
        var prop, extended = {};
        for (prop in defaults)
          if (Object.prototype.hasOwnProperty.call(defaults, prop))
            extended[prop] = defaults[prop];

        for (prop in options)
          if (Object.prototype.hasOwnProperty.call(options, prop))
            extended[prop] = options[prop];

        return extended;
      };

      this.isElement = function(o) {
        return (
          typeof HTMLElement === "object" ? o instanceof HTMLElement :
          o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
        );
      };

      this.start = function(element, options) {

        var opt = this.extendObj(this.defaultOpts, options);
        if (this.isElement(element[0])) {
          var entry = this.normalizeAdElement(element[0], opt);
          this.adsToLoad.push(entry);
        }
        this.elements = this.adsToLoad;
        this.initAds();
      };

      this.rmGlKey = function() {
        if (typeof adsbygoogle !== 'undefined') {
          ["adk2_experiment",
            "async_config",
            "correlator",
            "exp_persistent",
            "iframe_oncopy",
            "jobrunner",
            "num_0ad_slots",
            "num_ad_slots",
            "num_reactive_ad_slots",
            "num_sdo_slots",
            "num_slot_to_show",
            "num_slots_by_channel",
            "onload_fired",
            "persistent_language",
            "persistent_state",
            "persistent_state_async",
            "prev_ad_formats_by_region",
            "prev_ad_slotnames_by_region",
            "pstate_expt",
            "pstate_rc_expt",
            "reactive_ads_global_state",
            "top_js_status",
            "unique_id",
            "viewed_host_channels"
          ].forEach(function(val) {
            delete window["google_" + val];
          });
          delete window.adsbygoogle;
        }
      };

      window.addEventListener('scroll', this.throttle(this.throttleTO, this.initAds.bind(this)));
      window.addEventListener('resize', this.throttle(this.throttleTO, this.initAds.bind(this)));
      window.addEventListener('resize', this.throttle(this.throttleTO, this.resizeAds.bind(this)));
      $rootScope.$on('$stateChangeStart', function () {
        this.rmGlKey();
        this.adsToLoad = [];
        this.adsLoaded = [];
        this.adsPending = [];
      }.bind(this));

      $rootScope.$on('$stateChangeSuccess', function () {
        this.scriptLoaded = false;
        this.initAds();
      }.bind(this));


      this.advertType = {
        vertical: {
          width: '160px',
          height: '600px',
          adClient: 'ca-pub-1496537292778110',
          adSlot: '7763175589',
          stubImgSrc: 'assets/images/banners/banner_160x600.png',
          stubLink: '/signUp/user',
          altText: 'seo.alt.regUserBanner',
          format: 'vertical',
          class: 'vertical'
        },

        horizontal: {
          width: '970px',
          height: '90px',
          adClient: 'ca-pub-1496537292778110',
          adSlot: '6286442381',
          stubImgSrc: 'assets/images/banners/banner_970x90.png',
          stubLink: '/signUp/doctor',
          altText: 'seo.alt.regDoctorBanner',
          format: 'horizontal',
          class: 'horizontal'
        },

        block200: {
          width: '200px',
          height: '200px',
          adClient: 'ca-pub-1496537292778110',
          adSlot: '9239908784',
          stubImgSrc: 'assets/images/banners/banner_200x200.png',
          stubLink: 'http://www.facebook.com/BabyCompy',
          altText: 'seo.alt.facebook',
          format: 'rectangle',
          class: 'square'
        },

        block300: {
          width: '300px',
          height: '250px',
          adClient: 'ca-pub-1496537292778110',
          adSlot: '1716641987',
          stubImgSrc: 'assets/images/banners/banner_300_250.png',
          stubLink: 'http://www.facebook.com/BabyCompy',
          altText: 'seo.alt.facebook',
          format: 'rectangle',
          class: 'rectangle'
        }

      };

      this.advertDevelop = {
        vertical: {
          width: '160px',
          height: '600px',
          adClient: 'ca-pub-0000000000000000',
          adSlot: '0000000000',
          stubImgSrc: 'assets/images/banners/banner_160x600.png',
          stubLink: '/signUp/user',
          altText: 'seo.alt.regUserBanner',
          format: 'vertical',
          class: 'vertical'
        },

        horizontal: {
          width: '970px',
          height: '90px',
          adClient: 'ca-pub-0000000000000000',
          adSlot: '0000000000',
          stubImgSrc: 'assets/images/banners/banner_970x90.png',
          stubLink: '/signUp/doctor',
          altText: 'seo.alt.regDoctorBanner',
          format: 'horizontal',
          class: 'horizontal'
        },

        block200: {
          width: '200px',
          height: '200px',
          adClient: 'ca-pub-0000000000000000',
          adSlot: '0000000000',
          stubImgSrc: 'assets/images/banners/banner_200x200.png',
          stubLink: 'http://www.facebook.com/BabyCompy',
          altText: 'seo.alt.facebook',
          format: 'square',
          class: 'square'
        },

        block300: {
          width: '300px',
          height: '250px',
          adClient: 'ca-pub-0000000000000000',
          adSlot: '0000000000',
          stubImgSrc: 'assets/images/banners/banner_300_250.png',
          stubLink: 'http://www.facebook.com/BabyCompy',
          altText: 'seo.alt.facebook',
          format: 'rectangle',
          class: 'rectangle'
        }
      };

    }])
}());



/*
* @class EventTarget
* This class contains functionality 
*/
angular.module('babycompy.base')
    .factory('EventTarget', [function () {

        var undefined;

        var EventTarget = Class.extend({
            init: function () {
                this._listeners = {};
            },

            /*
            * @function 
            * @name addListener
            * @param type {string} property name
            * @param listener {function} function (event{target, type, property}){}
            * @param context (object) context will be 'this' in handler
            */
            addListener: function (type, listener, context) {
                if (this._listeners[type] === undefined) {
                    this._listeners[type] = [];
                }

                if (!listener) {
                    console.warn('Listener not specified!');
                    return;
                }

                this._listeners[type].push({ handler: listener, context: context });
            },

            bindOnce: function (type, listener, context) {
                if (this._listeners[type] === undefined) {
                    this._listeners[type] = [];
                }

                this._listeners[type].push({
                    handler: function (ctx, i) {
                        return function (event) {
                            listener.call(context, event);
                            if (ctx._listeners[type] instanceof Array) {
                                ctx._listeners[type].splice(i, 1);
                            }
                        }
                    }(this, this._listeners[type].length),
                    context: context
                });
            },

            /*
            * @function
            * @name fire
            * @param event event{target, type, property} 
            */
            fire: function (event) {
                if (typeof event == "string") {
                    event = { type: event };
                }

                if (!event.type) {
                    throw new Error("Event object missing 'type' property.");
                }

                if (this._listeners[event.type] instanceof Array) {
                    var listeners = this._listeners[event.type];
                    for (var i = 0; i < listeners.length; i++) {
                        try {
                            listeners[i].handler.call(listeners[i].context, event);
                        }
                        catch (e) {
                            throw new Error(e);
                        }
                    }
                }
            },

            /*
            * @function 
            * @name removeListener
            * @param type {string} property name
            * @param listener {function} function (event{target, type, property}){}
            */
            removeListener: function (type, listener) {
                if (this._listeners[type] instanceof Array) {
                    var listeners = this._listeners[type];
                    for (var i = 0; i < listeners.length; i++) {
                        if (listeners[i].handler === listener) {
                            listeners.splice(i, 1);
                            break;
                        }
                    }
                }
            },

            removeAllListeners: function (type) {
                if (this._listeners[type] instanceof Array) {
                    this._listeners[type] = [];
                }
            }

        });

        return EventTarget;
    }]);
;(function () {
    'use strict;'

    angular.module('babycompy.base').filter('trusted', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }]);
})();
angular.module('babycompy.base').filter('trustResource', ['$sce', function ($sce) {
    return function(url) {
        return $sce.trustAsResourceUrl(url);
    };
}]);

(function () {
    'use strict;'

    angular.module('babycompy.base').filter('trust', ['$sce', function($sce) { return $sce.trustAsHtml; }]);
})();

(function () {
  'use strict;'

  angular.module('babycompy.base').filter('trim', function () {

    return function (value) {
      if (!angular.isString(value)) {
        return value;
      }

      return value.trim();
    };
  });
})();

(function () {
    'use strict;'

    angular.module('babycompy.base').filter('lineBreak', function () {

        return function (input) {
            if (input) {
                input = input.replace(/(\r\n|\r|\n)/g, '<br />');
            }
            return input;
        };
    });
})();
(function () {
    'use strict;'

angular.module('babycompy.base').filter('htmlToPlaintext', function() {
    return function(text) {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }
);
})();
(function () {
    'use strict;'

    angular.module('babycompy.base').filter('dot', function () {

        return function (value, len) {
            if (!angular.isString(value)) {
                return value;
            }

            value = value.trim();
            if (value.length > len) {
                value = value.substr(0, len).trim();
                value = value.substring(0, value.lastIndexOf(' ')) + '...';
            }

            return value;
        };
    });
})();

(function () {
    'use strict;'

    angular.module('babycompy.base').filter('capitalize', function() {
    	return function(input) {
      		return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1) : '';
    	}
	});
})();
//replace content with template without creating child scope
angular.module('babycompy.base').directive('staticInclude', ['$http', '$templateCache', '$compile',
    function ($http, $templateCache, $compile) {
        return {
            link: function (scope, element, attrs) {
                var templatePath = attrs.staticInclude;
                var contents = element.html($templateCache.get(templatePath)).contents();
                $compile(contents)(scope);
            }
        }
    }]);
angular.module('babycompy.base')
    .directive('select', [function () {
        return {
            restrict: 'E',
            link: function (scope, element, attr) {
                var select = angular.element(element);
                select.addClass("empty");
                select.change(function () {
                    angular.element(element).val() === '' ? select.addClass("empty") : select.removeClass("empty");
                });
            }
        };
    }]);
(function () {
    angular.module('babycompy.base').directive('matchValidator', [function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attr, ctrl) {
                var pwdWidget = elm.inheritedData('$formController')[attr.matchValidator];

                ctrl.$parsers.push(function (value) {
                    if (value === pwdWidget.$viewValue || (value === '' && !pwdWidget.$viewValue)) {
                        ctrl.$setValidity('match', true);
                        return value;
                    }

                    if (value && pwdWidget.$viewValue) {
                        ctrl.$setValidity('match', false);
                    }

                });

                pwdWidget.$parsers.push(function (value) {
                    if (value && ctrl.$viewValue) {
                        ctrl.$setValidity('match', value === ctrl.$viewValue);
                        ctrl.$setValidity('parse', true);
                    }
                    return value;
                });
            }
        };
    }])
})();
angular.module('babycompy.base').directive('loadOnScroll', ['$parse' , function ($parse) {
    return {
        restrict: 'A',

        link: function (scope, element, attrs) {
            var fn = $parse(attrs.loadOnScroll), load = false;

            element.on('scroll', function (event) {
                if (element.scrollTop() > (element[0].scrollHeight - element.height() - 100)) {
                    if (!load) {
                            fn(scope);
                    }

                    load = true;
                } else {
                    load = false;
                }
            });
        }
    };
}]);


angular.module('babycompy.base')
    .directive('inject', function () {
        return {
            link: function ($scope, $element, $attrs, controller, $transclude) {
                if (!$transclude) {
                    throw minErr('ngTransclude')('orphan',
                        'Illegal use of ngTransclude directive in the template! ' +
                        'No parent directive that requires a transclusion found. ' +
                        'Element: {0}',
                        startingTag($element));
                }

                var innerScope = $scope.$new();
                $transclude(innerScope, function (clone) {
                    $element.empty();
                    $element.append(clone);
                    $element.on('$destroy', function () {
                        innerScope.$destroy();
                    });
                });
            }
        };
    });
angular.module('babycompy.base').directive('includeReplace', ['$compile', function ($compile) {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */
        link: function (scope, el, attrs, controller) {
            
            controller.onload = function() {             
                el.children().each(function(i, e) {
                    $compile(e)(scope);
                });
                
                el.replaceWith(el.children());   
            }
        }
    };
}]);
(function (angular) {
    'use strict'
    angular.module('babycompy.base').directive('googleMap', ['$timeout', function ($timeout) {
        var defaults = {
          zoom: 18
        };

        return {
            restrict: 'A',
            scope:{
                position:'=?',
                options:'=?'
            },
            link: function (scope, element, attr) {
                scope.options = angular.extend(scope.options || {}, defaults);

                scope.onMapLoaded = function () {
                    var map = new google.maps.Map(element[0], {
                        center: scope.position
                    });

                    var marker = new google.maps.Marker({
                        position: scope.position,
                        map: map,
                        title: ''
                    });

                    map.setZoom(scope.options.zoom);
                };


                $timeout(function () {
                    if (window.google && window.google.maps) {
                        scope.onMapLoaded();
                    } else {
                        window.initialize = function () {
                            scope.onMapLoaded()
                        };

                        $.getScript('http://maps.googleapis.com/maps/api/js?&libraries=places&key=AIzaSyAmxvFCZnOD69KnTMnyz4PsXa_xhNwWpC4&sensor=false&callback=initialize', function () {
                        }.bind(this)); //this == window
                    }
                }.bind(this), 1);
            }
        };
    }]);
})(angular);
angular.module('babycompy.base').directive('gausBlur', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            blur: '=',
            index: '='
        },
        template: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' height='0'>" +
            "<filter id='{{&quot;blur&quot; + index}}'>" +
            "<feGaussianBlur id='{{&quot;blurAttr&quot; + index}}'/>" +
           "</filter>" +
           "</svg>",
        link: function (scope, element, attr) {
            scope.$watch('blur', function (newValue) {
              if (newValue) element.find('feGaussianBlur')[0].setAttribute('stdDeviation', scope.blur);
            })
        }
    };
});

/**
 * Created by Vlad on 13.10.2014.
 */

angular.module('babycompy.base')
    .directive('findReset', [function () {

        return {
            restrict: 'E',
            scope: {
                searchAction: '&',
                resetAction: '&'
            },
            replace: true,
            template: '<div><button class="btn btn-primary" data-ng-click="search($event)"><i class="fa fa-search"></i> Find\
            <i data-ng-show="activities.searchAction" class="fa fa-spinner fa-spin"></i>\
            </button>\
             <button class="btn btn-default text-blue" data-ng-click="reset($event)">Reset\
             <i data-ng-show="activities.resetAction" class="fa fa-spinner fa-spin"></i></button></div>',

            controller: ['$scope', function (scope) {

                scope.lock = false;
                scope.activities = {
                    searchAction: false,
                    resetAction: false
                };

                scope.search = function ($event) {
                    scope.performAction($event, 'searchAction');
                };

                scope.reset = function ($event) {
                    scope.performAction($event, 'resetAction');
                };

                scope.performAction = function ($event, action) {

                    var elem = angular.element($event.currentTarget);
                        icon = elem.find('i');

                    if (scope.lock) {
                        return;
                    }

                    scope.lock = true;
                    scope.activities[action] = true;
                    icon.show();

                    if (scope[action]) {
                        scope[action]().then(function () {
                            scope._afterAction(action, icon);
                        }).catch(function () {
                            scope._afterAction(action, icon);
                        });
                    } else {
                        scope._afterAction(action, icon);
                    }
                };

                scope._afterAction = function(action, icon){
                    scope.lock = false;
                    scope.activities[action] = false;
                    icon.hide();
                };
            }]
        };
    }]);

angular.module('babycompy.base').directive('fileWrapper', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var instance = $parse(attrs.fileWrapper)(scope);

            instance.openFile = function () {
                element.trigger('click');
            };

            element.bind('change', function (event) {
                instance.fileAdded(event, {file: event.currentTarget.files});
                element.val(null);
            });
        }
    };
}]);

angular.module('babycompy.base')
    .directive('enterDirective', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.enterDirective, { 'event': event });
                });

                event.preventDefault();
            }
        });
    };
});
angular.module('babycompy.base')
.directive('validationEmail', function () {
    var EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return {
        require: 'ngModel',
        restrict: '',
        link: function (scope, elm, attrs, ctrl) {
            // only apply the validator if ngModel is present and Angular has added the email validator
            if (ctrl && ctrl.$validators.email) {

                // this will overwrite the default Angular email validator
                ctrl.$validators.email = function (modelValue) {
                    return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
                };
            }
        }
    };
});
(function (angular) {
    angular.module('babycompy.base').directive('dynamicContent', ['$compile', '$parse', '$templateRequest', function ($compile, $parse, $templateRequest) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('dynamicContent', function(newValue){
                    if(!newValue){
                        element.html('');
                        return;
                    }

                    //for static pages test
                    //$templateRequest('/assets/about-test.html').then(function(result){
                    //    element.html(result);
                    //    $compile(element.contents())(scope);
                    //});

                    element.html($parse(newValue)(scope));
                    $compile(element.contents())(scope);
                });
            }
        };
    }]);

})(angular);
angular.module('babycompy.base').directive('delayedRender', ['$compile',
    function ($compile) {
        return {
            compile: function compile(templateElement, templateAttrs) {
                this._savedHTML = templateElement[0].innerHTML;
                templateElement.html("");
                return this.link.bind(this);
            },
            link: function (scope, element, attrs) {
                attrs.$observe('ready', function (ready) {
                    if (ready === "true") {
                        var contents = element.html(this._savedHTML).contents();
                        $compile(contents)(scope);
                    }
                }.bind(this));
            }
        }
    }]);
angular.module('babycompy.base')
    .directive('contextDropdown', ['$timeout', '$dropdown', function ($timeout, $dropdown) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {

                var tempX, tempY;
                var dropdown = $dropdown(element, {
                    templateUrl: attr.contextDropdown,
                    scope: scope,
                });

                //1. remember event click position
                element.on('click', function (e) {
                    var pos = $(e.currentTarget).position();

                    tempX = e.offsetX + pos.left;
                    tempY = e.offsetY + pos.top;
                });

                //2. positioning dropdown and show it setting opacity to 1
                scope.$on('dropdown.show.before', function (e) {
                    $timeout(function () {
                        if (dropdown.$element) {
                            dropdown.$element
                                .css({'top': tempY, 'left': tempX})
                                .css('opacity', 1);
                        }
                    }, 0, false);

                });

            }
        };
    }]);

(function (angular) {
    angular.module('babycompy.base').directive('checkMobile', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
              if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                element.addClass('mobileDevice');
              }
            }
        };
    }]);
})(angular);

angular.module('babycompy.base').directive('blurAndFocus', [function () {
    return function(scope, elem, attr) {
        scope.$on(attr.blurAndFocus, function(e) {
            elem[0].blur();
            elem[0].focus();
        });
    };
}]);


angular.module('babycompy.base').directive('backButton', ['backService', function (backService) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            element.bind('click', function () {
                backService.back();
            });
        }
    };
}]);
(function (angular) {
  angular.module('babycompy.mainSlider')
    .directive('babyCompySlider', ['$window', '$timeout', '$modal', function ($window, $timeout, $modal) {
      return {
        restrict: 'E',
        replace: true,
        template: getTemplate(),
        scope: {
          list: '=',
          initOnload: '@',
          data: '=',
          currentIndex: '=',
          accessibility: '@',
          adaptiveHeight: '@',
          arrows: '@',
          asNavFor: '@',
          appendArrows: '@',
          appendDots: '@',
          autoplay: '@',
          autoplaySpeed: '@',
          centerMode: '@',
          centerPadding: '@',
          cssEase: '@',
          customPaging: '&',
          dots: '@',
          draggable: '@',
          easing: '@',
          fade: '@',
          focusOnSelect: '@',
          infinite: '@',
          initialSlide: '@',
          lazyLoad: '@',
          onBeforeChange: '&',
          onAfterChange: '&',
          onInit: '&',
          onReInit: '&',
          onSetPosition: '&',
          pauseOnHover: '@',
          pauseOnDotsHover: '@',
          responsive: '=',
          rtl: '@',
          slide: '@',
          slidesToShow: '@',
          slidesToScroll: '@',
          speed: '@',
          swipe: '@',
          swipeToSlide: '@',
          touchMove: '@',
          touchThreshold: '@',
          useCSS: '@',
          variableWidth: '@',
          vertical: '@',
          prevArrow: '@',
          nextArrow: '@'
        },
        link: linkFunc
      };

      function linkFunc(scope, element, attrs, ctrl) {

        var destroySlick,
          initializeSlick,
          isInitialized,
          slide;

        scope.href = window.location.href;

        scope.videoModal = {
          actions: $modal({
            templateUrl: 'app/components/core/templates/modal-video.html',
            show: false,
            animation: "am-fade-and-scale",
            scope: scope,
            placement: "center"
          })
        };

        scope.showVideo = function (link) {
          scope.videoLink = link.replace("watch?v=", "embed/");
          scope.videoModal.actions.show()
        };

        destroySlick = function () {
          return $timeout(function () {
            var slider;

            slider = $(element);
            slider.slick('unslick');
            slider.find('.slick-list').remove();
            return slider;
          });
        };
        initializeSlick = function () {
          return $timeout(function () {

            var currentIndex,
              customPaging,
              slider;

            slider = $(element);
            if (scope.currentIndex != null) {
              currentIndex = scope.currentIndex;
            }
            customPaging = function (slick, index) {
              return scope.customPaging({
                slick: slick,
                index: index
              });
            };
            slider.slick({
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? $(scope.appendArrows) : $(element),
              appendDots: scope.appendDots ? $(scope.appendDots) : $(element),
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attrs.customPaging ? customPaging : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              easing: scope.easing || 'linear',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              infinite: scope.infinite !== 'false',
              initialSlide: scope.initialSlide || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              beforeChange: attrs.onBeforeChange ? scope.onBeforeChange : void 0,
              onReInit: attrs.onReInit ? scope.onReInit : void 0,
              onSetPosition: attrs.onSetPosition ? scope.onSetPosition : void 0,
              pauseOnHover: scope.pauseOnHover !== 'false',
              responsive: scope.responsive || void 0,
              rtl: scope.rtl === 'true',
              slide: scope.slide || 'li',
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              prevArrow: scope.prevArrow ? $(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? $(scope.nextArrow) : void 0
            });
            slider.on('init', function (sl) {

              if (attrs.onInit) {
                scope.onInit();
              }

              if (currentIndex != null) {
                return sl.slideHandler(currentIndex);
              }

            });
            slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
              if (scope.onAfterChange) {
                scope.onAfterChange();
              }
              if (currentIndex != null) {
                return scope.$apply(function () {
                  currentIndex = currentSlide;
                  return scope.currentIndex = currentSlide;
                });
              }
            });

            scope.$on('$stateChangeSuccess', function (e, toState) {
              if (toState['name'] === 'index') {
                setTimeout(function(){
                  slider.slick('setPosition');
                }, 10)
              }
            });

            return scope.$watch('currentIndex', function (newVal, oldVal) {
              if (currentIndex != null && newVal != null && newVal !== currentIndex) {
                return slider.slick('slickGoTo', newVal);
              }
            });
          });
        };

        if (scope.initOnload) {
          isInitialized = false;
          return scope.$watch('list', function (newVal, oldVal) {
            if (newVal != null) {
              if (isInitialized) {
                destroySlick();
              }
              initializeSlick();
              return isInitialized = true;
            }
          });
        } else {
          return initializeSlick();
        }
      }

      function getTemplate() {
        return [
          '<ul id="home-slider">',
            '<li ng-style="{\'background-image\': \'url({{\'api/v1/files/\' + item.image}})\'}" class="slick-slide" data-ng-if="item.enable" data-ng-repeat="item in list">',
              '<div class="container container-slide">',
              '<div class="slide-bg_blur">',
              '<div class="home-slider-blured" ng-style="{\'filter\':\'url(\' + href + \'#blur\' + $index + \')\', \'background-image\': \'url({{\'api/v1/files/\' + item.image}})\'}"></div>',
              '<div class="subColor" ng-style="{\'background\': item.colorSubstrate, \'opacity\': item.transparency / 100}"></div>',
              '<a ng-href="{{item.showLink ? item.link.url : \'\'}}" target="{{item.link.target}}" class="slide-bg_blur_inner">',
              '<h1 ng-style="{color: item.colorText}">{{item.title}}</h1>',
              '<p ng-style="{color: item.colorText}">{{item.description}}</p>',
              '<button type="button" class="btn btn-flat mb-1 mt-1" data-ng-if="item.showVideo" ng-click="showVideo(item.video);$event.preventDefault()">',
                ' <svg class="icon play-circle"><use xlink:href="#play-circle"/></svg>',
                '<span>{{"general.watch" | translate}}</span>',
              '</button>',
              '</a>',
              '</div>',
              '</div>',
              '<gaus-blur index="$index" blur="item.blur"></gaus-blur>',
            '</li>',
          '</ul>'
        ].join('');
      }
    }]);
})(angular);

(function () {
  angular.module('babycompy.base')
    .directive('adsense', ['$location', '$translate', 'AdSense', function ($location, $translate, AdSense) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          adClient: '@',
          adSlot: '@',
          inlineStyle: '@',
          adFormat: '@'
        },
        template: function (element, attrs) {

          var advert = AdSense.isDevHost
            ? (AdSense.advertDevelop[attrs['blockType']] || AdSense.advertDevelop.vertical)
            : AdSense.advertType[attrs['blockType']] || AdSense.advertType.vertical;
          var tpl = null;
          var isTest = AdSense.isTest ? "on" : "off";

          if (AdSense.isDevHost) {
            tpl = String.format('<a target="_blank" href="{0}"> <img class="img-responsive" src="{1}" alt="{2}"/></a>',
              advert.stubLink, advert.stubImgSrc, $translate.instant(advert.altText));
          } else {
            tpl = String.format('<div class="ads {5}">' +
              '<a data-ng-if="AdSense.showPlaceholder" class="ads-imgPlaceholder" target="_blank" href="{6}"> <img class="img-responsive" src="{7}" alt="{8}"/></a>' +
              '<ins class="adsbygoogle" data-ad-client="{0}" data-ad-slot="{1}" style="{3}" data-ad-format="{2}"></ins>' +
              '</div>',
              advert.adClient, advert.adSlot, advert.format, attrs.inlineStyle, isTest, advert.class, advert.stubLink, advert.stubImgSrc, advert.altText);
          }
          return tpl;
        },

        controller: ['AdSense', '$timeout', '$element', '$scope', function (AdSense, $timeout, $element, $scope) {
          if (AdSense.isDevHost) { return; }
          AdSense.start($element);
          $scope.AdSense = AdSense;
        }]
      };
    }]);
}());

(function (angular) {
    angular.module('babycompy.base').directive('alertMessage', [function () {
        return {
            restrict: 'E',
            scope:{
                type:'='
            },

            template : '<div class="alert" data-ng-class="[type ? \'alert-\' + type : null]" role="alert">\
        <svg class="icon check-circle" data-ng-show="type ==\'success\'">\
        <use xlink:href="#check-circle"></use>\
        </svg>\
        <svg class="icon exclamation-triangle" data-ng-show="type !==\'success\'">\
        <use xlink:href="#exclamation-triangle"></use>\
        </svg>\
        <span class="alert-text"><ng-transclude></ng-transclude></span>\
        </div>',

            transclude: true,
            link: function (scope, element, attr) {

            }
        };
    }]);
})(angular);
(function(angular) {
angular.module('babycompy.base')
    .directive('addressFormatter', function () {
        return {
            restrict : 'A',
            scope: {
                address: '=?',
                city: '=?',
                country: '=?'
            },

            link: function (scope, element, attrs) {
                scope.$watchGroup(['country', 'city', 'address'], function (newValues) {
                    var filtered = newValues.filter(function (item) {
                        return !!item
                    });
                    element.text(filtered.join(', '));
                })
            }
        }
    });
})(angular);
(function() {
    angular.module('babycompy.base')
        .factory('baseNameListController', ['baseListController', function (baseListController) {

            var baseNameListController = baseListController.extend({

                search: function () {
                    return this.scope.dataTable.refresh();
                },

                _initGridColumns: function () {
                    this._super();
                    this._addEditGridColumn('Name', this._getNameColumnData());
                },

                _getNameColumnData: function () {
                    return 'name';
                },

                _addEditGridColumn: function (title, data, renderEditLink) {
                    var ePage = this.editPageLink;
                    this.gridOptions.columns.push({
                        title: title,
                        data: data,
                        render: function (data, type, full) {
                            if (renderEditLink == undefined || renderEditLink === true) {
                                return String.format('<a href="{0}/{1}">{2}</a>', ePage, full.uuid,
                                    this._getEditLinkStringRepresentation(full));
                            } else if (renderEditLink == false) {
                                return this._getEditLinkStringRepresentation(full);
                            }
                        }.bind(this)
                    });
                },

                _addViewGridColumn: function (title, data) {
                    this.gridOptions.columns.push({
                        title: title,
                        data: data,
                        render: function (data, type, full) {
                            return String.format(this._getViewColumnTemplate(),
                                this.resource.resourceName, full.uuid,
                                this._getEditLinkStringRepresentation(full));
                        }.bind(this)
                    });
                },

                _getViewColumnTemplate: function (full) {
                    return '<a href="{0}/{1}">{2}</a>';
                },

                _getEditLinkStringRepresentation: function (entity) {
                    return entity.name;
                }
            });

            return baseNameListController;
        }]);
})();
(function () {
    angular.module('babycompy.base')
        .factory('baseListController', ['baseController', function (baseController) {

            var baseListController = baseController.extend({

                init: function ($scope, resource) {
                    this.data = [];
                    this.searchFormParameters = {};
                    this.searchParameters = {};
                    this.dataBounds = {};
                    this.enums = {};
                    this.requestBounds = { total: 0 };

                    var $super = this._super($scope, resource);

                    $scope.$on('pageChanged', function ($event, newDataBounds) {
                        angular.copy(newDataBounds, this.dataBounds);
                        return this.search();
                    }.bind(this));

                    return $super;
                },

                searchWithFormParameters: function () {
                    this.dataBounds.offset = 0;
                    this.synchronizeSearchParameters();
                    return this.search();
                },

                synchronizeSearchParameters: function () {
                    this.searchParameters = angular.copy(this.searchFormParameters);
                },

                search: function () {
                    return this._loadDataInternal();
                },

                reset: function () {
                    angular.element('#search-form-filter').find("select").addClass('empty');
                    angular.element('#search-form-filter').find("select").val('');
                    this.searchFormParameters = {};
                    this.searchParameters = {};
                    this.data = [];
                    return this.searchWithFormParameters();
                },

                onAttachedToDOM: function () {
                    this._initInternal();
                    return this._super();
                },

                _loadDataInternal: function () {
                    return this.resource[this._dataRetrievalFunctionName()](
                        angular.copy(this.dataBounds),
                        this._applySearchParameters(this.searchParameters))
                        .then(function (response) {
                            this.data = response.content.items;
                            this.requestBounds = {
                                limit: response.content.limit,
                                offset: response.content.offset,
                                total: response.content.total
                            }

                            this.setTitle(response.content.items);
                            return response.content;
                        }.bind(this));
                },

                _initInternal: function () {
                },

                _applySearchParameters: function (params) {
                    return params;
                },

                _dataRetrievalFunctionName: function () {
                    return 'get';
                }
            });

            return baseListController;
        }]);
})();
(function() {
    angular.module('babycompy.base')
        .factory('BaseEntityController', ['baseController', 'EntityService', 'entityTypes',
            function (baseController, EntityService, entityTypes) {

                var BaseEntityController = baseController.extend({
                    init: function (scope, entityType) {
                        this._super(scope);
                        this.entityType = entityType;
                        EntityService.addListener(entityTypes[this.entityType], this._onEntityChanged, this);
                    },

                    _onScopeDestroy: function () {
                        EntityService.removeListener(this.entityType, this._onEntityChanged);
                        this._super();
                    },

                    _onEntityChanged: function (event) {
                        this.entity = event.entity;
                    }
                });

                return BaseEntityController;
            }]);
})();
(function () {
    angular.module('babycompy.base')
        .factory('baseEditController', ['$q', 'backService', 'app',
            'baseController', '$location', 'compareObjects', '$translate',
            function ($q, backService, app,
                      baseController, $location, compareObjects, $translate) {

                var baseEditController = baseController.extend({

                    init: function ($scope, resource) {
                        this._super($scope, resource);
                        this.entity = {};
                        this.formName = 'editForm';
                        this.confirmUnsavedChangesMsgKey = null;
                        window.onbeforeunload = this.showBeforeUnloadConfirm.bind(this);
                    },

                    save: function () {
                        this.submitted = true;
                        if (this.scope[this.formName].$valid) {
                            this.isSaving = true;
                            return this._preSave(this.entity).then(function (entity) {
                                this.entity = entity;
                                return this._saveInternal(entity).then(function (response) {
                                    return this._postSave(response.content)
                                        .then(this._afterSave.bind(this));
                                }.bind(this), this._saveErrorHandler.bind(this))
                            }.bind(this)).finally(function () {
                                this.isSaving = false;
                            }.bind(this));
                        }
                    },

                    cancel: function () {
                        backService.back();
                    },

                    _saveInternal: function (entity) {
                        return this.resource.save(entity);
                    },

                    _afterSave: function () {
                        this.isDataSaved = true;
                        this._returnBack();
                    },

                    _setEntity: function (entity) {
                        this.old = $.extend(true, {}, entity);
                        if (!this._isConfirmationDialogCalled && this.confirmUnsavedChangesMsgKey) {
                            this.showConfirmChangesModal();
                            this._isConfirmationDialogCalled = true;
                        }

                        this.old = $.extend(true, {}, entity);
                        this.entity = entity;
                    },

                    _getEntityName: function () {
                        return null;
                    },

                    _returnBack: function () {
                        backService.back();
                    },

                    extractEntityId: function () {
                        //return $route.current.params[this._routeIdField];
                    },

                    _setIsReadonly: function (entity) {
                        this.readonly = false;
                    },

                    _loadDataInternal: function () {
                        var id = this.extractEntityId();
                        if (id !== undefined && id !== app.newEntityPath) {
                            return this._loadExistingEntity(id);
                        } else {
                            return this._createNewEntity();
                        }
                    },

                    isNew: function () {
                        return this.entity[this._idField] == undefined;
                    },

                    onAttachedToDOM: function () {
                        return this._super().then(this.loadData.bind(this));
                    },

                    _loadExistingEntity: function (id) {
                        return this.resource.getById(id).then(function (response) {
                            this._setEntity(this._postLoad(response.content));
                        }.bind(this));
                    },

                    _createNewEntity: function () {
                        return this._getDefaultEntity()
                            .then(this._postLoad.bind(this))
                            .then(function (entity) {
                                this._setEntity(entity);
                                return entity;
                            }.bind(this));
                    },

                    _postLoad: function (entity) {
                        this.setTitle(entity);
                        this._setIsReadonly(entity);
                        return entity;
                    },

                    _getDefaultEntity: function () {
                        return $q.when({});
                    },

                    _preSave: function (entity) {
                        return $q.when(entity);
                    },

                    _postSave: function (entity) {
                        return $q.when(entity);
                    },

                    _saveErrorHandler: function (response) {
                        return $q.when(response.data);
                    },

                    _setTitleInternal: function (entity) {

                    },

                    showBeforeUnloadConfirm: function (event) {
                        if (this.confirmUnsavedChangesMsgKey && this._isEntityChanged()) {
                            return $translate.instant(this.confirmUnsavedChangesMsgKey);
                        }

                        return null;
                    },

                    showConfirmChangesModal: function () {
                        var deregistrate = this.scope.$on('$stateChangeStart', function ($event, newUrl) {
                            if (!this._isEntityChanged()) {
                                return;
                            }

                            var result = confirm($translate.instant(this.confirmUnsavedChangesMsgKey));

                            if (result) {
                                deregistrate();
                                // newUrl is absolute url
                                // path() accepts only relative url
                               // $location.url(newUrl.substring($location.absUrl().length - $location.url().length));
                            } else {
                                $event.preventDefault();
                            }


                            return;
                        }.bind(this))
                    },

                    _isEntityChanged: function () {
                        var isEntityChanged = compareObjects(this.entity, this.old);
                        if (this.isDataSaved) {
                            return false;
                        }

                        if (isEntityChanged) {
                            return false;
                        }

                        return true;
                    },

                    _onScopeDestroy: function () {
                        this._super();
                        window.onbeforeunload = null;
                    }
                });

                return baseEditController;
            }]);
})();
(function() {
    angular.module('babycompy.base')
        .factory('baseController', ['$q', 'modalService', function ($q, modalService) {

            var baseController = Class.extend({

                init: function ($scope, resource) {
                    this._idField = 'uuid';
                    this._routeIdField = 'uuid';
                    this.scope = $scope;
                    this.resource = resource;
                    this.enums = {};

                    this.scope.$on('$destroy', function () {
                        this._onScopeDestroy();
                    }.bind(this));

                    return this.onAttachedToDOM();
                },

                setTitle: function (params) {
                    this.scope.$emit('titleChanged', this._setTitleInternal(params));
                },

                _setTitleInternal: function (params) {

                },

                loadData: function () {
                    return this._loadDataInternal();
                },

                _loadDataInternal: function () {
                    return $q.when();
                },

                _onScopeDestroy: function () {
                    if (this.resource && this.resource.clearAll) {
                        this.resource.clearAll();
                    }

                },

                onAttachedToDOM: function () {
                    return $q.when();
                },


                'delete': function (item) {
                    return this._confirmDelete(item).then(function () {
                        return this._deleteInternal(item).then(function () {
                            return this._onDeleteSuccess();
                        }.bind(this), function (result) {
                            return this._onDeleteError(result);
                        }.bind(this));
                    }.bind(this));
                },

                _deleteInternal: function (item) {
                    return this.resource.delete(item.uuid);
                },

                _onDeleteSuccess: function () {
                    return this.loadData();
                },

                _onDeleteError: function (result) {
                    return $q.when();
                },

                _confirmDelete: function (item) {
                    var modalScope = this.scope.$new(true, this.scope);

                    return this._getDeleteMessage(item).then(function (args) {
                        modalScope.message = args.message;
                        modalScope.title = args.title;
                        var modal = modalService.open({
                            templateUrl: 'app/main/html/deleteModalTpl.html',
                            scope: modalScope
                        });

                        modalScope.$close = modal.$modalService.close.bind(modal.$modalService);
                        modalScope.$dismiss = modal.$modalService.dismiss.bind(modal.$modalService);

                        return modal.result;
                    }.bind(this));
                },

                _getDeleteMessage: function () {
                    return $q.when({});
                },
            });

            return baseController;
        }]);
})();
angular.module('babycompy.base')
    .factory('upgrowthService', ['profileChildAgesService', '$stateParams', '$translate', 'enums', '$state',
        function(profileChildAgesService, $stateParams, $translate, enums, $state) {
            return {
                getAgeTitle: function(childAges) {
                    return this.onReady().then(function() {
                        return this._getAgeTitle(childAges);
                    }.bind(this))
                },

                _getAgeTitle: function(childAges) {
                    var childAge = this.getAgeType(childAges);
                    switch (childAge.ageType) {
                        case enums.ageType.newBorn:
                            return $translate('content.newBorn');
                        case enums.ageType.months:
                            return $translate('content.childAgeMonth', { month: childAge.age });
                        case enums.ageType.years:
                            return $translate('content.childAgeYears', { years: childAge.age });
                        case enums.ageType.ageRange:
                            return $translate('content.childAgeRange', { //expecting only years
                                yearStart: childAge.yearsStart.age,
                                yearEnd: childAge.yearsEnd.age
                            });
                    }


                },


                getAgeType: function(childAges) {
                    var childAgesDictionary = profileChildAgesService.childAgeCache;
                    var result = {};
                    if (childAges.length === 1) {
                        if(!!childAgesDictionary[childAges[0]]) {
                            var hours = childAgesDictionary[childAges[0]].hours;
                            result = this._getSingleAgeType(hours);
                        } else {
                            $state.go('index.notFound');
                        }
                    } else {
                        result.ageType = enums.ageType.ageRange;
                        var startHours = childAgesDictionary[childAges[0]].hours;
                        var endHours = childAgesDictionary[childAges[childAges.length - 1]].hours;

                        result.yearsStart = this._getSingleAgeType(startHours),
                            result.yearsEnd = this._getSingleAgeType(endHours)
                    }

                    return result
                },

                _getSingleAgeType: function(hours) {
                    var result = {};
                    if (hours <= 120) {
                        result.ageType = enums.ageType.newBorn;
                        result.age = 0;
                    } else if (hours <= 8031) {
                        result.ageType = enums.ageType.months;
                        result.age = Math.floor(hours / 720);
                    } else {
                        result.ageType = enums.ageType.years;
                        result.age = Math.floor(hours / 8760);
                    }

                    return result;
                },

                onReady: function() {
                    return profileChildAgesService.load().then(function() {
                        return profileChildAgesService.childAgeCache;
                    })
                },

                processCategories: function(originalCategories) {
                    var parentGroup = {},
                        categories = [];

                    originalCategories.forEach(function(item) {
                        var cat = {
                            id: item.id,
                            name: item.name,
                            uuid: item.uuid,
                            parent: {
                                id: item.parent.id,
                                name: item.parent.name,
                                uuid: item.parent.uuid,
                                contentExists: item.parent.contentExists,
                            }
                        };

                        if (cat.parent && cat.parent.uuid) {
                            if (!parentGroup[cat.parent.uuid]) {
                                parentGroup[cat.parent.uuid] = [];
                            }

                            parentGroup[cat.parent.uuid].push(cat);
                        }

                        categories.push(cat)
                    });

                    var resultCategories = [];
                    categories.forEach(function(category) {
                        if (category.skipped) {
                            return;
                        }

                        if (category.parent && category.parent.id && (
                                parentGroup[category.parent.uuid].length > 1 ||
                                category.parent.contentExists)) {
                            parentGroup[category.parent.uuid].forEach(function(item) {
                                item.skipped = true;
                            });

                            category.asParent = true;
                            category.href = 'index.upgrowth.categories' + '({categoryUUID : \'' + category.parent.uuid + '\'})';
                            category.name = category.parent.name;
                            category.uuid = category.parent.uuid;
                            category.childExists = true;
                        } else {
                            //category.href = 'index.upgrowth.categories.article' + '({categoryUUID: \'' + category.parent.uuid + '\', articleUUID: \'' + category.uuid + '\'})';
                            category.href = 'index.upgrowth.categories' + '({categoryUUID: \'' + category.uuid + '\'})';
                            category.childExists = false;
                        }

                        resultCategories.push(category);
                    });

                    return resultCategories;
                }

            }

        }
    ]);

(function () {
    'use strict';

    angular.module('babycompy.content.upgrowth', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.upgrowth.categories',
        'babycompy.content.upgrowth.categories.article'
    ]);
})();

(function () {
    angular.module('babycompy.content.upgrowth')
        .controller('upgrowthController', ['baseContentCategoriesController', '$scope',
            'ageSearchResult', '$translate', 'childAges', 'childAgesDictionary', 'ageTitle', 'seoService',
            function (baseContentCategoriesController, $scope, ageSearchResult,
                $translate, childAges, childAgesDictionary, ageTitle, seoService) {

                var ContentSubcategoriesController = baseContentCategoriesController.extend({
                    init: function ($scope, returnedContent) {
                        this._super($scope, returnedContent);
                        this.categories = returnedContent.items || [];
                        this.titleName = ageTitle;
                        seoService.title(this.titleName);
                        seoService.description(this.titleName);
                    }
                });

                return new ContentSubcategoriesController($scope, ageSearchResult);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.upgrowth')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.upgrowth', {
            url: 'upgrowth/:age',
            views: {
                'content': {
                    templateUrl: 'app/components/content/upgrowth/upgrowth.html',
                    controller: 'upgrowthController',
                    controllerAs: 'c'
                }
            },
            params:{
                childAges:{
                    value:null,
                    array:true
                }
            },
            resolve: {
                ageSearchResult: ['contentCategoriesResource', '$stateParams',
                    function (contentCategoriesResource, $stateParams) {
                        return contentCategoriesResource.search($stateParams.childAges || [$stateParams.age]).then(function (response) {
                            return response.content;
                        })
                    }],

                childAges: ['$stateParams', function ($stateParams) {
                    return $stateParams.childAges || [$stateParams.age];
                }],

                childAgesDictionary: ['profileChildAgesService', function (profileChildAgesService) {
                    return profileChildAgesService.load().then(function(){
                        return profileChildAgesService.childAgeCache;
                    });
                }],

                ageTitle: ['$stateParams', 'upgrowthService',
                    function ($stateParams, upgrowthService) {
                        var childAges = $stateParams.childAges || [$stateParams.age];
                        return upgrowthService.getAgeTitle(childAges);
                }]

            },

            breadcrumb: "{{ageTitle}}"
        });

    }

})();

(function (angular) {
    'use strict';
    angular.module('babycompy.content.search', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})(angular);
(function (angular) {
    angular.module('babycompy.content.search')
        .controller('searchController', ['$scope',
            '$state', '$filter',
            '$translate', 'baseListController', 'query',
            'contentCategoriesResource',
            function ($scope,
                $state, $filter, $translate,
                baseListController, query, contentCategoriesResource) {

                var limitLeft = 10;
                var refreshForFirefox = function() {
                    angular.element('#previousBtn').empty();
                    angular.element('#previousBtn').append('<svg aria-hidden="true" class="icon angle-double-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-double-left"></use></svg>');
                    angular.element('#nextBtn').empty();    
                    angular.element('#nextBtn').append('<svg aria-hidden="true" class="icon angle-double-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-double-right"></use></svg>');
            }
                
                var SearchController = baseListController.extend({

                    init: function () {
                        this._super.apply(this, arguments);
                        this.preferSearchText = this.searchText = query;
                        this.searching = false;
                    },

                    _dataRetrievalFunctionName: function () {
                        return 'searchByText';
                    },

                    _getOffset: function () {
                        var newOffset = this.preferSearchText !== this.searchText ? 0 : this.dataBounds.offset;
                        this.preferSearchText = this.searchText;
                        return newOffset;
                    },

                    search: function () {
                        this.searching=true;
                        var offset = this._getOffset();

                        this.dataBounds = { limit: limitLeft, offset: offset, query: this.searchText };
                        //update url params without reloading
                        $state.go($state.current, this.dataBounds, { notify: false, reload: false });

                        return this._loadDataInternal();
                    },
                    _loadDataInternal: function () {
                        if (this.dataBounds.query=="" || this.dataBounds.query==null) {
                            this.data = [];
                            this.requestBounds = {
                                    limit: 0,
                                    offset: 0,
                                    total: 0
                                };
                            return null;
                        }
                        return this.resource[this._dataRetrievalFunctionName()](
                            angular.copy(this.dataBounds),
                            this._applySearchParameters(this.searchParameters))
                            .then(function (response) {
                                this.data = response.content.items;
                                this.requestBounds = {
                                    limit: response.content.limit,
                                    offset: response.content.offset,
                                    total: response.content.total
                                }

                                this.setTitle(response.content.items);
                                this.searching=false;
                                if (navigator.userAgent.search("Firefox") > -1) {
                                    refreshForFirefox();
                                }
                                return response.content;
                            }.bind(this));
                    },


                });

                return new SearchController($scope, contentCategoriesResource);

            }]);
})(angular);

(function (angular) {
    'use strict';
    angular
        .module('babycompy.content.search')
        .config(['$stateProvider', config]);
    function config($stateProvider) {
        $stateProvider.state('index.search', {
            url: 'search?query&limit&offset',
            views: {
                'content': {
                    templateUrl: 'app/components/content/search/search.html',
                    controller: 'searchController as c',
                 //   controllerAs: 'c'
                },
            },

            resolve: {
                query: ['$stateParams',
                    function ($stateParams) {
                        return $stateParams.query;
                    }]
            },

            breadcrumb: false


        });
    }
})(angular);
(function () {
    angular.module('babycompy.content.news.article')
        .service('newsService', ['$q', 'newsResource',
            'singleRequestService',
            function ($q, newsResource, singleRequestService) {

                var NewsService = singleRequestService.extend({

                    getFromResource: function () {
                        return newsResource.get.apply(newsResource, arguments);
                    },

                    _setEntity: function (result) {
                        this.entity = result.content.items;
                    },

                    get: function (uuid) {
                        return this.entity.filter(function (item) {
                            return item.uuid === uuid;
                        })[0];
                    }

                });

                return new NewsService();
            }]);
})();

(function(angular) {
    angular.module('babycompy.content.news')
        .factory('newsResource', ['baseApiService', 'resources',
            function(baseApiService, resources) {

                var NewsResource = baseApiService.extend({

                    _setupCustomActions: function() {
                        var o = this._super();
                        o.getNews = {
                            method: 'GET',
                            isObject: true
                        }

                        return o;
                    },

                    getNews: function(uuid) {
                        return this.resource.getNews({ id: uuid }).$promise;
                    }

                });

                return new NewsResource(resources.news);
            }]);
})(angular);
(function () {
    angular.module('babycompy.content.news')
        .controller('newsController', ['baseCategoriesController', '$scope', 'newsItems', 'customPaging', 'seoService', '$translate',
            function (baseCategoriesController, $scope, newsItems, customPaging, seoService, $translate) {

                var NewsController = baseCategoriesController.extend({

                    init: function () {
                        var offset = 0,
                            limit = 5;
                            
                        this._super.apply(this, arguments);
                        this.news = newsItems;
                        
                        seoService.title($translate.instant('news.news'));                        
                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.news);
                    },
                    
                    extractVisibleNews: function() {
                        return this.customPaging.extractVisibleSupplements();
                    }
                });

                return new NewsController($scope, baseCategoriesController);

            }]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.content.news')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.news', {
            url: 'news',
            views: {
                'content@index': {
                    templateUrl: 'app/components/content/news/news.html',
                    controller: 'newsController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                newsItems: ['newsService', function(newsService) {
                    return newsService.load().then(function(newsItems) {
                        return newsItems;
                    });
                }]
            },
            breadcrumb: "{{'index.ourBlog' | translate}}"
        });
    }
})();
(function (angular) {
    angular.module('babycompy.content.medicine')
        .factory('medicineResource', ['categoriesResource', function (baseCategoriesResource) {

            var MedicineResource = baseCategoriesResource.extend({
                _setupCustomActions: function () {
                    var o = this._super();
                    
                    o.categories = {
                        method: 'GET',
                        params: {
                            controller: 'medicineCategories'
                        }
                    };

                    o.article = {
                        method: 'GET',
                        params: {
                            controller: 'medicine'                            
                        }
                    };

                    o.medicines = {
                        method: 'GET',
                        params: {
                            action: 'medicines'
                        }
                    };

                    o.similar = {
                        method: 'GET',
                        params: {
                            controller: 'medicine',
                            action: 'similar'
                        }
                    };
                   
                    return o;
                },
              
                search: function (searchStr) {
                    return this.resource.article({ query: searchStr }).$promise;
                },

                loadTopCategories: function () {
                    return this.resource.categories().$promise;
                },
                loadArticle: function(uuid){
                    return this.resource.article({id: uuid}).$promise;
                },

                medicines: function (uuid) {
                    return this.resource.medicines({id: uuid}).$promise;
                },

                similar: function(uuid){
                    return this.resource.similar({id: uuid}).$promise;
                }


            });

            return new MedicineResource('medicineCategories');
        }]);
})(angular);
(function () {
    angular.module('babycompy.content.medicine')
        .controller('medicineController', ['baseCategoriesController', '$scope',
            'parentCategories', 'customPaging', '$translate', 'seoService', '$q',
            function (baseCategoriesController, $scope,
                parentCategories, customPaging, $translate, seoService, $q) {
                // dependencies will be resolved during page load in the route definition

                var MedicineController = baseCategoriesController.extend({
                    init: function () {
                        var offset = 0,
                            limit = 10;

                        this.categories = parentCategories;
                        this.customPaging = new customPaging();
                        this.pagingParameters = this.customPaging.getPagingParameters(limit, offset, this.categories);
                        $q.all([
                            $translate('medicine.knowMore'),
                            $translate('menu.medication')
                        ]).then(function (translations) {
                            this.content = translations[0];
                            seoService.title(translations[1], this.content);
                            seoService.description(this.content);
                        }.bind(this));

                        this._super.apply(this, arguments);
                    },

                    extractVisibleSupplements: function () {
                        return this.customPaging.extractVisibleSupplements();
                    }

                });

                return new MedicineController($scope, parentCategories);
            }]);
})();

;(function () {
    'use strict';

    angular
        .module('babycompy.content.medicine')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medicine', {
            url: 'medicine',
            views: {
                'content': {
                    templateUrl: 'app/components/content/medicine/medicine.html',
                    controller: 'medicineController',
                    controllerAs: 'c'
                },
            },

            resolve: {
                parentCategories: ['$stateParams', 'medicineResource', function ($stateParams, medicineResource) {
                    return medicineResource.loadTopCategories().then(function (response) {
                        return response.content.items;
                    });
                }],
                
            },
            
            breadcrumb: '{{ "medicine.breadcrumbs.medicine" | translate }}'
        });
    }
})();

(function () {
    angular.module('babycompy.content.food')
        .controller('foodController', ['baseContentController', '$scope', 'welcomeText',
            '$state', 'seoService', '$translate', '$q',
            function (baseContentController, $scope, welcomeText,
                $state, seoService, $translate, $q) {
                // dependencies will be resolved during page load in the route definition
                var removeAppendIconsFireFox = function (id) {
                    var appendable = '<svg class="icon chevron-down"><use xlink:href="#chevron-left"></use></svg><svg class="icon chevron-left"><use xlink:href="#chevron-down"></use></svg>';
                    angular.element(id).find('svg').remove();
                    angular.element(id).append(appendable);
                }
                var FoodController = baseContentController.extend({
                    init: function () {

                        this._super.apply(this, arguments);
                        this.scope.toggleSupplement = false;
                        this.scope.$on('supplementCategorySelected', function ($event, name) {
                            this.supplementCategoryName = name;
                        }.bind(this));

                        this.scope.$on('productCategorySelected', function ($event, category) {
                            if (!category) {
                                return;
                            }
                            if (category.parent) {
                                this.productsCategoryName = category.parent.name;
                            } else {
                                this.productsCategoryName = null;
                            }
                        }.bind(this));

                        this.scope.$on('switchSupplement', function ($event, value) {
                            if (navigator.userAgent.search("Firefox") > -1) {
                                removeAppendIconsFireFox('#supplementsSvg');
                                removeAppendIconsFireFox('#productsSvg');
                            }
                            this.scope.toggleSupplement = value;
                        }.bind(this));

                        $q.all([
                            $translate('food.nutrition'),
                            $translate('food.supplement'),
                            $translate('food.name')
                        ]).then(function (translations) {
                            seoService.title(translations[0], this.content.name);
                            seoService.description(this.content.name);
                            this._defaultHeaderName = translations[1];
                            this._defaultProductsName = translations[2];
                        }.bind(this));
                    },

                    categoriesHeader: function () {
                        if ($state.is('index.contentCategories.contentSubcategories.food.supplementsCategories')) {
                            seoService.title(this._defaultHeaderName);
                            return this._defaultHeaderName;
                        }
                        return this._defaultHeaderName;
                    },

                    productsHeader: function () {
                        
                        if ($state.is('index.contentCategories.contentSubcategories.food.productsCategories')) {
                            seoService.title(this._defaultHeaderName);
                        }
                        if ($state.includes('index.contentCategories.contentSubcategories.food.supplementsCategories')
                            || $state.is('index.contentCategories.contentSubcategories.food.productsCategories')
                            || $state.is('index.contentCategories.contentSubcategories.food')) {
                            this.productCategoryName = null;
                            return this._defaultProductsName;
                        }
                        if (this.productsCategoryName) {
                            return this.productsCategoryName;
                        }
                        return this._defaultProductsName;
                    }
                });

                return new FoodController($scope, welcomeText);
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.food')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {
        // !!Important this is part of contentSubcategories
        $stateProvider.state('index.contentCategories.contentSubcategories.food', {
            url: '/food',
            views: {
                'content@index.contentCategories': {
                    templateUrl: 'app/components/content/food/food.html',
                    controller: 'foodController',
                    controllerAs: 'c'
                },
                'productsCategory@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/productsCategories/productsCategories.html',
                    controller: 'productsCategoriesController',
                    controllerAs: 'c'
                },
                'supplements@index.contentCategories.contentSubcategories.food': {
                    templateUrl: 'app/components/content/food/supplementsCategories/supplementsCategories.html',
                    controller: 'supplementsCategoriesController',
                    controllerAs: 'c'
                }

            },
            resolve: {
                welcomeText: ['aboutUsResource', 'enums', function (aboutUsResource, enums) {
                    return aboutUsResource.loadPage(enums.pageTypes.nutritinalSupplements).then(function (response) {
                        return response.content;
                    })
                }],

                productsCategories: ['productsCategoriesResource', function (productsCategoriesResource) {
                    return productsCategoriesResource.loadCategories().then(function (response) {
                        return response.content.items.map(function (item, index) {
                            item.iconIndex = index;
                            return item;
                        });
                    });
                }],

                supplementsCategories: ['supplementsCategoriesResource', function (supplementsCategoriesResource) {
                    return supplementsCategoriesResource.loadCategories().then(function (response) {
                        return response.content.items;
                    });
                }]
            },
            breadcrumb: false
        });
    }
})();

(function() {
    angular.module('babycompy.content.favorites')
        .controller('favoritesController', ['favoritesContent', 'favoriteTypes', '$state', 'enums',
            'modalService', '$q', 'favoriteStateShange', 'favoriteResource', 'favoritesService', '$translate', 'seoService',
            function(favoritesContent, favoriteTypes, $state, enums,
                modalService, $q, favoriteStateShange, favoriteResource, favoritesService, $translate, seoService) {

                var FavoritesController = function() {
                    this.favoritesContent = favoritesContent;
                    this.favoritesContent = filterFavoriteContent(favoritesContent, enums, $state);
                    this.favoriteTypes = favoriteTypes;
                    this.firstLoad(this.favoritesContent);
                    this.title = this.generateTitle(this.favoritesContent);
                    $translate('headerNavBar.myFavorites').then(function(translations) {
                        seoService.title(translations, this.title);
                        seoService.description(this.title);
                    }.bind(this));

                };
                var filterFavoriteContent = function(favoritesContent, enums, $state) {
                    if ($state.params.uuid != "") {
                        return favoritesContent.filter(function(item) {
                            if (enums.selectFavoriteTypes[$state.params.uuid] === item.type) {
                                return item;
                            }
                        });
                    } else {
                        if (favoritesContent && favoritesContent.length > 0) {
                            $state.go('index.favorites', { uuid: enums.selectFavoriteByType[favoritesContent[0].type] });
                        }
                        var maxValue = Object.getOwnPropertyNames(enums.selectFavoriteTypes).length;
                        var result;
                        for (var i = 0; i < maxValue; i++) {
                            result = favoritesContent.filter(function(item) {
                                if (i === item.type) {
                                    return item;
                                }
                            })
                            if (result && result.length != 0) {
                                break;
                            }
                        }
                        return result;
                    }
                }
                FavoritesController.prototype.createLinks = function(favoritesContent, linkContainer) {
                    var linkArray = linkContainer || [];
                    if (favoritesContent.parent == undefined) {
                        linkArray.push(favoritesContent.uuid);
                    } else if (favoritesContent.parent !== null) {
                        linkArray.push(favoritesContent.uuid);
                        this.createLinks(favoritesContent.parent, linkArray);
                    }
                    return linkArray;
                };

                FavoritesController.prototype.firstLoad = function(favoritesContent) {
                    if (!favoritesContent || favoritesContent.length === 0) {
                        for (var i = 0; i < favoriteTypes.length; ++i) {
                            if (favoriteTypes[i].count > 0) {
                                $state.go('index.favorites', { uuid: enums.selectFavoriteByType[favoriteTypes[i].ordinal] });
                                break;
                            }
                        }
                    } 
                };

                FavoritesController.prototype.onDelete = function(favoriteEntity) {
                    var deleteFavoriteModal = modalService.open({
                        templateUrl: 'app/components/content/favorites/favoriteModal/favoritesDelete.modal.html',
                        controller: 'favoriteModalController as c',
                        show: true,
                        resolve: {
                            favoriteEntity: function() {
                                return $q.when(favoriteEntity);
                            }
                        }
                    }).result.then(function() {
                        var entityPosition = this.favoritesContent.indexOf(favoriteEntity);
                        if (entityPosition >= 0) {
                            favoriteResource.getTypes().then(function(response) {
                                this.favoriteTypes = response.content.items;
                                if (this.favoritesContent.length === 1) {
                                    this.nextCatogoryConversion(this.favoriteTypes);

                                    if (nonEmptyCategory(this.favoriteTypes).length == 0) {
                                        this.favoritesContent.splice(entityPosition, 1);
                                    }
                                } else {
                                    this.favoritesContent.splice(entityPosition, 1);
                                }
                            }.bind(this));
                        }
                    }.bind(this));
                };

                function nonEmptyCategory(categories) {
                    var nonEmptyCategory = categories.filter(function(elem) {
                        return elem.count > 0;
                    });
                    return nonEmptyCategory;
                }
                FavoritesController.prototype.changeState = function(article) {
                    var linkArray = this.createLinks(article),
                        articleUuid = linkArray[0],
                        categotyUuid = linkArray[1];

                    favoriteStateShange[article.type](articleUuid, categotyUuid);
                };

                FavoritesController.prototype.nextCatogoryConversion = function(categories) {


                    nonEmptyCategory(categories).length > 0 ?
                        $state.go('index.favorites', { uuid: enums.selectFavoriteByType[nonEmptyCategory(categories)[0].ordinal] }) : '';

                };

                FavoritesController.prototype.generateTitle = function(content) {
                    if (content.length > 0) {
                        var title = 'favoriteMenuTypes.' + enums.selectFavoriteByType[content[0].type];
                        return $translate.instant(title);
                    }
                }

                return new FavoritesController();
            }
        ]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.content.favorites')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.favorites', {
            url: 'favorites/:uuid',
            views: {
                'content': {
                    templateUrl: 'app/components/content/favorites/favorites.html',
                    controller: 'favoritesController',
                    controllerAs: 'c'
                },
            },
            resolve: {
                favoriteTypes: ['favoriteResource', function (favoriteResource) {
                    return favoriteResource.getTypes().then(function (response) {
                        return response.content.items;
                    })
                }],

                favoritesContent: ['favoriteResource', 'enums', '$stateParams', function (favoriteResource, enums, $stateParams) {
                    return favoriteResource.getAllFavorites().then(function (response) {
                        return response.content.items;
                    });
                }],

                contentCategoriesService: ['contentCategoriesService', function (contentCategoriesService) {
                    return contentCategoriesService.load().then(function () {
                        return contentCategoriesService;
                    });
                }],

                currentUser: ['currentUserService', '$state', 'favoriteTypes', 'enums', function (currentUserService, $state, favoriteTypes, enums) {
                    return currentUserService.load().then(function (user) {
                        if (!user) {
                            $state.go('index.login');
                            return;
                        }
                        return currentUserService.get();
                    });
                }]
            },

            breadcrumb: '{{ "headerNavBar.myFavorites" | translate }}'
        });
    }
})();
(function() {
    angular.module('babycompy.content.favorites')
        .service('favoriteStateShange', ['$state', 'contentCategoriesService', function($state, contentCategoriesService) {

            var FavoriteStateShange = function() {

                var productCategories = contentCategoriesService.getLink('supplementsCategories'),
                    contentCategories = productCategories.uuid;

                return {
                    0: function(articleUuid, categotyUuid) {
                        //articles
                        return $state.go('index.contentCategories.contentSubcategories.article', { categoryUUID: categotyUuid, articleUUID: articleUuid });
                    },

                    1: function(articleUuid, categotyUuid) {
                        //medicine
                        return $state.go('index.medicine.medicineCategories.article', { categoryUUID: categotyUuid, articleUUID: articleUuid });
                    },

                    2: function(articleUuid, categotyUuid) {
                        //products
                        return $state.go('index.contentCategories.contentSubcategories.food.productsCategories.products.article',
                            { categoryUUID: contentCategories, productCategoryUUID: categotyUuid, articleUUID: articleUuid });
                    },

                    3: function(articleUuid, categotyUuid) {
                        //supplements
                        return $state.go('index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement',
                            { categoryUUID: contentCategories, supplementCategoryUUID: categotyUuid, supplementUUID: articleUuid });
                    },

                    4: function(articleUuid, categotyUuid) {
                        //algorithms
                        return $state.go('index.algorithms.group.algorithm', { groupUuid: categotyUuid, algorithmUuid: articleUuid });
                    },

                    5: function(articleUuid) {
                        //news
                        return $state.go('index.news.article', { uuid: articleUuid });
                    },

                    6: function(articleUuid) {
                        //clinics
                        return $state.go('index.clinics.details', { uuid: articleUuid });
                    },

                    7: function(articleUuid) {
                        //doctors
                        return $state.go('index.doctorSearch.details', {uuid: articleUuid});
                    },

                    8: function(articleUuid, categotyUuid) {
                        //medicAnswers
                        return $state.go('index.medics.answers.article', { rubricUUID: categotyUuid, articleUUID: articleUuid });
                    },
                }
            };

            return FavoriteStateShange();
        }]);
})();

(function () {
    angular.module('babycompy.base')
        .factory('favoritesService', ['singleRequestService', 'favoriteResource', 'applicationLifecycle', 'EventTarget',
            function (singleRequestService, favoriteResource, applicationLifecycle, EventTarget) {

                var AllFavorites = singleRequestService.extend({
                    init: function () {
                        this._super();
                        this.eventTarget = new EventTarget();
                        applicationLifecycle.onBeforeLogout(this._onLogout.bind(this));
                    },

                    getFromResource: function () {
                        return favoriteResource.get.apply(favoriteResource, arguments);
                    },

                    _setEntity: function (result) {
                        this.entity = result;
                    },

                    delete: function (uuid) {
                        this.onDeleteFavorite();

                        var items = this.entity.content.items,
                            item = items.filter(function (item) {
                                return item.uuid === uuid;
                            })[0],
                            index = items.indexOf(item);
                        if (index >= 0) {
                            items.splice(items.indexOf(item), 1);
                        }

                        return favoriteResource.deleteFromFavorite(uuid);
                    },

                    _onLogout: function () {
                        this.entity = null;
                    },

                    onAddFavorite: function () {
                        this.eventTarget.fire('onAddFavorite');
                    },

                    onDeleteFavorite: function () {
                        this.eventTarget.fire('onDeleteFavorite');
                    }
                });


                return new AllFavorites();
            }])
})();

(function () {

    angular.module('babycompy.base')
        .factory('favoriteResource', ['baseApiService', function (baseApiService) {
            var FavoriteResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.getTypes = {
                        method: 'GET',
                        params: {
                            id: 'types'
                        }
                    },
                    
                    o.getAllFavorites = {
                        method: 'GET',
                        params: {
                            controller: 'favorites'
                        }
                    },
                    
                    o.selectAsFavorite = {
                        method: 'POST'                        
                    },
                    
                    o.deleteFromFavorite = {
                        method: 'DELETE'
                    }

                    return o;
                },
                
                getTypes: function () {
                    return this.resource.getTypes().$promise;
                },
                
                getAllFavorites: function () {
                    return this.resource.getAllFavorites().$promise;
                },
                
                selectAsFavorite: function (id, selectedType) {
                    return this.resource.selectAsFavorite({
                        entity: id,
                        type: selectedType
                    }).$promise
                },
                
                deleteFromFavorite: function (id) {
                    return this.resource.deleteFromFavorite({
                        id: id                        
                    }).$promise
                }     

            })
            return new FavoriteResource('favorites');
        }])

})();
(function () {
    'use strict';

    angular.module('babycompy.content.contentCategories', [
        'babycompy.categories.common',
        'babycompy.content.common',
        'babycompy.content.contentCategories.calendar',
        'babycompy.content.contentCategories.trimesters',
        'babycompy.content.contentCategories.contentSubcategories'
    ]);
})();

(function (angular) {
    angular.module('babycompy.content.contentCategories')
        .factory('contentCategoriesResource', ['categoriesResource', function (baseCategoriesResource) {

            var ContentCategoriesResource = baseCategoriesResource.extend({

                getSections: function () {
                    return this.get({
                        controller: 'sections'
                    });
                },

                getSectionsContent: function (uuid) {
                    return this.get({
                        controller: 'sections',
                        id: uuid
                    });
                },

                search:function(childAges, uuid){
                    return this.get({
                        controller: 'sections',
                        action: 'search',
                        childAges: childAges,
                        uuid: uuid
                    });
                },

                searchPregnancyAge:function(pregnancyAges, uuid){
                    return this.get({
                        controller: 'sections',
                        pregnancyAges: pregnancyAges,
                        id: uuid
                    });
                },

                searchByText:function(dataBounds, params){
                       dataBounds = dataBounds || {};
                        params = params || {};

                    return this.get({
                        controller: 'sections',
                        action: 'search'
                    }, angular.extend({}, dataBounds, params));
                },

                popular: function(limit){
                    return this.get({
                        controller: 'sections',
                        action: 'popular',
                        limit: limit
                    });
                }

            });

            return new ContentCategoriesResource('sections');
        }]);
})(angular);
(function () {
    'use strict';

    angular
        .module('babycompy.content.contentCategories')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.contentCategories', {
            url: 'contentCategories',
            abstract: true,
            views: {
                'content': {
                    templateUrl: 'app/components/content/contentCategories/containerContentCategories.html',
                },
            },
            breadcrumb: "{{responseContent.parent.name}}",
            childState: 'index.contentCategories.subcategories'
        });
    }
})();
(function () {
    angular.module('babycompy.content.common')
        .factory('baseContentCategoriesController', [function () {
            // dependencies will be resolved during page load in the route definition

            var BaseContentCategoriesController = Class.extend({
                init: function($scope, returnedContent) {
                    this.returnedContent = returnedContent || {};
                    this.categories = returnedContent.childs || [];
                    this.titleName = returnedContent.name || '';
                    this.content = returnedContent.content || '';
                    this.parentCategories = returnedContent.parent || [];
                    this.scope = $scope;
                },

            });

            return BaseContentCategoriesController;
        }]);
})();
(function() {
    angular.module('babycompy.content.algorithms')
        .controller('algorithmsController', ['baseContentController', '$scope', '$translate', 'seoService', '$state', 'groups', 'savedAlgorithms', 'algorithmService', 'modalService', 'algorithmSavesService',
            function(baseContentController, $scope, $translate, seoService, $state, groups, savedAlgorithms, algorithmService, modalService, algorithmSavesService) {

                var algorithmsController = baseContentController.extend({

                    init: function() {
                        this._super.apply(this, arguments);
                        this.groups = groups.items;
                        this.description = groups.description;
                        this.savedAlgorithms = savedAlgorithms.items;
                        if (!!this.savedAlgorithms && this.savedAlgorithms.length > 0) {
                            angular.forEach(this.savedAlgorithms, function(save) {
                                save.redirect = {};
                                save.redirect.groupUuid = save.group;
                                save.redirect.algorithmUuid = save.algorithm;
                                save.redirect.stepUuid = save.lastStep;
                            });
                        }


                        $translate('menu.algorithms').then(function(translations) {
                            seoService.title(translations);
                            seoService.description(translations);
                        })
                    },

                    continueAlgorithm: function(item) {
                        var requestBody = {};
                        requestBody.userAlgorithm = item.uuid;
                        requestBody.nextStep = item.lastStep;
                        requestBody.lastSaveDate = moment().toISOString().replace('Z', '');
                        algorithmService.saveAlgorithm(item.algorithm, requestBody).then(
                            function(response) {
                                $state.go('index.algorithms.group.algorithm.step', item.redirect);
                            }.bind(this),
                            function(error) {
                                if (error.data.metadata.errorCode === 404101) {
                                    modalService.showErrorAlert({
                                        title: $translate.instant('algorithms.error'),
                                        message: $translate.instant('algorithms.saveDeleted')
                                    });
                                    $state.reload();
                                }
                            }
                        );
                    },

                    restartAlgorithm: function(item) {
                        modalService.open({
                            template: 'app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html',
                            controller: 'algorithmConfirmModalController as c',
                            show: true,
                            backdrop: 'static'
                        }).result.then(function() {
                            algorithmService.restartAlgorithm(item.uuid).then(
                                function(response) {
                                    item.redirect.stepUuid = response.content.step.uuid;
                                    item.description = response.content.step.name;
                                    $state.go('index.algorithms.group.algorithm.step', item.redirect, { reload: true });
                                }.bind(this),
                                function(error) {
                                    if (error.data.metadata.errorCode === 404101) {
                                        modalService.showErrorAlert({
                                            title: $translate.instant('algorithms.error'),
                                            message: $translate.instant('algorithms.saveDeleted')
                                        });
                                        $state.reload();
                                    }
                                }
                            );
                        }.bind(this));
                    },

                    finishAlgorithm: function(item) {
                        modalService.open({
                            template: 'app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html',
                            controller: 'algorithmConfirmModalController as c',
                            show: true,
                            backdrop: 'static'
                        }).result.then(function() {
                            algorithmService.finishAlgorithm(item.uuid).then(
                                function(response) {
                                    this.savedAlgorithms.splice(this.savedAlgorithms.indexOf(item), 1);
                                }.bind(this),
                                function(error) {
                                    if (error.data.metadata.errorCode === 404101) {
                                        modalService.showErrorAlert({
                                            title: $translate.instant('algorithms.error'),
                                            message: $translate.instant('algorithms.saveDeleted')
                                        });
                                        $state.reload();
                                    }
                                }
                            );
                            algorithmSavesService.onFinishAlgorithm();
                        }.bind(this));
                    }
                });
                return new algorithmsController($scope);
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('babycompy.content.algorithms')
        .config(['$stateProvider', config]);

    function config($stateProvider) {
        $stateProvider.state('index.algorithms', {
            url: 'algorithms',
            inherit : false,
            views: {
                'content': {
                    templateUrl: 'app/components/content/algorithms/algorithms.template.html',
                    controller: 'algorithmsController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                groups: ['groupService', function(groupService) {
                    return groupService.getAllGroups().then(function(response) {
                        return response.content;
                    });
                }],
                savedAlgorithms: ['groupService', 'authService', 'currentUserService', function(groupService, authService, currentUserService) {
                  return currentUserService.load().then(function (user) {
                    if (authService.isLoggedIn() && !user.doctor) {
                      return groupService.getSavedAlgorithms().then(function(response) {
                        return response.content;
                      });
                    } else {
                      return [];
                    }
                  });
                }]
            },
            breadcrumb: "{{'menu.algorithms' | translate}}"
        });
    }
})();

(function () {
    'use strict';

    angular.module('babycompy.content.aboutUs', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();
/* global angular */
(function(angular) {
    angular.module('babycompy.content.aboutUs')
        .factory('aboutUsResource', ['categoriesResource', '$q', '$filter', '$translate',
            function(baseCategoriesResource, $q, $filter, $translate) {

                var AboutUsResource = baseCategoriesResource.extend({
                    _setupCustomActions: function() {
                        var o = this._super();
                        o.loadPage = {
                            method: 'GET',
                            isObject: true,

                        },

                            o.sendFeedback = {
                                method: 'POST',
                                isObject: true,
                                params: {
                                    controller: 'advertiser'
                                }
                            };

                        return o;
                    },

                    loadPage: function(type) {
                        return this.resource.loadPage({
                            id: type
                        }).$promise;
                    },
                    
                    sendFeedback: function(data) {
                        return this.resource.sendFeedback({
                            name: data.name,
                            companyName: data.companyName,
                            activityField: data.activityField,
                            companySite: data.companySite,
                            phone: data.phone,
                            email: data.email,
                            comments: data.comments
                        }).$promise
                    },

                    loadAllPages: function() {
                        return $translate.onReady().then(function() {
                            return $q.when({
                                content: {
                                    items: [
                                        {
                                            uuid: 'whoWeAre',
                                            name: $filter('translate')('headerNavBar.aboutUsContainer.whoWeAre')
                                        },
                                        {
                                            uuid: 'aboutProject',
                                            name: $filter('translate')('headerNavBar.aboutUsContainer.aboutProject')
                                        },
                                        {
                                            uuid: 'helpWithSite',
                                            name: $filter('translate')('headerNavBar.aboutUsContainer.helpWithSite')
                                        },
                                        {
                                            uuid: 'doctorsAndClinics',
                                            name: $filter('translate')('headerNavBar.partnershipsContainer.doctorsAndClinics')
                                        },
                                        {
                                            uuid: 'advertiser',
                                            name: $filter('translate')('headerNavBar.partnershipsContainer.advertisers')
                                        },
                                        {
                                            uuid: 'confidentiality',
                                            name: $filter('translate')('headerNavBar.aboutUsContainer.confidentiality')
                                        },
                                        {
                                            uuid: 'termsOfUse',
                                            name: $filter('translate')('headerNavBar.aboutUsContainer.termsOfUse')
                                        }]
                                }
                            });

                        });
                    }
                });


                return new AboutUsResource('page');
            }]);
})(angular);
(function () {
    angular.module('babycompy.content.aboutUs')
        .controller('aboutUsController', ['baseContentCategoriesController', '$scope', 'content',
            'categories', 'aboutUsResource', '$translate', 'modalService', 'seoService',
            function (BaseContentCategoriesController, $scope, content,
                categories, aboutUsResource, $translate, modalService, seoService) {
                // dependencies will be resolved during page load in the route definition

                var AboutUsController = BaseContentCategoriesController.extend({
                    init: function () {
                        this._super.apply(this, arguments);
                        this.content = content;
                        this.categories = categories;
                        this.advertiser = {};
                        this.response = null;

                        $translate('headerNavBar.aboutUsContainer.aboutUs').then(function (translations) {
                            seoService.title(translations, this.content.name);
                            seoService.description(this.content.name);
                        }.bind(this));
                    },

                    setCaptchaResponse: function (response) {
                        this.response = response;
                    },

                    sendFeedback: function () {
                        if (!this.advertiser.name || !this.advertiser.email || !this.advertiser.comments || !this.response) {
                            return;
                        }

                        aboutUsResource.sendFeedback(this.advertiser).then(function (response) {
                            var showText = $translate.instant('forAdvertisers.alertMessage');
                            modalService.showSuccessAlert(showText);
                        });
                    }
                });

                return new AboutUsController($scope, content);
            }])
})();
(function() {
    'use strict';

    angular
        .module('babycompy.content.aboutUs')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.aboutUs', {
            url: 'info/:articleUUID',
            views: {
                'content': {
                    templateUrl: 'app/components/content/aboutUs/aboutUs.html',
                    controller: 'aboutUsController',
                    controllerAs: 'c'
                },
            },

            resolve: {
                categories: ['$stateParams', 'aboutUsResource', function($stateParams, aboutUsResource) {
                    return aboutUsResource.loadAllPages().then(function(response) {
                        return response.content.items;
                    });
                }],

                content: ['$stateParams', 'aboutUsResource', 'enums', function($stateParams, aboutUsResource, enums) {
                    var idType = enums.pageTypes[$stateParams.articleUUID];
                    return aboutUsResource.loadPage(idType).then(function (response) {
                        return response.content;
                    })
                }]
            },

            breadcrumb: '{{ "aboutUs.breadcrumbs.whoWeAre" | translate }}'
        });
    }
})();
(function () {
    'use strict';

    angular.module('babycompy.clinics.details', [
        'babycompy.categories.common',
        'babycompy.content.common'
    ]);
})();

(function (angular) {
    'use strict;'


    angular.module('babycompy.clinics.details')
        .directive('workingHours', ['$translate', function ($translate) {
            return {
                restrict: 'E',
                replace: true,

                template: '<ul class="list-unstyled">\
                                <li data-ng-repeat="workHour in workingHours">\
                                <b>{{workHour.day + ":"}}</b>&nbsp;\
                                <span data-ng-if="workHour.isDayOff"><mark>{{workHour.time}}</mark> </span>\
                                <span data-ng-if="!workHour.isDayOff">{{workHour.time}}</span> \
                           </li>',

                scope: {
                    schedule: "="
                },

                link: function (scope, element, attrs) {
                    scope.$watch('schedule', function (shedule) {
                        if (!shedule) {
                            return;
                        }
                        $translate.onReady().then(function () {
                            var currentGroup = {},
                                currKey = null;

                            shedule.forEach(function (item, index) {
                                var key = item.holiday ? item.holiday : item.startTime + '_' + item.endTime;
                                item.index = index;
                                
                                if(!currentGroup.hasOwnProperty(key)){
                                    currentGroup[key] = [];
                                }
                                currentGroup[key].push(item);  
                            });

                            //keys order in object is not defined,
                            //so we need to transform it to array and sort
                            var workingHours = Object.keys(currentGroup).map(function (key) {
                                return currentGroup[key];
                            }).sort(function (a, b) {
                                return a[0].index - b[0].index;
                            });


                            scope.workingHours = workingHours.map(function (dayHours) {
                                if (dayHours.length == 1) {
                                    return {
                                        isDayOff: dayHours[0].holiday,
                                        time: translateDayHours(dayHours[0].startTime, dayHours[0].endTime, dayHours[0].holiday),
                                        day: $translate.instant('clinicProfile.workingHours.' + dayHours[0].day)
                                    };
                                } else {
                                    return {
                                        isDayOff: dayHours[0].holiday,
                                        time: translateDayHours(dayHours[0].startTime, dayHours[dayHours.length - 1].endTime, dayHours[0].holiday),
                                        day: translateDays(dayHours)
                                    };
                                }
                            }).sort(function (a, b) {
                                if(a.isDayOff) {
                                    return 1;
                                } else if(b.isDayOff) {
                                    return -1;
                                }
                            });
                        });

                    })

                }
            }

            function translateDays(dayHours) {
                var DAYS_IN_WEAK = 7;

                var result = $translate.instant('clinicProfile.workingHours.' + dayHours[0].day);                
                var startIndex = dayHours[0].day;
                var endIndex = null;
                
                //Go through grouped days
                dayHours.forEach(function(day, index, dayHours) {
                    // if no interval started
                    if (endIndex === null) {
                        if(day.day - 1 > startIndex) {       // not the next day - add with COMA
                            result += (", " + $translate.instant('clinicProfile.workingHours.' + day.day));
                            startIndex = day.day;
                        } else if(day.day != startIndex) {  // next day - start interval
                            endIndex = day.day;
                        }
                    }

                    // if interval have been started
                    if (endIndex !== null) {
                        if(day.day - 1 > endIndex) {        // end of inteval
                            result += _addDateIntervalToString(startIndex, endIndex);
                            //start new interval
                            endIndex = null;
                            startIndex = day.day;
                            result += (", " + $translate.instant('clinicProfile.workingHours.' + day.day));
                        } else if(index + 1 >= dayHours.length || day.day + 1 >= DAYS_IN_WEAK) {   // end of current group array or weakday3
                            result += _addDateIntervalToString(startIndex, day.day);
                            return result;
                        } else {                            // interval continues
                            endIndex = day.day;
                        }
                    }
                });

                return result;
            }

            function _addDateIntervalToString(startIndex, endIndex) {
                var result = "";
                if(startIndex + 1 == endIndex) {
                    result += (", " + $translate.instant('clinicProfile.workingHours.' + endIndex));
                } else {
                    result += ("-" + $translate.instant('clinicProfile.workingHours.' + endIndex));
                }
                return result;
            }


            function translateDayHours(startTime, endTime, holiday) {
                if (holiday) {
                    return $translate.instant('clinicProfile.workingHours.dayOff')
                }

                if( startTime == endTime && startTime == "00:00"){
                    return $translate.instant('clinicProfile.workingHours.dayAndNight')
                }

                return String.format('{0} - {1}', startTime, endTime);
            }
        }]);
})(angular);

(function () {
    angular.module('babycompy.clinics.details')
        .controller('clinicDetailsController', ['baseController', '$scope',
            'responseContent', '$translate', 'enums', 'seoService',
            function (baseController, $scope, responseContent,
                $translate, enums, seoService) {

                var ClinicController = baseController.extend({
                    init: function ($scope) {
                        this._super.apply(this, arguments);
                        $translate('clinicSearch.pageTitle').then(function (translations) {
                            seoService.title(translations, this.content.name);
                            seoService.description(this.content.name);
                        }.bind(this));
                        
                        this.content = responseContent;
                        this.favoriteType = enums.selectFavoriteTypes.clinics;
                        this.doctorFavoriteType = enums.selectFavoriteTypes.doctors;
                        this.specializations = responseContent.specializations.map(function (specialization) {
                            return specialization.name.toLowerCase();
                        }).join(", ");


                        this.titleName = responseContent.name;
                        this.activeTab = 'description';
                        this.position = { lat: +this.content.latitude, lng: +this.content.longitude };
                    }

                });

                return new ClinicController($scope);
            }]);
})();



(function () {
    'use strict';

    angular
        .module('babycompy.clinics.details')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.clinics.details', {
            url: '/:uuid/details',
            views: {
                'content@index': {
                    templateUrl: 'app/components/clinics/details/clinicDetails.html',
                    controller: 'clinicDetailsController',
                    controllerAs: 'c'
                },
                'breadcrumbs@index': {
                    templateUrl: 'app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html',
                    controller:  'clinicBreadcrumbController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                responseContent: ['$stateParams', 'clinicResource',
                    function ($stateParams, clinicProfileResource) {
                        return clinicProfileResource.getProfile($stateParams.uuid).then(function(response){
                            return response.content;
                        });
                    }]

            },

            breadcrumb: "{{responseContent.name}}"
        });

    }

})();

(function () {
    angular.module('babycompy.clinics.details')
        .controller('clinicBreadcrumbController', ['baseController', '$scope',
            'responseContent', '$translate', '$state', '$filter',
            function (baseController, $scope, responseContent,
                      $translate, $state, $filter) {

                var ClinicBreadcrumbController = baseController.extend({
                    init: function ($scope) {
                        this._super($scope);
                        this.arrayOfParents = [];
                        this.arrayOfParents.push({
                            name: $filter('translate')('main.main'),
                            href:  '/'
                        });

                        this.arrayOfParents.push({
                            name:  $filter('translate')('menu.clinics'),
                            href: $state.href('index.clinics')
                        });
                    }

                });

                return new ClinicBreadcrumbController($scope);
            }]);
})();



angular.module('babycompy.authentication.signUp')
  .service('signUpResource', ['baseApiService', '$facebook', 'GooglePlus',
    function (baseApiService, $facebook, GooglePlus) {
      var SignUpService = baseApiService.extend({
        _setupCustomActions: function () {
          return {
            'userSignUp': {
              method: 'POST',
              isObject: true
            }
          }
        },

        userSignUp: function (user) {
          return this.resource.userSignUp({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            avatar: user.avatar,
            country: user.country.uuid,
            city: user.city.uuid,
            password: user.password
          }).$promise
        },

        facebookLogin: function () {
          return $facebook.login().then(function () {
            return $facebook.api("/me?fields=id,first_name,last_name,email,picture{url}");
          })
        },

        googlePlusLogin: function () {
          return GooglePlus.login().then(function () {
            return GooglePlus.getUser();
          }).catch(function (e) {
            console.error(e);
          })
        }
      });
      return new SignUpService('signUp');
    }]);

angular.module('babycompy.authentication.signUp')
  .controller('signUpController', ['$q', '$scope', '$state', 'baseController', 'signUpResource',
    'vkClient', 'okClient', 'authCode', 'isVk', 'isOk', 'seoService', '$translate', 'modalService', 'applicationLifecycle',
    function ($q, $scope, $state, baseController, signUpResource,
      vkClient, okClient, authCode, isVk, isOk, seoService, $translate, modalService, applicationLifecycle) {

      var signUpController = baseController.extend({

        init: function () {
          this._super.apply(this, arguments);
          this.user = {};
          console.info(authCode);
          this.fetchUserInfo();
          this.emailExist = false;
          this.response = null;
          if (navigator.userAgent.search("Firefox") > -1) {
            angular.element('#signInSvg').remove();
            angular.element('#signInSvgParent')
              .prepend('<svg id="signInSvg" class="icon sign-in"><use xlink:href="#sign-in"></use></svg>');
          }
          $translate('userProfile.registration').then(function (translations) {
            seoService.title(translations);
            seoService.description(translations);
          });

        },

        register: function () {


          if (!this.user.country || !this.user.region || !this.user.city || !this.response) {
            return;
          }

          this.isRegistering = true;
          this.resource.userSignUp(this.user).then(function (response) {
            if (response.metadata.code == 200) {

              $q.all([
                $translate('authentication.signUp.successTitle'),
                $translate('authentication.signUp.registerSuccess')
              ]).then(function (translations) {
                this.opts = {};
                this.opts.title = translations[0];
                this.opts.message = translations[1];
                modalService.showSuccessSignUpAlert(this.opts);
                applicationLifecycle.loggedIn();
              }.bind(this));


              // $state.go('index');
            }
          }, function (response) {
            if (response.data.metadata.errorCode === 400404) {
              this.emailExist = true;
            }
          }.bind(this)).finally(function () {
            this.isRegistering = false;
          }.bind(this));
        },

        setCaptchaResponse: function (response) {
          this.response = response;
        },

        facebookInfo: function () {
          this.resource.facebookLogin().then(function (fbUser) {
            this.user.firstName = fbUser.first_name;
            this.user.lastName = fbUser.last_name;
            this.user.email = fbUser.email;
            this.user.emailRepeat = fbUser.email;
            this.user.avatar = fbUser.picture.data.url;
          }.bind(this));
        },

        googlePlusInfo: function () {
          this.resource.googlePlusLogin().then(function (user) {
            this.user.firstName = user.given_name;
            this.user.lastName = user.firstName;
            this.user.email = user.email;
            this.user.emailRepeat = user.email;
            this.user.avatar = user.picture;
          }.bind(this));
        },

        startVkAuth: function () {
          vkClient.initAuth();
        },

        startOkAuth: function () {
          okClient.initAuth();
        },

        fetchUserInfo: function (code) {
          if (isOk) {
            okClient.getUserInfo(authCode).then(function (response) {
              var data = response.data;
              this.user.firstName = data.first_name;
              this.user.lastName = data.last_name;
              this.user.avatar = data.pic_3;
            }.bind(this));
          } else if (isVk && authCode) {
            vkClient.getAccessToken(authCode).then(function (codeResponse) {
              return vkClient.getUserInfo(codeResponse.data.access_token, codeResponse.data.user_id).then(function (response) {
                var user = response.data.response[0];
                this.user.firstName = user.first_name;
                this.user.lastName = user.last_name;
                this.user.avatar = user.photo_100;
                this.user.email = codeResponse.data.email;
                this.user.emailRepeat = codeResponse.data.email;
              }.bind(this));
            }.bind(this));
          }
        }
      });
      return new signUpController($scope, signUpResource);
    }]);

(function () {
  'use strict';

  angular
    .module('babycompy.authentication.signUp')
    .config(['$stateProvider', config]);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('index.signUp', {
      abstract: true,
      url: 'signUp?code&access_token&user_id&state',
      views: {
        'content-wrapper@': {
          templateUrl: 'app/components/authentication/signUp/signUp.html',
          controller: 'signUpController as c'
        }
      },
      resolve: {
        authCode: ['$stateParams', function ($stateParams) {
          return $stateParams.code
        }],
        accessToken: ['$stateParams', function ($stateParams) {
          return $stateParams.access_token
        }],
        userId: ['$stateParams', function ($stateParams) {
          return $stateParams.user_id
        }],

        isVk: ['$stateParams', function ($stateParams) {
          return $stateParams.state === 'vk';
        }],
        isOk: ['$stateParams', function ($stateParams) {
          return $stateParams.code != undefined && $stateParams.state == undefined;
        }],
        'urlFix': ['$location', function ($location) {
          $location.url($location.url().replace("#", "?"));
        }]
      }
    }).state('index.signUp.user', {
      url: '/user',
      views: {
        'social-networks': { 'templateUrl': 'app/components/authentication/signUp/partials/socialNetworks.html' },
        'signUp-form': {
          templateUrl: 'app/components/authentication/signUp/partials/userSignUp.html',
        }
      }
    }).state('index.signUp.doctor', {
      url: '/doctor',
      views: {
        'signUp-form': {
          templateUrl: 'app/components/authentication/signUp/doctor/doctorSignUp.html',
          controller: 'doctorsSignUpController as c'
        }
      }
    }).state('index.signUp.clinic', {
      url: '/clinic',
      views: {
        'signUp-form': { templateUrl: 'app/components/authentication/signUp/partials/clinicSignUp.html' }
      }
    });
  }
})();

(function () {
    angular.module('babycompy.authentication.profile')
        .service('profileService', ['$q', '$translate', 'profileConstants',
            function ($q, $translate, profileConstants) {

                function ProfileService() {
                };

                ProfileService.prototype.checkUploadingImage = function (file) {
                    var deferred = $q.defer();

                    if (file.size > profileConstants.maxAvatarSize) {
                        return $q.reject({
                            message: $translate.instant('userProfile.avatarMaxFileSize')
                        });
                    }

                    return this.readAsImage(file).then(function (img) {
                        if (img.width < profileConstants.minAvatarWidth ||
                            img.height < profileConstants.minAvatarHeight) {

                            return $q.reject({
                                message: $translate.instant('userProfile.avatarMinImageSize')
                            });
                        } else {
                           return $q.when();
                        }
                    }.bind(this));
                };

                ProfileService.prototype.readAsImage = function (file) {
                    var deferred = $q.defer();
                    var fr = new FileReader;

                    fr.onload = function () {
                        var img = new Image();
                        img.onload = function () {
                            deferred.resolve(img);
                        };

                        img.src = fr.result;
                    };
                    fr.readAsDataURL(file);

                    return deferred.promise;
                };

                return new ProfileService();
            }])
        .constant('profileConstants', {
            maxAvatarSize: 5242880, //5 MB
            minAvatarHeight: 250,
            minAvatarWidth: 250
        });
})(angular);
(function () {
    angular.module('babycompy.authentication.profile')
        .service('updateProfileService', ['baseApiService',
            'resources', 'fileService', function (baseApiService, resources, fileService) {
                var updateProfileService = baseApiService.extend({
                    _setupCustomActions: function () {
                        return {
                            'updateProfile': {
                                method: 'POST',
                                isObject: true,
                                params: {
                                    action: 'profile'
                                }
                            },
                            'getPregnancyAges': {
                                method: 'GET',
                                isObject: true,
                                params: {
                                    controller: 'dictionaries',
                                    action: 'pregnancyAges',
                                }
                            },
                            updateImage: {
                                method: 'POST',
                                params: {
                                    expand: undefined,
                                    controller: 'files',
                                    id: 'upload',
                                    action: 'image'
                                },
                                transformRequest: angular.identity,
                                headers: {
                                    'Content-Type': undefined
                                }
                            },

                            deleteImage: {
                              method: "DELETE",
                              params: {
                                controller: 'files'
                              }
                            }
                        }
                    },

                    updateProfile: function (userProfile) {
                        return this.resource.updateProfile(userProfile).$promise;
                    },

                    getPregnancyAges: function () {
                        return this.resource.getPregnancyAges().$promise;
                    },

                    updateImage: function (content, fileName) {
                        var fd = new FormData();
                        if (!angular.isObject(content)) {
                          content = fileService.base64UriToFile(content);
                        }
                        fd.append('file', content, fileName);
                        return this.resource.updateImage(fd).$promise;
                    },

                    deleteImage: function (uuid) {
                      return this.resource.deleteImage({id: uuid}).$promise;
                    }

                });
                return new updateProfileService(resources.users);
            }]);
})();

(function () {
    angular.module('babycompy.authentication.profile')
        .controller('profileController', ['$scope', 'baseController',
            'updateProfileService',
            'modalService', 'cropperService', '$q', 'profileService',
            '$translate', 'currentUserService',
            function ($scope, baseController, updateProfileService,
                modalService, cropperService, $q, profileService,
                $translate, currentUserService) {

                var ProfileController = baseController.extend({
                    init: function ($scope, resource) {
                        this._super($scope, resource);
                        this.entity = currentUserService.get();
                        if (this.entity.avatar && typeof this.entity.avatar == 'string') {
                            if (this.entity.avatar.indexOf("http") >= 0) {
                                this.avatarPath = this.entity.avatar;
                            } else {
                                this.avatarPath = "/api/v1/files/" + this.entity.avatar;
                            }
                        } else {
                            this.avatarPath = "/assets/images/user-no-photo.png";
                        }
                        this.avatarService = new cropperService();
                        this.fileWrapper = {
                            fileAdded: this.fileAdded.bind(this)
                        }
                    },

                    fileAdded: function ($event, flowFile) {
                        var file = flowFile.file[0];
                        profileService.checkUploadingImage(file).then(function () {
                            this.showAvatarEditModal(file);
                        }.bind(this), function (reason) {
                            modalService.showErrorAlert({
                                title: $translate.instant('userProfile.avatarUpload'),
                                message: reason.message
                            });
                        });
                    },

                    removeAvatar: function () {
                        this.entity.avatar = null;
                        currentUserService.onChangeAvatar();
                        return updateProfileService.updateProfile(this.entity);
                    },

                    editAvatar: function () {
                        this.fileWrapper.openFile();
                    },

                    showAvatarEditModal: function (file) {
                        modalService.open({
                            scope: $scope,
                            template: 'app/components/authentication/profile/avatarModal/avatar.modal.html',
                            controller: 'profileAvatarModalController as c',
                            show: true,
                            backdrop: 'static',
                            resolve: {
                                file: function () {
                                    return $q.when(file);
                                }
                            }
                        }).result.then(function (entity) {
                            this.entity.avatar = entity.avatar;
                            $scope.c.avatarPath = "/api/v1/files/" + this.entity.avatar;
                            currentUserService.set(this.entity);
                            currentUserService.onChangeAvatar();
                        }.bind(this))
                    }

                });


                return new ProfileController($scope, updateProfileService);
            }]);
})();

(function () {
  'use strict';

  angular
    .module('babycompy.authentication.profile')
    .config(['$stateProvider', config]);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('index.profile', {
      abstract: true,
      url: 'profile'
    })
    .state('index.profile.user', {
      abstract: true,
      url: '/user',
      views: {
        'promo_menu_ruler@': {template: ''},
        'content-wrapper@': {
          templateUrl: 'app/components/authentication/profile/profile.html',
          controller: 'profileController as c'
        }
      },

      resolve: {
        currentUser: ['currentUserService', '$state', function (currentUserService, $state) {
          return currentUserService.load().then(function (user) {
            if (user == null) {
              $state.go('index.login');
              return;
            }

            return currentUserService.get();
          });
        }],

        pregnancyAges: ['updateProfileService', function (updateProfileService) {
          return updateProfileService.getPregnancyAges().then(function (response) {
            return response.content.items;
          });
        }]
      }
    });
  }
})();

(function () {
    angular.module('babycompy.authentication.login')
        .controller('LoginController', ['$scope', '$state', 'authService', '$modal', 'applicationLifecycle', '$modalService',
            function ($scope, $state, authService, $modal, applicationLifecycle, $modalService) {

                function LoginController() {
                    this.userId = '';
                    this.password = '';
                    this.showError = false;
                    this.isUserBlocked = false;
                    if (navigator.userAgent.search("Firefox") > -1) {
                        angular.element('#signUpSvg').remove();
                        angular.element('#signUpSvgParent')
                            .prepend('<svg id="signUpSvg" class="icon child"><use xlink:href="#child"></use></svg>');
                    }
                }

                LoginController.prototype.login = function () {
                    if (!this.userId || !this.password) {
                        this.showError = true;
                        return;
                    }

                    this.isLoggingIn = true;
                    return authService.signIn(this.userId, this.password).then(function (response) {
                        if ($state.is('index.login')) {
                            $state.go('index');
                        } else {
                            $state.reload();
                        }

                        applicationLifecycle.loggedIn(response.content);
                        $modalService.close();
                    }.bind(this), function (response) {
                        if (response.status === 401) {
                            if (response.data
                                && response.data.metadata
                                && response.data.metadata.errorCode === 401405) {
                                this.isUserBlocked = true;
                                this.showError = false;
                            } else {
                                this.showError = true;
                                this.isUserBlocked = false;
                            }
                        }

                    }.bind(this)).finally(function () {
                        this.isLoggingIn = false;
                    }.bind(this))
                };

                LoginController.prototype.checkField = function () {
                    if (!this.password || !this.userId) {
                        this.showError = false;
                        this.isUserBlocked = false;
                    }
                };

                LoginController.prototype.openForgotModal = function () {
                    var forgotPasswordModal = $modal({
                        templateUrl: 'app/components/authentication/login/forgotPassword/forgot.password.modal.html',
                        controller: 'forgotPasswordController as c',
                        show: true
                    });

                };

                LoginController.prototype.closeModal = function () {
                    $modalService.dismiss();
                }

                return new LoginController();
            }]);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.authentication.login')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.login', {
            url: 'login',
            views: {
                'content-wrapper@': {
                    templateUrl: 'app/components/authentication/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'c'
                }
            },
            resolve: {
                $modalService: function () {
                    return {
                        close: function () { }
                    }
                }
            }
        });
    }
})();

/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});


(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            var iptcdata = findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        return tags;
    }

    EXIF.getData = function(img, callback) {
        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (typeof define === 'function' && define.amd) {
        define('exif-js', [], function() {
            return EXIF;
        });
    }
}.call(this));


(function () {
    'use strict';

    angular.module('ngCropper', ['ng'])
        .directive('ngCropper', ['$q', function ($q) {
            return {
                restrict: 'A',
                scope: {
                    options: '=ngCropperOptions',
                    showEvent: '=ngCropperShow',
                    hideEvent: '=ngCropperHide'
                },
                link: function (scope, element, atts) {
                    var shown = false;

                    scope.$on(scope.showEvent, function () {
                        if (shown) return;
                        shown = true;

                        preprocess(scope.options, element[0])
                            .then(function (options) {
                                element.cropper(options);
                            })
                    });

                    scope.$on(scope.hideEvent, function () {
                        if (!shown) return;
                        shown = false;
                        element.cropper('destroy');
                    });

                    scope.$watch('options.disabled', function (disabled) {
                        if (!shown) return;
                        if (disabled) element.cropper('disable');
                        if (!disabled) element.cropper('enable');
                    });
                }
            };

            function preprocess(options, img) {
                options = options || {};
                var result = $q.when(options); // No changes.
                if (options.maximize) {
                    result = maximizeSelection(options, img);
                }
                return result;
            }

            /**
             * Change options to make selection maximum for the image.
             * fengyuanchen/cropper calculates valid selection's height & width
             * with respect to `aspectRatio`.
             */
            function maximizeSelection(options, img) {
                return getRealSize(img).then(function (size) {
                    options.data = size;
                    return options;
                });
            }

            /**
             * Returns real image size (without changes by css, attributes).
             */
            function getRealSize(img) {
                var defer = $q.defer();
                var size = { height: null, width: null };
                var image = new Image();

                image.onload = function () {
                    defer.resolve({ width: image.width, height: image.height });
                }

                image.src = img.src;
                return defer.promise;
            }
        }])
        .service('Cropper', ['$q', function ($q) {

            var that = this;
            this.encode = function (blob, correctExif) {
                var defer = $q.defer();

                // if (!correctExif) {
                //   alert('bad');
                that._readAsDataUrl(blob, defer);
                return defer.promise.then(function (result) {
                    return this.rotateImg(blob, result, correctExif);
                }.bind(that));


                //} else {
                //    alert('good');
                //    var reader = new FileReader();
                //    reader.onload = function (e) {
                //        //   defer.resolve(e.target.result);
                //        var newBlob = this.removeExif(e.target.result);
                //        that._readAsDataUrl(newBlob || blob, defer);
                //    }.bind(that);

                //   reader.readAsArrayBuffer(blob);                
                //}       

                //return defer.promise;
            };

            this._readAsDataUrl = function (blob, defer) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    defer.resolve(e.target.result);
                }.bind(this);
                reader.readAsDataURL(blob);
            }

            this.rotateImg = function (file, urlBlob, imgInfo) {
                return _createImage(urlBlob).then(function (image) {
                    var canvas = createCan(image.width, image.height); //createCan(image.width, image.height); //
                    var context = canvas.getContext('2d');

                    //drawImageIOSFix(context, image, data.x, data.y, data.width, data.height, 0, 0, data.width, data.height, detectVerticalSquash);
                    //  alert(JSON.stringify(imgInfo));    


                    var angl = 0;
                    var degrees = 0;
                    switch (imgInfo) {
                        case 8:
                            angl = -90 * Math.PI / 180;
                            degrees = -90;
                            break;
                        case 3:
                            angl = -180 * Math.PI / 180;
                            degrees = -180;
                            break;
                        case 6:
                            angl = 90 * Math.PI / 180;
                            degrees = 90;
                            break;
                    }

                    if (angl !== 0) {

                        if (degrees == 90 || degrees == 270) {
                            canvas.width = image.height;
                            canvas.height = image.width;
                        } else {
                            canvas.width = image.width;
                            canvas.height = image.height;
                        }
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        if (degrees == 90 || degrees == 270) {
                            context.translate(image.height / 2, image.width / 2);
                        } else {
                            context.translate(image.width / 2, image.height / 2);
                        }

                        context.rotate(degrees * Math.PI / 180);

                        context.drawImage(image, -image.width / 2, -image.height / 2);

                        context.rotate(-degrees * Math.PI / 180);

                        if (degrees == 90 || degrees == 270) {
                            context.translate(-image.height / 2, -image.width / 2);
                        } else {
                            context.translate(-image.width / 2, -image.height / 2);
                        }

                    } else {
                        context.drawImage(image, 0, 0);
                    }


                    ////alert(angl);
                    ////angl = 90 * Math.PI / 180;
                    //if (angl !== 0) {                   
                    //    var x = image.width / 2;
                    //    var y = image.height / 2;
                    //    //angl = 90 * Math.PI / 180;
                    //    context.translate(x, y);
                    //    context.rotate(angl);
                    //    context.drawImage(image, -image.width / 2, -image.height / 2);
                    //    // context2.save();
                    //    context.rotate(-angl);
                    //    context.translate(-x, -y);                
                    //} else {
                    //    context.drawImage(image, 0, 0);                 
                    //}

                    var encoded = canvas.toDataURL(file.type);
                    removeElement(canvas);
                    context = null;

                    return encoded;
                });
            }

            this.removeExif = function (result) {

                var dv = new DataView(result);
                var offset = 0, recess = 0;
                var pieces = [];
                var i = 0;
                if (dv.getUint16(offset) == 0xffd8) {
                    offset += 2;
                    var app1 = dv.getUint16(offset);
                    offset += 2;
                    while (offset < dv.byteLength) {
                        console.log(offset, '0x' + app1.toString(16), recess);
                        if (app1 == 0xffe1) {

                            pieces[i] = { recess: recess, offset: offset - 2 };
                            recess = offset + dv.getUint16(offset);
                            i++;
                        }
                        else if (app1 == 0xffda) {
                            break;
                        }
                        offset += dv.getUint16(offset);
                        var app1 = dv.getUint16(offset);
                        offset += 2;
                    }
                    if (pieces.length > 0) {
                        var newPieces = [];
                        pieces.forEach(function (v) {
                            newPieces.push(result.slice(v.recess, v.offset));
                        }, this);
                        newPieces.push(result.slice(recess));
                        var br = new Blob(newPieces, { type: 'image/jpeg' });
                        //window.open(URL.createObjectURL(br), "_blank", "toolbar=yes, scrollbars=yes, resizable=yes, top=500, left=500, width=400, height=400");

                        return br;
                    }
                } else {
                    return null;
                }
            }

            this.decode = function (dataUrl) {
                var meta = dataUrl.split(';')[0];
                var type = meta.split(':')[1];
                var binary = atob(dataUrl.split(',')[1]);
                var array = new Uint8Array(binary.length);
                for (var i = 0; i < binary.length; i++) {
                    array[i] = binary.charCodeAt(i);
                }
                return new Blob([array], { type: type });
            };

            this.makeSquare = function (dataUrl) {
                var _decodeBlob = this.decode;
                return _createImage(dataUrl).then(function (image) {
                    var canvas, context;
                    
                    if (image.height > image.width) {
                        canvas = createCan(image.width, image.width);
                        context = canvas.getContext('2d');
                        context.drawImage(image, 0, (image.height-image.width)/2, image.width, image.width, 0, 0, image.width, image.width);
                    } else {
                        canvas = createCan(image.height, image.height);
                        context = canvas.getContext('2d');
                        context.drawImage(image, (image.width-image.height)/2,0 ,image.height, image.height, 0, 0, image.height, image.height);
                    }
                    var encoded = canvas.toDataURL();
                    removeElement(canvas);
                    return _decodeBlob(encoded);
                });
            };

            this.crop = function (file, data, imgInfo, dataUrl) {
                var _decodeBlob = this.decode;
                var drawImageIOSFix = this.drawImageIOSFix;
                var detectVerticalSquash = this.detectVerticalSquash;
                //return this.encode(file).then(
                return _createImage(dataUrl).then(function (image) {

                    var canvas = createCanvas(data); //createCan(image.width, image.height); //
                    var context = canvas.getContext('2d');

                    //drawImageIOSFix(context, image, data.x, data.y, data.width, data.height, 0, 0, data.width, data.height, detectVerticalSquash);
                    //  alert(JSON.stringify(imgInfo));    

                    var angl = 0;
                    switch (imgInfo) {
                        case 8:
                            angl = -90 * Math.PI / 180;
                            break;
                        case 3:
                            angl = -180 * Math.PI / 180;
                            break;
                        case 6:
                            angl = 90 * Math.PI / 180;
                            break;
                    }


                    context.drawImage(image, data.x, data.y, data.width, data.height, 0, 0, data.width, data.height);

                    var encoded;
                    if (angl !== 0) {
                        var canvas2 = createCanvas(data);
                        var context2 = canvas2.getContext('2d');
                        var x = data.width / 2;
                        var y = data.height / 2;
                        //angl = 90 * Math.PI / 180;
                        context2.translate(x, y);
                        context2.rotate(angl);
                        context2.drawImage(canvas, -data.width / 2, -data.height / 2);
                        // context2.save();
                        context2.rotate(-angl);
                        context2.translate(-x, -y);

                        encoded = canvas2.toDataURL(file.type);
                        removeElement(canvas);
                        removeElement(canvas2);

                        context2 = null;
                        canvas2 = null;
                    } else {
                        encoded = canvas.toDataURL(file.type);
                        removeElement(canvas);
                    }


                    return _decodeBlob(encoded);
                });
            };

            this.drawImageIOSFix = function drawImageIOSFix(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh, detectVerticalSquash) {
                var vertSquashRatio = detectVerticalSquash(img);

                alert(vertSquashRatio)
                // Works only if whole image is displayed:
                // ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
                // The following works correct also when only a part of the image is displayed:
                ctx.drawImage(img, sx * vertSquashRatio, sy * vertSquashRatio,
                    sw * vertSquashRatio, sh * vertSquashRatio,
                    dx, dy, dw, dh);
            }

            this.detectVerticalSquash = function (img) {
                var iw = img.naturalWidth, ih = img.naturalHeight;
                var canvas = document.createElement('canvas');
                canvas.width = 1;
                canvas.height = ih;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                var data = ctx.getImageData(0, 0, 1, ih).data;
                // search image edge pixel position in case it is squashed vertically.
                var sy = 0;
                var ey = ih;
                var py = ih;
                while (py > sy) {
                    var alpha = data[(py - 1) * 4 + 3];
                    if (alpha === 0) {
                        ey = py;
                    } else {
                        sy = py;
                    }
                    py = (ey + sy) >> 1;
                }
                var ratio = (py / ih);
                return (ratio === 0) ? 1 : ratio;
            }


            this.scale = function (file, data) {
                var _decodeBlob = this.decode;
                return this.encode(file).then(_createImage).then(function (image) {
                    var heightOrig = image.height;
                    var widthOrig = image.width;
                    var ratio, height, width;

                    if (angular.isNumber(data)) {
                        ratio = data;
                        height = heightOrig * ratio;
                        width = widthOrig * ratio;
                    }

                    if (angular.isObject(data)) {
                        ratio = widthOrig / heightOrig;
                        height = data.height;
                        width = data.width;

                        if (height && !width)
                            width = height * ratio;
                        else if (width && !height)
                            height = width / ratio;
                    }

                    var canvas = createCanvas(data);
                    var context = canvas.getContext('2d');

                    canvas.height = height;
                    canvas.width = width;

                    context.drawImage(image, 0, 0, widthOrig, heightOrig, 0, 0, width, height);

                    var encoded = canvas.toDataURL(file.type);
                    removeElement(canvas);

                    return _decodeBlob(encoded);
                });
            };


            function _createImage(source) {
                var defer = $q.defer();
                var image = new Image();
                image.setAttribute('crossOrigin', 'anonymous');
                image.onload = function (e) { defer.resolve(e.target); };
                image.src = source;
                return defer.promise;
            }

            function createCanvas(data) {
                var canvas = document.createElement('canvas');
                canvas.width = data.width;
                canvas.height = data.height;
                canvas.style.display = 'none';
                document.body.appendChild(canvas);
                return canvas;
            }

            function createCan(width, height) {
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.style.display = 'none';
                document.body.appendChild(canvas);
                return canvas;
            }

            function removeElement(el) {
                el.parentElement.removeChild(el);
            }

        }]);

})();

/*!
 * Cropper v0.10.1
 * https://github.com/fengyuanchen/cropper
 *
 * Copyright (c) 2014-2015 Fengyuan Chen and contributors
 * Released under the MIT license
 *
 * Date: 2015-07-05T10:44:58.203Z
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node / CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals.
    factory(jQuery);
  }
})(function ($) {

  'use strict';

  var $window = $(window),
      $document = $(document),
      location = window.location,

      // Constants
      CROPPER_NAMESPACE = '.cropper',
      CROPPER_PREVIEW = 'preview' + CROPPER_NAMESPACE,

      // RegExps
      REGEXP_DRAG_TYPES = /^(e|n|w|s|ne|nw|sw|se|all|crop|move|zoom)$/,

      // Classes
      CLASS_MODAL = 'cropper-modal',
      CLASS_HIDE = 'cropper-hide',
      CLASS_HIDDEN = 'cropper-hidden',
      CLASS_INVISIBLE = 'cropper-invisible',
      CLASS_MOVE = 'cropper-move',
      CLASS_CROP = 'cropper-crop',
      CLASS_DISABLED = 'cropper-disabled',
      CLASS_BG = 'cropper-bg',

      // Events
      EVENT_MOUSE_DOWN = 'mousedown touchstart pointerdown MSPointerDown',
      EVENT_MOUSE_MOVE = 'mousemove touchmove pointermove MSPointerMove',
      EVENT_MOUSE_UP = 'mouseup touchend touchcancel pointerup pointercancel MSPointerUp MSPointerCancel',
      EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll',
      EVENT_DBLCLICK = 'dblclick',
      EVENT_RESIZE = 'resize' + CROPPER_NAMESPACE, // Bind to window with namespace
      EVENT_BUILD = 'build' + CROPPER_NAMESPACE,
      EVENT_BUILT = 'built' + CROPPER_NAMESPACE,
      EVENT_DRAG_START = 'dragstart' + CROPPER_NAMESPACE,
      EVENT_DRAG_MOVE = 'dragmove' + CROPPER_NAMESPACE,
      EVENT_DRAG_END = 'dragend' + CROPPER_NAMESPACE,
      EVENT_ZOOM_IN = 'zoomin' + CROPPER_NAMESPACE,
      EVENT_ZOOM_OUT = 'zoomout' + CROPPER_NAMESPACE,
      EVENT_CHANGE = 'change' + CROPPER_NAMESPACE,

      // Supports
      SUPPORT_CANVAS = $.isFunction($('<canvas>')[0].getContext),

      // Others
      sqrt = Math.sqrt,
      min = Math.min,
      max = Math.max,
      abs = Math.abs,
      sin = Math.sin,
      cos = Math.cos,
      num = parseFloat,

      // Prototype
      prototype = {};

  function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
  }

  function isUndefined(n) {
    return typeof n === 'undefined';
  }

  function toArray(obj, offset) {
    var args = [];

    if (isNumber(offset)) { // It's necessary for IE8
      args.push(offset);
    }

    return args.slice.apply(obj, args);
  }

  // Custom proxy to avoid jQuery's guid
  function proxy(fn, context) {
    var args = toArray(arguments, 2);

    return function () {
      return fn.apply(context, args.concat(toArray(arguments)));
    };
  }

  function isCrossOriginURL(url) {
    var parts = url.match(/^(https?:)\/\/([^\:\/\?#]+):?(\d*)/i);

    return parts && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }

  function addTimestamp(url) {
    var timestamp = 'timestamp=' + (new Date()).getTime();

    return (url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp);
  }

  function getRotateValue(degree) {
    return degree ? 'rotate(' + degree + 'deg)' : 'none';
  }

  function getRotatedSizes(data, reverse) {
    var deg = abs(data.degree) % 180,
        arc = (deg > 90 ? (180 - deg) : deg) * Math.PI / 180,
        sinArc = sin(arc),
        cosArc = cos(arc),
        width = data.width,
        height = data.height,
        aspectRatio = data.aspectRatio,
        newWidth,
        newHeight;

    if (!reverse) {
      newWidth = width * cosArc + height * sinArc;
      newHeight = width * sinArc + height * cosArc;
    } else {
      newWidth = width / (cosArc + sinArc / aspectRatio);
      newHeight = newWidth / aspectRatio;
    }

    return {
      width: newWidth,
      height: newHeight
    };
  }

  function getSourceCanvas(image, data) {
    var canvas = $('<canvas>')[0],
        context = canvas.getContext('2d'),
        width = data.naturalWidth,
        height = data.naturalHeight,
        rotate = data.rotate,
        rotated = getRotatedSizes({
          width: width,
          height: height,
          degree: rotate
        });

    if (rotate) {
      canvas.width = rotated.width;
      canvas.height = rotated.height;
      context.save();
      context.translate(rotated.width / 2, rotated.height / 2);
      context.rotate(rotate * Math.PI / 180);
      context.drawImage(image, -width / 2, -height / 2, width, height);
      context.restore();
    } else {
      canvas.width = width;
      canvas.height = height;
      context.drawImage(image, 0, 0, width, height);
    }

    return canvas;
  }

  function Cropper(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Cropper.DEFAULTS, $.isPlainObject(options) && options);

    this.ready = false;
    this.built = false;
    this.rotated = false;
    this.cropped = false;
    this.disabled = false;
    this.replaced = false;
    this.isImg = false;
    this.originalUrl = '';
    this.canvas = null;
    this.cropBox = null;

    this.init();
  }

  prototype.init = function () {
    var $this = this.$element,
        url;

    if ($this.is('img')) {
      this.isImg = true;
      this.originalUrl = url = $this.attr('src'); // e.g.: "img/picture.jpg"

      if (!url) { // Blank image
        return;
      }

      url = $this.prop('src'); // e.g.: "http://example.com/img/picture.jpg"
    } else if ($this.is('canvas') && SUPPORT_CANVAS) {
      url = $this[0].toDataURL();
    }

    this.load(url);
  };

  prototype.load = function (url) {
    var options = this.options,
        $this = this.$element,
        crossOrigin,
        bustCacheUrl,
        buildEvent,
        $clone;

    if (!url) {
      return;
    }

    buildEvent = $.Event(EVENT_BUILD);
    $this.one(EVENT_BUILD, options.build).trigger(buildEvent); // Only trigger once

    if (buildEvent.isDefaultPrevented()) {
      return;
    }

    if (options.checkImageOrigin && isCrossOriginURL(url)) {
      crossOrigin = ' crossOrigin="anonymous"';

      if (!$this.prop('crossOrigin')) { // Only when there was not a "crossOrigin" property
        bustCacheUrl = addTimestamp(url); // Bust cache (#148)
      }
    }

    // IE8 compatibility: Don't use "$().attr()" to set "src"
    this.$clone = $clone = $('<img' + (crossOrigin || '') + ' src="' + (bustCacheUrl || url) + '">');

    $clone.one('load', $.proxy(function () {
      var image = $clone[0],
          naturalWidth = image.naturalWidth || image.width,
          naturalHeight = image.naturalHeight || image.height; // $clone.width() and $clone.height() will return 0 in IE8 (#319)

      this.image = {
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        aspectRatio: naturalWidth / naturalHeight,
        rotate: 0
      };

      this.url = url;
      this.ready = true;
      this.build();
    }, this)).one('error', function () {
      $clone.remove();
    });

    // Hide and insert into the document
    $clone.addClass(CLASS_HIDE).insertAfter($this);
  };

  prototype.build = function () {
    var $this = this.$element,
        $clone = this.$clone,
        options = this.options,
        $cropper,
        $cropBox,
        $face;

    if (!this.ready) {
      return;
    }

    if (this.built) {
      this.unbuild();
    }

    // Create cropper elements
    this.$cropper = $cropper = $(Cropper.TEMPLATE);

    // Hide the original image
    $this.addClass(CLASS_HIDDEN);

    // Show the clone iamge
    $clone.removeClass(CLASS_HIDE);

    this.$container = $this.parent().append($cropper);
    this.$canvas = $cropper.find('.cropper-canvas').append($clone);
    this.$dragBox = $cropper.find('.cropper-drag-box');
    this.$cropBox = $cropBox = $cropper.find('.cropper-crop-box');
    this.$viewBox = $cropper.find('.cropper-view-box');
    this.$face = $face = $cropBox.find('.cropper-face');

    this.addListeners();
    this.initPreview();

    // Format aspect ratio
    options.aspectRatio = num(options.aspectRatio) || NaN; // 0 -> NaN

    if (options.autoCrop) {
      this.cropped = true;

      if (options.modal) {
        this.$dragBox.addClass(CLASS_MODAL);
      }
    } else {
      $cropBox.addClass(CLASS_HIDDEN);
    }

    if (!options.guides) {
      $cropBox.find('.cropper-dashed').addClass(CLASS_HIDDEN);
    }

    if (!options.center) {
      $cropBox.find('.cropper-center').addClass(CLASS_HIDDEN);
    }

    if (options.cropBoxMovable) {
      $face.addClass(CLASS_MOVE).data('drag', 'all');
    }

    if (!options.highlight) {
      $face.addClass(CLASS_INVISIBLE);
    }

    if (options.background) {
      $cropper.addClass(CLASS_BG);
    }

    if (!options.cropBoxResizable) {
      $cropBox.find('.cropper-line, .cropper-point').addClass(CLASS_HIDDEN);
    }

    this.setDragMode(options.dragCrop ? 'crop' : options.movable ? 'move' : 'none');

    this.built = true;
    this.render();
    this.setData(options.data);
    $this.one(EVENT_BUILT, options.built).trigger(EVENT_BUILT); // Only trigger once
  };

  prototype.unbuild = function () {
    if (!this.built) {
      return;
    }

    this.built = false;
    this.initialImage = null;
    this.initialCanvas = null; // This is necessary when replace
    this.initialCropBox = null;
    this.container = null;
    this.canvas = null;
    this.cropBox = null; // This is necessary when replace
    this.removeListeners();

    this.resetPreview();
    this.$preview = null;

    this.$viewBox = null;
    this.$cropBox = null;
    this.$dragBox = null;
    this.$canvas = null;
    this.$container = null;

    this.$cropper.remove();
    this.$cropper = null;
  };

  $.extend(prototype, {
    render: function () {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();

      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },

    initContainer: function () {
      var $this = this.$element,
          $container = this.$container,
          $cropper = this.$cropper,
          options = this.options;

      $cropper.addClass(CLASS_HIDDEN);
      $this.removeClass(CLASS_HIDDEN);

      $cropper.css((this.container = {
        width: max($container.width(), num(options.minContainerWidth) || 200),
        height: max($container.height(), num(options.minContainerHeight) || 100)
      }));

      $this.addClass(CLASS_HIDDEN);
      $cropper.removeClass(CLASS_HIDDEN);
    },

    // image box (wrapper)
    initCanvas: function () {
      var container = this.container,
          containerWidth = container.width,
          containerHeight = container.height,
          image = this.image,
          aspectRatio = image.aspectRatio,
          canvas = {
            aspectRatio: aspectRatio,
            width: containerWidth,
            height: containerHeight
          };

      if (containerHeight * aspectRatio > containerWidth) {
        canvas.height = containerWidth / aspectRatio;
      } else {
        canvas.width = containerHeight * aspectRatio;
      }

      canvas.oldLeft = canvas.left = (containerWidth - canvas.width) / 2;
      canvas.oldTop = canvas.top = (containerHeight - canvas.height) / 2;

      this.canvas = canvas;
      this.limitCanvas(true, true);
      this.initialImage = $.extend({}, image);
      this.initialCanvas = $.extend({}, canvas);
    },

    limitCanvas: function (size, position) {
      var options = this.options,
          strict = options.strict,
          container = this.container,
          containerWidth = container.width,
          containerHeight = container.height,
          canvas = this.canvas,
          aspectRatio = canvas.aspectRatio,
          cropBox = this.cropBox,
          cropped = this.cropped && cropBox,
          initialCanvas = this.initialCanvas || canvas,
          initialCanvasWidth = initialCanvas.width,
          initialCanvasHeight = initialCanvas.height,
          minCanvasWidth,
          minCanvasHeight;

      if (size) {
        minCanvasWidth = num(options.minCanvasWidth) || 0;
        minCanvasHeight = num(options.minCanvasHeight) || 0;

        if (minCanvasWidth) {
          if (strict) {
            minCanvasWidth = max(cropped ? cropBox.width : initialCanvasWidth, minCanvasWidth);
          }

          minCanvasHeight = minCanvasWidth / aspectRatio;
        } else if (minCanvasHeight) {
          if (strict) {
            minCanvasHeight = max(cropped ? cropBox.height : initialCanvasHeight, minCanvasHeight);
          }

          minCanvasWidth = minCanvasHeight * aspectRatio;
        } else if (strict) {
          if (cropped) {
            minCanvasWidth = cropBox.width;
            minCanvasHeight = cropBox.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          } else {
            minCanvasWidth = initialCanvasWidth;
            minCanvasHeight = initialCanvasHeight;
          }
        }

        $.extend(canvas, {
          minWidth: minCanvasWidth,
          minHeight: minCanvasHeight,
          maxWidth: Infinity,
          maxHeight: Infinity
        });
      }

      if (position) {
        if (strict) {
          if (cropped) {
            canvas.minLeft = min(cropBox.left, (cropBox.left + cropBox.width) - canvas.width);
            canvas.minTop = min(cropBox.top, (cropBox.top + cropBox.height) - canvas.height);
            canvas.maxLeft = cropBox.left;
            canvas.maxTop = cropBox.top;
          } else {
            canvas.minLeft = min(0, containerWidth - canvas.width);
            canvas.minTop = min(0, containerHeight - canvas.height);
            canvas.maxLeft = max(0, containerWidth - canvas.width);
            canvas.maxTop = max(0, containerHeight - canvas.height);
          }
        } else {
          canvas.minLeft = -canvas.width;
          canvas.minTop = -canvas.height;
          canvas.maxLeft = containerWidth;
          canvas.maxTop = containerHeight;
        }
      }
    },

    renderCanvas: function (changed) {
      var options = this.options,
          canvas = this.canvas,
          image = this.image,
          aspectRatio,
          rotated;

      if (this.rotated) {
        this.rotated = false;

        // Computes rotatation sizes with image sizes
        rotated = getRotatedSizes({
          width: image.width,
          height: image.height,
          degree: image.rotate
        });

        aspectRatio = rotated.width / rotated.height;

        if (aspectRatio !== canvas.aspectRatio) {
          canvas.left -= (rotated.width - canvas.width) / 2;
          canvas.top -= (rotated.height - canvas.height) / 2;
          canvas.width = rotated.width;
          canvas.height = rotated.height;
          canvas.aspectRatio = aspectRatio;
          this.limitCanvas(true, false);
        }
      }

      if (canvas.width > canvas.maxWidth || canvas.width < canvas.minWidth) {
        canvas.left = canvas.oldLeft;
      }

      if (canvas.height > canvas.maxHeight || canvas.height < canvas.minHeight) {
        canvas.top = canvas.oldTop;
      }

      canvas.width = min(max(canvas.width, canvas.minWidth), canvas.maxWidth);
      canvas.height = min(max(canvas.height, canvas.minHeight), canvas.maxHeight);

      this.limitCanvas(false, true);

      canvas.oldLeft = canvas.left = min(max(canvas.left, canvas.minLeft), canvas.maxLeft);
      canvas.oldTop = canvas.top = min(max(canvas.top, canvas.minTop), canvas.maxTop);

      this.$canvas.css({
        width: canvas.width,
        height: canvas.height,
        left: canvas.left,
        top: canvas.top
      });

      this.renderImage();

      if (this.cropped && options.strict) {
        this.limitCropBox(true, true);
      }

      if (changed) {
        this.output();
      }
    },

    renderImage: function () {
      var canvas = this.canvas,
          image = this.image,
          reversed;

      if (image.rotate) {
        reversed = getRotatedSizes({
          width: canvas.width,
          height: canvas.height,
          degree: image.rotate,
          aspectRatio: image.aspectRatio
        }, true);
      }

      $.extend(image, reversed ? {
        width: reversed.width,
        height: reversed.height,
        left: (canvas.width - reversed.width) / 2,
        top: (canvas.height - reversed.height) / 2
      } : {
        width: canvas.width,
        height: canvas.height,
        left: 0,
        top: 0
      });

      this.$clone.css({
        width: image.width,
        height: image.height,
        marginLeft: image.left,
        marginTop: image.top,
        transform: getRotateValue(image.rotate)
      });
    },

    initCropBox: function () {
      var options = this.options,
          canvas = this.canvas,
          aspectRatio = options.aspectRatio,
          autoCropArea = num(options.autoCropArea) || 0.8,
          cropBox = {
            width: canvas.width,
            height: canvas.height
          };

      if (aspectRatio) {
        if (canvas.height * aspectRatio > canvas.width) {
          cropBox.height = cropBox.width / aspectRatio;
        } else {
          cropBox.width = cropBox.height * aspectRatio;
        }
      }

      this.cropBox = cropBox;
      this.limitCropBox(true, true);

      // Initialize auto crop area
      cropBox.width = min(max(cropBox.width, cropBox.minWidth), cropBox.maxWidth);
      cropBox.height = min(max(cropBox.height, cropBox.minHeight), cropBox.maxHeight);

      // The width of auto crop area must large than "minWidth", and the height too. (#164)
      cropBox.width = max(cropBox.minWidth, cropBox.width * autoCropArea);
      cropBox.height = max(cropBox.minHeight, cropBox.height * autoCropArea);
      cropBox.oldLeft = cropBox.left = canvas.left + (canvas.width - cropBox.width) / 2;
      cropBox.oldTop = cropBox.top = canvas.top + (canvas.height - cropBox.height) / 2;

      this.initialCropBox = $.extend({}, cropBox);
    },

    limitCropBox: function (size, position) {
      var options = this.options,
          strict = options.strict,
          container = this.container,
          containerWidth = container.width,
          containerHeight = container.height,
          canvas = this.canvas,
          cropBox = this.cropBox,
          aspectRatio = options.aspectRatio,
          minCropBoxWidth,
          minCropBoxHeight;

      if (size) {
        minCropBoxWidth = num(options.minCropBoxWidth) || 0;
        minCropBoxHeight = num(options.minCropBoxHeight) || 0;

        // min/maxCropBoxWidth/Height must less than conatiner width/height
        cropBox.minWidth = min(containerWidth, minCropBoxWidth);
        cropBox.minHeight = min(containerHeight, minCropBoxHeight);
        cropBox.maxWidth = min(containerWidth, strict ? canvas.width : containerWidth);
        cropBox.maxHeight = min(containerHeight, strict ? canvas.height : containerHeight);

        if (aspectRatio) {
          // compare crop box size with container first
          if (cropBox.maxHeight * aspectRatio > cropBox.maxWidth) {
            cropBox.minHeight = cropBox.minWidth / aspectRatio;
            cropBox.maxHeight = cropBox.maxWidth / aspectRatio;
          } else {
            cropBox.minWidth = cropBox.minHeight * aspectRatio;
            cropBox.maxWidth = cropBox.maxHeight * aspectRatio;
          }
        }

        // The "minWidth" must be less than "maxWidth", and the "minHeight" too.
        cropBox.minWidth = min(cropBox.maxWidth, cropBox.minWidth);
        cropBox.minHeight = min(cropBox.maxHeight, cropBox.minHeight);
      }

      if (position) {
        if (strict) {
          cropBox.minLeft = max(0, canvas.left);
          cropBox.minTop = max(0, canvas.top);
          cropBox.maxLeft = min(containerWidth, canvas.left + canvas.width) - cropBox.width;
          cropBox.maxTop = min(containerHeight, canvas.top + canvas.height) - cropBox.height;
        } else {
          cropBox.minLeft = 0;
          cropBox.minTop = 0;
          cropBox.maxLeft = containerWidth - cropBox.width;
          cropBox.maxTop = containerHeight - cropBox.height;
        }
      }
    },

    renderCropBox: function () {
      var options = this.options,
          container = this.container,
          containerWidth = container.width,
          containerHeight = container.height,
          cropBox = this.cropBox;

      if (cropBox.width > cropBox.maxWidth || cropBox.width < cropBox.minWidth) {
        cropBox.left = cropBox.oldLeft;
      }

      if (cropBox.height > cropBox.maxHeight || cropBox.height < cropBox.minHeight) {
        cropBox.top = cropBox.oldTop;
      }

      cropBox.width = min(max(cropBox.width, cropBox.minWidth), cropBox.maxWidth);
      cropBox.height = min(max(cropBox.height, cropBox.minHeight), cropBox.maxHeight);

      this.limitCropBox(false, true);

      cropBox.oldLeft = cropBox.left = min(max(cropBox.left, cropBox.minLeft), cropBox.maxLeft);
      cropBox.oldTop = cropBox.top = min(max(cropBox.top, cropBox.minTop), cropBox.maxTop);

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        this.$face.data('drag', (cropBox.width === containerWidth && cropBox.height === containerHeight) ? 'move' : 'all');
      }

      this.$cropBox.css({
        width: cropBox.width,
        height: cropBox.height,
        left: cropBox.left,
        top: cropBox.top
      });

      if (this.cropped && options.strict) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },

    output: function () {
      var options = this.options,
          $this = this.$element;

      this.preview();

      if (options.crop) {
        options.crop.call($this, this.getData());
      }

      $this.trigger(EVENT_CHANGE);
    }
  });

  prototype.initPreview = function () {
    var url = this.url;

    this.$preview = $(this.options.preview);
    this.$viewBox.html('<img src="' + url + '">');

    // Override img element styles
    // Add `display:block` to avoid margin top issue (Occur only when margin-top <= -height)
    this.$preview.each(function () {
      var $this = $(this);

      $this.data(CROPPER_PREVIEW, {
        width: $this.width(),
        height: $this.height(),
        original: $this.html()
      }).html('<img src="' + url + '" style="display:block;width:100%;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation: 0deg!important">');
    });
  };

  prototype.resetPreview = function () {
    this.$preview.each(function () {
      var $this = $(this);

      $this.html($this.data(CROPPER_PREVIEW).original).removeData(CROPPER_PREVIEW);
    });
  };

  prototype.preview = function () {
    var image = this.image,
        canvas = this.canvas,
        cropBox = this.cropBox,
        width = image.width,
        height = image.height,
        left = cropBox.left - canvas.left - image.left,
        top = cropBox.top - canvas.top - image.top,
        rotate = image.rotate;

    if (!this.cropped || this.disabled) {
      return;
    }

    this.$viewBox.find('img').css({
      width: width,
      height: height,
      marginLeft: -left,
      marginTop: -top,
      transform: getRotateValue(rotate)
    });

    this.$preview.each(function () {
      var $this = $(this),
          data = $this.data(CROPPER_PREVIEW),
          ratio = data.width / cropBox.width,
          newWidth = data.width,
          newHeight = cropBox.height * ratio;

      if (newHeight > data.height) {
        ratio = data.height / cropBox.height;
        newWidth = cropBox.width * ratio;
        newHeight = data.height;
      }

      $this.width(newWidth).height(newHeight).find('img').css({
        width: width * ratio,
        height: height * ratio,
        marginLeft: -left * ratio,
        marginTop: -top * ratio,
        transform: getRotateValue(rotate)
      });
    });
  };

  prototype.addListeners = function () {
    var options = this.options,
        $this = this.$element,
        $cropper = this.$cropper;

    if ($.isFunction(options.dragstart)) {
      $this.on(EVENT_DRAG_START, options.dragstart);
    }

    if ($.isFunction(options.dragmove)) {
      $this.on(EVENT_DRAG_MOVE, options.dragmove);
    }

    if ($.isFunction(options.dragend)) {
      $this.on(EVENT_DRAG_END, options.dragend);
    }

    if ($.isFunction(options.zoomin)) {
      $this.on(EVENT_ZOOM_IN, options.zoomin);
    }

    if ($.isFunction(options.zoomout)) {
      $this.on(EVENT_ZOOM_OUT, options.zoomout);
    }

    if ($.isFunction(options.change)) {
      $this.on(EVENT_CHANGE, options.change);
    }

    $cropper.on(EVENT_MOUSE_DOWN, $.proxy(this.dragstart, this));

    if (options.zoomable && options.mouseWheelZoom) {
      $cropper.on(EVENT_WHEEL, $.proxy(this.wheel, this));
    }

    if (options.doubleClickToggle) {
      $cropper.on(EVENT_DBLCLICK, $.proxy(this.dblclick, this));
    }

    $document.on(EVENT_MOUSE_MOVE, (this._dragmove = proxy(this.dragmove, this))).on(EVENT_MOUSE_UP, (this._dragend = proxy(this.dragend, this)));

    if (options.responsive) {
      $window.on(EVENT_RESIZE, (this._resize = proxy(this.resize, this)));
    }
  };

  prototype.removeListeners = function () {
    var options = this.options,
        $this = this.$element,
        $cropper = this.$cropper;

    if ($.isFunction(options.dragstart)) {
      $this.off(EVENT_DRAG_START, options.dragstart);
    }

    if ($.isFunction(options.dragmove)) {
      $this.off(EVENT_DRAG_MOVE, options.dragmove);
    }

    if ($.isFunction(options.dragend)) {
      $this.off(EVENT_DRAG_END, options.dragend);
    }

    if ($.isFunction(options.zoomin)) {
      $this.off(EVENT_ZOOM_IN, options.zoomin);
    }

    if ($.isFunction(options.zoomout)) {
      $this.off(EVENT_ZOOM_OUT, options.zoomout);
    }

    if ($.isFunction(options.change)) {
      $this.off(EVENT_CHANGE, options.change);
    }

    $cropper.off(EVENT_MOUSE_DOWN, this.dragstart);

    if (options.zoomable && options.mouseWheelZoom) {
      $cropper.off(EVENT_WHEEL, this.wheel);
    }

    if (options.doubleClickToggle) {
      $cropper.off(EVENT_DBLCLICK, this.dblclick);
    }

    $document.off(EVENT_MOUSE_MOVE, this._dragmove).off(EVENT_MOUSE_UP, this._dragend);

    if (options.responsive) {
      $window.off(EVENT_RESIZE, this._resize);
    }
  };

  $.extend(prototype, {
    resize: function () {
      var $container = this.$container,
          container = this.container,
          canvasData,
          cropBoxData,
          ratio;

      if (this.disabled || !container) { // Check "container" for IE8
        return;
      }

      ratio = $container.width() / container.width;

      if (ratio !== 1 || $container.height() !== container.height) {
        canvasData = this.getCanvasData();
        cropBoxData = this.getCropBoxData();

        this.render();
        this.setCanvasData($.each(canvasData, function (i, n) {
          canvasData[i] = n * ratio;
        }));
        this.setCropBoxData($.each(cropBoxData, function (i, n) {
          cropBoxData[i] = n * ratio;
        }));
      }
    },

    dblclick: function () {
      if (this.disabled) {
        return;
      }

      if (this.$dragBox.hasClass(CLASS_CROP)) {
        this.setDragMode('move');
      } else {
        this.setDragMode('crop');
      }
    },

    wheel: function (event) {
      var e = event.originalEvent,
          delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault();

      if (e.deltaY) {
        delta = e.deltaY > 0 ? 1 : -1;
      } else if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;
      } else if (e.detail) {
        delta = e.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * 0.1);
    },

    dragstart: function (event) {
      var options = this.options,
          originalEvent = event.originalEvent,
          touches = originalEvent && originalEvent.touches,
          e = event,
          dragType,
          dragStartEvent,
          touchesLength;

      if (this.disabled) {
        return;
      }

      if (touches) {
        touchesLength = touches.length;

        if (touchesLength > 1) {
          if (options.zoomable && options.touchDragZoom && touchesLength === 2) {
            e = touches[1];
            this.startX2 = e.pageX;
            this.startY2 = e.pageY;
            dragType = 'zoom';
          } else {
            return;
          }
        }

        e = touches[0];
      }

      dragType = dragType || $(e.target).data('drag');

      if (REGEXP_DRAG_TYPES.test(dragType)) {
        event.preventDefault();

        dragStartEvent = $.Event(EVENT_DRAG_START, {
          originalEvent: originalEvent,
          dragType: dragType
        });

        this.$element.trigger(dragStartEvent);

        if (dragStartEvent.isDefaultPrevented()) {
          return;
        }

        this.dragType = dragType;
        this.cropping = false;
        this.startX = e.pageX;
        this.startY = e.pageY;

        if (dragType === 'crop') {
          this.cropping = true;
          this.$dragBox.addClass(CLASS_MODAL);
        }
      }
    },

    dragmove: function (event) {
      var options = this.options,
          originalEvent = event.originalEvent,
          touches = originalEvent && originalEvent.touches,
          e = event,
          dragType = this.dragType,
          dragMoveEvent,
          touchesLength;

      if (this.disabled) {
        return;
      }

      if (touches) {
        touchesLength = touches.length;

        if (touchesLength > 1) {
          if (options.zoomable && options.touchDragZoom && touchesLength === 2) {
            e = touches[1];
            this.endX2 = e.pageX;
            this.endY2 = e.pageY;
          } else {
            return;
          }
        }

        e = touches[0];
      }

      if (dragType) {
        event.preventDefault();

        dragMoveEvent = $.Event(EVENT_DRAG_MOVE, {
          originalEvent: originalEvent,
          dragType: dragType
        });

        this.$element.trigger(dragMoveEvent);

        if (dragMoveEvent.isDefaultPrevented()) {
          return;
        }

        this.endX = e.pageX;
        this.endY = e.pageY;

        this.change(e.shiftKey);
      }
    },

    dragend: function (event) {
      var dragType = this.dragType,
          dragEndEvent;

      if (this.disabled) {
        return;
      }

      if (dragType) {
        event.preventDefault();

        dragEndEvent = $.Event(EVENT_DRAG_END, {
          originalEvent: event.originalEvent,
          dragType: dragType
        });

        this.$element.trigger(dragEndEvent);

        if (dragEndEvent.isDefaultPrevented()) {
          return;
        }

        if (this.cropping) {
          this.cropping = false;
          this.$dragBox.toggleClass(CLASS_MODAL, this.cropped && this.options.modal);
        }

        this.dragType = '';
      }
    }
  });

  $.extend(prototype, {
    crop: function () {
      if (!this.built || this.disabled) {
        return;
      }

      if (!this.cropped) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          this.$dragBox.addClass(CLASS_MODAL);
        }

        this.$cropBox.removeClass(CLASS_HIDDEN);
      }

      this.setCropBoxData(this.initialCropBox);
    },

    reset: function () {
      if (!this.built || this.disabled) {
        return;
      }

      this.image = $.extend({}, this.initialImage);
      this.canvas = $.extend({}, this.initialCanvas);
      this.cropBox = $.extend({}, this.initialCropBox); // required for strict mode

      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },

    clear: function () {
      if (!this.cropped || this.disabled) {
        return;
      }

      $.extend(this.cropBox, {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      });

      this.cropped = false;
      this.renderCropBox();

      this.limitCanvas();
      this.renderCanvas(); // Render canvas after render crop box

      this.$dragBox.removeClass(CLASS_MODAL);
      this.$cropBox.addClass(CLASS_HIDDEN);
    },

    destroy: function () {
      var $this = this.$element;

      if (this.ready) {
        if (this.isImg) {
          $this.attr('src', this.originalUrl);
        }

        this.unbuild();
        $this.removeClass(CLASS_HIDDEN);
      } else if (this.$clone) {
        this.$clone.remove();
      }

      $this.removeData('cropper');
    },

    replace: function (url) {
      if (!this.disabled && url) {
        if (this.isImg) {
          this.$element.attr('src', url);
        }

        this.options.data = null; // Remove previous data
        this.load(url);
      }
    },

    enable: function () {
      if (this.built) {
        this.disabled = false;
        this.$cropper.removeClass(CLASS_DISABLED);
      }
    },

    disable: function () {
      if (this.built) {
        this.disabled = true;
        this.$cropper.addClass(CLASS_DISABLED);
      }
    },

    move: function (offsetX, offsetY) {
      var canvas = this.canvas;

      if (this.built && !this.disabled && this.options.movable && isNumber(offsetX) && isNumber(offsetY)) {
        canvas.left += offsetX;
        canvas.top += offsetY;
        this.renderCanvas(true);
      }
    },

    zoom: function (delta) {
      var canvas = this.canvas,
          zoomEvent,
          width,
          height;

      delta = num(delta);

      if (delta && this.built && !this.disabled && this.options.zoomable) {
        zoomEvent = delta > 0 ? $.Event(EVENT_ZOOM_IN) : $.Event(EVENT_ZOOM_OUT);
        this.$element.trigger(zoomEvent);

        if (zoomEvent.isDefaultPrevented()) {
          return;
        }

        delta = delta <= -1 ? 1 / (1 - delta) : delta <= 1 ? (1 + delta) : delta;
        width = canvas.width * delta;
        height = canvas.height * delta;
        canvas.left -= (width - canvas.width) / 2;
        canvas.top -= (height - canvas.height) / 2;
        canvas.width = width;
        canvas.height = height;
        this.renderCanvas(true);
        this.setDragMode('move');
      }
    },

    rotate: function (degree) {
      var image = this.image;

      degree = num(degree);

      if (degree && this.built && !this.disabled && this.options.rotatable) {
        image.rotate = (image.rotate + degree) % 360;
        this.rotated = true;
        this.renderCanvas(true);
      }
    },

    getData: function (rounded) {
      var cropBox = this.cropBox,
          canvas = this.canvas,
          image = this.image,
          ratio,
          data;

      if (this.built && this.cropped) {
        data = {
          x: cropBox.left - canvas.left,
          y: cropBox.top - canvas.top,
          width: cropBox.width,
          height: cropBox.height
        };

        ratio = image.width / image.naturalWidth;

        $.each(data, function (i, n) {
          n = n / ratio;
          data[i] = rounded ? Math.round(n) : n;
        });

      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      data.rotate = this.ready ? image.rotate : 0;

      return data;
    },

    setData: function (data) {
      var image = this.image,
          canvas = this.canvas,
          cropBoxData = {},
          ratio;

      if (this.built && !this.disabled && $.isPlainObject(data)) {
        if (isNumber(data.rotate) && data.rotate !== image.rotate && this.options.rotatable) {
          image.rotate = data.rotate;
          this.rotated = true;
          this.renderCanvas(true);
        }

        ratio = image.width / image.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvas.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvas.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }
    },

    getContainerData: function () {
      return this.built ? this.container : {};
    },

    getImageData: function () {
      return this.ready ? this.image : {};
    },

    getCanvasData: function () {
      var canvas = this.canvas,
          data;

      if (this.built) {
        data = {
          left: canvas.left,
          top: canvas.top,
          width: canvas.width,
          height: canvas.height
        };
      }

      return data || {};
    },

    setCanvasData: function (data) {
      var canvas = this.canvas,
          aspectRatio = canvas.aspectRatio;

      if (this.built && !this.disabled && $.isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvas.left = data.left;
        }

        if (isNumber(data.top)) {
          canvas.top = data.top;
        }

        if (isNumber(data.width)) {
          canvas.width = data.width;
          canvas.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvas.height = data.height;
          canvas.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }
    },

    getCropBoxData: function () {
      var cropBox = this.cropBox,
          data;

      if (this.built && this.cropped) {
        data = {
          left: cropBox.left,
          top: cropBox.top,
          width: cropBox.width,
          height: cropBox.height
        };
      }

      return data || {};
    },

    setCropBoxData: function (data) {
      var cropBox = this.cropBox,
          aspectRatio = this.options.aspectRatio;

      if (this.built && this.cropped && !this.disabled && $.isPlainObject(data)) {

        if (isNumber(data.left)) {
          cropBox.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBox.top = data.top;
        }

        if (isNumber(data.width)) {
          cropBox.width = data.width;
        }

        if (isNumber(data.height)) {
          cropBox.height = data.height;
        }

        if (aspectRatio) {
          if (isNumber(data.width)) {
            cropBox.height = cropBox.width / aspectRatio;
          } else if (isNumber(data.height)) {
            cropBox.width = cropBox.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }
    },

    getCroppedCanvas: function (options) {
      var originalWidth,
          originalHeight,
          canvasWidth,
          canvasHeight,
          scaledWidth,
          scaledHeight,
          scaledRatio,
          aspectRatio,
          canvas,
          context,
          data;

      if (!this.built || !this.cropped || !SUPPORT_CANVAS) {
        return;
      }

      if (!$.isPlainObject(options)) {
        options = {};
      }

      data = this.getData();
      originalWidth = data.width;
      originalHeight = data.height;
      aspectRatio = originalWidth / originalHeight;

      if ($.isPlainObject(options)) {
        scaledWidth = options.width;
        scaledHeight = options.height;

        if (scaledWidth) {
          scaledHeight = scaledWidth / aspectRatio;
          scaledRatio = scaledWidth / originalWidth;
        } else if (scaledHeight) {
          scaledWidth = scaledHeight * aspectRatio;
          scaledRatio = scaledHeight / originalHeight;
        }
      }

      canvasWidth = scaledWidth || originalWidth;
      canvasHeight = scaledHeight || originalHeight;

      canvas = $('<canvas>')[0];
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      context = canvas.getContext('2d');

      if (options.fillColor) {
        context.fillStyle = options.fillColor;
        context.fillRect(0, 0, canvasWidth, canvasHeight);
      }

      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
      context.drawImage.apply(context, (function () {
        var source = getSourceCanvas(this.$clone[0], this.image),
            sourceWidth = source.width,
            sourceHeight = source.height,
            args = [source],
            srcX = data.x, // source canvas
            srcY = data.y,
            srcWidth,
            srcHeight,
            dstX, // destination canvas
            dstY,
            dstWidth,
            dstHeight;

        if (srcX <= -originalWidth || srcX > sourceWidth) {
          srcX = srcWidth = dstX = dstWidth = 0;
        } else if (srcX <= 0) {
          dstX = -srcX;
          srcX = 0;
          srcWidth = dstWidth = min(sourceWidth, originalWidth + srcX);
        } else if (srcX <= sourceWidth) {
          dstX = 0;
          srcWidth = dstWidth = min(originalWidth, sourceWidth - srcX);
        }

        if (srcWidth <= 0 || srcY <= -originalHeight || srcY > sourceHeight) {
          srcY = srcHeight = dstY = dstHeight = 0;
        } else if (srcY <= 0) {
          dstY = -srcY;
          srcY = 0;
          srcHeight = dstHeight = min(sourceHeight, originalHeight + srcY);
        } else if (srcY <= sourceHeight) {
          dstY = 0;
          srcHeight = dstHeight = min(originalHeight, sourceHeight - srcY);
        }

        args.push(srcX, srcY, srcWidth, srcHeight);

        // Scale destination sizes
        if (scaledRatio) {
          dstX *= scaledRatio;
          dstY *= scaledRatio;
          dstWidth *= scaledRatio;
          dstHeight *= scaledRatio;
        }

        // Avoid "IndexSizeError" in IE and Firefox
        if (dstWidth > 0 && dstHeight > 0) {
          args.push(dstX, dstY, dstWidth, dstHeight);
        }

        return args;
      }).call(this));

      return canvas;
    },

    setAspectRatio: function (aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        options.aspectRatio = num(aspectRatio) || NaN; // 0 -> NaN

        if (this.built) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }
    },

    setDragMode: function (mode) {
      var options = this.options,
          croppable,
          movable;

      if (this.ready && !this.disabled) {
        croppable = options.dragCrop && mode === 'crop';
        movable = options.movable && mode === 'move';
        mode = (croppable || movable) ? mode : 'none';

        this.$dragBox.data('drag', mode).toggleClass(CLASS_CROP, croppable).toggleClass(CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable(#300)
          this.$face.data('drag', mode).toggleClass(CLASS_CROP, croppable).toggleClass(CLASS_MOVE, movable);
        }
      }
    }
  });

  prototype.change = function (shiftKey) {
    var dragType = this.dragType,
        options = this.options,
        canvas = this.canvas,
        container = this.container,
        cropBox = this.cropBox,
        width = cropBox.width,
        height = cropBox.height,
        left = cropBox.left,
        top = cropBox.top,
        right = left + width,
        bottom = top + height,
        minLeft = 0,
        minTop = 0,
        maxWidth = container.width,
        maxHeight = container.height,
        renderable = true,
        aspectRatio = options.aspectRatio,
        range = {
          x: this.endX - this.startX,
          y: this.endY - this.startY
        },
        offset;

    // Locking aspect ratio in "free mode" by holding shift key (#259)
    if (!aspectRatio && shiftKey) {
      aspectRatio = width && height ? width / height : 1;
    }

    if (options.strict) {
      minLeft = cropBox.minLeft;
      minTop = cropBox.minTop;
      maxWidth = minLeft + min(container.width, canvas.width);
      maxHeight = minTop + min(container.height, canvas.height);
    }

    if (aspectRatio) {
      range.X = range.y * aspectRatio;
      range.Y = range.x / aspectRatio;
    }

    switch (dragType) {
      // Move cropBox
      case 'all':
        left += range.x;
        top += range.y;
        break;

      // Resize cropBox
      case 'e':
        if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }

        width += range.x;

        if (aspectRatio) {
          height = width / aspectRatio;
          top -= range.Y / 2;
        }

        if (width < 0) {
          dragType = 'w';
          width = 0;
        }

        break;

      case 'n':
        if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }

        height -= range.y;
        top += range.y;

        if (aspectRatio) {
          width = height * aspectRatio;
          left += range.X / 2;
        }

        if (height < 0) {
          dragType = 's';
          height = 0;
        }

        break;

      case 'w':
        if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }

        width -= range.x;
        left += range.x;

        if (aspectRatio) {
          height = width / aspectRatio;
          top += range.Y / 2;
        }

        if (width < 0) {
          dragType = 'e';
          width = 0;
        }

        break;

      case 's':
        if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }

        height += range.y;

        if (aspectRatio) {
          width = height * aspectRatio;
          left -= range.X / 2;
        }

        if (height < 0) {
          dragType = 'n';
          height = 0;
        }

        break;

      case 'ne':
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = false;
            break;
          }

          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
        } else {
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width += range.x;
          }

          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }

        if (width < 0 && height < 0) {
          dragType = 'sw';
          height = 0;
          width = 0;
        } else if (width < 0) {
          dragType = 'nw';
          width = 0;
        } else if (height < 0) {
          dragType = 'se';
          height = 0;
        }

        break;

      case 'nw':
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = false;
            break;
          }

          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
          left += range.X;
        } else {
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }

          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }

        if (width < 0 && height < 0) {
          dragType = 'se';
          height = 0;
          width = 0;
        } else if (width < 0) {
          dragType = 'ne';
          width = 0;
        } else if (height < 0) {
          dragType = 'sw';
          height = 0;
        }

        break;

      case 'sw':
        if (aspectRatio) {
          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = false;
            break;
          }

          width -= range.x;
          left += range.x;
          height = width / aspectRatio;
        } else {
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }

          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }

        if (width < 0 && height < 0) {
          dragType = 'ne';
          height = 0;
          width = 0;
        } else if (width < 0) {
          dragType = 'se';
          width = 0;
        } else if (height < 0) {
          dragType = 'nw';
          height = 0;
        }

        break;

      case 'se':
        if (aspectRatio) {
          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = false;
            break;
          }

          width += range.x;
          height = width / aspectRatio;
        } else {
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width += range.x;
          }

          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }

        if (width < 0 && height < 0) {
          dragType = 'nw';
          height = 0;
          width = 0;
        } else if (width < 0) {
          dragType = 'sw';
          width = 0;
        } else if (height < 0) {
          dragType = 'ne';
          height = 0;
        }

        break;

      // Move image
      case 'move':
        canvas.left += range.x;
        canvas.top += range.y;
        this.renderCanvas(true);
        renderable = false;
        break;

      // Scale image
      case 'zoom':
        this.zoom(function (x1, y1, x2, y2) {
          var z1 = sqrt(x1 * x1 + y1 * y1),
              z2 = sqrt(x2 * x2 + y2 * y2);

          return (z2 - z1) / z1;
        }(
          abs(this.startX - this.startX2),
          abs(this.startY - this.startY2),
          abs(this.endX - this.endX2),
          abs(this.endY - this.endY2)
        ));

        this.startX2 = this.endX2;
        this.startY2 = this.endY2;
        renderable = false;
        break;

      // Crop image
      case 'crop':
        if (range.x && range.y) {
          offset = this.$cropper.offset();
          left = this.startX - offset.left;
          top = this.startY - offset.top;
          width = cropBox.minWidth;
          height = cropBox.minHeight;

          if (range.x > 0) {
            if (range.y > 0) {
              dragType = 'se';
            } else {
              dragType = 'ne';
              top -= height;
            }
          } else {
            if (range.y > 0) {
              dragType = 'sw';
              left -= width;
            } else {
              dragType = 'nw';
              left -= width;
              top -= height;
            }
          }

          // Show the cropBox if is hidden
          if (!this.cropped) {
            this.cropped = true;
            this.$cropBox.removeClass(CLASS_HIDDEN);
          }
        }

        break;

      // No default
    }

    if (renderable) {
      cropBox.width = width;
      cropBox.height = height;
      cropBox.left = left;
      cropBox.top = top;
      this.dragType = dragType;

      this.renderCropBox();
    }

    // Override
    this.startX = this.endX;
    this.startY = this.endY;
  };

  $.extend(Cropper.prototype, prototype);

  Cropper.DEFAULTS = {
    // Defines the aspect ratio of the crop box
    // Type: Number
    aspectRatio: NaN,

    // Defines the percentage of automatic cropping area when initializes
    // Type: Number (Must large than 0 and less than 1)
    autoCropArea: 0.8, // 80%

    // Outputs the cropping results.
    // Type: Function
    crop: null,

    // Previous/latest crop data
    // Type: Object
    data: null,

    // Add extra containers for previewing
    // Type: String (jQuery selector)
    preview: '',

    // Toggles
    strict: true, // strict mode, the image cannot zoom out less than the container
    responsive: true, // Rebuild when resize the window
    checkImageOrigin: true, // Check if the target image is cross origin

    modal: true, // Show the black modal
    guides: true, // Show the dashed lines for guiding
    center: true, // Show the center indicator for guiding
    highlight: true, // Show the white modal to highlight the crop box
    background: true, // Show the grid background

    autoCrop: true, // Enable to crop the image automatically when initialize
    dragCrop: true, // Enable to create new crop box by dragging over the image
    movable: true, // Enable to move the image
    rotatable: true, // Enable to rotate the image
    zoomable: true, // Enable to zoom the image
    touchDragZoom: true, // Enable to zoom the image by wheeling mouse
    mouseWheelZoom: true, // Enable to zoom the image by dragging touch
    cropBoxMovable: true, // Enable to move the crop box
    cropBoxResizable: true, // Enable to resize the crop box
    doubleClickToggle: true, // Toggle drag mode between "crop" and "move" when double click on the cropper

    // Dimensions
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: 200,
    minContainerHeight: 100,

    // Events
    build: null, // Function
    built: null, // Function
    dragstart: null, // Function
    dragmove: null, // Function
    dragend: null, // Function
    zoomin: null, // Function
    zoomout: null, // Function
    change: null // Function
  };

  Cropper.setDefaults = function (options) {
    $.extend(Cropper.DEFAULTS, options);
  };

  // Use the string compressor: Strmin (https://github.com/fengyuanchen/strmin)
  Cropper.TEMPLATE = (function (source, words) {
    words = words.split(',');
    return source.replace(/\d+/g, function (i) {
      return words[i];
    });
  })('<0 6="5-container"><0 6="5-canvas"></0><0 6="5-2-9"></0><0 6="5-crop-9"><1 6="5-view-9"></1><1 6="5-8 8-h"></1><1 6="5-8 8-v"></1><1 6="5-center"></1><1 6="5-face"></1><1 6="5-7 7-e" 3-2="e"></1><1 6="5-7 7-n" 3-2="n"></1><1 6="5-7 7-w" 3-2="w"></1><1 6="5-7 7-s" 3-2="s"></1><1 6="5-4 4-e" 3-2="e"></1><1 6="5-4 4-n" 3-2="n"></1><1 6="5-4 4-w" 3-2="w"></1><1 6="5-4 4-s" 3-2="s"></1><1 6="5-4 4-ne" 3-2="ne"></1><1 6="5-4 4-nw" 3-2="nw"></1><1 6="5-4 4-sw" 3-2="sw"></1><1 6="5-4 4-se" 3-2="se"></1></0></0>', 'div,span,drag,data,point,cropper,class,line,dashed,box');

  /* Template source:
  <div class="cropper-container">
    <div class="cropper-canvas"></div>
    <div class="cropper-drag-box"></div>
    <div class="cropper-crop-box">
      <span class="cropper-view-box"></span>
      <span class="cropper-dashed dashed-h"></span>
      <span class="cropper-dashed dashed-v"></span>
      <span class="cropper-center"></span>
      <span class="cropper-face"></span>
      <span class="cropper-line line-e" data-drag="e"></span>
      <span class="cropper-line line-n" data-drag="n"></span>
      <span class="cropper-line line-w" data-drag="w"></span>
      <span class="cropper-line line-s" data-drag="s"></span>
      <span class="cropper-point point-e" data-drag="e"></span>
      <span class="cropper-point point-n" data-drag="n"></span>
      <span class="cropper-point point-w" data-drag="w"></span>
      <span class="cropper-point point-s" data-drag="s"></span>
      <span class="cropper-point point-ne" data-drag="ne"></span>
      <span class="cropper-point point-nw" data-drag="nw"></span>
      <span class="cropper-point point-sw" data-drag="sw"></span>
      <span class="cropper-point point-se" data-drag="se"></span>
    </div>
  </div>
  */

  // Save the other cropper
  Cropper.other = $.fn.cropper;

  // Register as jQuery plugin
  $.fn.cropper = function (options) {
    var args = toArray(arguments, 1),
        result;

    this.each(function () {
      var $this = $(this),
          data = $this.data('cropper'),
          fn;

      if (!data) {
        if (/destroy/.test(options)) {
          return;
        }

        $this.data('cropper', (data = new Cropper(this, options)));
      }

      if (typeof options === 'string' && $.isFunction((fn = data[options]))) {
        result = fn.apply(data, args);
      }
    });

    return isUndefined(result) ? this : result;
  };

  $.fn.cropper.Constructor = Cropper;
  $.fn.cropper.setDefaults = Cropper.setDefaults;

  // No conflict
  $.fn.cropper.noConflict = function () {
    $.fn.cropper = Cropper.other;
    return this;
  };

});

(function (angular) {
    angular.module('babycompy.menu').directive('popularArticles',
        ['contentCategoriesResource', function (contentCategoriesResource) {
            var limit = 4;

            return {
                restrict: 'E',
                templateUrl: 'app/main/popularArticles/popularArticles.html',
                replace: true,

                link: function ($scope) {
                    contentCategoriesResource.popular(limit).then(function(response){
                        $scope.items = response.content.items;
                    })
                }
            }
        }]
    );

})(angular);
(function (angular) {
    angular.module('babycompy.menu')
        .directive('mainMenu', ['contentCategoriesService',
            function (contentCategoriesServece) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attr) {
                        scope.links = [];
                        contentCategoriesServece.getCategories().then(function (categories) {
                            scope.links = contentCategoriesServece.getLinks();
                        }.bind(this));

                        scope.getMenuByLinkType = function (type) {
                            var result = scope.links.filter(function (item) {
                                return item.linkType === type;
                            })[0];
                            return result ? result.url : null;
                        }
                    }
                }
            }]);
})(angular);
(function () {
  angular.module('babycompy.menu')
    .directive('footerRowDirective', ['contentCategoriesService', 'currentUserService', 'applicationLifecycle', '$filter',
      function (contentCategoriesServece, currentUserService, applicationLifecycle, $filter) {
        function onLink(scope) {
          return currentUserService.load().then(function (user) {
            scope.user = user;
          });
        }

        return {
          restrict: 'E',
          replace: true,
          templateUrl: 'app/main/html/footerRow.template.html',

          link: function (scope, element, attr) {
            if (navigator.userAgent.search("Firefox") > -1) {
              var html = angular.element('.footer-social').html();
              angular.element('.footer-social').empty();
              angular.element('.footer-social').append(html);
            }

            applicationLifecycle.onLoggedIn(function () {
              onLink(scope);
            });

            applicationLifecycle.onBeforeLogout(function () {
              scope.user = null;
            });

            contentCategoriesServece.getCategories().then(function (categories) {
              var cat = angular.copy(categories);

              var services = {
                name: $filter("translate")('footer.services'),
                links: [
                  {href: 'index.doctorSearch', name: $filter('translate')('menu.doctors')},
                  {href: 'index.clinics', name: $filter('translate')('menu.clinics')},
                  {href: 'index.medicine', name: $filter('translate')('menu.medication')},
                  {href: 'index.medics', name: $filter('translate')('headerNavBar.doctorsAnswer')}
                ]
              };
              cat.splice(4, 1);
              cat.push(services);
              scope.sectionCategories = cat;
            }.bind(this));

            onLink(scope);

            scope.multiplePanels = {
              activePanels: []
            };

            scope.isSelected = function ($index) {
              return scope.multiplePanels.activePanels.indexOf($index) > -1;
            };
          }
        }
      }]);
})();

(function () {
    angular.module('babycompy.base')
        .factory('userProfileResource', ['baseApiService', 'resources',
            function (baseApiService, resources) {

                var userProfileResource = baseApiService.extend({

                    _setupCustomActions: function () {
                        return {
                            'getUserProfile': {
                                method: 'GET',
                                isObject: true,
                                params: {
                                    action: 'profile'
                                }
                            }
                        };
                    },

                    getUserProfile: function () {
                        return this.resource.getUserProfile().$promise;
                    }
                });

                return new userProfileResource(resources.users);
            }]);
})();

angular.module('babycompy.userProfile')
  .directive('userProfile', ['authTokenService', 'currentUserService', 'applicationLifecycle', 'favoritesService', 'groupResource', 'algorithmSavesService',
    'medicAnswersService', 'modalService', '$translate', '$state',
    function (authTokenService, currentUserService, applicationLifecycle,
              favoritesService, groupResource, algorithmSavesService, medicAnswersService, modalService, $translate, $state) {

      function onLink(scope) {
        return currentUserService.load().then(function (user) {
          scope.user = user;

          if (user) {
            scope.username = String.format("{0} {1}",
              user.firstName,
              user.lastName || '');

            var avatar = user.avatar || user.photo;

            scope.avatar = avatar;

            if (avatar && typeof avatar == 'string') {
              if (avatar.indexOf("http") >= 0) {
                scope.avatarPath = avatar;
              } else {
                scope.avatarPath = "/api/v1/files/" + avatar;
              }
            } else {
              scope.avatarPath = "/assets/images/user-no-photo.png";
            }

            favoritesService.load().then(function (response) {
              scope.favoritesCount = response.content.total;
              return scope.favoritesCount;
            });

            if (!user.doctor) {
              medicAnswersService.load().then(function () {
                scope.answers = medicAnswersService.getUnreadVisible();
              });

              groupResource.getSavedAlgorithms().then(function (response) {
                scope.algorithmsCount = response.content.total;
                scope.algorithms = response.content.items;
              });
            }

          }
        });
      }

      return {
        restrict: 'E',
        replace: true,
        scope: true,
        templateUrl: 'app/components/userProfileBadge/userProfileBadge.html',
        link: function (scope) {
          scope.search = function () {
            if (scope.searchText) {
              $state.go('index.search', {
                'query': scope.searchText
              });
              scope.searchText = '';
            }
          };

          scope.$on('userUpdated', function (e, user) {
            scope.user = user;
          });
          scope.checkAvatar = function () {
            if (scope.avatarPath) {
              if (scope.avatarPath.indexOf("http") >= 0) {
                return true;
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
          scope.askDoctor = function () {
            if (!currentUserService.get()) {
              modalService.showLoginModal().result.then(function () {
                modalService.showQuestionModal(scope);
              }.bind(scope));
            } else {
              modalService.showQuestionModal(scope);
            }
          },

            scope.hideSignInButton = function () {
              var result = !$state.is('index.login');
              return result;
            };

          scope.hideRegisterButton = function () {
            var result = !$state.is('index.signUp.user') && !$state.is('index.signUp.doctor');
            return result;
          };

          scope.hideAnswer = function (answer, $event) {
            medicAnswersService.hideAnswer(answer);
            scope.answers = medicAnswersService.getUnreadVisible();
            $event.stopPropagation();
          };

          scope.readAnswer = function (answer) {
            medicAnswersService.markAsRead(answer);
            scope.answers = medicAnswersService.getUnreadVisible();
            $state.go('index.medics.answers.article', {
              'articleUUID': answer.uuid,
              'rubricUUID': answer.rubricUuid
            });
          };

          applicationLifecycle.onLoggedIn(function () {
            onLink(scope);
          });

          currentUserService.eventTarget.addListener('onChangeAvatar', function () {
            var user = currentUserService.get();
            var avatar = user.avatar || user.photo;

            if (avatar && typeof avatar == 'string') {
              if (avatar.indexOf("http") >= 0) {
                scope.avatarPath = avatar;
              } else {
                scope.avatarPath = "/api/v1/files/" + avatar;
              }
            } else {
              scope.avatarPath = "/assets/images/user-no-photo.png";
            }
          });

          favoritesService.eventTarget.addListener('onAddFavorite', function () {
            ++scope.favoritesCount;
          });

          favoritesService.eventTarget.addListener('onDeleteFavorite', function () {
            --scope.favoritesCount;
          });

          algorithmSavesService.eventTarget.addListener('onStartAlgorithm', function () {
            groupResource.getSavedAlgorithms().then(function (response) {
              scope.algorithmsCount = response.content && response.content.total;
              scope.algorithms = response.content && response.content.items;
            });
          });

          algorithmSavesService.eventTarget.addListener('onFinishAlgorithm', function () {
            groupResource.getSavedAlgorithms().then(function (response) {
              scope.algorithmsCount = response.content.total;
              scope.algorithms = response.content.items;
            });
          });

          applicationLifecycle.onBeforeLogout(function () {
            scope.algorithms = null;
            scope.algorithmsCount = 0;
            scope.user = null;
            scope.answers = null;
            scope.avatarPath = "/assets/images/user-no-photo.png";
          });

          onLink(scope);
        },

        controller: ['$scope', 'authService', function ($scope, authService) {
          $scope.logOut = function () {
            $state.go('index');
            return authService.logOut();
          }
        }]
      }
    }
  ]);

;(function () {
    'use strict';

    angular.module('babycompy.seo', []);

})();

(function () {
    angular.module('babycompy.seo')
        .factory('seoService', ['$q', '$location', '$translate', 'openGraph', 'facebook',
            function ($q, $location, $translate, appConstants, fbConstants) {

                function SeoService() {
                    $q.all([
                        $translate('seo.defaultTitle'),
                        $translate('seo.defaultDescription'),
                        $translate('seo.defaultKeywords'),
                    ]).then(function (translations) {
                        this._defaultTitle = translations[0];
                        this._defaultDescription = translations[1];
                        this._defaultKeywords = translations[2];
                        this._defaultImage = appConstants.defaultImage;
                        this._fbAppId = fbConstants.appId;
                    }.bind(this));

                };


                SeoService.prototype.title = function (articleHeader, sectionName, articleMetaTags) {
                    if (arguments.length === 0) {
                        return this._title || this._defaultTitle;
                    } else if(!!articleMetaTags && !!articleMetaTags.title) {
                        this._title = articleMetaTags.title;
                        this._ogTitle = articleMetaTags.title;
                    } else if (sectionName === undefined || articleHeader === sectionName) {
                        this._title = String.format("{0} | {1}",
                            articleHeader,
                            this._defaultTitle);
                        this._ogTitle = articleHeader;
                    } else {
                        this._title = String.format("{0} | {1} | {2}",
                            sectionName,
                            articleHeader,
                            this._defaultTitle);
                        this._ogTitle = sectionName;
                    }
                };

                SeoService.prototype.description = function (articleHeader, articleMetaTags) {
                    if (arguments.length === 0) {
                        return this._description || this._defaultDescription;
                    } else if (!!articleMetaTags && !!articleMetaTags.description) {
                        this._description = articleMetaTags.description;
                        this._ogDescription = articleMetaTags.description;
                    } else {
                        this._description = String.format("{0} | {1}",
                            articleHeader,
                            this._defaultDescription);
                        this._ogDescription = this._description || this._defaultDescription;
                    }

                };


                SeoService.prototype.keywords = function (articleMetaTags) {
                    if (arguments.length === 0) {
                        return this._keywords || this._defaultKeywords;
                    } else if (!!articleMetaTags && !!articleMetaTags.keywords) {
                        this._keywords = articleMetaTags.keywords;
                    } else {
                        this._keywords = this._defaultKeywords;
                    }
                };

                SeoService.prototype.ogTitle = function () {
                    if (arguments.length === 0){
                        return this._ogTitle || this._defaultTitle;
                    }
                };

                SeoService.prototype.ogDescription = function (metaDescription) {
                    if (arguments.length === 0){
                        return this._ogDescription || this._defaultDescription;
                    } else {
                        this._ogDescription = metaDescription;
                    }
                };

                SeoService.prototype.ogImage = function (metaImage) {
                    if (arguments.length === 0){
                        return this._ogImage || this._defaultImage;
                    } else {
                        this._ogImage = metaImage;
                    }
                };

                SeoService.prototype.ogFbAppId = function () {
                    return this._fbAppId;
                };

                return new SeoService();
            }]);
})();

(function () {
    angular.module('babycompy.selectLocation')
        .factory('locationResource', ['baseApiService', 'resources', 'ApiUrl',
            function (baseApiService, resources, ApiUrl) {

                var locationResource = baseApiService.extend({
                    _setupCustomActions: function () {
                        var o = this._super();
                        o.getCountries = {
                            method: 'GET',
                            params: {
                                controller: 'countries'
                            }
                        },

                            o.getRegions = {
                                method: 'GET',
                                params: {
                                    controller: 'countries',
                                    action: 'regions'
                                }
                            };

                        o.getCities = {
                            method: 'GET',
                            params: {
                                controller: 'regions',
                                action: 'cities'
                            }
                        };

                        o.getCitiesInCountry = {
                            method: 'GET',
                            params: {
                                controller: 'countries',
                                action: 'cities'
                            }
                        };

                        return o;
                    },

                    getCountries: function (fullContent) {
                        return this.resource.getCountries({full: fullContent}).$promise;
                    },

                    getRegions: function (idCountry, fullContent) {
                        var requestObj = {
                            id: idCountry,
                            full: fullContent
                        }
                        return this.resource.getRegions(requestObj).$promise;
                    },

                    getCities: function (idRegion, fullContent) {
                        var requestObj = {
                            id: idRegion,
                            full: fullContent
                        }
                        return this.resource.getCities(requestObj).$promise;
                    },

                    getCitiesInCountry: function (idCountry, cityName) {
                        return this.resource.getCitiesInCountry({ id: idCountry, query: cityName }).$promise;
                    }
                })
                return new locationResource(resources.locations);
            }])
})();
angular.module('babycompy.selectLocation')
    .directive('locationSelect', ['locationResource', '$rootScope',
        function (locationResource, $rootScope) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    selectedCountry: '=country',
                    selectedRegion: '=?region',
                    selectedCity: '=city',
                    withoutRegionMode: '=?',
                    countryPlaceholder: '=?',
                    regionPlaceholder: '=?',
                    cityPlaceholder: '=?',
                    countryLabel: '=?',
                    regionLabel: '=?',
                    cityLabel: '=?',
                    isRequired: '=?',
                    parentForm: '=?',
                    inlineView: '=?',
                    fullContent: '@'
                },
                templateUrl: 'app/components/selectLocation/selectLocation.html',
                link: function (scope, element, attr) {




                    scope.$watch('selectedCountry', function (newVal, oldVal) {
                        if (!newVal) {
                            scope.selectedRegion = null;
                            scope.selectedCity = null;
                            if ($rootScope.searchFormParameters) {
                                $rootScope.searchFormParameters.country = null;
                                $rootScope.searchFormParameters.region = null;
                                $rootScope.searchFormParameters.city = null;
                            }
                            angular.element('#search-user-country').addClass('empty');
                            return;
                        } else {
                            angular.element('#search-user-country').removeClass('empty');
                        }
                        if (!scope.withoutRegionMode) {
                            scope._getRegions(newVal.uuid, scope.fullContent);
                        } else {
                            scope.selectedCity = null;
                            scope._getCitiesInCountry(newVal.uuid);
                        }
                        if ($rootScope.searchFormParameters) {
                            $rootScope.searchFormParameters.country = newVal;
                            $rootScope.searchFormParameters.region = null;
                            $rootScope.searchFormParameters.city = null;
                        }
                    });
                    scope.$watch('selectedRegion', function (newVal, oldVal) {
                        if (scope.withoutRegionMode) {
                            return;
                        }
                        if (!newVal) {
                            scope.selectedCity = null;
                            angular.element('#search-user-region').addClass('empty');
                            return;
                        } else {
                            angular.element('#search-user-region').removeClass('empty');
                        }
                        scope._getCities(newVal.uuid, scope.fullContent);
                        if ($rootScope.searchFormParameters) {
                            $rootScope.searchFormParameters.region = newVal;
                            $rootScope.searchFormParameters.city = null;
                        }
                    });

                    scope.$watch('selectedCity', function (newVal, oldVal) {
                        if (!newVal) {
                            scope.selectedCity = null;
                            angular.element('#search-user-city').addClass('empty');
                            return;
                        } else {
                            angular.element('#search-user-city').removeClass('empty');
                        }
                        if ($rootScope.searchFormParameters) {
                            $rootScope.searchFormParameters.city = newVal;
                        }
                    });

                },
                controller: ['$scope', 'locationResource', function ($scope, locationResource) {

                    (function () {
                        locationResource.getCountries($scope.fullContent)
                            .then(function (response) {
                                $scope.countries = response.content.items;
                            }.bind(this));
                    })();

                    $scope._getRegions = function (selectedCountry, fullContent) {
                        locationResource.getRegions(selectedCountry, fullContent)
                            .then(function (response) {
                                $scope.regions = response.content.items;
                            }.bind(this));
                    };

                    $scope._getCities = function (selectedRegion, fullContent) {
                        locationResource.getCities(selectedRegion, fullContent)
                            .then(function (response) {
                                $scope.cities = response.content.items;
                            }.bind(this));
                    };

                    $scope._getCitiesInCountry = function (selectedCountry) {
                        locationResource.getCitiesInCountry(selectedCountry).then(function (response) {
                            $scope.citiesInCountry = response.content.items;
                        }.bind(this))
                    };

                    $scope.setValue = function (item, model) {
                        $scope.selectedCity = item;
                    }

                    $scope.getValue = function () {
                        return $scope.selectedCity;
                    }



                }]
            }
        }]);

(function () {

    angular.module('babycompy.ruler')
        .filter('rulerTooltipAge', ['$translate', function ($translate) {
            return function (dateStr) {
                if (dateStr) {
                    var date = moment(new Date(dateStr)),
                        currDate = moment();

                    var result = null;
                    var monthDiff = currDate.diff(date, 'month');

                    if (monthDiff > 12) {
                        result = {
                            type: 'yearsCount',
                            value: currDate.diff(date, 'years'),
                            key: 'years'
                        }
                    } else if (monthDiff >= 1) {
                        result = {
                            type: 'monthCount',
                            value: monthDiff,
                            key: 'month'
                        }
                    } else {
                        var daysDiff = currDate.diff(date, 'days');
                        //28-days as 1 month
                        if (daysDiff >= 28) {
                            result = {
                                type: 'monthCount',
                                value: 1,
                                key: 'month'
                            };
                        } else {
                            result = {
                                type: 'daysCount',
                                value: currDate.diff(date, 'days'),
                                key: 'days'
                            }
                        }

                    }
                    var params = {};
                    params[result.key] = result.value;

                    return $translate.instant('general.' + result.type, params);
                }
            };
        }]);
})();
angular.module('babycompy.ruler')
    .directive('ruler', [
        '$compile', 'profileChildAgesService',
        'profileChildrenService', '$q', '$popover',
        'currentUserService', 'applicationLifecycle', '$templateCache',
        function($compile,
            profileChildAgesService, profileChildrenService, $q, $popover,
            currentUserService, applicationLifecycle, $templateCache) {

            var templateUrl = 'app/components/ruler/ruler.template.html';

            return {
                restrict: 'E',
                replace: true,
                templateUrl: templateUrl,

                link: function(scope, element, attr) {

                    function clearRuler() {

                        profileChildAgesService.load().then(function(childAges) {
                            element.html($templateCache.get(templateUrl));

                            var els = angular.element(element).find('a');
                            for (var i = 0; i < els.length; i++) {
                                var currEl = els[i],
                                    nextEl = els[i + 1];

                                var elData = getElementData(currEl, nextEl);
                                buildLink(childAges, elData.minAge, elData.maxAge, currEl);
                            }

                            $compile(element.contents())(scope);
                        });
                    };

                    function getElementData(currEl, nextEl) {
                        var result = {
                            minAgeCategory: null,
                            minAgeCategoryType: null,
                            maxAgeCategory: null,
                            maxAgeCategoryType: null,
                            minAge: 0,
                            maxAge: 0
                        }

                        result.minAge = Number(currEl.getAttribute('data-age-min'));
                        result.maxAge = Number(currEl.getAttribute('age-max'));

                        result.maxAgeCategory = currEl.getAttribute('age-max-category');
                        result.maxAgeCategoryType = currEl.getAttribute('age-max-category-type');

                        result.minAgeCategory = currEl.getAttribute('data-age-min-category');
                        result.minAgeCategoryType = currEl.getAttribute('data-age-min-category-type');


                        if (!result.maxAge) {
                            result.maxAge = nextEl ? Number(nextEl.getAttribute('data-age-min')) : Number.MAX_VALUE;
                        }

                        result.minAgeCategoryType = result.minAgeCategoryType || 'hours';
                        result.minAgeCategory = Number(result.minAgeCategory || result.minAge);

                        result.maxAgeCategoryType = result.maxAgeCategoryType || 'hours';
                        result.maxAgeCategory = Number(result.maxAgeCategory || result.maxAge);

                        return result;
                    }

                    function buildRuler(childAges, childrens) {
                        var dtNow = moment(),
                            minAge = 0,
                            maxAge = 0;

                        var els = angular.element(element).find('a');
                        for (var i = 0; i < els.length; i++) {

                            var currEl = els[i],
                                nextEl = els[i + 1];

                            var elData = getElementData(els[i], els[i + 1]);

                            var linkChildrens = childrens.filter(function(child) {
                                var childAgeMin = dtNow.diff(new Date(child.birthDate), elData.minAgeCategoryType);
                                var childAgeMax = dtNow.diff(new Date(child.birthDate), elData.maxAgeCategoryType);


                                return childAgeMin >= elData.minAgeCategory && childAgeMax < elData.maxAgeCategory;
                            });

                            if (linkChildrens.length >= 1) {

                                // add prefix only if avatar exists
                                var imgSrc = linkChildrens.length == 1 ?
                                    (linkChildrens[0].avatar == null ? null : 'api/v1/files/' + linkChildrens[0].avatar) : 'assets/images/child-group-photo.png';
                                imgSrc = imgSrc || 'assets/images/my-children-no-photo.png';

                                var img = angular.element(String.format('<span class="child"><img src="{0}" alt="{1}"></img></span>', imgSrc, linkChildrens[0].firstName));
                                currEl.insertBefore(img[0], currEl.firstChild);
                                var ageSpan = currEl.querySelector('span[data-age]');
                                if (ageSpan) {
                                    ageSpan.innerHTML = linkChildrens.length == 1 ? dtNow.diff(new Date(linkChildrens[0].birthDate), 'years') : '';
                                }

                                var tooltip = $popover(angular.element(currEl), {
                                    trigger: 'hover',
                                    placement: 'bottom',
                                    container: 'body',
                                    html: true,
                                    templateUrl: 'app/components/ruler/ruler.tooltip.html'
                                });
                                tooltip.$scope.children = linkChildrens;
                            } else {
                                angular.element(currEl).find('.child').remove();
                            }

                            buildLink(childAges, elData.minAgeCategory, elData.maxAge, currEl);
                        }
                    }

                    function buildLink(childAges, minAge, maxAge, currEl) {
                        var filteredAges = childAges.filter(function(item) {
                            return item.hours >= minAge && item.hours < maxAge;
                        });

                        var params;
                        if (filteredAges.length > 1) {
                            params = {
                                age: filteredAges[0].uuid,
                                childAges: filteredAges.map(function(item) {
                                    return item.uuid
                                }),
                            };
                        } else {
                            params = {
                                age: filteredAges[0].uuid
                            };
                        }
                        currEl.setAttribute('data-ui-sref', 'index.upgrowth(' + JSON.stringify(params) + ')');
                        currEl.setAttribute('data-ui-sref-opts', '{inherit  : false }');
                        $compile(currEl)(scope);
                    }


                    function updateRuler(withChildrens) {
                        var childAgesPromise = profileChildAgesService.load();
                        var childrenPromise = withChildrens ? profileChildrenService.load() :
                            $q.resolve({ content: { items: [] } });

                        $q.all([childAgesPromise, childrenPromise]).then(function(responses) {
                            buildRuler(responses[0], responses[1].content ? responses[1].content.items : [])
                        });
                    }

                    currentUserService.load().then(function(user) {
                        applicationLifecycle.onLoggedIn(updateRuler.bind(this, user && !user.doctor));
                        applicationLifecycle.onBeforeLogout(clearRuler);
                        updateRuler(user && !user.doctor);

                    });

                }
            }
        }
    ]);

; (function () {
    angular.module('babycompy.pager')
        .directive('pager', ['$location', function ($location) {

            var pageSize = 12;
            var maxButtons = 5; // odd number ( << ) ( 1 ) ( ... ) ( 9 ) ( ... ) ( 40 ) ( >> )

            return {
                restrict: 'E',
                replace: true,
                scope: {
                    total: '=',
                    offset: '=',
                    limit: '=',
                    maxButtons: '@'
                },
                templateUrl: 'app/components/pager/pager.html',

                link: function (scope, element, attr) {
                    scope.$watch('total', function (newValue, oldValue) {
                        scope.pagesTotal = Math.ceil(scope.total / scope.limit);
                        if (scope.currentPage >= scope.pagesTotal && scope.currentPage != 0) {
                            scope.page(scope.pagesTotal - 1);
                        } else {
                            scope.renderButtons();
                        }
                    });

                    scope.$watch('offset', function (newValue, oldValue) {
                        scope.currentPage = scope.offsetToPage(newValue);
                        scope.updateSearchParameters(newValue);
                        scope.renderButtons();
                    });

                    scope.$watch('limit', function (newValue, oldValue) {
                        scope.updateSearchParameters(null ,newValue);
                        scope.renderButtons();
                    });

                    var search = $location.search();
                    var offset = Math.max(search.offset || 0, 0);
                    scope.limit = Math.max(search.limit || pageSize, 1);

                    scope.page(scope.offsetToPage(offset));
                },

                controller: ['$scope', function (scope) {

                    scope.page = function (page) {

                        if (page + 1 > scope.pagesTotal) {
                            return;
                        }

                        if (page < 0) {
                            return;
                        }

                        page = Math.max(page, 0);
                        scope.currentPage = page;
                        scope.offset = scope.limit * scope.currentPage;

                        scope.renderButtons();
                        scope.emitPageChanged();
                    }

                    scope.updateSearchParameters = function(offset, limit) {
                        var search = $location.search();
                        angular.extend(search, {
                            offset: offset || scope.offset,
                            limit: limit || scope.limit
                        });

                        $location.search(search);
                    }

                    scope.emitPageChanged = function () {
                        scope.updateSearchParameters();
                        scope.$emit('pageChanged', { offset: scope.offset, limit: scope.limit });
                    }

                    scope.renderButtons = function () {
                        var windowSize = Math.min(scope.pagesTotal, (+scope.maxButtons) || maxButtons);
                        var windowPosition = Math.min(Math.max(Math.ceil(scope.currentPage - windowSize / 2), 0), scope.pagesTotal - windowSize);

                        var pages = _.range(windowPosition, windowPosition + windowSize).map(function (v, k) {
                            return { ellipsis: false, index: v };
                        });
                        if (windowPosition >= 1) {
                            pages[1].ellipsis = true;
                            pages[0].index = 0;
                        }
                        if (windowPosition + windowSize <= scope.pagesTotal - 1) {
                            pages[pages.length - 2].ellipsis = true;
                            pages[pages.length - 1].index = scope.pagesTotal - 1;
                        }
                        scope.pages = pages;
                    }

                    scope.offsetToPage = function (offset) {
                        return Math.floor(offset / scope.limit)
                    }
                }]
            }
        }])
})();

(function () {
    'use strict';

    angular.module('babycompy.notFound', []);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.notFound')
        .config(['$stateProvider', config]);

    function config($stateProvider) {
        $stateProvider.state('index.notFound', {
            url: 'notFound',
            views: {
                'content': {
                    templateUrl: 'app/components/notFound/notFound.html',
                }
            },
            
            breadcrumb: false
        });
    }
})();
(function () {
    'use strict';

    angular.module('babycompy.mobileApps', []);
})();

(function () {
    'use strict';

    angular
        .module('babycompy.mobileApps')
        .config(['$stateProvider', config]);

    function config($stateProvider) {
        $stateProvider.state('index.mobileApps', {
            url: 'mobileApps',
            views: {
                'content': {
                    templateUrl: 'app/components/mobileApps/mobileApps.html'
                }
            },
            
            breadcrumb: false
        });
    }
})();
angular.module('babycompy.menu')
    .directive('menuHamburger', [function () {
        return {
            restrict: 'A',
            replace: true,

            link: function (scope, element, attr) {
                angular.element('body').bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                        .find(event.target)
                        .length > 0;
                    if (isClickedElementChildOfPopup) {
                        return;
                    }
                    angular.element('.btn-group').removeClass('open');    
                });
                
                var fireFoxIcons = function (element) {
                    var iconLeft = '<svg class="icon angle-left"><use xlink:href="#angle-left"></use></svg>'
                    var iconDown = '<svg class="icon angle-down"><use xlink:href="#angle-down"></use></svg>'
                    angular.element(element).find('.caret-angle-left').empty().append(iconLeft);
                    angular.element(element).find('.caret-angle-down').empty().append(iconDown);

                }
                element.on('click', '.mm-hamburger-block', function (event) {
                    if (angular.element(event.target).is("button")) {
                        event.preventDefault();
                        return;
                    }
                    if (navigator.userAgent.search("Firefox") > -1) {
                        fireFoxIcons(element);
                    }
                    angular.element(element).find('.mm-hamburger').toggleClass('open');
                    angular.element(element).parent().find('.mm-dropdown').toggleClass('open');
                })

                element.on('click', '.mm-dropdown button', function (event) {
                    var parentElement = angular.element(event.currentTarget).parent();
                    var otherInput = angular.element(parentElement).closest('.mm-dropdown').children();
                    var currentLi = angular.element(parentElement).parent();
                    for (var i = 0; i < otherInput.length; i++) {
                        if (angular.element(currentLi).is(angular.element(otherInput[i]))) {
                            continue;
                        }
                        angular.element(otherInput[i]).find('.btn-group').removeClass('open');
                    }
                    angular.element(parentElement).toggleClass('open');
                    if (navigator.userAgent.search("Firefox") > -1) {
                        fireFoxIcons(element);
                    }
                });

                element.on('click', '.mm-dropdown a', function (event) {

                    angular.element(event.currentTarget).closest('.btn-group').toggleClass('open');
                    angular.element(element).find('.mm-hamburger').toggleClass('open');
                    angular.element(element).parent().find('.mm-dropdown').toggleClass('open');
                    if (navigator.userAgent.search("Firefox") > -1) {
                        fireFoxIcons(element);
                    }
                });

            }
        }
    }]);
angular.module('babycompy.menu')
    .directive('topMenu', ['contentCategoriesService', '$state',
        function (contentCategoriesServece, $state) {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/components/menu/menu.template.html',

                link: function (scope, element, attr) {
                    contentCategoriesServece.getCategories().then(function (categories) {
                        scope.menuCategories = categories;
                    }.bind(this));

                    scope.search = function () {
                        if (scope.searchText) {
                            $state.go('index.search', {
                                'query': scope.searchText
                            });
                            scope.searchText = '';
                        }
                    };
                }
            }
        }]);
(function () {
    angular.module('babycompy.medics.answers')
        .service('medicRubricsService', ['$q', 'medicAnswersResource', 'singleRequestService',
            function ($q, medicAnswersResource, singleRequestService) {

                var MedicRubricsService = singleRequestService.extend({

                    getFromResource: function () {
                        return medicAnswersResource.getRubrics.apply(medicAnswersResource, arguments);
                    },

                    _setEntity: function (result) {
                        this.entity = result;
                    },

                    get: function () {
                        return this.entity.content.items;
                    }
                });

                return new MedicRubricsService();
            }]);
})();

(function() {
    angular.module('babycompy.medics')
        .controller('medicsInfoController', ['$scope', 'modalService',
            'rubrics',  'latestAnswers', '$state', '$filter', '$translate', 'baseController',  'user', 'seoService','currentUserService',
            function ($scope, modalService,
                      rubrics, latestAnswers, $state, $filter, $translate, baseController, user, seoService,currentUserService) {

                var MedicsInfoController = baseController.extend({

                    init: function() {
                        this._super.apply(this, arguments);
                        this.rubrics = rubrics;
                        this.latestAnswers = latestAnswers;
                        this.user = user;
                        // this.content = articleContent.description || '';
                        //this.images = articleContent.images;
                        this.doctor = latestAnswers[0].doctor || {};
                        $translate("medic.info.doctorsName", {
                            firstName: this.doctor.firstName,
                            lastName: this.doctor.lastName,
                            patronymic: this.doctor.patronymic
                        }).then(function(translate){
                            this.doctorName = translate;
                        }.bind(this));

                        $translate('medic.info.title').then(function(translations){
                            seoService.title(translations);
                            seoService.description(translations);
                        })
                        currentUserService.load(function (user) {
                          this.user = user;
                        }.bind(this));
                    },

                    askDoctor: function() {
                        if (!currentUserService.get()) {
                            modalService.showLoginModal($scope).result.then(function() {
                              currentUserService.load().then(function (user) {
                                if (user.doctor) {
                                  $scope.$state.go('index.profile.doctor');
                                } else {
                                  modalService.showQuestionModal($scope);
                                }
                              });
                            }.bind(this));
                        } else {
                            modalService.showQuestionModal($scope);
                        }
                    },

                });

                return new MedicsInfoController($scope, null);

            }]);
})();

(function() {
    'use strict';

    angular
        .module('babycompy.medics')
        .config(['$stateProvider', config]);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('index.medics', {
            url: 'medic',
            views: {
                'content@index': {
                    templateUrl: 'app/components/medics/medics.html',
                    controller: 'medicsInfoController',
                    controllerAs: 'c'
                }
            },

            resolve: {
                rubrics: ['medicRubricsService', function(medicRubricsService) {
                    return medicRubricsService.load().then(function(resonse) {
                        return resonse.content.items;
                    });
                }],

                latestAnswers: ['medicAnswersResource', function(medicAnswersResource) {
                    return medicAnswersResource.getLatest({limit:10}).then(function(resonse) {
                        return resonse.content.items;
                    });
                }],

                user: ['currentUserService', function(currentUserService) {
                    return currentUserService.load().then(function(user) {
                        return user;
                    });
                }]
            },

            breadcrumb: "{{'medic.answers.breadcrumb' | translate}}"
        });
    }
})();
(function (angular) {
    angular.module('babycompy.medics')
        .factory('medicAnswersResource', ['baseApiService', 'resources',
            function (baseApiService, resources) {

            var MedicAnswersResource = baseApiService.extend({
                _setupCustomActions: function () {
                    var obj = this._super();

                    var custom =  {
                        'getForCurrentUser': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'user'
                            }
                        },

                        'markAsRead': {
                            method: 'DELETE',
                            isObject: true,
                            params: {
                                action: 'read'
                            }
                        },

                        'hide': {
                            method: 'DELETE',
                            isObject: true,
                            params: {
                                action: 'hide'
                            }
                        },

                        'getRubrics': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                controller: 'rubrics'
                            }
                        },

                        'getLatest': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'latest'
                            }
                        },

                        'getByRubric': {
                            method: 'GET',
                            isObject: true,
                            params: {
                                action: 'rubric',
                            },

                            url: '/:apiPrefix/:apiVersion/:controller/:action/:id'
                        }
                    };

                    angular.extend(obj, custom);
                    return obj;
                },

                getForCurrentUser: function(){
                    return this.resource.getForCurrentUser().$promise;
                },

                markAsRead: function(id){
                    return this.resource.markAsRead({id: id}).$promise;
                },

                hide: function(id){
                    return this.resource.hide({id: id}).$promise;
                },

                getRubrics: function(){
                    return this.resource.getRubrics().$promise;
                },

                getLatest: function(args){
                    return this.resource.getLatest(args).$promise;
                },

                getByRubric: function(dataBounds, params){
                    angular.extend(params, dataBounds);
                    return this.resource.getByRubric(params).$promise;
                }


            });

            return new MedicAnswersResource(resources.answers);
        }]);
})(angular);
angular.module('babycompy.mainSlider')
    .factory('mainSliderResource', ['baseApiService',
    function (baseApiService) {

        var mainSliderResource = baseApiService.extend({

            _setupCustomActions: function () {
                var o = this._super();

                return o;
            }
        });

        return new mainSliderResource('slider');
    }]);

angular.module('babycompy.mainSlider')
  .controller('mainSliderController', ['$scope', 'mainSliderResource', 'baseListController',
    function ($scope, mainSliderResource, baseListController) {

      var mainSliderController = baseListController.extend({
        init: function () {
          this._super.apply(this, arguments);
          this._loadDataInternal();
          this.sliderIndex = 0;
        }
      });

      return new mainSliderController($scope, mainSliderResource);
}]);

(function () {
    'use strict';

    angular.module('babycompy.loadMore', []).constant('loadMoreConstants', {
        direction: {
            top: 'top',
            bottom: 'bottom'
        }
    });
})();
angular.module('babycompy.loadMore')
    .directive('loadMore', ['loadMoreConstants', function (loadMoreConstants) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                total: '=',
                pagingParameters: '=',
                // could be 'top' or 'bottom'
                direction: '@',
                load: '='
            },
            template:
            '<li data-ng-show="isMoreNeeded()"  data-ng-class="{ \'prev-elements\': direction === \'top\', \'next-elements\': direction === \'bottom\'}">\
                <a href="#" data-ng-click="loadMore()" >\
                    {{ "general.loadMore" | translate }}\
                    <svg class="icon" data-ng-class="{ \'angle-up\': direction === \'top\', \'angle-down\': direction === \'bottom\' }">\
                      <use data-ng-show="direction === \'top\'" xlink:href="#angle-up"></use>\
                      <use data-ng-show="direction === \'bottom\'" xlink:href="#angle-down"></use>\
                    </svg>\
                </a>\
            </li>',


            link: function(scope){
                scope.pagingParameters = angular.extend({}, scope.pagingParameters);
                scope.loadMore = function () {
                    if (scope.direction === loadMoreConstants.direction.top) {
                        scope.pagingParameters.offset -= scope.pagingParameters.limit;
                    } else {
                        // bottom is by default
                        scope.pagingParameters.offset += scope.pagingParameters.limit;
                    }
                    scope.load(scope.pagingParameters.offset,
                        scope.direction);
                    
                };

                scope.isMoreNeeded = function () {
                    if (scope.direction === loadMoreConstants.direction.top) {
                        return scope.pagingParameters.offset > 0;
                    } else {
                        // bottom is by default

                        // initial load - total is not set yet
                        if (scope.total === undefined) {
                            return true;
                        }
                        return !(scope.total <= scope.pagingParameters.offset + scope.pagingParameters.limit);
                    }
                }
            }
        }
    }]);

(function () {
    angular.module('babycompy.doctorSearch')
        .factory('doctorResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var doctorResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.get = {
                        method: 'GET',
                        params: {
                            action: 'search'
                        }
                    };

                    o.getProfile = {
                        method: 'GET',
                        params: {
                            action: 'profile'
                        }
                    }

                    return o;
                },

                getProfile: function (uuid) {
                    return this.resource.getProfile({id: uuid}).$promise;
                }

            })
            return new doctorResource(resources.doctors);
        }])
})();
angular.module('babycompy.doctorSearch')
.controller('doctorSearchController', ['$scope', 'doctorResource', 'baseListController', 'seoService', '$translate', 'enums', 'authService',
  function ($scope, doctorResource, baseListController, seoService, $translate, enums, authService) {

        var doctorSearchController = baseListController.extend({
            init: function(){
                this._super.apply(this, arguments);
                this.favoriteType = enums.selectFavoriteTypes.doctors;
                this.userLoggedIn = authService.isLoggedIn() ? true : false;
                $translate('menu.doctors').then(function(translations){
                    seoService.title(translations);
                    seoService.description(translations);
                });
            },

            _applySearchParameters: function (params) {
                function uuid(obj) {
                    return obj ? obj.uuid : null
                }

                return {
                    country: uuid(params.country),
                    region: uuid(params.region),
                    city: uuid(params.city),
                    specialization: uuid(params.department),
                    name: params.name,
                    onHome: params.homeVisit,
                    recursive: params.recursive
                };
            }
        });

        return new doctorSearchController($scope, doctorResource);
    }]);

(function () {
    'use strict';

    angular
        .module('babycompy.doctorSearch')
        .config(['$stateProvider', config])
        .filter("htmlSafe", ['$sce', function($sce) {
            return function(htmlCode){
                return $sce.trustAsHtml(htmlCode);
            };
        }]);
        
    function config($stateProvider) {
        $stateProvider.state('index.doctorSearch', {
            url: 'doctors',
            views: {
                'content': { 
                    templateUrl: 'app/components/doctorSearch/doctorSearch.html',
                    controller: 'doctorSearchController',
                    controllerAs: 'c'
                }
            }
        });
    }
})();
angular.module('babycompy.comments', [])
  .factory('commentsResource', ['baseApiService',
    function (baseApiService) {

      var commentsResource = baseApiService.extend({

        _setupCustomActions: function () {
          var o = this._super();

          return o;
        }
      });

      return new commentsResource('comments');
    }]);

angular.module('babycompy.comments').directive('comments', [function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/components/comments/comments.html',
    controller: 'commentsController as commCtrl',
    link: function (scope, elem, attrs) {
      if (!attrs.type) throw Error('Type attribute is required');

      scope.type = attrs.type;
      scope.uuid = attrs.uuid;
      scope.noHead = attrs.noHead;
      var textarea;

      scope.commCtrl.getComments();

      scope.$on('comment.loaded', function () {
        texareaEvents();
      });

      scope.$on('comment.posted', function () {
         textarea.height(29);
      });

      scope.$on('comments.answer', function () {
        areaHeight();
        textarea.focus();
      });

      function texareaEvents() {
        if (textarea) return;

        textarea = elem.find('textarea');

        textarea.on('keyup', function () {
         areaHeight();
        });

        textarea.on('keydown', function (e) {
          if (e.which === 13 && e.shiftKey === false) {
            scope.commCtrl.postComment();
            e.preventDefault();
          }
        });
      }

      function areaHeight() {
        textarea[0].style.height = "1px";
        textarea[0].style.height = textarea[0].scrollHeight + "px";
      }
    }
  }
}]);

angular.module('babycompy.comments')
  .controller('commentsController', ['$scope', 'commentsResource', 'baseListController', '$state', 'currentUserService', 'modalService',
    function ($scope, commentsResource, baseListController, $state, currentUserService, modalService) {

      var commentsController = baseListController.extend({
        init: function () {
          this._super.apply(this, arguments);
          currentUserService.load().then(function (user) {
            this.user = user;
          }.bind(this));
        },

        comment: '',
        limit: 5,
        offset: 0,
        showLoader: false,
        complainVal: 0,

        getComments: function (options) {
          if (options && options.offset) this.limit += 5;

          this.resource['get']({
            entityUuid: $scope.uuid,
            limit: this.limit,
            offset: this.offset
          }).then(function (resp) {
            this.data = resp.content.items;
            this.total = resp.content.total;
            $scope.$emit('comment.loaded');
            $scope.$emit('comment.total', this.total);
            if (this.showLoader) this.showLoader = false;
          }.bind(this));
        },

        openDoctor: function (comment) {
          if (comment.author.doctor && !comment.author.hidden) $scope.$state.go('index.doctorSearch.details', {uuid: comment.author.uuid});
        },

        postComment: function () {
          if (!this.comment) return;

          var obj = {
            entity: $scope.uuid,
            type: $scope.type
          };
          obj.text = this.comment;
          this.showLoader = true;

          this.resource['save'](obj).then(function (resp) {
            this.comment = '';
            $scope.$emit('comment.posted');
            this.getComments();
          }.bind(this));
        },

        answer: function (comment) {
          if (comment.author.admin) {
            this.comment = comment.text + '\n' + '— BabyCompy\n\n';
          } else {
            this.comment = comment.text + '\n' + '— ' + comment.author.firstName + ' ' + (comment.author.lastName || '') + '\n\n';
          }

          setTimeout(function () {
            $scope.$emit('comments.answer');
          }, 0);
        },

        complain: function (comment) {
          this.commentCurrent = comment;

          modalService.open({
            template: 'app/components/comments/complainModal.html',
            scope: $scope,
            show: true,
            backdrop: 'static'
          })
        },

        postComplain: function () {
          this.commentCurrent.complaint = true;

          this.resource['post']({id: this.commentCurrent.uuid, action: 'complaints'}, {type: this.complainVal});
        },

        deleteComment: function (uuid) {
          this.resource['delete'](uuid).then(function (resp) {
            this.getComments();
          }.bind(this));
        }

      });
      return new commentsController($scope, commentsResource);
    }]);

(function () {
    'use strict';

    angular.module('babycompy.clinics',
        [
            'babycompy.clinics.search',
            'babycompy.clinics.details',
            'babycompy.selectLocation',
            'babycompy.pager',
            'ngSanitize',
            'ui.select'
        ]);
})();

(function () {
    angular.module('babycompy.clinics')
        .factory('clinicResource', ['baseApiService', 'resources', function (baseApiService, resources) {

            var clinicResource = baseApiService.extend({

                _setupCustomActions: function () {
                    var o = this._super();
                    o.get = {
                        method: 'GET',
                        params: {
                            action: 'search'
                        }
                    };

                    o.getProfile = {
                        method: 'GET',
                        params: {
                            action: 'profile'
                        }
                    };

                    return o;
                },

                getProfile: function (uuid) {
                    return this.resource.getProfile({ id: uuid }).$promise;
                }
            });
            return new clinicResource(resources.healthFacilities);
        }])
})();
angular.module('babycompy.clinics')
    .controller('clinicSearchController', ['$scope', '$rootScope', 'clinicResource', 'baseListController',
        'enums', 'user', 'seoService', '$q', '$translate',
        function($scope, $rootScope, clinicResource, baseListController,
            enums, user, seoService, $q, $translate) {

            var clinicSearchController = baseListController.extend({

                init: function() {
                    this._super.apply(this, arguments);
                    $q.all([
                        $translate('menu.clinics'),
                        $translate('clinicSearch.pageTitle')
                    ]).then(function(result) {
                        this.favoriteType = enums.selectFavoriteTypes.clinics;
                        this._locationOnFirstTimeLoad();
                        seoService.title(result[0], result[1]);
                        seoService.description(result[1]);
                    }.bind(this));

                },

                _applySearchParameters: function(params) {
                    function uuid(obj) {
                        return obj ? obj.uuid : null
                    };

                    function compareSelectedWithParams(selected, params, id) {
                        if (!params.recursive) {
                            return angular.element(id).val() !== uuid(selected) ? angular.element(id).val() : uuid(selected);
                        } else {
                            return uuid(selected);
                        }
                    };
                    
                    return {
                        country: compareSelectedWithParams(params.country, params, '#search-user-country'),
                        region: compareSelectedWithParams(params.region, params, '#search-user-region'),
                        city: compareSelectedWithParams(params.city, params, '#search-user-city'),
                        type: uuid(params.type),
                        departments: uuid(params.department),
                        services: uuid(params.service),
                        name: params.name,
                        recursive: params.recursive
                    };
                },
                
                _locationOnFirstTimeLoad: function() {
                    if (!user) {
                        return;
                    }
                    this.searchFormParameters.recursive = true;
                    initSearchFormParameters($rootScope, this, user);
                    // INF_BBCMP-1389
                    // we will receive an event from pager, so now just set required search parameters
                    // this.searchWithFormParameters();
                    this.synchronizeSearchParameters();
                    this.searchFormParameters.recursive = false;
                }

            });
            var isEmpty = function(object) {
                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        return false;
                    }
                }
                return true;
            }
            var initSearchFormParameters = function(rootScope, localScope, user) {
                if (isEmpty(rootScope.searchFormParameters)) {
                    localScope.searchFormParameters.country = user.userLocation.country;
                    localScope.searchFormParameters.region = user.userLocation.region;
                    localScope.searchFormParameters.city = user.userLocation.city;
                    rootScope.searchFormParameters = {};
                    rootScope.searchFormParameters.country = user.userLocation.country;
                    rootScope.searchFormParameters.region = user.userLocation.region;
                    rootScope.searchFormParameters.city = user.userLocation.city;
                } else {
                    localScope.searchFormParameters.country = rootScope.searchFormParameters.country;
                    localScope.searchFormParameters.region = rootScope.searchFormParameters.region;
                    localScope.searchFormParameters.city = rootScope.searchFormParameters.city;
                }
            }
            return new clinicSearchController($scope, clinicResource);
        }
    ]);

(function () {
    'use strict';

    angular
        .module('babycompy.clinics')
        .config(['$stateProvider', config])
        .filter("htmlSafe", ['$sce', function ($sce) {
            return function (htmlCode) {
                return $sce.trustAsHtml(htmlCode);
            };
        }]);

    function config($stateProvider) {
        $stateProvider.state('index.clinics', {
            url: 'clinics',
            views: {
                    'content': {
                    templateUrl: 'app/components/clinics/clinics.html',
                    controller: 'clinicSearchController',
                    controllerAs: 'c'
                }
            },
            
            resolve: {
              user : ['currentUserService', function(currentUserService){
                  return currentUserService.load().then(function(currentUser) {
                      return currentUser;
                  }, function(rejected) {
                      return null;
                  });
              }]
            },
            breadcrumb: "{{'menu.clinics' | translate}}"
        });
    }
})();
(function() {
    'use strict';
    angular.module('babycompy.authentication')
        .config(['$httpProvider', function($httpProvider) {

            $httpProvider.interceptors.push(['localStorageService', '$q', 'auth',
                function(localStorageService, $q, authConst) {
                    return {
                        'request': function(config) {
                            var token = localStorageService.get(authConst.tokenHeaderName);
                            if (token && token !== '') {
                                config.headers['Authorization'] = String.format('{0}', token);
                            }

                            return config;
                        },

                        'response': function(response) {
                            var token = response.headers()[authConst.tokenHeaderName.toLowerCase()];
                            if (token !== undefined) {
                                localStorageService.set(authConst.tokenHeaderName, token);
                            }

                            return response;
                        },

                        'responseError': function(response) {
                            if (response.status === 401) {
                                if (localStorageService.get(authConst.tokenHeaderName)) {
                                    localStorageService.set(authConst.tokenHeaderName, '');
                                    window.location.href = "/login";
                                }
                            }
                            return $q.reject(response);
                        }
                    };
                }
            ]);
        }])
})();

(function () {
    angular.module('babycompy.base')
        .factory('authTokenService', ['localStorageService', 'auth',
            function (localStorageService, auth) {

                var AuthTokenService = Class.extend({

                    isLoggedIn: function () {
                        var token = this.getToken();
                        return token && token !== '';
                    },

                    getToken: function () {
                        return localStorageService.get(auth.tokenHeaderName);
                    },

                    deleteToken: function () {
                        // reset token
                        localStorageService.set(auth.tokenHeaderName, '');
                    }

                });

                return new AuthTokenService();
            }]);
})();
(function () {
  angular.module('babycompy.base')
      .factory('authService', ['baseApiService', 'authTokenService', 'auth', 'resources', 'applicationLifecycle',
        function (baseApiService, authTokenService, auth, resources, applicationLifecycle) {

          var AuthService = baseApiService.extend({
            _setupCustomActions: function () {
              return {
                'signIn': {
                  method: 'POST',
                  isObject: 'true',
                  params: {
                    controller: 'signIn'
                  }
                },
                'logout': {
                  method: 'GET',
                  params: {
                    controller: 'signOut'
                  }
                },
                'checkPassword': {
                  method: 'POST',
                  isObject: 'true',
                  params: {
                    controller: 'checkPassword'
                  }
                },
                'changePassword': {
                  method: 'PUT',
                  params: {
                    controller: 'account',
                    id: 'changePassword'
                  }
                }
              };
            },

            signIn: function (email, pwd) {
              return this.resource.signIn({
                login: email,
                password: pwd
              }).$promise;
            },

            isLoggedIn: function () {
              return authTokenService.isLoggedIn();
            },

            getToken: function () {
              return authTokenService.getToken();
            },

            logOut: function () {
              // reset token
              applicationLifecycle.beforeLogout();
              authTokenService.deleteToken();
              return this.resource.logout().$promise;
            },

            checkPassword: function (password) {
              return this.resource.checkPassword({password: password}).$promise;
            },

            changePassword: function (id) {
              return this.resource.changePassword({u: id}).$promise;
            }

          });

          return new AuthService(resources.auth);
        }]);
})();
/**
 * State-based routing for AngularJS
 * @version v0.2.18
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];

    //ArtemP: Do not remove!
    if(Array.isArray(a[k])){
      return angular.equals(a[k], b[k]);
    }

    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = resolution.promise,
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = invocation.promise;
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
function $TemplateFactory(  $http,   $templateCache,   $injector) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else return $http
        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
        .then(function(response) { return response.data; });
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
      pattern: /\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
    var TransitionPrevented = $q.reject(new Error('transition prevented'));
    var TransitionAborted = $q.reject(new Error('transition aborted'));
    var TransitionFailed = $q.reject(new Error('transition failed'));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) return TransitionSuperseded;
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) return TransitionSuperseded;

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) return TransitionSuperseded;

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }, function (error) {
        if ($state.transition !== transition) return TransitionSuperseded;

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
            $urlRouter.update();
        }

        return $q.reject(error);
      });

      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .provider('$state', $StateProvider);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

var ngMajorVer = angular.version.major;
var ngMinorVer = angular.version.minor;
/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
 * will be applied to the ui-view)
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 * 
 * @example
 * A view can be unnamed or named. 
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div> 
 * 
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a 
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div> 
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 * 
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * But typically you'll only use the views property if you name your view or have more than one view 
 * in the same template. There's not really a compelling reason to name a view if its the only one, 
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre> 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div> 
 * <div ui-view="data"></div> 
 * </pre>
 * 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = {
      enter: function (element, target, cb) { target.after(element); cb(); },
      leave: function (element, cb) { element.remove(); cb(); }
    };

    if (!!attrs.noanimation) return statics;

    function animEnabled(element) {
      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
      return (!!$animator);
    }

    // ng 1.2+
    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (!animEnabled(element)) {
            statics.enter(element, target, cb);
          } else if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (!animEnabled(element)) {
            statics.leave(element, cb);
          } else if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    // ng 1.1.5
    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics;
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope);

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          var _previousEl = previousEl;
          var _currentScope = currentScope;

          if (_currentScope) {
            _currentScope._willBeDestroyed = true;
          }

          function cleanOld() {
            if (_previousEl) {
              _previousEl.remove();
            }

            if (_currentScope) {
              _currentScope.$destroy();
            }
          }

          if (currentEl) {
            renderer.leave(currentEl, function() {
              cleanOld();
              previousEl = null;
            });

            previousEl = currentEl;
          } else {
            cleanOld();
            previousEl = null;
          }

          currentEl = null;
          currentScope = null;
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            renderer.enter(clone, $element, function onUiViewEnter() {
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
          }
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var inherited = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (active) active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (active) active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        addState(newState, newParams, uiSrefActive);
        update();
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        states.push({
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        });

        activeClasses[stateHash] = activeClass;
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);
(function () {
    $type = String;
    $type.__typeName = 'String';
    $type.__class = true;

    $prototype = $type.prototype;
    $type.empty = '';

    $prototype.endsWith = function String$endsWith(suffix) {
        /// <summary locid="M:J#String.endsWith">Determines whether the end of this instance matches the specified string.</summary>
        /// <param name="suffix" type="String">A string to compare to.</param>
        /// <returns type="Boolean">true if suffix matches the end of this instance; otherwise, false.</returns>
        return (this.substr(this.length - suffix.length) === suffix);
    }

    $type.isNullOrEmpty = function String$isNullOrEmpty(str) {
        return str == undefined || str === null || str === this.empty;
    }

    $prototype.startsWith = function String$startsWith(prefix) {
        /// <summary locid="M:J#String.startsWith">Determines whether the beginning of this instance matches the specified string.</summary>
        /// <param name="prefix" type="String">The String to compare.</param>
        /// <returns type="Boolean">true if prefix matches the beginning of this string; otherwise, false.</returns>
        return (this.substr(0, prefix.length) === prefix);
    }

    $prototype.trim = function String$trim() {
        /// <summary locid="M:J#String.trim">Removes all leading and trailing white-space characters from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the start and end of the current String object.</returns>
        return this.replace(/^\s+|\s+$/g, '');
    }

    $prototype.trimEnd = function String$trimEnd() {
        /// <summary locid="M:J#String.trimEnd">Removes all trailing white spaces from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the end of the current String object.</returns>
        return this.replace(/\s+$/, '');
    }

    $prototype.trimStart = function String$trimStart() {
        /// <summary locid="M:J#String.trimStart">Removes all leading white spaces from the current String object.</summary>
        /// <returns type="String">The string that remains after all white-space characters are removed from the start of the current String object.</returns>
        return this.replace(/^\s+/, '');
    }

    $prototype.padLeft = function String$padLeft(paddingString, totalLength) {
        var padding = Array.apply(null, { length: totalLength })
            .map(String.prototype.valueOf, paddingString).join('');
        return String(padding + this)
            .slice(-totalLength);
    }

    $type.format = function String$format(format, args) {
        /// <summary locid="M:J#String.format">Replaces the format items in a specified String with the text equivalents of the values of   corresponding object instances. The invariant culture will be used to format dates and numbers.</summary>
        /// <param name="format" type="String">A format string.</param>
        /// <param name="args" parameterArray="true" mayBeNull="true">The objects to format.</param>
        /// <returns type="String">A copy of format in which the format items have been replaced by the   string equivalent of the corresponding instances of object arguments.</returns>
        return String._toFormattedString(false, arguments);
    }

    $type._toFormattedString = function String$_toFormattedString(useLocale, args) {
        var result = '';
        var format = args[0];

        for (var i = 0; ;) {
            // Find the next opening or closing brace
            var open = format.indexOf('{', i);
            var close = format.indexOf('}', i);
            if ((open < 0) && (close < 0)) {
                // Not found: copy the end of the string and break
                result += format.slice(i);
                break;
            }
            if ((close > 0) && ((close < open) || (open < 0))) {
                if (format.charAt(close + 1) !== '}') {
                    throw Error('stringFormatBraceMismatch');
                }
                result += format.slice(i, close + 1);
                i = close + 2;
                continue;
            }

            // Copy the string before the brace
            result += format.slice(i, open);
            i = open + 1;

            // Check for double braces (which display as one and are not arguments)
            if (format.charAt(i) === '{') {
                result += '{';
                i++;
                continue;
            }

            //#if DEBUG
            // at this point we have a valid opening brace, which should be matched by a closing brace.
            if (close < 0) throw Error('stringFormatBraceMismatch');
            //#else
            // This test is just done to break a potential infinite loop for invalid format strings.
            // The code here is minimal because this is an error condition in debug mode anyway.
            if (close < 0) break;
            //#endif

            // Find the closing brace

            // Get the string between the braces, and split it around the ':' (if any)
            var brace = format.substring(i, close);
            var colonIndex = brace.indexOf(':');
            var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10) + 1;
            //#if DEBUG
            if (isNaN(argNumber)) if (close < 0) throw Error('stringFormatInvalid');
            //#endif
            var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);

            var arg = args[argNumber];
            if (typeof (arg) === "undefined" || arg === null) {
                arg = '';
            }

            // If it has a toFormattedString method, call it.  Otherwise, call toString()
            if (arg.toFormattedString) {
                result += arg.toFormattedString(argFormat);
            }
            else if (useLocale && arg.localeFormat) {
                result += arg.localeFormat(argFormat);
            }
            else if (arg.format) {
                result += arg.format(argFormat);
            }
            else
                result += arg.toString();

            i = close + 1;
        }

        return result;
    }
})();
/**
 * Синтаксис:
 * Class.extend(props)
 * Class.extend(props, staticProps)
 * Class.extend([mixins], props)
 * Class.extend([mixins], props, staticProps)
*/
!function () {

    window.Class = function () { /* вся магия - в Class.extend */ };


    Class.extend = function (props, staticProps) {

        var mixins = [];

        // если первый аргумент -- массив, то переназначить аргументы    
        if ({}.toString.apply(arguments[0]) == "[object Array]") {
            mixins = arguments[0];
            props = arguments[1];
            staticProps = arguments[2];
        }

        // эта функция будет возвращена как результат работы extend
        function Constructor() {
            this.init && this.init.apply(this, arguments);
        }

        // this -- это класс "перед точкой", для которого вызван extend (Animal.extend)
        // наследуем от него:
        Constructor.prototype = Class.inherit(this.prototype);

        // constructor был затёрт вызовом inherit
        Constructor.prototype.constructor = Constructor;

        // добавим возможность наследовать дальше
        Constructor.extend = Class.extend;

        // скопировать в Constructor статические свойства
        copyWrappedProps(staticProps, Constructor, this);

        // скопировать в Constructor.prototype свойства из примесей и props
        for (var i = 0; i < mixins.length; i++) {
            copyWrappedProps(mixins[i], Constructor.prototype, this.prototype);
        }

        copyWrappedProps(props, Constructor.prototype, this.prototype);

        return Constructor;
    };


    //---------- вспомогательные методы ----------

    // fnTest -- регулярное выражение, 
    // которое проверяет функцию на то, есть ли в её коде вызов _super
    // 
    // для его объявления мы проверяем, поддерживает ли функция преобразование
    // в код вызовом toString: /xyz/.test(function() {xyz})
    // в редких мобильных браузерах -- не поддерживает, поэтому регэксп будет /./
    var fnTest = /xyz/.test(function () { xyz }) ? /\b_super\b/ : /./;


    // копирует свойства из props в targetPropsObj
    // третий аргумент -- это свойства родителя
    // 
    // при копировании, если выясняется что свойство есть и в родителе тоже,
    // и является функцией -- его вызов оборачивается в обёртку,
    // которая ставит this._super на метод родителя, 
    // затем вызывает его, затем возвращает this._super
    function copyWrappedProps(props, targetPropsObj, parentPropsObj) {
        if (!props) return;

        for (var name in props) {
            if (typeof props[name] == "function"
              && typeof parentPropsObj[name] == "function"
              && fnTest.test(props[name])) {
                // скопировать, завернув в обёртку
                targetPropsObj[name] = wrap(props[name], parentPropsObj[name]);
            } else {
                targetPropsObj[name] = props[name];
            }
        }

    }

    // возвращает обёртку вокруг method, которая ставит this._super на родителя
    // и возвращает его потом 
    function wrap(method, parentMethod) {
        return function () {
            var backup = this._super;

            this._super = parentMethod;

            try {
                return method.apply(this, arguments);
            } finally {
                this._super = backup;
            }
        }
    }

    // эмуляция Object.create для старых IE
    Class.inherit = Object.create || function (proto) {
        function F() { }
        F.prototype = proto;
        return new F;
    };
}();

(function() {
    // Main menu hamburger opened
    var mainMenu = angular.element('#main-menu');
    mainMenu.on('click', '.mm-hamburger-block', function(){
        angular.element(this).find('.mm-hamburger').toggleClass('open');
        angular.element(this).parent().find('.mm-dropdown').toggleClass('open');
    });

    // Placeholder Select First Element
    var selectControl = $('select.form-control');
    selectControl.change(function () {
        if($(this).val() == "0") $(this).addClass("empty"); else $(this).removeClass("empty");
    });
    selectControl.change();
})();
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435",
      "\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
      "\u0432\u0442\u043e\u0440\u043d\u0438\u043a",
      "\u0441\u0440\u0435\u0434\u0430",
      "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
      "\u043f\u044f\u0442\u043d\u0438\u0446\u0430",
      "\u0441\u0443\u0431\u0431\u043e\u0442\u0430"
    ],
    "ERANAMES": [
      "\u0434\u043e \u043d. \u044d.",
      "\u043d. \u044d."
    ],
    "ERAS": [
      "\u0434\u043e \u043d. \u044d.",
      "\u043d. \u044d."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "\u044f\u043d\u0432\u0430\u0440\u044f",
      "\u0444\u0435\u0432\u0440\u0430\u043b\u044f",
      "\u043c\u0430\u0440\u0442\u0430",
      "\u0430\u043f\u0440\u0435\u043b\u044f",
      "\u043c\u0430\u044f",
      "\u0438\u044e\u043d\u044f",
      "\u0438\u044e\u043b\u044f",
      "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
      "\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f",
      "\u043e\u043a\u0442\u044f\u0431\u0440\u044f",
      "\u043d\u043e\u044f\u0431\u0440\u044f",
      "\u0434\u0435\u043a\u0430\u0431\u0440\u044f"
    ],
    "SHORTDAY": [
      "\u0432\u0441",
      "\u043f\u043d",
      "\u0432\u0442",
      "\u0441\u0440",
      "\u0447\u0442",
      "\u043f\u0442",
      "\u0441\u0431"
    ],
    "SHORTMONTH": [
      "\u044f\u043d\u0432.",
      "\u0444\u0435\u0432\u0440.",
      "\u043c\u0430\u0440\u0442\u0430",
      "\u0430\u043f\u0440.",
      "\u043c\u0430\u044f",
      "\u0438\u044e\u043d\u044f",
      "\u0438\u044e\u043b\u044f",
      "\u0430\u0432\u0433.",
      "\u0441\u0435\u043d\u0442.",
      "\u043e\u043a\u0442.",
      "\u043d\u043e\u044f\u0431.",
      "\u0434\u0435\u043a."
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d MMMM y '\u0433'.",
    "longDate": "d MMMM y '\u0433'.",
    "medium": "d MMM y '\u0433'. H:mm:ss",
    "mediumDate": "d MMM y '\u0433'.",
    "mediumTime": "H:mm:ss",
    "short": "dd.MM.yy H:mm",
    "shortDate": "dd.MM.yy",
    "shortTime": "H:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u0440\u0443\u0431.",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": "\u00a0",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "ru-ru",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  if (vf.v == 0 && i % 10 == 0 || vf.v == 0 && i % 10 >= 5 && i % 10 <= 9 || vf.v == 0 && i % 100 >= 11 && i % 100 <= 14) {    return PLURAL_CATEGORY.MANY;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

tinymce.addI18n('ru',{
"Cut": "\u0412\u044b\u0440\u0435\u0437\u0430\u0442\u044c",
"Heading 5": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 5",
"Header 2": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 2",
"Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043d\u0435 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043f\u0440\u044f\u043c\u043e\u0439 \u0434\u043e\u0441\u0442\u0443\u043f \u043a \u0431\u0443\u0444\u0435\u0440\u0443 \u043e\u0431\u043c\u0435\u043d\u0430. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u043e\u0447\u0435\u0442\u0430\u043d\u0438\u044f \u043a\u043b\u0430\u0432\u0438\u0448: Ctrl+X\/C\/V.",
"Heading 4": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 4",
"Div": "\u0411\u043b\u043e\u043a",
"Heading 2": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 2",
"Paste": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c",
"Close": "\u0417\u0430\u043a\u0440\u044b\u0442\u044c",
"Font Family": "\u0428\u0440\u0438\u0444\u0442",
"Pre": "\u041f\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u0444\u043e\u0440\u043c\u0430\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435",
"Align right": "\u041f\u043e \u043f\u0440\u0430\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
"New document": "\u041d\u043e\u0432\u044b\u0439 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442",
"Blockquote": "\u0426\u0438\u0442\u0430\u0442\u0430",
"Numbered list": "\u041d\u0443\u043c\u0435\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0439 \u0441\u043f\u0438\u0441\u043e\u043a",
"Heading 1": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 1",
"Headings": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043a\u0438",
"Increase indent": "\u0423\u0432\u0435\u043b\u0438\u0447\u0438\u0442\u044c \u043e\u0442\u0441\u0442\u0443\u043f",
"Formats": "\u0424\u043e\u0440\u043c\u0430\u0442",
"Headers": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043a\u0438",
"Select all": "\u0412\u044b\u0434\u0435\u043b\u0438\u0442\u044c \u0432\u0441\u0435",
"Header 3": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 3",
"Blocks": "\u0411\u043b\u043e\u043a\u0438",
"Undo": "\u0412\u0435\u0440\u043d\u0443\u0442\u044c",
"Strikethrough": "\u0417\u0430\u0447\u0435\u0440\u043a\u043d\u0443\u0442\u044b\u0439",
"Bullet list": "\u041c\u0430\u0440\u043a\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0439 \u0441\u043f\u0438\u0441\u043e\u043a",
"Header 1": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 1",
"Superscript": "\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",
"Clear formatting": "\u041e\u0447\u0438\u0441\u0442\u0438\u0442\u044c \u0444\u043e\u0440\u043c\u0430\u0442",
"Font Sizes": "\u0420\u0430\u0437\u043c\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
"Subscript": "\u041d\u0438\u0436\u043d\u0438\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",
"Header 6": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 6",
"Redo": "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
"Paragraph": "\u041f\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
"Ok": "\u041e\u043a",
"Bold": "\u041f\u043e\u043b\u0443\u0436\u0438\u0440\u043d\u044b\u0439",
"Code": "\u041a\u043e\u0434",
"Italic": "\u041a\u0443\u0440\u0441\u0438\u0432",
"Align center": "\u041f\u043e \u0446\u0435\u043d\u0442\u0440\u0443",
"Header 5": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 5",
"Heading 6": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 6",
"Heading 3": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 3",
"Decrease indent": "\u0423\u043c\u0435\u043d\u044c\u0448\u0438\u0442\u044c \u043e\u0442\u0441\u0442\u0443\u043f",
"Header 4": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 4",
"Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "\u0412\u0441\u0442\u0430\u0432\u043a\u0430 \u043e\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432 \u0432\u0438\u0434\u0435 \u043f\u0440\u043e\u0441\u0442\u043e\u0433\u043e \u0442\u0435\u043a\u0441\u0442\u0430, \u043f\u043e\u043a\u0430 \u043d\u0435 \u043e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0434\u0430\u043d\u043d\u0443\u044e \u043e\u043f\u0446\u0438\u044e.",
"Underline": "\u041f\u043e\u0434\u0447\u0435\u0440\u043a\u043d\u0443\u0442\u044b\u0439",
"Cancel": "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
"Justify": "\u041f\u043e \u0448\u0438\u0440\u0438\u043d\u0435",
"Inline": "\u0421\u0442\u0440\u043e\u0447\u043d\u044b\u0435",
"Copy": "\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c",
"Align left": "\u041f\u043e \u043b\u0435\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
"Visual aids": "\u041f\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u0442\u044c \u043a\u043e\u043d\u0442\u0443\u0440\u044b",
"Lower Greek": "\u0421\u0442\u0440\u043e\u0447\u043d\u044b\u0435 \u0433\u0440\u0435\u0447\u0435\u0441\u043a\u0438\u0435 \u0431\u0443\u043a\u0432\u044b",
"Square": "\u041a\u0432\u0430\u0434\u0440\u0430\u0442\u044b",
"Default": "\u0421\u0442\u0430\u043d\u0434\u0430\u0440\u0442\u043d\u044b\u0439",
"Lower Alpha": "\u0421\u0442\u0440\u043e\u0447\u043d\u044b\u0435 \u043b\u0430\u0442\u0438\u043d\u0441\u043a\u0438\u0435 \u0431\u0443\u043a\u0432\u044b",
"Circle": "\u041e\u043a\u0440\u0443\u0436\u043d\u043e\u0441\u0442\u0438",
"Disc": "\u041a\u0440\u0443\u0433\u0438",
"Upper Alpha": "\u0417\u0430\u0433\u043b\u0430\u0432\u043d\u044b\u0435 \u043b\u0430\u0442\u0438\u043d\u0441\u043a\u0438\u0435 \u0431\u0443\u043a\u0432\u044b",
"Upper Roman": "\u0417\u0430\u0433\u043b\u0430\u0432\u043d\u044b\u0435 \u0440\u0438\u043c\u0441\u043a\u0438\u0435 \u0446\u0438\u0444\u0440\u044b",
"Lower Roman": "\u0421\u0442\u0440\u043e\u0447\u043d\u044b\u0435 \u0440\u0438\u043c\u0441\u043a\u0438\u0435 \u0446\u0438\u0444\u0440\u044b",
"Name": "\u0418\u043c\u044f",
"Anchor": "\u042f\u043a\u043e\u0440\u044c",
"You have unsaved changes are you sure you want to navigate away?": "\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044c \u043d\u0435 \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0435 \u0438\u0437\u043c\u0435\u043d\u0435\u043d\u0438\u044f. \u0412\u044b \u0443\u0432\u0435\u0440\u0435\u043d\u044b, \u0447\u0442\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0443\u0439\u0442\u0438?",
"Restore last draft": "\u0412\u043e\u0441\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u0435 \u043f\u043e\u0441\u043b\u0435\u0434\u043d\u0435\u0433\u043e \u043f\u0440\u043e\u0435\u043a\u0442\u0430",
"Special character": "\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u044c\u043d\u044b\u0435 \u0441\u0438\u043c\u0432\u043e\u043b\u044b",
"Source code": "\u0418\u0441\u0445\u043e\u0434\u043d\u044b\u0439 \u043a\u043e\u0434",
"B": "B",
"R": "R",
"G": "G",
"Color": "\u0426\u0432\u0435\u0442",
"Right to left": "\u041d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0441\u043f\u0440\u0430\u0432\u0430 \u043d\u0430\u043b\u0435\u0432\u043e",
"Left to right": "\u041d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0441\u043b\u0435\u0432\u0430 \u043d\u0430\u043f\u0440\u0430\u0432\u043e",
"Emoticons": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u043c\u0430\u0439\u043b",
"Robots": "\u0420\u043e\u0431\u043e\u0442\u044b",
"Document properties": "\u0421\u0432\u043e\u0439\u0441\u0442\u0432\u0430 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430",
"Title": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
"Keywords": "\u041a\u043b\u044e\u0447\u0438\u0432\u044b\u0435 \u0441\u043b\u043e\u0432\u0430",
"Encoding": "\u041a\u043e\u0434\u0438\u0440\u043e\u0432\u043a\u0430",
"Description": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
"Author": "\u0410\u0432\u0442\u043e\u0440",
"Fullscreen": "\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c",
"Horizontal line": "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u0430\u044f \u043b\u0438\u043d\u0438\u044f",
"Horizontal space": "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u044b\u0439 \u0438\u043d\u0442\u0435\u0440\u0432\u0430\u043b",
"Insert\/edit image": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c\/\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0435",
"General": "\u041e\u0431\u0449\u0435\u0435",
"Advanced": "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043d\u043d\u044b\u0435",
"Source": "\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a",
"Border": "\u0420\u0430\u043c\u043a\u0430",
"Constrain proportions": "\u0421\u043e\u0445\u0440\u0430\u043d\u044f\u0442\u044c \u043f\u0440\u043e\u043f\u043e\u0440\u0446\u0438\u0438",
"Vertical space": "\u0412\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c\u043d\u044b\u0439 \u0438\u043d\u0442\u0435\u0440\u0432\u0430\u043b",
"Image description": "\u041e\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u044f",
"Style": "\u0421\u0442\u0438\u043b\u044c",
"Dimensions": "\u0420\u0430\u0437\u043c\u0435\u0440",
"Insert image": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0435",
"Zoom in": "\u041f\u0440\u0438\u0431\u043b\u0438\u0437\u0438\u0442\u044c",
"Contrast": "\u041a\u043e\u043d\u0442\u0440\u0430\u0441\u0442",
"Back": "\u041d\u0430\u0437\u0430\u0434",
"Gamma": "\u0413\u0430\u043c\u043c\u0430",
"Flip horizontally": "\u041e\u0442\u0440\u0430\u0437\u0438\u0442\u044c \u043f\u043e \u0433\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u0438",
"Resize": "\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0440\u0430\u0437\u043c\u0435\u0440",
"Sharpen": "\u0427\u0435\u0442\u043a\u043e\u0441\u0442\u044c",
"Zoom out": "\u041e\u0442\u0434\u0430\u043b\u0438\u0442\u044c",
"Image options": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u044f",
"Apply": "\u041f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u044c",
"Brightness": "\u042f\u0440\u043a\u043e\u0441\u0442\u044c",
"Rotate clockwise": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u044c \u043f\u043e \u0447\u0430\u0441\u043e\u0432\u043e\u0439 \u0441\u0442\u0440\u0435\u043b\u043a\u0435",
"Rotate counterclockwise": "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u044c \u043f\u0440\u043e\u0442\u0438\u0432 \u0447\u0430\u0441\u043e\u0432\u043e\u0439 \u0441\u0442\u0440\u0435\u043b\u043a\u0438",
"Edit image": "\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0435",
"Color levels": "\u0426\u0432\u0435\u0442\u043e\u0432\u044b\u0435 \u0443\u0440\u043e\u0432\u043d\u0438",
"Crop": "\u041e\u0431\u0440\u0435\u0437\u0430\u0442\u044c",
"Orientation": "\u041e\u0440\u0438\u0435\u043d\u0442\u0430\u0446\u0438\u044f",
"Flip vertically": "\u041e\u0442\u0440\u0430\u0437\u0438\u0442\u044c \u043f\u043e \u0432\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u0438",
"Invert": "\u0418\u043d\u0432\u0435\u0440\u0441\u0438\u044f",
"Insert date\/time": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0434\u0430\u0442\u0443\/\u0432\u0440\u0435\u043c\u044f",
"Remove link": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443",
"Url": "\u0410\u0434\u0440\u0435\u0441 \u0441\u0441\u044b\u043b\u043a\u0438",
"Text to display": "\u041e\u0442\u043e\u0431\u0440\u0430\u0436\u0430\u0435\u043c\u044b\u0439 \u0442\u0435\u043a\u0441\u0442",
"Anchors": "\u042f\u043a\u043e\u0440\u044f",
"Insert link": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443",
"New window": "\u0412 \u043d\u043e\u0432\u043e\u043c \u043e\u043a\u043d\u0435",
"None": "\u041d\u0435\u0442",
"The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "\u0412\u0432\u0435\u0434\u0451\u043d\u043d\u044b\u0439 URL \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432\u043d\u0435\u0448\u043d\u0435\u0439 \u0441\u0441\u044b\u043b\u043a\u043e\u0439. \u0412\u044b \u0436\u0435\u043b\u0430\u0435\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043f\u0440\u0435\u0444\u0438\u043a\u0441 \u00abhttp:\/\/\u00bb?",
"Target": "\u041e\u0442\u043a\u0440\u044b\u0432\u0430\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443",
"The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "\u0412\u0432\u0435\u0434\u0451\u043d\u043d\u044b\u0439 URL \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u043a\u043e\u0440\u0440\u0435\u043a\u0442\u043d\u044b\u043c \u0430\u0434\u0440\u0435\u0441\u043e\u043c \u044d\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0439 \u043f\u043e\u0447\u0442\u044b. \u0412\u044b \u0436\u0435\u043b\u0430\u0435\u0442\u0435 \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043f\u0440\u0435\u0444\u0438\u043a\u0441 \u00abmailto:\u00bb?",
"Insert\/edit link": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c\/\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0441\u044b\u043b\u043a\u0443",
"Insert\/edit video": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c\/\u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0432\u0438\u0434\u0435\u043e",
"Poster": "\u0418\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0435",
"Alternative source": "\u0410\u043b\u044c\u0442\u0435\u0440\u043d\u0430\u0442\u0438\u0432\u043d\u044b\u0439 \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a",
"Paste your embed code below:": "\u0412\u0441\u0442\u0430\u0432\u044c\u0442\u0435 \u0432\u0430\u0448 \u043a\u043e\u0434 \u043d\u0438\u0436\u0435:",
"Insert video": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0432\u0438\u0434\u0435\u043e",
"Embed": "\u041a\u043e\u0434 \u0434\u043b\u044f \u0432\u0441\u0442\u0430\u0432\u043a\u0438",
"Nonbreaking space": "\u041d\u0435\u0440\u0430\u0437\u0440\u044b\u0432\u043d\u044b\u0439 \u043f\u0440\u043e\u0431\u0435\u043b",
"Page break": "\u0420\u0430\u0437\u0440\u044b\u0432 \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u044b",
"Paste as text": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043a\u0430\u043a \u0442\u0435\u043a\u0441\u0442",
"Preview": "\u041f\u0440\u0435\u0434\u043f\u0440\u043e\u0441\u043c\u043e\u0442\u0440",
"Print": "\u041f\u0435\u0447\u0430\u0442\u044c",
"Save": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
"Could not find the specified string.": "\u0417\u0430\u0434\u0430\u043d\u043d\u0430\u044f \u0441\u0442\u0440\u043e\u043a\u0430 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u0430",
"Replace": "\u0417\u0430\u043c\u0435\u043d\u0438\u0442\u044c",
"Next": "\u0412\u043d\u0438\u0437",
"Whole words": "\u0421\u043b\u043e\u0432\u043e \u0446\u0435\u043b\u0438\u043a\u043e\u043c",
"Find and replace": "\u041f\u043e\u0438\u0441\u043a \u0438 \u0437\u0430\u043c\u0435\u043d\u0430",
"Replace with": "\u0417\u0430\u043c\u0435\u043d\u0438\u0442\u044c \u043d\u0430",
"Find": "\u041d\u0430\u0439\u0442\u0438",
"Replace all": "\u0417\u0430\u043c\u0435\u043d\u0438\u0442\u044c \u0432\u0441\u0435",
"Match case": "\u0423\u0447\u0438\u0442\u044b\u0432\u0430\u0442\u044c \u0440\u0435\u0433\u0438\u0441\u0442\u0440",
"Prev": "\u0412\u0432\u0435\u0440\u0445",
"Spellcheck": "\u041f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u043f\u0440\u0430\u0432\u043e\u043f\u0438\u0441\u0430\u043d\u0438\u0435",
"Finish": "\u0417\u0430\u043a\u043e\u043d\u0447\u0438\u0442\u044c",
"Ignore all": "\u0418\u0433\u043d\u043e\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0432\u0441\u0435",
"Ignore": "\u0418\u0433\u043d\u043e\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c",
"Add to Dictionary": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0432 \u0441\u043b\u043e\u0432\u0430\u0440\u044c",
"Insert row before": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043f\u0443\u0441\u0442\u0443\u044e \u0441\u0442\u0440\u043e\u043a\u0443 \u0441\u0432\u0435\u0440\u0445\u0443",
"Rows": "\u0421\u0442\u0440\u043e\u043a\u0438",
"Height": "\u0412\u044b\u0441\u043e\u0442\u0430",
"Paste row after": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0441\u0442\u0440\u043e\u043a\u0443 \u0441\u043d\u0438\u0437\u0443",
"Alignment": "\u0412\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435",
"Border color": "\u0426\u0432\u0435\u0442 \u0440\u0430\u043c\u043a\u0438",
"Column group": "\u0413\u0440\u0443\u043f\u043f\u0430 \u043a\u043e\u043b\u043e\u043d\u043e\u043a",
"Row": "\u0421\u0442\u0440\u043e\u043a\u0430",
"Insert column before": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u0442\u043e\u043b\u0431\u0435\u0446 \u0441\u043b\u0435\u0432\u0430",
"Split cell": "\u0420\u0430\u0437\u0431\u0438\u0442\u044c \u044f\u0447\u0435\u0439\u043a\u0443",
"Cell padding": "\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u0438\u0439 \u043e\u0442\u0441\u0442\u0443\u043f",
"Cell spacing": "\u0412\u043d\u0435\u0448\u043d\u0438\u0439 \u043e\u0442\u0441\u0442\u0443\u043f",
"Row type": "\u0422\u0438\u043f \u0441\u0442\u0440\u043e\u043a\u0438",
"Insert table": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0442\u0430\u0431\u043b\u0438\u0446\u0443",
"Body": "\u0422\u0435\u043b\u043e",
"Caption": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
"Footer": "\u041d\u0438\u0437",
"Delete row": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u0442\u0440\u043e\u043a\u0443",
"Paste row before": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0441\u0442\u0440\u043e\u043a\u0443 \u0441\u0432\u0435\u0440\u0445\u0443",
"Scope": "Scope",
"Delete table": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0442\u0430\u0431\u043b\u0438\u0446\u0443",
"H Align": "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u043e\u0435 \u0432\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435",
"Top": "\u041f\u043e \u0432\u0435\u0440\u0445\u0443",
"Header cell": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
"Column": "\u0421\u0442\u043e\u043b\u0431\u0435\u0446",
"Row group": "\u0413\u0440\u0443\u043f\u043f\u0430 \u0441\u0442\u0440\u043e\u043a",
"Cell": "\u042f\u0447\u0435\u0439\u043a\u0430",
"Middle": "\u041f\u043e \u0441\u0435\u0440\u0435\u0434\u0438\u043d\u0435",
"Cell type": "\u0422\u0438\u043f \u044f\u0447\u0435\u0439\u043a\u0438",
"Copy row": "\u041a\u043e\u043f\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0442\u0440\u043e\u043a\u0443",
"Row properties": "\u041f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u044b \u0441\u0442\u0440\u043e\u043a\u0438",
"Table properties": "\u0421\u0432\u043e\u0439\u0441\u0442\u0432\u0430 \u0442\u0430\u0431\u043b\u0438\u0446\u044b",
"Bottom": "\u041f\u043e \u043d\u0438\u0437\u0443",
"V Align": "\u0412\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c\u043d\u043e\u0435 \u0432\u044b\u0440\u0430\u0432\u043d\u0438\u0432\u0430\u043d\u0438\u0435",
"Header": "\u0428\u0430\u043f\u043a\u0430",
"Right": "\u041f\u043e \u043f\u0440\u0430\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
"Insert column after": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u0442\u043e\u043b\u0431\u0435\u0446 \u0441\u043f\u0440\u0430\u0432\u0430",
"Cols": "\u0421\u0442\u043e\u043b\u0431\u0446\u044b",
"Insert row after": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043f\u0443\u0441\u0442\u0443\u044e \u0441\u0442\u0440\u043e\u043a\u0443 \u0441\u043d\u0438\u0437\u0443",
"Width": "\u0428\u0438\u0440\u0438\u043d\u0430",
"Cell properties": "\u041f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u044b \u044f\u0447\u0435\u0439\u043a\u0438",
"Left": "\u041f\u043e \u043b\u0435\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
"Cut row": "\u0412\u044b\u0440\u0435\u0437\u0430\u0442\u044c \u0441\u0442\u0440\u043e\u043a\u0443",
"Delete column": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u0442\u043e\u043b\u0431\u0435\u0446",
"Center": "\u041f\u043e \u0446\u0435\u043d\u0442\u0440\u0443",
"Merge cells": "\u041e\u0431\u044a\u0435\u0434\u0438\u043d\u0438\u0442\u044c \u044f\u0447\u0435\u0439\u043a\u0438",
"Insert template": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0448\u0430\u0431\u043b\u043e\u043d",
"Templates": "\u0428\u0430\u0431\u043b\u043e\u043d\u044b",
"Background color": "\u0426\u0432\u0435\u0442 \u0444\u043e\u043d\u0430",
"Custom...": "\u0412\u044b\u0431\u0440\u0430\u0442\u044c\u2026",
"Custom color": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c\u0441\u043a\u0438\u0439 \u0446\u0432\u0435\u0442",
"No color": "\u0411\u0435\u0437 \u0446\u0432\u0435\u0442\u0430",
"Text color": "\u0426\u0432\u0435\u0442 \u0442\u0435\u043a\u0441\u0442\u0430",
"Show blocks": "\u041f\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u0442\u044c \u0431\u043b\u043e\u043a\u0438",
"Show invisible characters": "\u041f\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u0442\u044c \u043d\u0435\u0432\u0438\u0434\u0438\u043c\u044b\u0435 \u0441\u0438\u043c\u0432\u043e\u043b\u044b",
"Words: {0}": "\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u0441\u043b\u043e\u0432: {0}",
"Insert": "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c",
"File": "\u0424\u0430\u0439\u043b",
"Edit": "\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c",
"Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u0422\u0435\u043a\u0441\u0442\u043e\u0432\u043e\u0435 \u043f\u043e\u043b\u0435. \u041d\u0430\u0436\u043c\u0438\u0442\u0435 ALT-F9 \u0447\u0442\u043e\u0431\u044b \u0432\u044b\u0437\u0432\u0430\u0442\u044c \u043c\u0435\u043d\u044e, ALT-F10 \u043f\u0430\u043d\u0435\u043b\u044c \u0438\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u043e\u0432, ALT-0 \u0434\u043b\u044f \u0432\u044b\u0437\u043e\u0432\u0430 \u043f\u043e\u043c\u043e\u0449\u0438.",
"Tools": "\u0418\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u044b",
"View": "\u0412\u0438\u0434",
"Table": "\u0422\u0430\u0431\u043b\u0438\u0446\u0430",
"Format": "\u0424\u043e\u0440\u043c\u0430\u0442"
});
(function () {
    // TODO move to .config section of module
    angular.module('babycompy.base').constant('ApiUrl', {
        protocol: 'http',
        version: 'v1',
        apiPrefix: 'api'
    })
    .constant('webSocketsEndpoint', {
        protocol: 'ws',
        path: '/ws/entitiesListen'
    });
})();
(function() {
    angular.module('babycompy')
        .controller('indexController', ['seoService', '$translate', '$state', 'authService', 'openGraph', function(seoService, $translate, $state, authService, appConstants) {

            $translate('general.shareDescription').then(function(translations) {
                if ($state.current.url === "/") {
                    seoService._title = $translate.instant('seo.mainPageTitle');
                    seoService._description = translations;
                    seoService._keywords = seoService._defaultKeywords;
                    seoService._ogTitle = seoService._defaultTitle;
                    seoService._ogDescription = translations;
                    seoService._ogImage = appConstants.defaultImage;
                }
            });


            var indexController = function() {
                onClick();
                this.onClick = onClick;
                if (navigator.userAgent.search("Firefox") > -1) {
                    angular.element('#signUpSvg').remove();
                    angular.element('#signUpSvgParent')
                        .prepend('<svg id="signUpSvg" class="icon child"><use xlink:href="#child"></use></svg>');
                    angular.element('#signInSvg').remove();
                    angular.element('#signInSvgParent')
                        .prepend('<svg id="signInSvg" class="icon sign-in"><use xlink:href="#sign-in"></use></svg>');
                }
            };
            var onClick = function() {
                var isLogged = authService.isLoggedIn();
                this.path = isLogged ? '' : '/signUp/user';
            }
            return new indexController();
        }])
})();

(function() {
    'use strict';

    angular
        .module('babycompy')
        .config(['$locationProvider', '$stateProvider', '$urlRouterProvider', '$httpProvider', '$logProvider', '$compileProvider',
            '$translateProvider', '$facebookProvider', 'facebook', 'GooglePlusProvider', 'google', 'vcRecaptchaServiceProvider',
            config
        ]);

    /** @ngInject */
    function config($locationProvider, $stateProvider, $urlRouterProvider, $httpProvider, $logProvider, $compileProvider,
        $translateProvider, $facebookProvider, facebook, GooglePlusProvider, google, vcRecaptchaServiceProvider) {
        $locationProvider.html5Mode(true);

        $logProvider.debugEnabled(false);
        // $compileProvider.debugInfoEnabled(false);

        $stateProvider.state('index', {
            url: '/',
            views: {
                promo_menu_ruler: { templateUrl: 'app/main/html/promoMenuRuler.html', controller: 'mainSliderController as sliderCtrl'},
                'content-wrapper': {
                    templateUrl: 'app/main/html/main.html'
                },
                'content@index': {
                  templateUrl: 'app/main/html/content.html'
                },
                header: { templateUrl: 'app/main/html/header.html' },
                footer: { templateUrl: 'app/main/html/footer.html' }
            },
            breadcrumb: '{{ "main.main" | translate }}'
        });

        $urlRouterProvider.otherwise('/notFound');

        $httpProvider.interceptors.push(['$rootScope', '$q',
            function($rootScope, $q) {

                return {
                    'request': function(config) {
                        $rootScope.requestLoading = true;
                        return config;
                    },

                    'response': function(response) {
                        $rootScope.requestLoading = false;
                        return response;
                    },

                    'responseError': function(response) {
                        $rootScope.requestLoading = false;
                        return $q.reject(response);
                    }
                };
            }
        ]);


        $locationProvider.html5Mode(true);

        $translateProvider.useStaticFilesLoader({
            prefix: 'app/translations/locale-',
            suffix: '.json'
        }).preferredLanguage('ru');
        $translateProvider.useLoaderCache(true);
        $translateProvider.useMessageFormatInterpolation();

        $facebookProvider.setAppId(facebook.appId);
        $facebookProvider.setPermissions('email');
        $facebookProvider.setVersion(facebook.apiVersion);

        GooglePlusProvider.setScopes('https://www.googleapis.com/auth/plus.login email');
        GooglePlusProvider.init({
            clientId: google.clientId,
            apiKey: google.apiKey
        });


        //Init facebook js
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.7";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        //captcha setting
        vcRecaptchaServiceProvider.setSiteKey('6Leg8B0TAAAAAOdwXp60y5GmsKvMEs5J1KLCqZtw');
        vcRecaptchaServiceProvider.setTheme('light');
        vcRecaptchaServiceProvider.setSize('normal');
        vcRecaptchaServiceProvider.setType('image');
    }
})();

angular.module("babycompy").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/clinics/clinics.html","<div class=\"default-block search-users\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-translate=\"clinicSearch.pageTitle\"></h1></div><div class=\"block-content\"><form class=\"search-users-filter\" id=\"search-form-filter\"><fieldset class=\"row\"><div class=\"col-sm-4\"><location-select data-country=\"c.searchFormParameters.country\" data-region=\"c.searchFormParameters.region\" data-city=\"c.searchFormParameters.city\"></location-select></div><div class=\"col-sm-4\"><select-clinic-type data-value=\"c.searchFormParameters.type\" data-placeholder=\"{{\'clinicSearch.clinicType\' | translate}}\"></select-clinic-type><select-clinic-department data-value=\"c.searchFormParameters.department\" data-placeholder=\"{{\'clinicSearch.clinicDepartment\' | translate}}\"></select-clinic-department><search-clinic-service data-required=\"false\" data-placeholder=\"{{\'clinicSearch.clinicService\' | translate}}\" data-search-form-parameters=\"c.searchFormParameters\"></search-clinic-service></div><div class=\"col-sm-4\"><div class=\"form-group\"><input id=\"search-user-name\" type=\"text\" name=\"clinicName\" class=\"form-control\" placeholder=\"{{\'clinicSearch.clinicName\' | translate}}\" maxlength=\"512\" data-ng-model=\"c.searchFormParameters.name\"> <label for=\"search-user-name\" class=\"sr-only\"></label></div><div class=\"form-group\"><button class=\"btn btn-default btn-block\" data-ng-click=\"c.searchWithFormParameters()\" data-translate=\"clinicSearch.search\"></button></div><div class=\"form-group\"><button class=\"btn btn-info btn-block\" data-ng-click=\"c.reset()\" data-translate=\"clinicSearch.clear\"></button></div></div></fieldset></form><div class=\"search-users-result\"><div class=\"search-result-controls clearfix\"><div class=\"search-result-size pull-left\" data-ng-bind-html=\"\'clinicSearch.itemsFoundCount\' | translate:c.requestBounds\"></div><div class=\"search-result-sorting pull-right\"></div></div><div class=\"search-result-list\"><div class=\"row\"><div class=\"col-sm-6 col-lg-4\" data-ng-repeat=\"i in c.data track by $index\"><div class=\"search-user-profile\"><share-buttons data-only-star=\"true\" data-article=\"i\" data-type=\"c.favoriteType\"></share-buttons><figure><a data-ui-sref=\"index.clinics.details({\'uuid\' : i.uuid})\"><img data-object-fit=\"cover\" data-ng-src=\"{{\'api/v1/files/\' + i.photo + \'?ratio=90\'}}\" alt=\"{{\'seo.alt.photo\' | translate}}\" data-ng-show=\"i.photo\"> <img data-ng-src=\"/assets/images/clinic-no-photo.png\" alt=\"{{\'seo.alt.nophoto\' | translate}}\" data-ng-show=\"!i.photo\"></a></figure><div class=\"information\"><a title=\"{{i.name}}\" data-ui-sref=\"index.clinics.details({\'uuid\' : i.uuid})\" class=\"name\">{{i.name | dot:60}}</a><address>{{(i.address | dot:60) + \',\'}} <span>{{i.city}}</span></address></div></div></div></div></div><nav><pager data-total=\"c.requestBounds.total\" data-offset=\"c.dataBounds.offset\" data-limit=\"c.dataBounds.limit\"></pager></nav></div></div></div>");
$templateCache.put("app/components/comments/comments.html","<div class=\"comments clearfix\"><div class=\"loader\" data-ng-show=\"commCtrl.showLoader\"><svg class=\"icon spin\"><use xlink:href=\"#spin\"></use></svg></div><h4 data-ng-if=\"!noHead\" class=\"comments-head\" translate=\"comments.comments\"></h4><span data-ng-if=\"!noHead\" class=\"badge badge-up\">{{commCtrl.total}}</span><div data-ng-if=\"!commCtrl.user\" class=\"alert alert-info alert-login\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg><span class=\"text-muted\">{{\'comments.login\' | translate}}</span> <a data-ui-sref=\"index.login\">{{\'comments.authorise\' | translate}}</a></div><div class=\"wrapcenter\" data-ng-show=\"commCtrl.data.length < commCtrl.total\"><div class=\"center\"><button type=\"button\" data-ng-click=\"commCtrl.getComments({offset: true})\" class=\"btn btn-more\">{{(\'general.more\' | translate) + \' \' + (commCtrl.total - commCtrl.data.length)}}</button></div></div><div class=\"left left-noBorder\" data-ng-show=\"commCtrl.data.length < commCtrl.total\"></div><div class=\"comments-users clearfix\" data-ng-repeat=\"comment in commCtrl.data\"><div class=\"wrapcenter\"><div class=\"center\"><div ng-class=\"{\'comments-users-doctorName\': comment.author.doctor, \'comments-users-adminName\': comment.author.admin}\" class=\"comments-users-name\"><div class=\"f-g1\"><div class=\"name\" ng-click=\"commCtrl.openDoctor(comment)\"><span data-ng-hide=\"comment.author.admin\">{{comment.author.firstName + \' \' + (comment.author.lastName || \'\')}}</span> <span data-ng-show=\"comment.author.admin\">BabyCompy</span></div><small data-ng-repeat=\"spec in comment.author.specialization\">{{spec + \" \"}}</small></div><small class=\"f-sh0 f-as-end\">{{comment.creationTime | date: \'d MMMM HH:mm\'}}</small></div><div class=\"comments-users-text\"><span class=\"text\" data-ng-bind-html=\"comment.text | lineBreak\"></span> <button data-ng-if=\"commCtrl.user && !commCtrl.user.hidden\" ng-hide=\"comment.complaint\" type=\"button\" class=\"btn btn-noStyle\" data-template-url=\"app/components/comments/popover.html\" data-placement=\"auto\" data-auto-close=\"1\" bs-popover=\"\"><svg class=\"icon ellipsis-h\"><use xlink:href=\"#ellipsis-h\"></use></svg></button> <button data-ng-if=\"commCtrl.user\" type=\"button\" class=\"btn btn-noStyle answer\" data-ng-click=\"commCtrl.answer(comment)\">{{\'comments.answer\' | translate}}</button></div></div></div><div class=\"left\"><img data-ng-hide=\"comment.author.avatar || comment.author.admin\" data-ng-src=\"{{\'assets/images/user-no-photo.png\'}}\" alt=\"user avatar\"> <img data-ng-hide=\"comment.author.admin || !comment.author.avatar\" data-object-fit=\"cover\" data-ng-src=\"{{\'api/v1/files/\' + comment.author.avatar}}\" alt=\"user avatar\"> <img data-ng-show=\"comment.author.admin\" data-ng-src=\"{{\'api/v1/files/4d90b3c6-a990-4e04-a25c-3ac8de6c1e14\'}}\" alt=\"user avatar\"></div></div><div data-ng-if=\"commCtrl.user && !commCtrl.user.hidden\" class=\"wrapcenter post-comment\"><div class=\"center\"><form class=\"comments-textarea\"><button type=\"button\" data-ng-click=\"commCtrl.postComment()\" class=\"btn btn-send\" data-ng-class=\"{\'btn-disabled\': !commCtrl.comment}\"><svg class=\"icon send\"><use xlink:href=\"#send\"></use></svg></button> <textarea placeholder=\"{{\'comments.comment\' | translate}}\" data-ng-model=\"commCtrl.comment\" maxlength=\"2000\" name=\"comment\"></textarea></form></div></div><div data-ng-if=\"commCtrl.user && !commCtrl.user.hidden\" class=\"left post-comment\"><img data-object-fit=\"cover\" data-ng-if=\"commCtrl.user.avatar || commCtrl.user.photo\" data-ng-src=\"{{\'api/v1/files/\' + (commCtrl.user.avatar || commCtrl.user.photo)}}\" alt=\"user avatar\"> <img data-ng-hide=\"commCtrl.user.avatar || commCtrl.user.photo\" data-ng-src=\"{{\'assets/images/user-no-photo.png\'}}\" alt=\"user avatar\"></div></div>");
$templateCache.put("app/components/comments/complainModal.html","<div class=\"modal\" tabindex=\"-1\" id=\"startAlgorithmConfirmModal\"><div class=\"modal-dialog modal-complain\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-ng-click=\"$hide()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"comments.complain\"></h4></div><div class=\"modal-body\"><form><div class=\"radio-custom\"><label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"0\"> <span class=\"circle\"></span> {{\'complain.spam\' | translate}}</label> <label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"1\"> <span class=\"circle\"></span> {{\'complain.affront\' | translate}}</label> <label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"2\"> <span class=\"circle\"></span> {{\'complain.adult\' | translate}}</label> <label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"3\"> <span class=\"circle\"></span> {{\'complain.drugPromotion\' | translate}}</label> <label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"4\"> <span class=\"circle\"></span> {{\'complain.childPorn\' | translate}}</label> <label><input type=\"radio\" data-ng-model=\"commCtrl.complainVal\" value=\"5\"> <span class=\"circle\"></span> {{\'complain.violence\' | translate}}</label></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" data-ng-click=\"commCtrl.postComplain();$hide()\" data-translate=\"general.ok\"></button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"$hide()\" data-translate=\"general.cancel\"></button></div></div></div></div>");
$templateCache.put("app/components/comments/popover.html","<div class=\"popover popover-custom\" tabindex=\"-1\"><div class=\"arrow\"></div><button data-ng-hide=\"commCtrl.user.uuid === comment.author.uuid\" type=\"button\" class=\"btn\" data-ng-click=\"commCtrl.complain(comment); $hide()\"><svg class=\"icon\"><use xlink:href=\"#bullhorn\"></use></svg><span data-ng-bind-html=\"&nbsp;(\'comments.complain\' | translate)\"></span></button> <button type=\"button\" class=\"btn\" data-ng-click=\"commCtrl.deleteComment(comment.uuid);$hide()\" data-ng-show=\"commCtrl.user.uuid === comment.author.uuid\"><svg class=\"icon\"><use xlink:href=\"#trash\"></use></svg>{{\'general.delete\' | translate}}</button></div>");
$templateCache.put("app/components/doctorSearch/doctorSearch.html","<div class=\"default-block\"><div class=\"row content-empty\" ng-controller=\"indexController as c\"><div style=\"font-size: 17px; line-height: 20px;\" class=\"col-md-offset-1 col-md-10 text-center\"><br><img class=\"img-responsive\" style=\"max-width: 390px; display: inline-block; margin: 25px 10% 38px;\" src=\"assets/images/promo/doctors_cap.svg\" alt=\"\"><h2 translate=\"doctorSearch.disabled.title\"></h2><p translate=\"doctorSearch.disabled.post\"></p><br><p translate=\"doctorSearch.disabled.postTwo\"></p><br><p ng-controller=\"doctorSearchController as e\" ng-hide=\"e.userLoggedIn\">Раздел еще в процессе разработки, поэтому <a style=\"cursor:pointer\" data-ng-click=\"c.onClick()\" data-ng-href=\"{{c.path}}\">регистрируйтесь</a>, чтобы первым узнать о запуске!</p><br></div></div></div>");
$templateCache.put("app/components/medics/medics.html","<div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-translate=\"medic.info.title\"></h1></div><hr><div class=\"block-content\"><div class=\"row doctor-question-content\"><div class=\"col-sm-3 col-sm-push-9\"><figure class=\"doctor-question-image\"><img class=\"img-responsive\" src=\"assets/images/user-no-photo.png\" alt=\"{{\'seo.alt.nophoto\' | translate}}\" data-ng-show=\"!c.doctor.photo\"> <img class=\"img-responsive\" data-ng-src=\"{{\'api/v1/files/\' + c.doctor.photo}}\" alt=\"{{\'seo.alt.photo\' | translate}}\" data-ng-show=\"c.doctor.photo\"></figure></div><div class=\"col-sm-9 col-sm-pull-3\"><p><b>{{c.doctorName}}</b></p><p data-translate=\"medic.info.subtitle1\"></p><p><span data-translate=\"medic.info.doctorRespond\"></span></p><p data-translate=\"medic.info.subtitle2\"></p><br class=\"hidden-xs hidden-sm\"><button class=\"btn btn-primary doctor-question-button\" data-toggle=\"modal\" data-target=\"#doctorQuestionModal\" data-translate=\"medic.askDoctor\" data-ng-if=\"!c.user.doctor\" data-ng-click=\"c.askDoctor()\"></button><br></div></div></div><hr><div class=\"block-content\"><h3 data-translate=\"medic.info.rubrics\"></h3><div class=\"block-tags\"><a data-ng-repeat=\"rubric in c.rubrics\" data-ui-sref=\"index.medics.answers({\'rubricUUID\': rubric.uuid})\">{{rubric.name}}</a></div></div><hr><div class=\"block-content\"><h3 data-translate=\"medic.info.newQuestions\"></h3><br><ul class=\"block-content-list block-content-list-md no-margin-side\"><li data-ng-repeat=\"answer in c.latestAnswers\"><a data-ui-sref=\"index.medics.answers.article({\'articleUUID\': answer.uuid, \'rubricUUID\': answer.rubricUuid})\"><svg class=\"icon hover question-circle\"><use xlink:href=\"#question-circle\"></use></svg><b class=\"text\">{{answer.name}}</b></a></li></ul><br></div></div>");
$templateCache.put("app/components/menu/menu.template.html","<nav class=\"main-menu\" id=\"main-menu\" data-menu-hamburger=\"\"><div class=\"container\"><div class=\"mm-hamburger-block visible-sm visible-xs\"><div class=\"mm-hamburger\"><div class=\"mm-hamburger-inner\"><span>&nbsp;</span></div></div></div><div class=\"mm-search visible-sm visible-xs\"><form data-ng-submit=\"search()\" class=\"input-group\"><input autocomplete=\"off\" placeholder=\"{{ \'headerNavBar.search\' | translate }}\" id=\"mm-search\" type=\"text\" class=\"form-control\" data-ng-model=\"searchText\"> <label for=\"mm-search\" class=\"sr-only\"></label> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><svg class=\"icon search\"><use xlink:href=\"#search\"></use></svg></button></span></form></div><ul class=\"list-unstyled mm-dropdown\"><li data-ui-sref-active=\"active\" data-ng-repeat=\"category in menuCategories\"><div class=\"btn-group\"><button id=\"mainMenuDrDwn\" type=\"button\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-bs-dropdown=\"\">{{ category.name }} <span class=\"caret\"></span> <span class=\"caret-angle-left\"><svg class=\"icon angle-left\"><use xlink:href=\"#angle-left\"></use></svg></span> <span class=\"caret-angle-down\"><svg class=\"icon angle-down\"><use xlink:href=\"#angle-down\"></use></svg></span></button><ul class=\"dropdown-menu\"><li data-ui-sref-active=\"active\" data-ng-repeat=\"child in category.links\"><a data-ui-sref=\"{{ child.href }}\">{{::child.name}}</a></li></ul><a ng-if=\"category.state\" data-ui-sref=\"{{ category.state }}\"></a></div></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.doctorSearch\"><span data-translate=\"menu.doctors\"></span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.clinics\"><span data-translate=\"menu.clinics\"></span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.medicine\"><span data-translate=\"menu.medication\"></span></a></li></ul></div></nav>");
$templateCache.put("app/components/mobileApps/mobileApps.html","<div class=\"default-block\"><div class=\"block-content\"><div class=\"mobile-apps\"><div class=\"text-center\"><h2 data-translate=\"mobileApps.title\"></h2><blockquote data-translate=\"mobileApps.blockquote\"></blockquote><p data-translate=\"mobileApps.description\"></p><p data-translate=\"mobileApps.descriptionHelp\"></p><div class=\"mobile-apps-link\"><a href=\"https://itunes.apple.com/us/app/mobile-security-cloud-mdm/id1113948225?mt=8\" target=\"_blank\"><img class=\"img-responsive\" src=\"assets/images/apple_store_badge.svg\" alt=\"Приложение в AppStore\"></a> <a href=\"https://play.google.com/store/apps/details?id=com.babycompy\" target=\"_blank\"><img class=\"img-responsive\" src=\"assets/images/google_play_badge.svg\" alt=\"Приложение в GooglePlay\"></a></div></div><div class=\"row\"><div class=\"col-md-6\"><figure><img class=\"img-responsive\" src=\"assets/images/phones-apps.png\" alt=\"\"></figure></div><div class=\"col-md-6\"><h4 data-translate=\"mobileApps.whySet.title\"></h4><p data-translate=\"mobileApps.whySet.professionalism\"></p><p data-translate=\"mobileApps.whySet.personalization\"></p><p data-translate=\"mobileApps.whySet.other\"></p></div></div><div class=\"row mobile-advantages\"><div class=\"col-sm-4\"><figure><img class=\"img-responsive\" src=\"assets/images/mobile-advantages-doctor.svg\"><figcaption><b data-translate=\"mobileApps.advantages.doctor\"></b><br><p data-translate=\"mobileApps.advantages.doctorDescription\"></p></figcaption></figure></div><div class=\"col-sm-4\"><figure><img class=\"img-responsive calendar-fixed\" src=\"assets/images/mobile-advantages-calendar.svg\"><figcaption><b data-translate=\"mobileApps.advantages.calendar\"></b><br><p data-translate=\"mobileApps.advantages.calendarDescription\"></p></figcaption></figure></div><div class=\"col-sm-4\"><figure><img class=\"img-responsive\" src=\"assets/images/mobile-advantages-blog.svg\"><figcaption><b data-translate=\"mobileApps.advantages.blog\"></b><br><p data-translate=\"mobileApps.advantages.blogDescription\"></p></figcaption></figure></div></div></div></div></div>");
$templateCache.put("app/components/notFound/notFound.html","<div class=\"default-block\"><div class=\"block-content page-no-found\"><figure class=\"step-one\" style=\"display: none;\"><img src=\"assets/images/baby_crying\" alt=\"{{\'seo.alt.notfound\' | translate}}\"><figcaption>Ой! Похоже мы не можем найти нужную вам страницу...<br>Но вы не расстраивайтесь, а лучше попробуйте чуть позже :)</figcaption></figure><div class=\"step-two\"><figure><img src=\"assets/images/404.svg\" alt=\"{{\'seo.alt.notfound\' | translate}}\"><figcaption>Здесь нет ничего, кроме детских вещей:)</figcaption></figure><div class=\"full-width-image\"><img src=\"assets/images/baby_clothes_404.svg\" alt=\"{{\'seo.alt.notfound\' | translate}}\"></div></div></div></div>");
$templateCache.put("app/components/pager/pager.html","<ul class=\"pagination\" ng-show=\"pagesTotal > 1\"><li data-ng-click=\"page(currentPage - 1)\" data-ng-class=\"{\'disabled\': currentPage === 0}\"><a id=\"previousBtn\" aria-label=\"Previous\" href=\"#\"><svg aria-hidden=\"true\" class=\"icon angle-double-left\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle-double-left\"></use></svg></a></li><li data-ng-repeat=\"p in pages track by p.index\" data-ng-class=\"{\'active\': currentPage==p.index}\" data-ng-click=\"page(p.index)\"><span data-ng-if=\"!p.ellipsis\">{{p.index + 1}}</span> <span data-ng-if=\"p.ellipsis\">...</span></li><li data-ng-click=\"page(currentPage + 1)\" data-ng-class=\"{\'disabled\': (currentPage === pagesTotal - 1) || (currentPage===pagesTotal) }\"><a id=\"nextBtn\" aria-label=\"Next\" href=\"#\"><svg aria-hidden=\"true\" class=\"icon angle-double-right\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle-double-right\"></use></svg></a></li></ul>");
$templateCache.put("app/components/ruler/ruler.template.html","<div class=\"range-age\"><div class=\"container\"><div class=\"btn-toolbar\"><div class=\"btn-group-block age-level-one\"><div class=\"btn-group-label\" data-translate=\"ruler.theFirstMonthOfLife\"></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"0\"><span data-translate=\"ruler.newborn\"></span></a></div></div><div class=\"btn-group-block age-level-two\"><div class=\"btn-group-label\" data-translate=\"ruler.infantsAgedUpToOneYear\"></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"730\"><span class=\"age\">1</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"1460\"><span class=\"age\">2</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"2190\"><span class=\"age\">3</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"2920\"><span class=\"age\">4</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"3650\"><span class=\"age\">5</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"4380\"><span class=\"age\">6</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"5111\"><span class=\"age\">7</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"5841\"><span class=\"age\">8</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"6571\"><span class=\"age\">9</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"7301\"><span class=\"age\">10</span></a> <a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"8031\"><span class=\"age\">11</span></a></div></div><div class=\"btn-group-block age-level-three\"><div class=\"btn-group-label\" data-translate=\"ruler.preschoolPeriod\"></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"8761\"><span class=\"age\">1</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"17522\"><span class=\"age\">2</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"26282\"><span class=\"age\">3</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"35043\"><span class=\"age\">4</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"43804\"><span class=\"age\">5</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"52565\"><span class=\"age\">6</span></a></div></div><div class=\"btn-group-block age-level-four\"><div class=\"btn-group-label\" data-translate=\"ruler.schoolAndTeenPeriods\"></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" data-ng-click=\"setActive\" class=\"btn btn-primary\" data-age-min=\"61326\"><span data-age=\"\">7 - 12</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"113890\"><span data-age=\"\">13 - 15</span></a></div><div class=\"btn-group\"><a data-ui-sref-active=\"active\" class=\"btn btn-primary\" data-age-min=\"140173\"><span data-age=\"\">16 - 18</span></a></div></div></div></div></div>");
$templateCache.put("app/components/ruler/ruler.tooltip.html","<div class=\"popover range-age-popover\" role=\"tooltip\"><div class=\"popover-content\"><div data-ng-repeat=\"child in children\"><img data-ng-src=\"{{\'api/v1/files/\' + child.avatar}}\" data-ng-show=\"child.avatar != null\" width=\"30px\" alt=\"{{child.firstName}}\"> <img src=\"assets/images/my-children-no-photo.png\" data-ng-show=\"child.avatar == null\" width=\"30px\" alt=\"{{child.firstName}}\"> <span>{{ child.firstName + \' (\' + (child.birthDate | rulerTooltipAge) + \')\'}}</span></div></div></div>");
$templateCache.put("app/components/selectLocation/selectLocation.html","<div ng-class=\"{\'row\': inlineView}\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': parentForm[\'search-user-country\'].$error.required && parentForm.$submitted, \'col-sm-4\': inlineView}\"><label for=\"search-user-country\" data-ng-if=\"countryLabel\" data-ng-class=\"{\'required\': isRequired}\">{{ \'selectLocationLabel.countryLabel\' | translate }}</label><select data-ng-required=\"isRequired\" name=\"search-user-country\" class=\"form-control\" ng-class=\"{\'form-control-sm\': inlineView }\" id=\"search-user-country\" data-ng-model=\"selectedCountry\" data-ng-options=\"country.name for country in countries track by country.uuid\"><option value=\"\">{{ (countryPlaceholder || \'selectLocation.country\') | translate }}</option></select><p data-ng-show=\"parentForm[\'search-user-country\'].$error.required && parentForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"general.requiredField\"></span></p></div><div data-ng-show=\"!withoutRegionMode\" class=\"form-group\" data-ng-class=\"{\'has-required\': !withoutRegionMode && selectedCountry && parentForm[\'search-user-region\'].$error.required && parentForm.$submitted, \'col-sm-4\': inlineView}\"><label for=\"search-user-region\" data-ng-if=\"regionLabel\" data-ng-class=\"{\'required\': isRequired}\">{{ \'selectLocationLabel.regionLabel\' | translate }}</label><select data-ng-required=\"isRequired\" name=\"search-user-region\" class=\"form-control\" ng-class=\"{\'form-control-sm\': inlineView }\" id=\"search-user-region\" data-ng-disabled=\"!selectedCountry\" data-ng-model=\"selectedRegion\" data-ng-options=\"region.name for region in regions track by region.uuid\"><option value=\"\">{{ (regionPlaceholder || \'selectLocation.region\') | translate }}</option></select><p data-ng-show=\"!withoutRegionMode && selectedCountry && parentForm[\'search-user-region\'].$error.required && parentForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"general.requiredField\"></span></p></div><div class=\"form-group\" data-ng-show=\"!withoutRegionMode\" data-ng-class=\"{\'has-required\': !withoutRegionMode && selectedRegion && selectedCountry && parentForm[\'search-user-city\'].$error.required && parentForm.$submitted, \'col-sm-4\': inlineView}\"><label for=\"search-user-city\" data-ng-if=\"cityLabel\" data-ng-class=\"{\'required\': isRequired}\">{{ \'selectLocationLabel.cityLabel\' | translate }}</label><select data-ng-required=\"isRequired\" disabled=\"\" name=\"search-user-city\" class=\"form-control\" ng-class=\"{\'form-control-sm\': inlineView }\" id=\"search-user-city\" data-ng-disabled=\"!selectedCountry || !selectedRegion\" data-ng-model=\"selectedCity\" data-ng-options=\"city.name for city in cities track by city.uuid\"><option value=\"\">{{ (cityPlaceholder || \'selectLocation.city\') | translate }}</option></select><p data-ng-show=\"!withoutRegionMode && selectedRegion && selectedCountry && parentForm[\'search-user-city\'].$error.required && parentForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"general.requiredField\"></span></p></div><div class=\"form-group\" data-ng-show=\"withoutRegionMode\"><label for=\"search-user-city\" data-ng-if=\"cityLabel\">{{ \'selectLocationLabel.cityLabel\' | translate }}</label><ui-select data-ng-disabled=\"!selectedCountry\" id=\"search-user-services\" data-ng-model=\"selectedCity\" on-select=\"setValue($item, $model)\"><ui-select-match placeholder=\"{{(cityPlaceholder || \'selectLocation.city\') | translate}}\"><span data-ng-if=\"selectedCountry\" data-ng-bind=\"getValue().name\"></span></ui-select-match><ui-select-choices repeat=\"item in (citiesInCountry | filter: $select.search) track by item.uuid\" refresh-delay=\"100\"><span data-ng-bind=\"item.name\"></span></ui-select-choices></ui-select><label for=\"search-user-services\" class=\"sr-only\"></label></div></div>");
$templateCache.put("app/components/selectLocation/selectLocation.template.html","<fieldset><div class=\"form-group\"><select id=\"search-user-country\" data-ng-model=\"selectedCountry\" class=\"form-control\" data-ng-options=\"country.name for country in countries\"></select><label class=\"sr-only\">{{countryLabel}}</label></div><div class=\"form-group\"><select id=\"search-user-region\" data-ng-disabled=\"!selectedCountry\" data-ng-model=\"selectedRegion\" class=\"form-control\" data-ng-options=\"region.name for region in regions\"></select><label class=\"sr-only\">{{regionLabel}}</label></div><div class=\"form-group\"><select id=\"search-user-city\" data-ng-disabled=\"!selectedRegion\" data-ng-model=\"selectedCity\" class=\"form-control\" data-ng-options=\"city.name for city in cities\"></select><label class=\"sr-only\">{{cityLabel}}</label></div></fieldset>");
$templateCache.put("app/components/tabs/tabs.html","<ul class=\"nav\" ng-class=\"$navClass\" role=\"tablist\"><li role=\"presentation\" ng-repeat=\"$pane in $panes track by $index\" ng-class=\"[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' , tabs[$index].valid ? \'\' : \'notValid\']\"><a role=\"tab\" data-toggle=\"tab\" ng-class=\"{\'required\': tabs[$index].required}\" ng-click=\"!$pane.disabled && $setActive($pane.name || $index)\" data-index=\"{{ $index }}\" aria-controls=\"$pane.title\" href=\"\"><i class=\"fa fa-warning\"></i> {{$pane.title | translate}} &nbsp;<span class=\"badge badge-up badge-primary\" data-ng-if=\"tabs[$index].counter\">{{tabs[$index].counter}}</span></a></li></ul><div ng-transclude=\"\" class=\"tab-content\"></div>");
$templateCache.put("app/components/userProfileBadge/userProfileBadge.authorized.html","<div class=\"btn-group\"><button type=\"button\" class=\"btn dropdown-toggle header-btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-bs-dropdown=\"\" data-placement=\"bottom-right\"><span class=\"authorized-user-avatar\" data-placement=\"bottom\" data-delay=\"500,100\" data-title=\"{{user.firstName + \' \' + user.lastName}}\" bs-tooltip=\"\"><img data-object-fit=\"cover\" class=\"img-responsive\" data-ng-src=\"{{avatarPath}}\" alt=\"{{\'seo.alt.photo\' | translate}}\" data-ng-if=\"checkAvatar() && avatarPath\"> <img class=\"img-responsive\" src=\"/assets/images/user-no-photo.png\" alt=\"{{\'seo.alt.nophoto\' | translate}}\" data-ng-show=\"!checkAvatar() || !avatarPath\"></span></button><ul class=\"dropdown-menu with-arrow with-arrow_right\"><li><a data-ui-sref=\"{{user.doctor ? \'index.profile.doctor\': \'index.profile.user.edit\'}}\"><svg class=\"icon user\"><use xlink:href=\"#user\"></use></svg>{{\'userProfile.myProfile\' | translate}}</a></li><li ng-if=\"user.doctor\"><a data-ui-sref=\"index.profile.doctor.settings\"><svg class=\"icon user\"><use xlink:href=\"#settings\"></use></svg>{{\'doctorProfile.settings\' | translate}}</a></li><li class=\"divider\"></li><li><a href=\"#\" data-ng-click=\"logOut()\"><svg class=\"icon sign-out\"><use xlink:href=\"#sign-out\"></use></svg>{{\'userProfile.exit\' | translate}}</a></li></ul></div>");
$templateCache.put("app/components/userProfileBadge/userProfileBadge.html","<div class=\"header-fixed\"><div class=\"container\"><div class=\"row authorized-user\"><div class=\"pull-left\"><div class=\"header-navbar navbar-left\"><a href=\"/\" class=\"header-logo\"><img class=\"logo img-responsive\" src=\"assets/images/logo.svg\" alt=\"{{\'seo.alt.logo\' | translate}}\"> <img class=\"logo-small img-responsive\" src=\"assets/images/logo-small.svg\" alt=\"{{\'seo.alt.logo\' | translate}}\"></a></div></div><div class=\"header-search hidden-xs\"><form data-ng-submit=\"search()\" class=\"input-group\"><input autocomplete=\"off\" placeholder=\"{{ \'headerNavBar.search\' | translate }}\" id=\"header-search\" type=\"text\" class=\"form-control\" data-ng-model=\"searchText\"> <label for=\"header-search\" class=\"sr-only\"></label> <span class=\"input-group-btn\"><button class=\"btn\" type=\"submit\" data-ng-disabled=\"searchText.length === 0 || searchText === undefined\"><svg class=\"icon search\"><use xlink:href=\"#search\"></use></svg></button></span></form></div><div class=\"pull-right\"><div class=\"header-navbar header-navbar-noPadding navbar-right\"><nav class=\"header-nav\"><ul class=\"list-unstyled\"><li ui-sref-active=\"active\" data-ng-show=\"!user || (!!!algorithmsCount || algorithmsCount === 0)\"><button type=\"button\" class=\"btn header-btn\" data-ui-sref=\"index.algorithms\"><svg class=\"icon algorithms\" viewbox=\"0 0 64 56\" data-placement=\"bottom\" data-container=\".header-nav\" data-title=\"{{\'favoriteMenuTypes.algorithms\' | translate}}\" data-delay=\"500,100}\" bs-tooltip=\"\"><path d=\"M38.7,34.2c-2.9,1.3-7.6,1.3-10.5,0.1l-16.8-8.1v9.6c0,4.7,9.4,14.2,22.3,14.2c12.9,0,21.2-10.3,21.2-14.2v-9.6L38.7,34.2z M52.4,35.8c0,2.4-7,11.7-18.8,11.7c-11.8,0-19.8-8.8-19.8-11.7v-5.6l13.4,6.4l0.1,0c1.7,0.7,3.8,1.1,6,1.1c2.4,0,4.7-0.4,6.4-1.2l12.7-6.3V35.8z\"></path><path d=\"M62.7,15.6L37.6,4.1c-2.3-1-6-1.1-8.3-0.2L2.2,15.2c-2.7,1.1-2.9,3-0.4,4.1l27.1,12.9c2.5,1.2,6.6,1.1,9.1-0.1l25.1-12.6C65.3,18.4,65.1,16.7,62.7,15.6z M36.9,29.8c-0.9,0.4-2.2,0.7-3.6,0.7c0,0,0,0,0,0c-1.3,0-2.5-0.2-3.4-0.6L3.5,17.4L30.2,6.3C31,6,32,5.8,33.2,5.8c1.3,0,2.6,0.2,3.4,0.6l24.6,11.3L36.9,29.8z\"></path><path d=\"M3.3,19h2.3v19H3.3V19z\"></path><path d=\"M4.3,35c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3C1.3,36.3,2.6,35,4.3,35z\"></path></svg></button></li><li ng-class=\"{\'active\': $state.is(\'index.algorithms\')}\" data-ng-show=\"user && algorithmsCount > 0\" data-placement=\"bottom\" data-delay=\"500,100\" data-title=\"{{\'favoriteMenuTypes.algorithms\' | translate}}\" bs-tooltip=\"\"><div class=\"btn-group\"><button type=\"button\" class=\"btn dropdown-toggle header-btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-container=\"body\" data-placement=\"bottom\" data-bs-dropdown=\"\"><svg class=\"icon algorithms\" viewbox=\"0 0 64 56\"><path d=\"M38.7,34.2c-2.9,1.3-7.6,1.3-10.5,0.1l-16.8-8.1v9.6c0,4.7,9.4,14.2,22.3,14.2c12.9,0,21.2-10.3,21.2-14.2v-9.6L38.7,34.2z M52.4,35.8c0,2.4-7,11.7-18.8,11.7c-11.8,0-19.8-8.8-19.8-11.7v-5.6l13.4,6.4l0.1,0c1.7,0.7,3.8,1.1,6,1.1c2.4,0,4.7-0.4,6.4-1.2l12.7-6.3V35.8z\"></path><path d=\"M62.7,15.6L37.6,4.1c-2.3-1-6-1.1-8.3-0.2L2.2,15.2c-2.7,1.1-2.9,3-0.4,4.1l27.1,12.9c2.5,1.2,6.6,1.1,9.1-0.1l25.1-12.6C65.3,18.4,65.1,16.7,62.7,15.6z M36.9,29.8c-0.9,0.4-2.2,0.7-3.6,0.7c0,0,0,0,0,0c-1.3,0-2.5-0.2-3.4-0.6L3.5,17.4L30.2,6.3C31,6,32,5.8,33.2,5.8c1.3,0,2.6,0.2,3.4,0.6l24.6,11.3L36.9,29.8z\"></path><path d=\"M3.3,19h2.3v19H3.3V19z\"></path><path d=\"M4.3,35c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3C1.3,36.3,2.6,35,4.3,35z\"></path></svg><span class=\"badge badge-up\" data-ng-bind-html=\"algorithmsCount\"></span></button><div class=\"dropdown-menu question-dropdown with-arrow dropdown-sm\"><div class=\"dropdown-header\" data-translate=\"headerNavBar.algorithmsTitle\"></div><div class=\"dropdown-body\"><ul class=\"dropdown-list\"><li data-ng-repeat=\"algorithm in algorithms\"><a data-ui-sref=\"index.algorithms.group.algorithm.step({algorithmUuid: algorithm.algorithm, groupUuid: algorithm.group, stepUuid : algorithm.lastStep})\" style=\"width: 100%\"><svg class=\"icon play-circle-o\"><use xlink:href=\"#play-circle-o\"></use></svg><span class=\"name\">{{algorithm.name}}</span></a></li></ul></div><div class=\"dropdown-footer\"><a href=\"#\" class=\"btn btn-secondary\" data-ui-sref=\"index.algorithms\" data-translate=\"headerNavBar.allAlgorithms\"></a></div></div></div></li><li ui-sref-active=\"active\" data-ng-hide=\"answers.length\"><button type=\"button\" class=\"btn header-btn\" data-ui-sref=\"index.medics\"><svg class=\"icon doctorAnswers\" viewbox=\"0 0 55 65\" data-placement=\"bottom\" data-container=\".header-nav\" data-delay=\"500,100\" data-title=\"{{\'headerNavBar.doctorsAnswer\' | translate}}\" bs-tooltip=\"\"><path d=\"M25.5,42.1c-2.8,0-5.6-0.5-8.3-1.3c-0.4-0.1-0.7-0.2-1.1-0.2c-0.5,0-1.1,0.1-1.6,0.4l-8.9,4.5l3.1-6.2c0.7-1.4,0.4-3-0.7-4.1C4.5,31.5,2.5,27,2.5,22.3c0-10.9,10.3-19.8,23-19.8c12.7,0,23,8.9,23,19.8c0,1.8-0.3,3.6-0.8,5.2c0.8,0.3,1.5,0.7,2.3,1.2c0.7-2,1.1-4.2,1.1-6.4C51,10,39.6,0,25.5,0C11.4,0,0,10,0,22.3C0,27.9,2.4,33,6.2,36.9c0.3,0.3,0.4,0.8,0.2,1.2l-5,10.1C1,49,1.9,50,2.8,49.6l12.8-6.4c0.2-0.1,0.5-0.1,0.8-0.1c2.8,0.9,5.9,1.5,9.1,1.5c1.9,0,3.7-0.2,5.5-0.5c-0.5-0.7-0.8-1.5-1.1-2.3C28.5,42,27,42.1,25.5,42.1z\"></path><path d=\"M50.3,44.9c-0.1-0.2,0-0.4,0.1-0.5c1.6-1.6,2.6-3.7,2.6-6.1c0-5.1-4.8-9.3-10.6-9.3c-5.9,0-10.6,4.2-10.6,9.3c0,5.1,4.7,9.3,10.6,9.3c1.3,0,2.6-0.2,3.8-0.6c0.1,0,0.2,0,0.3,0l5.3,2.7c0.4,0.2,0.8-0.2,0.6-0.6L50.3,44.9z M47.8,44.8l-0.2-0.1c-0.4-0.2-0.9-0.3-1.3-0.3c-0.3,0-0.6,0.1-0.9,0.2c-1,0.3-2,0.5-3,0.5c-4.5,0-8.1-3-8.1-6.8c0-3.7,3.6-6.8,8.1-6.8s8.1,3,8.1,6.8c0,2-1,3.4-1.9,4.3C48,43.2,47.7,44,47.8,44.8z\"></path><path d=\"M30,18.4V13h-8.3v5.4h-5.6v8h5.6v5.4H30v-5.4h5.6v-8H30z M33.5,24.4h-5.6v5.4h-4.2v-5.4h-5.6v-4h5.6V15h4.2v5.4h5.6V24.4z\"></path></svg></button></li><li data-ng-if=\"user && !user.doctor && answers.length > 0\" ng-class=\"{\'active\': $state.is(\'index.medics\')}\" data-placement=\"bottom\" data-delay=\"500,100\" data-container=\".header-nav\" data-title=\"{{\'headerNavBar.doctorsAnswer\' | translate}}\" bs-tooltip=\"\"><div class=\"btn-group\"><button type=\"button\" class=\"btn dropdown-toggle header-btn\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-placement=\"bottom\" data-container=\"body\" data-bs-dropdown=\"\"><svg class=\"icon doctorAnswers\" viewbox=\"0 0 55 65\"><path d=\"M25.5,42.1c-2.8,0-5.6-0.5-8.3-1.3c-0.4-0.1-0.7-0.2-1.1-0.2c-0.5,0-1.1,0.1-1.6,0.4l-8.9,4.5l3.1-6.2c0.7-1.4,0.4-3-0.7-4.1C4.5,31.5,2.5,27,2.5,22.3c0-10.9,10.3-19.8,23-19.8c12.7,0,23,8.9,23,19.8c0,1.8-0.3,3.6-0.8,5.2c0.8,0.3,1.5,0.7,2.3,1.2c0.7-2,1.1-4.2,1.1-6.4C51,10,39.6,0,25.5,0C11.4,0,0,10,0,22.3C0,27.9,2.4,33,6.2,36.9c0.3,0.3,0.4,0.8,0.2,1.2l-5,10.1C1,49,1.9,50,2.8,49.6l12.8-6.4c0.2-0.1,0.5-0.1,0.8-0.1c2.8,0.9,5.9,1.5,9.1,1.5c1.9,0,3.7-0.2,5.5-0.5c-0.5-0.7-0.8-1.5-1.1-2.3C28.5,42,27,42.1,25.5,42.1z\"></path><path d=\"M50.3,44.9c-0.1-0.2,0-0.4,0.1-0.5c1.6-1.6,2.6-3.7,2.6-6.1c0-5.1-4.8-9.3-10.6-9.3c-5.9,0-10.6,4.2-10.6,9.3c0,5.1,4.7,9.3,10.6,9.3c1.3,0,2.6-0.2,3.8-0.6c0.1,0,0.2,0,0.3,0l5.3,2.7c0.4,0.2,0.8-0.2,0.6-0.6L50.3,44.9z M47.8,44.8l-0.2-0.1c-0.4-0.2-0.9-0.3-1.3-0.3c-0.3,0-0.6,0.1-0.9,0.2c-1,0.3-2,0.5-3,0.5c-4.5,0-8.1-3-8.1-6.8c0-3.7,3.6-6.8,8.1-6.8s8.1,3,8.1,6.8c0,2-1,3.4-1.9,4.3C48,43.2,47.7,44,47.8,44.8z\"></path><path d=\"M30,18.4V13h-8.3v5.4h-5.6v8h5.6v5.4H30v-5.4h5.6v-8H30z M33.5,24.4h-5.6v5.4h-4.2v-5.4h-5.6v-4h5.6V15h4.2v5.4h5.6V24.4z\"></path></svg><span class=\"badge badge-up badge-primary bounce animated hinge\">{{answers.length}}</span></button><div class=\"dropdown-menu question-dropdown with-arrow dropdown-sm\"><div class=\"dropdown-header\" data-translate=\"headerNavBar.doctorsAnswerTitle\"></div><div class=\"dropdown-body\"><ul class=\"dropdown-list\"><li class=\"unanswered\" data-ng-class=\"{\'unanswered\' : !answer.read}\" data-ng-repeat=\"answer in answers\"><a data-ng-click=\"readAnswer(answer)\" href=\"#\"><svg class=\"icon hover check-circle\"><use xlink:href=\"#check-circle\"></use></svg><span class=\"name\" data-ng-bind-html=\"answer.name\"></span></a><div class=\"remove-question\" data-ng-click=\"hideAnswer(answer, $event)\"><svg class=\"icon times-circle-o\"><use xlink:href=\"#times-circle-o\"></use></svg></div></li></ul></div><div class=\"dropdown-footer\"><a href=\"#\" class=\"btn btn-secondary\" data-ui-sref=\"index.medics\" data-translate=\"headerNavBar.allQuestions\"></a> <button class=\"btn btn-secondary\" data-toggle=\"modal\" data-target=\"#doctorQuestionModal\" data-translate=\"headerNavBar.askDoctor\" data-ng-click=\"askDoctor()\"></button></div></div></div></li><li ui-sref-active=\"active\" data-ng-if=\"user\"><span></span> <button type=\"button\" class=\"btn header-btn\" data-ui-sref=\"index.favorites\"><svg class=\"icon favorites\" viewbox=\"0 0 55 65\" data-container=\".header-nav\" data-placement=\"bottom\" data-delay=\"500,100\" data-title=\"{{\'userProfile.myFavorites\' | translate}}\" bs-tooltip=\"\"><path d=\"M49.9,16.5l-13.2-1c-0.3,0-0.5-0.2-0.6-0.5l-5-12.4C30.4,1.1,28.8,0,27,0c-1.8,0-3.4,1.1-4.1,2.8l-5,12.4c-0.1,0.3-0.3,0.4-0.6,0.5l-13.1,1c-1.8,0.1-3.3,1.3-3.9,3c-0.6,1.8-0.1,3.6,1.3,4.8l10.2,8.5c0.2,0.2,0.3,0.5,0.2,0.7L8.9,46.5c-0.4,1.3-0.1,2.7,0.7,3.8c0.8,1.1,2.1,1.7,3.5,1.7c0.8,0,1.6-0.3,2.3-0.7l11.1-7c0.2-0.1,0.5-0.1,0.8,0l11.2,7c0.7,0.5,1.5,0.7,2.3,0.7c1.3,0,2.5-0.6,3.3-1.6c0.8-1.1,1.2-2.5,0.8-3.9l-3.1-12.9c-0.1-0.3,0-0.6,0.2-0.7l10.3-8.5c1.4-1.2,1.9-3,1.3-4.8C53.2,17.8,51.6,16.6,49.9,16.5z M50.7,22.3l-10.3,8.5c-1,0.8-1.5,2.2-1.2,3.5l3.1,12.9c0.2,0.8-0.1,1.3-0.3,1.5c-0.3,0.4-0.8,0.6-1.2,0.6c-0.3,0-0.6-0.1-0.9-0.3l-11.3-7c-0.5-0.3-1.2-0.5-1.8-0.5s-1.3,0.2-1.8,0.5l-11.2,7c-0.7,0.5-1.7,0.3-2.2-0.4c-0.2-0.3-0.4-0.8-0.2-1.5l3.1-12.9c0.3-1.3-0.1-2.6-1.1-3.5L3.3,22.3c-0.8-0.7-0.6-1.6-0.5-1.9c0.1-0.3,0.5-1.1,1.5-1.2l13.2-1c1.3-0.1,2.4-0.9,2.9-2.1l5-12.4c0.4-1,1.3-1.1,1.6-1.1c0.3,0,1.2,0.1,1.6,1.1l5,12.4c0.5,1.2,1.6,2,2.9,2.1l13.2,1c1,0.1,1.4,0.9,1.5,1.2C51.3,20.7,51.5,21.6,50.7,22.3z\"></path></svg></button> <span class=\"badge badge-up\" data-ng-show=\"favoritesCount > 0\">{{favoritesCount}}</span></li><li><a href=\"javascript:void(0)\"><div class=\"header-user-panel\" data-ng-include=\"\'app/components/userProfileBadge/userProfileBadge.authorized.html\'\" data-ng-if=\"user\"></div><div class=\"header-user-panel\" data-ng-include=\"\'app/components/userProfileBadge/userProfileBadge.unauthorized.html\'\" data-ng-if=\"!user\"></div></a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/components/userProfileBadge/userProfileBadge.unauthorized.html","<div class=\"btn-group\"><button type=\"button\" class=\"btn dropdown-toggle header-btn\" data-toggle=\"dropdown\" data-placement=\"bottom-right\" data-bs-dropdown=\"\"><span class=\"authorized-user-avatar\" data-placement=\"bottom\" data-delay=\"500,100\" data-title=\"{{\'userProfile.login\' | translate}}\" bs-tooltip=\"\"><svg class=\"icon userHead\"><use xlink:href=\"#userHead\"></use></svg></span></button><ul class=\"dropdown-menu with-arrow with-arrow_right\"><li><button type=\"button\" class=\"btn btn-success btn-block text-center\" data-ui-sref=\"index.signUp.user\"><svg id=\"signUpSvg\" class=\"icon child\"><use xlink:href=\"#child\"></use></svg>{{\'userProfile.registration\' | translate}}</button></li><li class=\"divider\"></li><li><button type=\"button\" class=\"btn btn-primary btn-block text-center\" data-ui-sref=\"index.login\"><svg id=\"signInSvg\" class=\"icon sign-in\"><use xlink:href=\"#sign-in\"></use></svg>{{\'userProfile.login\' | translate}}</button></li></ul></div>");
$templateCache.put("app/main/html/breadcrumbs.html","<div class=\"container\" data-ng-if=\"breadcrumbs.length > 2\"><nav class=\"breadcrumbs\"><ul data-ui-view=\"breadcrumbs\" class=\"list-unstyled\"><li data-ng-repeat=\"crumb in breadcrumbs\" data-ng-class=\"{ active: $last }\" data-ng-show=\"!$last\"><a data-ui-sref=\"{{ crumb.route }}\"><span>{{ crumb.displayName }}</span><svg class=\"icon angle-right\"><use xlink:href=\"#angle-right\"></use></svg></a></li></ul></nav></div>");
$templateCache.put("app/main/html/content.html","<div class=\"default-block banner-block banner-block_970\"><adsense data-block-type=\"horizontal\" inline-style=\"display:inline-block;width:970px;height:90px\"></adsense></div><div class=\"row d-f-md-up\"><div class=\"col-sm-8 pb-10-md-up\"><div class=\"default-block algorithm-promo f-d-c_md-up h-100\" data-ng-controller=\"indexController as c\"><div class=\"block-controls\"><span class=\"block-controls-name\" data-translate=\"algorithms.mainPage.title\"></span></div><div class=\"block-content clearfix d-f-md-up f-d-r_inverse-md-up\"><div class=\"col-sm-12 col-md-6 algorithm-promo_image\"></div><div class=\"col-sm-12 col-md-6\"><p class=\"algorithm-promo-title\"><strong data-translate=\"algorithms.mainPage.subtitle\"></strong></p><p data-translate=\"algorithms.mainPage.description\"></p><div><button data-ui-sref=\"index.algorithms\" class=\"btn btn-success btn-xl\" data-translate=\"algorithms.mainPage.try\"></button></div></div></div></div></div><div class=\"col-sm-4\" main-menu=\"\" data-ng-controller=\"indexController\"><a data-ng-href=\"{{getMenuByLinkType(\'calendar\')}}\" data-ui-sref-active=\"active\" class=\"default-block category-website\"><svg class=\"icon calendar\"><use xlink:href=\"#calendar\"></use></svg><span class=\"category-website-name\" data-translate=\"index.pregnancyCalendar\"></span></a> <a data-ng-href=\"{{getMenuByLinkType(\'disease\')}}\" class=\"default-block category-website\"><svg class=\"icon ills\"><use xlink:href=\"#ills\"></use></svg><span class=\"category-website-name\" data-translate=\"index.disease\"></span></a> <a data-ui-sref=\"index.medics\" class=\"default-block category-website\"><svg class=\"icon question\"><use xlink:href=\"#question\"></use></svg><span class=\"category-website-name\" data-translate=\"index.doctorsAnswer\"></span></a> <a data-ng-href=\"{{getMenuByLinkType(\'supplementsCategories\')}}\" data-ui-sref-active=\"active\" class=\"default-block category-website\"><svg class=\"icon food2\"><use xlink:href=\"#food2\"></use></svg><span class=\"category-website-name\" data-translate=\"index.foodSupplements\">)</span></a> <a data-ui-sref=\"index.clinics\" data-ui-sref-active=\"active\" class=\"default-block category-website\"><svg class=\"icon clinic\"><use xlink:href=\"#clinic\"></use></svg><span class=\"category-website-name\" data-translate=\"index.findClinic\"></span></a> <a data-ui-sref=\"index.medicine\" class=\"default-block category-website\"><svg class=\"icon drugs\"><use xlink:href=\"#drugs\"></use></svg><span class=\"category-website-name\" data-translate=\"index.drugsDescription\"></span></a> <a data-ui-sref=\"index.doctorSearch\" data-ui-sref-active=\"active\" class=\"default-block category-website hidden\"><svg class=\"icon doctor\"><use xlink:href=\"#doctor\"></use></svg><span class=\"category-website-name\" data-translate=\"index.findDoctor\"></span></a></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"default-block\"><div class=\"block-banner banner-block_300\"><adsense data-block-type=\"block300\" inline-style=\"display:inline-block;width:300px;height:250px\"></adsense></div></div><div class=\"default-block\"><div class=\"block-controls\"><span class=\"block-controls-name\">Партнерство</span> <span class=\"block-controls-icon middle-icons\"><svg class=\"icon dollar\"><use xlink:href=\"#dollar\"></use></svg></span></div><div class=\"block-content\"><ul class=\"block-content-list block-content-list-lg\"><li><a data-ui-sref=\"index.aboutUs({articleUUID: \'doctorsAndClinics\'})\"><span class=\"inner-text\" data-translate=\"index.doctorsAndClinics\"></span></a></li><li><a data-ui-sref=\"index.aboutUs({articleUUID: \'advertiser\'})\"><span class=\"inner-text\" data-translate=\"index.advertiser\"></span></a></li></ul></div></div></div><div class=\"col-sm-4\"><div class=\"default-block\"><div class=\"block-controls\"><span class=\"block-controls-name\">Самое популярное</span> <span class=\"block-controls-icon middle-icons\"><svg class=\"icon star-half-empty\"><use xlink:href=\"#star-half-empty\"></use></svg></span></div><popular-articles></popular-articles></div></div><div class=\"col-sm-4\"><div class=\"default-block\"><div class=\"block-controls\"><a href=\"#\" class=\"block-controls-name\" data-ui-sref=\"index.news\" data-translate=\"index.ourBlog\"></a> <span class=\"block-controls-icon middle-icons\"><svg class=\"icon newspaper-o\"><use xlink:href=\"#newspaper-o\"></use></svg></span></div><news-block></news-block></div></div></div>");
$templateCache.put("app/main/html/deleteModalTpl.html","<div class=\"modal\" tabindex=\"-1\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"$dismiss()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\">{{title}}</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\"><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span class=\"alert-text\">{{ message }}</span></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" data-ng-click=\"$close(true)\" data-translate=\"general.delete\"></button> <button class=\"btn btn-info\" data-ng-click=\"$dismiss(false)\" data-translate=\"general.cancel\"></button></div></div></div></div>");
$templateCache.put("app/main/html/footer.html","<div class=\"panel-group footer-collapse hidden-lg hidden-md hidden-sm\" role=\"tablist\" data-ng-model=\"multiplePanels.activePanels\" aria-multiselectable=\"true\" data-allow-multiple=\"true\" bs-collapse=\"\"><div class=\"panel panel-default\" data-ng-repeat=\"p in [0,1,2,3,4]\"><div class=\"panel-heading\" role=\"tab\"><h4 class=\"panel-title\"><a bs-collapse-toggle=\"\" ng-class=\"{\'expanded\': isSelected($index)}\">{{sectionCategories[$index].name}}<svg class=\"icon chevron-right\"><use xlink:href=\"#angle-down\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#angle-up\"></use></svg></a></h4></div><div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target=\"\"><div class=\"panel-body footer-up-nav\"><ul class=\"list-unstyled\"><li data-ng-repeat=\"category in sectionCategories[$index].links\"><a data-ui-sref=\"{{ category.href }}\">{{::category.name}}</a></li></ul></div></div></div></div><section class=\"footer-up hidden-xs\"><div class=\"container\"><footer-row-directive></footer-row-directive></div></section><section class=\"footer-down\"><div class=\"container\"><div class=\"row\"><div class=\"col-sm-8 col-md-6\"><nav class=\"footer-down-nav\"><ul class=\"list-unstyled\"><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.aboutUs({ articleUUID: \'whoWeAre\' })\" data-translate=\"headerNavBar.aboutUsContainer.whoWeAre\"></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.aboutUs({ articleUUID: \'aboutProject\' })\" data-translate=\"headerNavBar.aboutUsContainer.aboutProject\"></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.aboutUs({ articleUUID: \'helpWithSite\' })\" data-translate=\"headerNavBar.aboutUsContainer.help\"></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.aboutUs({articleUUID: \'doctorsAndClinics\'})\" data-translate=\"headerNavBar.partnershipsContainer.doctorsAndClinics\"></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.aboutUs({articleUUID: \'advertiser\'})\" data-translate=\"headerNavBar.partnershipsContainer.advertisers\"></a></li></ul></nav><div class=\"footer-down-sub-link hidden-xs\"><span class=\"copyright\"><a href=\"http://softarex.com/\" target=\"_blank\" rel=\"”nofollow”\">© {{currentDate| date:\'yyyy\'}} Softarex Technologies, Inc.</a></span> <a data-ui-sref=\"index.aboutUs({articleUUID: \'confidentiality\'})\" data-translate=\"headerNavBar.aboutUsContainer.confidentiality\"></a> <a data-ui-sref=\"index.aboutUs({articleUUID: \'termsOfUse\'})\" data-translate=\"headerNavBar.aboutUsContainer.termsOfUse\"></a></div></div><div class=\"col-sm-4 col-md-6\"><div class=\"row\"><div class=\"col-md-6 hidden-sm\"><div class=\"mobile-store\"><a href=\"https://play.google.com/store/apps/details?id=com.babycompy\" target=\"_blank\"><img class=\"img-responsive\" src=\"assets/images/google_play_badge.svg\" alt=\"{{\'seo.alt.googleplay\' | translate}}\"></a> <a href=\"https://itunes.apple.com/us/app/mobile-security-cloud-mdm/id1113948225?mt=8\" target=\"_blank\"><img class=\"img-responsive\" src=\"assets/images/apple_store_badge.svg\" alt=\"{{\'seo.alt.appstore\' | translate}}\"></a></div></div><div class=\"col-md-6\"><ul class=\"list-unstyled footer-social\"><li><a class=\"vk\" href=\"https://vk.com/babycompy\" target=\"_window\"><svg class=\"icon vk\"><use xlink:href=\"#vk\"></use></svg></a></li><li><a class=\"fb\" href=\"http://www.facebook.com/BabyCompy\" target=\"_window\"><svg class=\"icon facebook\"><use xlink:href=\"#facebook\"></use></svg></a></li><li><a class=\"tw\" href=\"http://ok.ru/group/52828947153103\" target=\"_window\"><svg class=\"icon odnoklassniki\"><use xlink:href=\"#odnoklassniki\"></use></svg></a></li></ul></div></div></div></div><div class=\"footer-down-sub-link visible-xs\"><span class=\"copyright\"><a href=\"http://softarex.com/\" target=\"_blank\">© {{currentDate| date:\'yyyy\'}} Softarex Technologies, Inc.</a></span> <a data-ui-sref=\"index.aboutUs({articleUUID: \'confidentiality\'})\" data-translate=\"headerNavBar.aboutUsContainer.confidentiality\"></a> <a data-ui-sref=\"index.aboutUs({articleUUID: \'termsOfUse\'})\" data-translate=\"headerNavBar.aboutUsContainer.termsOfUse\"></a></div></div></section>");
$templateCache.put("app/main/html/footerRow.template.html","<nav class=\"row footer-up-nav\"><div class=\"col-sm-6\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"nav-header\">{{sectionCategories[0].name}}</div><ul class=\"list-unstyled\"><li data-ng-repeat=\"category in sectionCategories[0].links\"><a data-ui-sref=\"{{ category.href }}\">{{::category.name}}</a></li></ul></div><div class=\"col-sm-6\"><div class=\"nav-header\">{{sectionCategories[1].name}}</div><ul class=\"list-unstyled\"><li data-ng-repeat=\"category in sectionCategories[1].links\"><a data-ui-sref=\"{{ category.href }}\">{{::category.name}}</a></li></ul><div class=\"nav-header\">{{sectionCategories[2].name}}</div><ul class=\"list-unstyled\"><li data-ng-repeat=\"category in sectionCategories[2].links\"><a data-ui-sref=\"{{ category.href }}\">{{::category.name}}</a></li></ul></div></div></div><div class=\"col-sm-6\"><div class=\"row\"><div class=\"col-sm-7\"><div class=\"nav-header\">{{sectionCategories[3].name}}</div><ul class=\"list-unstyled\"><li data-ng-repeat=\"category in sectionCategories[3].links\"><a data-ui-sref=\"{{ category.href }}\">{{::category.name}}</a></li></ul></div><div class=\"col-sm-5\"><div class=\"nav-header\" data-translate=\"footer.services\"></div><ul class=\"list-unstyled\"><li><a data-ui-sref=\"index.doctorSearch\" data-translate=\"menu.doctors\"></a></li><li><a data-ui-sref=\"index.clinics\" data-translate=\"menu.clinics\"></a></li><li><a data-ui-sref=\"index.medicine\" data-translate=\"menu.medication\"></a></li><li><a data-ui-sref=\"index.medics\" data-translate=\"headerNavBar.doctorsAnswer\"></a></li></ul></div></div></div></nav>");
$templateCache.put("app/main/html/header.html","<user-profile></user-profile><div class=\"header-empty\"></div>");
$templateCache.put("app/main/html/main.html","<ui-breadcrumbs displayname-property=\"breadcrumb\" abstract-proxy-property=\"childState\" template-url=\"app/main/html/breadcrumbs.html\"></ui-breadcrumbs><div class=\"container\" data-ui-view=\"content\"></div>");
$templateCache.put("app/main/html/modalTpl.html","<div class=\"modal\" tabindex=\"-1\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"$dismiss()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\">{{title}}</h4></div><div class=\"modal-body\"><div class=\"alert\" data-ng-class=\"alertClass\" role=\"alert\"><span class=\"alert-text\">{{ message }}</span></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" data-ng-click=\"$close(true)\" data-translate=\"general.ok\"></button></div></div></div></div>");
$templateCache.put("app/main/html/promoMenuRuler.html","<div class=\"promo-block\" ng-show=\"$state.is(\'index\')\"><baby-compy-slider dots=\"true\" infinite=\"true\" autoplay=\"true\" autoplay-speed=\"5000\" speed=\"300\" slides-to-show=\"1\" init-onload=\"true\" touch-move=\"true\" slides-to-scroll=\"1\" list=\"sliderCtrl.data\" css-ease=\"linear\" fade=\"true\" pause-on-hover=\"true\" pause-on-dots-hover=\"true\" arrows=\"false\" accessibility=\"false\" class=\"one-time slick-slider\"></baby-compy-slider></div><top-menu></top-menu><ruler></ruler>");
$templateCache.put("app/main/html/signUpModalSuccess.html","<div class=\"modal\" tabindex=\"-1\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{title}}</h4></div><div class=\"modal-body\"><div class=\"alert alert-success\" data-ng-class=\"[type ? \'alert-\' + type : null]\"><svg class=\"icon check-circle\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#check-circle\"></use></svg><span class=\"alert-text\">{{content}}</span></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" data-ng-click=\"$close(true)\" data-translate=\"general.ok\"></button></div></div></div></div>");
$templateCache.put("app/main/popularArticles/popularArticles.html","<div class=\"block-content\"><ul class=\"block-popular-list\"><li data-ng-repeat=\"item in items\"><a data-ng-if=\"item.parent\" class=\"article-title\" data-ui-sref=\"index.contentCategories.contentSubcategories.article({categoryUUID: item.parent.uuid, articleUUID: item.uuid})\">{{item.name}}</a> <a data-ng-if=\"!item.parent\" class=\"article-title\" data-ui-sref=\"index.contentCategories.contentSubcategories({categoryUUID: item.uuid})\">{{item.name}}</a><div class=\"article-body\"><p>{{item.content}}</p></div></li></ul></div>");
$templateCache.put("app/components/authentication/login/login.html","<div class=\"container\"><div class=\"user-authorization\"><h1>Вход</h1><div data-ui-view=\"social-networks\"></div><br><form name=\"loginForm\" novalidate=\"\"><fieldset><div class=\"form-group\"><input required=\"required\" id=\"r-user-email\" data-ng-change=\"c.checkField()\" type=\"email\" name=\"userId\" class=\"form-control\" data-validation-email=\"\" placeholder=\"E-mail\" maxlength=\"64\" data-ng-model=\"c.userId\"></div><div class=\"form-group\"><input required=\"required\" data-ng-change=\"c.checkField()\" type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"{{\'authentication.signUp.password\' | translate}}\" maxlength=\"32\" data-ng-model=\"c.password\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\"></div></fieldset><div class=\"form-group\" data-ng-if=\"c.showError\"><div role=\"alert\" class=\"alert alert-warning\"><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span class=\"alert-text\" data-translate=\"general.invalidPasswordOrMail\"></span></div></div><div class=\"form-group\" data-ng-if=\"c.isUserBlocked\"><div role=\"alert\" class=\"alert alert-warning\"><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span class=\"alert-text\" data-translate=\"general.userBlocked\"></span></div></div><button class=\"btn btn-default btn-block\" data-ng-disabled=\"c.isLoggingIn || !loginForm.$dirty || (loginForm.$submitted && loginForm.$invalid)\" data-ng-click=\"c.login()\" data-translate=\"userProfile.login\" type=\"submit\"></button> <a class=\"forgot-password\" href=\"#\" data-ng-click=\"c.openForgotModal(true)\" data-translate=\"authentication.signUp.forgotPassword\"></a></form></div></div>");
$templateCache.put("app/components/authentication/login/login.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"changeMyChildren\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"c.closeModal()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"userProfile.needAuthentication\"></h4></div><div class=\"modal-body\"><fieldset><div class=\"form-group\"><input required=\"required\" id=\"r-user-email\" data-ng-change=\"c.checkField()\" type=\"email\" name=\"userId\" class=\"form-control\" data-validation-email=\"\" placeholder=\"E-mail\" maxlength=\"64\" data-ng-model=\"c.userId\"></div><div class=\"form-group\"><input required=\"required\" data-ng-change=\"c.checkField()\" type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"{{\'authentication.signUp.password\' | translate}}\" maxlength=\"32\" data-ng-model=\"c.password\"></div></fieldset><div class=\"form-group\" data-ng-if=\"c.showError\"><div role=\"alert\" class=\"alert alert-warning\"><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span class=\"alert-text\" data-translate=\"general.invalidPasswordOrMail\"></span></div></div><button class=\"btn btn-default btn-block\" data-ng-show=\"!c.readonly\" data-ng-click=\"c.login()\" data-translate=\"userProfile.login\" type=\"submit\"></button><div class=\"text-center\"><a class=\"forgot-password\" href=\"#\" data-ng-click=\"c.openForgotModal()\" data-translate=\"authentication.signUp.forgotPassword\"></a></div></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/profile.html","<div class=\"profile-header\"><div class=\"container\"><div class=\"row profile-controls\"><div class=\"col-sm-3 col-lg-2\"><figure class=\"profile-avatar authorized-user-avatar\"><img data-ng-if=\"!$state.is(\'index.profile.user.edit\')\" data-object-fit=\"cover\" data-ng-show=\"c.entity.avatar\" class=\"img-responsive\" data-ng-src=\"{{c.avatarPath}}\" alt=\"{{\'seo.alt.avatar\' | translate}}\"> <img data-ng-if=\"!$state.is(\'index.profile.user.edit\')\" data-ng-show=\"!c.entity.avatar\" class=\"img-responsive\" src=\"/assets/images/user-no-photo.png\" alt=\"{{\'seo.alt.noavatar\' | translate}}\"><avatar data-ng-if=\"$state.is(\'index.profile.user.edit\')\" data-photo=\"c.entity.avatar\"></avatar></figure></div><div class=\"col-sm-9 col-lg-10\"><div class=\"profile-info\"><div class=\"profile-info-name\">{{ c.entity.firstName }} {{ c.entity.lastName }}</div><ul class=\"profile-info-tabs list-unstyled\"><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.profile.user.children\" class=\"btn\">{{ \'userProfile.myChildren\' | translate}}</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.profile.user.edit\" class=\"btn\">{{\'userProfile.editProfile\' | translate}}</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.profile.user.resetPassword\" class=\"btn\">{{\'userProfile.changePassword\' | translate}}</a></li></ul></div></div></div></div></div><div class=\"container\"><div class=\"default-block profile-content\"><div data-ui-view=\"profile-view\"></div></div></div>");
$templateCache.put("app/components/authentication/signUp/signUp.html","<div class=\"container\"><div class=\"user-authorization\"><h1>{{\'authentication.signUp.title\' | translate}}</h1><ul class=\"nav nav-pills\"><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.signUp.user\" aria-controls=\"registration-user\">{{\'authentication.signUp.user\' | translate}}</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"index.signUp.doctor\" aria-controls=\"registration-doctor\">{{\'authentication.signUp.doctor\' | translate}}</a></li></ul><div data-ui-view=\"social-networks\"></div><div class=\"tab-content\"><div data-ui-view=\"signUp-form\"></div></div></div></div>");
$templateCache.put("app/components/clinics/details/clinicDetails.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block-content\"><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-4\"><figure class=\"clinic-photo\"><image-gallery-wrapper data-images=\"c.content.images\" data-gal-width=\"200\" data-gal-height=\"200\" data-ng-show=\"c.content.images.length > 0\" data-alt-title=\"c.content.name\"></image-gallery-wrapper><img class=\"img-responsive\" data-ng-src=\"/assets/images/clinic-profile-placeholder.svg\" data-ng-show=\"c.content.images.length == 0\" alt=\"{{\'seo.alt.nophoto\' | translate}}\"></figure></div><div class=\"col-sm-8\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-header><div class=\"block-content clinic-information\"><p><b><span data-translate=\"clinicProfile.type\"></span>:&nbsp;</b>{{c.content.type.name}}</p><p><b><span data-translate=\"clinicProfile.specialization\"></span>:</b> <span data-ng-show=\"c.content.specializations.length > 0\">{{c.specializations}}</span> <span data-ng-show=\"c.content.specializations.length == 0\" data-translate=\"clinicProfile.noInfo\"></span></p><div class=\"row\"><div class=\"col-md-6\"><p><b><span data-translate=\"clinicProfile.address\"></span>:</b> <span address-formatter=\"\" country=\"c.content.country\" city=\"c.content.city\" address=\"c.content.address\"></span></p><b><span data-translate=\"clinicProfile.phones\"></span></b>:<br><span data-ng-repeat=\"phone in c.content.phones\"><b>{{phone.phone}}</b> <span data-ng-if=\"phone.name\">{{\' - \' + phone.name}}</span><br></span><br><p><b><span data-translate=\"clinicProfile.workHours\"></span>:</b> <span data-ng-show=\"!c.content.workingHours || c.content.workingHours.length ==0\" data-translate=\"clinicProfile.workingHours.dayAndNight\"></span><working-hours data-ng-show=\"c.content.workingHours.length!=0\" schedule=\"c.content.workingHours\"></working-hours></p><p><b><span data-translate=\"clinicProfile.site\"></span>:</b> <span data-ng-show=\"!c.content.site\" data-translate=\"clinicProfile.noInfo\"></span> <a data-ng-show=\"c.content.site\" data-ng-href=\"{{c.content.site}}\" target=\"_blank\">{{c.content.site}}</a></p><p><b><span data-translate=\"clinicProfile.email\"></span>:</b> <span data-ng-show=\"!c.content.email\" data-translate=\"clinicProfile.noInfo\"></span> <a data-ng-show=\"c.content.email\" data-ng-href=\"mailto:{{c.content.email}}\">{{c.content.email}}</a></p></div><div class=\"col-md-6\"><div google-map=\"\" position=\"c.position\" class=\"clinic-details-google-map\"></div></div></div><hr><div class=\"clinic-tabs-information\" data-bs-active-pane=\"c.activeTab\" data-bs-tabs=\"\"><div class=\"tab-content\"><div class=\"tab-pane in\" id=\"clinic_description\" data-bs-pane=\"\" data-title=\"{{ \'clinicProfile.description\' | translate }}\" name=\"{{ \'description\' }}\"><div data-ng-bind-html=\"c.content.about | trust\" data-ng-show=\"c.content.about\"></div><div data-translate=\"clinicProfile.noInfo\" data-ng-show=\"!c.content.about\"></div></div><div class=\"tab-pane\" id=\"clinic_services\" data-bs-pane=\"\" data-title=\"{{ \'clinicProfile.services\' | translate }}\" name=\"{{ \'services\' }}\"><ul class=\"list-unstyled\" data-ng-repeat=\"service in c.content.services\" data-ng-show=\"c.content.services.length > 0\"><li><p>{{\'● \' + service.name }}</p></li></ul><div data-translate=\"clinicProfile.noInfo\" data-ng-show=\"c.content.services.length == 0\"></div></div><div class=\"tab-pane\" id=\"clinic_structure\" data-bs-pane=\"\" data-title=\"{{ \'clinicProfile.departments\' | translate }}\" name=\"{{ \'departments\' }}\"><div data-translate=\"clinicProfile.noInfo\" data-ng-show=\"c.content.departments.length == 0\"></div><div class=\"clinic-structure-list\" data-ng-show=\"c.content.departments\"><div class=\"row\" data-ng-repeat=\"dep in c.content.departments\"><div class=\"col-sm-6\"><b>{{dep.name}}</b></div><div class=\"col-sm-6\">{{dep.phone}}</div></div></div></div><div class=\"tab-pane\" id=\"clinic_doctors\" data-bs-pane=\"\" data-title=\"{{ \'clinicProfile.doctors\' | translate }}\" name=\"{{ \'doctors\' }}\"><div translate=\"clinicProfile.noInfo\"></div></div></div></div><br></div></div></div></div></div></div></div>");
$templateCache.put("app/components/content/aboutUs/aboutUs.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.aboutUs\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.content.name\"></categories-header><div class=\"block-content\" data-dynamic-content=\"c.content.description\"></div><div data-ng-if=\"c.content.name === \'Рекламодателям\'\" data-ng-include=\"\'app/components/content/aboutUs/advertiserFeedbackForm.html\'\"></div></div></div></div>");
$templateCache.put("app/components/content/aboutUs/advertiserFeedbackForm.html","<form name=\"feedbackForm\" novalidate=\"\"><div class=\"row\"><fieldset class=\"col-sm-6\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && (feedbackForm.name.$error.required || feedbackForm.name.$error.pattern)}\"><input type=\"text\" tabindex=\"1\" maxlength=\"30\" class=\"form-control\" placeholder=\"{{\'headerNavBar.partnershipsContainer.advertiserName\' | translate}}\" required=\"required\" name=\"name\" data-ng-model=\"c.advertiser.name\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\_\\-\\u0080-\\u00FF]{2,30}$/\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && (feedbackForm.name.$error.required || feedbackForm.name.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.name.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"feedbackForm.name.$error.pattern\" data-translate=\"general.incorrectFirstName\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && feedbackForm.companyName.$error.pattern}\"><input type=\"text\" tabindex=\"2\" maxlength=\"30\" class=\"form-control\" placeholder=\"{{\'headerNavBar.partnershipsContainer.companyName\' | translate}}\" name=\"companyName\" data-ng-model=\"c.advertiser.companyName\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\_\\-\\&\\,\\.u0080-\\u00FF]{2,30}$/\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && feedbackForm.companyName.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.companyName.$error.pattern\" data-translate=\"forAdvertisers.generalIncorrectFiesl\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && feedbackForm.activityField.$error.pattern}\"><input type=\"text\" tabindex=\"3\" maxlength=\"32\" class=\"form-control\" placeholder=\"{{\'headerNavBar.partnershipsContainer.activityField\' | translate}}\" name=\"activityField\" data-ng-model=\"c.advertiser.activityField\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\_\\-\\u0080-\\u00FF]{2,32}$/\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && feedbackForm.activityField.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.activityField.$error.pattern\" data-translate=\"forAdvertisers.generalIncorrectFiesl\"></span></p></div></fieldset><fieldset class=\"col-sm-6\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && feedbackForm.companySite.$error.pattern}\"><input type=\"text\" tabindex=\"4\" maxlength=\"32\" class=\"form-control\" placeholder=\"{{\'headerNavBar.partnershipsContainer.companySite\' | translate}}\" name=\"companySite\" data-ng-model=\"c.advertiser.companySite\" data-ng-pattern=\"/^[a-zA-Z0-9\\-\\:\\/]{1,30}(?:\\.[a-zA-Z \\/\\-\\?\\=]{2,})+$/\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && feedbackForm.companySite.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.companySite.$error.pattern\" data-translate=\"forAdvertisers.incorrectSiteAddress\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && (feedbackForm.phone.$error.pattern || feedbackForm.phone.$error.required)}\"><input type=\"tel\" tabindex=\"5\" maxlength=\"25\" class=\"form-control\" required=\"required\" placeholder=\"{{\'headerNavBar.partnershipsContainer.phone\' | translate}}\" name=\"phone\" data-ng-model=\"c.advertiser.phone\" data-ng-pattern=\"/^[\\+]?[0-9]{2}\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{4})$|^\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{4})$/g\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && (feedbackForm.phone.$error.pattern || feedbackForm.phone.$error.required)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.phone.$error.pattern\" data-translate=\"forAdvertisers.incorrectPhoneNumber\"></span> <span data-ng-show=\"feedbackForm.phone.$error.required\" data-translate=\"general.requiredField\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted && (feedbackForm.email.$error.required || feedbackForm.email.$error.email)}\"><input type=\"email\" tabindex=\"6\" maxlength=\"80\" class=\"form-control\" placeholder=\"E-mail\" required=\"required\" name=\"email\" data-ng-model=\"c.advertiser.email\" data-validation-email=\"\"> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && (feedbackForm.email.$error.required || feedbackForm.email.$error.email)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.email.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"feedbackForm.email.$error.email\" data-translate=\"general.incorrectEmail\"></span></p></div></fieldset><div class=\"col-sm-12\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': feedbackForm.$submitted &&(feedbackForm.advertisers_form.$error.required || feedbackForm.advertisers_form.$error.pattern)}\"><textarea required=\"required\" tabindex=\"7\" class=\"form-control no-resize\" name=\"advertisers_form\" id=\"advertisers_form\" maxlength=\"255\" rows=\"4\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\_\\-\\.\\,\\\'\\u0080-\\u00FF]+$/\" data-ng-model=\"c.advertiser.comments\" placeholder=\"{{\'headerNavBar.partnershipsContainer.comment\' | translate}}\"></textarea> <label class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && (feedbackForm.advertisers_form.$error.required || feedbackForm.advertisers_form.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"feedbackForm.advertisers_form.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"feedbackForm.advertisers_form.$error.pattern\" data-translate=\"forAdvertisers.incorrectComment\"></span></p></div></div><div class=\"col-sm-12 col-md-6\"><div class=\"form-group feedback-recaptcha\" data-ng-class=\"{\'has-required\':feedbackForm.$submitted && !c.response }\"><div vc-recaptcha=\"\" id=\"recaptcha\" on-success=\"c.setCaptchaResponse(response)\"></div><label for=\"recaptcha\" class=\"sr-only\"></label><p data-ng-show=\"feedbackForm.$submitted && !c.response\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"!c.response\" data-translate=\"general.requiredField\"></span></p></div></div><div class=\"col-sm-12 col-md-6\"><button class=\"btn btn-default btn-lg btn-block btn-feedback-form\" type=\"submit\" data-translate=\"general.send\" data-ng-disabled=\"!feedbackForm.$dirty || (feedbackForm.$submitted && feedbackForm.$invalid)\" data-ng-click=\"c.sendFeedback()\"></button></div></div></form>");
$templateCache.put("app/components/content/algorithms/algorithms.dev.template.html","<div class=\"default-block-content\"><div class=\"row content-empty\" data-ng-controller=\"indexController as c\"><div style=\"\" class=\"col-md-offset-1 col-md-10 text-center\"><br class=\"hidden-xs\"><br class=\"hidden-xs\"><img class=\"img-responsive\" style=\"\" src=\"assets/images/promo/programms_cap-fb0204c1a6.svg\" alt=\"\"><br><br class=\"hidden-xs\"><h2>На данный момент раздел находится в разработке</h2><p>Узнайте первым, что команда BabyCompy готовит для своих пользователей!</p><p>Мы разрабатываем интерактивные оздоровительные тренинг-программы о здоровье и воспитании детей, чтобы обучить молодых родителей методам доврачебной медицинской помощи. В основе создания алгоритмов лежат принципы обучающего метода психологии — коучинга. Суть данного подхода не в том, чтобы учить пользователя, как поступать, а создавать похожие условия для принятия родителями самостоятельного решения и способов достижения цели в каждой конкретной ситуации.</p><p><a style=\"cursor:pointer\" data-ng-click=\"c.onClick()\" data-ng-href=\"{{c.path}}\">Регистрируйтесь</a>, чтобы первым узнать о запуске!</p><br></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithms.template.html","<div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-translate=\"algorithms.title\"></h1></div><div class=\"block-content\"><div class=\"row algorithms-row\"><div class=\"col-sm-10\"><div class=\"algorithms-block algorithms-my\" data-ng-if=\"c.savedAlgorithms && c.savedAlgorithms.length>0\"><div class=\"algorithms-content\"><div class=\"title\" data-translate=\"algorithms.my\"></div><ul class=\"in-process-algorithms\"><li data-ng-repeat=\"savedAlgorithm in c.savedAlgorithms\"><div class=\"row\"><div class=\"col-lg-8\"><a href=\"#\" class=\"link\" data-ng-click=\"c.continueAlgorithm(savedAlgorithm)\"><svg class=\"icon play-circle-o\"><use xlink:href=\"#play-circle-o\"></use></svg><span>{{savedAlgorithm.name}}</span></a></div><div class=\"col-lg-4\"><div class=\"algorithms-control\"><a class=\"btn btn-primary\" data-ng-click=\"c.continueAlgorithm(savedAlgorithm)\"><strong data-translate=\"algorithms.continue\"></strong><svg class=\"icon chevron-right\"><use xlink:href=\"#chevron-right\"></use></svg></a> <a class=\"btn btn-primary-circle\" data-ng-click=\"c.restartAlgorithm(savedAlgorithm)\"><svg class=\"icon rotate-left\"><use xlink:href=\"#rotate-left\"></use></svg></a> <a class=\"btn btn-primary-circle\" data-ng-click=\"c.finishAlgorithm(savedAlgorithm)\"><svg class=\"icon remove\"><use xlink:href=\"#close\"></use></svg></a></div></div></div></li></ul></div><figure class=\"algorithms-figure\"><span><svg class=\"icon program\"><use xlink:href=\"#program\"></use></svg></span></figure></div><p data-ng-bind-html=\"c.description\"></p><div class=\"row\"><div class=\"col-xs-12\" data-ng-repeat=\"group in c.groups\"><div class=\"algorithms-block\"><div class=\"algorithms-content\"><div class=\"title\"><a class=\"title\" data-ui-sref=\"index.algorithms.group({\'groupUuid\': group.uuid})\">{{group.name}}</a></div><ul class=\"list-algorithms two-column\"><li class=\"two-column_item\" data-ng-repeat=\"algorithm in group.algorithms\"><a data-ui-sref=\"index.algorithms.group.algorithm({\'groupUuid\' : group.uuid, \'algorithmUuid\' : algorithm.uuid})\"><svg class=\"icon play-circle-o\"><use xlink:href=\"#play-circle-o\"></use></svg><span>{{algorithm.name}}</span></a></li></ul></div><figure class=\"algorithms-figure\"><span><img data-ng-if=\"!!group.link\" class=\"icon\" data-ng-src=\"{{\'/api/v1/files/\' + group.link}}\"><svg data-ng-if=\"!!!group.link\" class=\"icon program\"><use xlink:href=\"#program\"></use></svg></span></figure></div></div></div></div><div class=\"col-sm-2\"><div data-ng-class=\"(c.savedAlgorithms && c.savedAlgorithms.length>0) ? \'block-banner algorithms-block\' : \'block-banner\'\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div></div>");
$templateCache.put("app/components/content/contentCategories/containerContentCategories.html","<div data-ui-view=\"content\"></div>");
$templateCache.put("app/components/content/favorites/favorites.html","<div class=\"row\" data-ng-if=\"c.favoritesContent.length > 0\"><div class=\"col-sm-3\"><div class=\"default-block\"><div class=\"block-content\"><ul class=\"block-content-list right-indent\"><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[0].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'articles\' })\"><svg class=\"icon x1 articls\"><use xlink:href=\"#articls\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.articles\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[0].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[1].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'medicine\' })\"><svg class=\"icon x1 drugs\"><use xlink:href=\"#drugs\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.medicine\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[1].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[2].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'products\' })\"><svg class=\"icon x1 products\"><use xlink:href=\"#products\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.products\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[2].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[3].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'supplements\' })\"><svg class=\"icon x1 nutritional-sup\"><use xlink:href=\"#nutritional-sup\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.supplements\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[3].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[4].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'algorithms\' })\"><svg class=\"icon x1 algotithms\"><use xlink:href=\"#algotithms\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.algorithms\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[4].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[5].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'news\' })\"><svg class=\"icon x1 news\"><use xlink:href=\"#news\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.news\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[5].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[6].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'clinics\' })\"><svg class=\"icon x1 clinic\"><use xlink:href=\"#clinic\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.clinics\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[6].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[7].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'doctors\' })\"><svg class=\"icon x1 doctor\"><use xlink:href=\"#doctor\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.doctors\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[7].count\"></span></a></li><li data-ui-sref-active=\"active\" data-ng-if=\"c.favoriteTypes[8].count > 0\"><a data-ui-sref=\"index.favorites({ uuid: \'medicAnswers\' })\"><svg class=\"icon x1 question\"><use xlink:href=\"#question\"></use></svg><span class=\"text\" data-translate=\"favoriteMenuTypes.medicAnswers\"></span> <span class=\"badge\" data-ng-bind=\"c.favoriteTypes[8].count\"></span></a></li></ul></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-ng-bind=\"c.title\"></h1></div><div class=\"block-content\"><ul class=\"block-content-list block-content-list-md no-margin-side\"><li data-ng-repeat=\"content in c.favoritesContent track by content.uuid\"><div class=\"row\"><div class=\"col-xs-10 col-sm-11\"><a href=\"javascript:void(0);\" data-ng-click=\"c.changeState(content)\"><span class=\"inner-text\" data-ng-bind=\"content.name\"></span></a></div><div class=\"col-xs-2 col-sm-1\"><a href=\"javascript:void(0);\" data-ng-click=\"c.onDelete(content)\" data-toggle=\"modal\" data-target=\"#removeFavorites\" class=\"text-center n-padding-right\"><svg class=\"icon trash\"><use xlink:href=\"#trash\"></use></svg></a></div></div></li></ul><br></div></div></div></div><div class=\"container\" data-ng-if=\"c.favoritesContent.length === 0\"><div class=\"default-block\"><div class=\"row content-empty\"><div style=\"\" class=\"col-md-offset-1 col-md-10 text-center\"><br class=\"hidden-xs\"><br class=\"hidden-xs\"><img class=\"img-responsive\" style=\"\" src=\"assets/images/promo/favorites_cap.svg\" alt=\"{{\'seo.alt.empty\' | translate}}\"><br><br class=\"hidden-xs\"><h2 data-translate=\"favoriteMenuTypes.emptyFavoriteTitle\"></h2><p><span data-translate=\"favoriteMenuTypes.onEmptyFavotiteText\"></span></p><br></div></div></div></div>");
$templateCache.put("app/components/content/food/food.html","<div class=\"row\"><div class=\"col-sm-3 block-accordion\"><div class=\"default-block\"><search-supplement></search-supplement></div><div class=\"panel-block-accordion\" data-bs-collapse=\"\" data-ng-model=\"toggleSupplement\" data-ui-view=\"categories\"><div class=\"default-block\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><a id=\"productsSvg\" data-ng-class=\"toggleSupplement === 0 ? \'collapsed\' : \'\' || toggleSupplement === false ? \'collapsed\' : \'\'\"><div class=\"panel-title-name\" data-ng-bind-html=\"c.productsHeader()\"></div><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-down\"></use></svg></a></h4></div><div class=\"panel-body\" data-bs-collapse-target=\"\" data-ng-class=\"toggleSupplement == false ? \'in\' : \'\'\"><div data-ui-view=\"productsCategory\"></div></div></div><div class=\"default-block\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><a id=\"supplementsSvg\" data-ng-class=\"toggleSupplement === 1 ? \'collapsed\' : \'\'\"><div class=\"panel-title-name\" data-ng-bind-html=\"c.categoriesHeader()\"></div><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-down\"></use></svg></a></h4></div><div class=\"panel-body supplement-content\" data-bs-collapse-target=\"\" data-ng-class=\"toggleSupplement == 1 ? \'in\' : \'\'\"><div data-ui-view=\"supplements\"></div></div></div></div></div><div data-ui-view=\"content\" class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.content.name\"></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\" data-ng-bind-html=\"c.content.description\"></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div></div></div>");
$templateCache.put("app/components/content/medicine/medicine.html","<div class=\"default-block\"><div class=\"row content-empty\"><div style=\"font-size: 17px; line-height: 20px;\" class=\"col-md-offset-1 col-md-10 text-center\"><br><img class=\"img-responsive\" style=\"max-width: 390px; display: inline-block; margin: 25px 10% 38px;\" src=\"assets/images/promo/Meds_image.svg\" alt=\"{{\'seo.alt.indevpromo\' | translate}}\"><h2 data-translate=\"medicine.disabled.title\"></h2><br></div></div></div>");
$templateCache.put("app/components/content/news/news.html","<div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-translate=\"index.ourBlog\"></h1></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-10\"><div class=\"block-news-articles\"><ul><li data-ng-repeat=\"newsItem in c.customPaging.visibleData\"><figure data-ng-if=\"newsItem.images[0] != null\"><a data-ui-sref=\"index.news.article({uuid: newsItem.uuid })\"><img class=\"img-responsive\" data-ng-src=\"{{\'api/v1/files/\' + newsItem.images[0].link}}\" alt=\"{{!!newsItem.images[0].alt ? newsItem.images[0].alt : newsItem.name}}\" title=\"{{!!newsItem.images[0].title ? newsItem.images[0].title : newsItem.name}}\"></a></figure><div class=\"article\"><a class=\"title\" data-ui-sref=\"index.news.article({uuid: newsItem.uuid })\">{{newsItem.name}}</a><div class=\"time\" data-ng-bind=\"newsItem.date | date:\'longDate\'\"></div><div class=\"article-body\" dotdotdot=\"\"><p data-ng-bind-html=\"newsItem.description | trust\"></p></div></div></li><load-more data-total=\"c.news.length\" load=\"c.customPaging.loadMore\" data-paging-parameters=\"c.pagingParameters\" data-direction=\"bottom\"></load-more></ul></div></div><div class=\"col-sm-2\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/content/search/search.html","<div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" data-translate=\"search.title\"></h1></div><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-10\"><div class=\"content-search\"><form class=\"input-group\" data-ng-submit=\"c.search()\"><input data-ng-model=\"c.searchText\" autocomplete=\"off\" type=\"text\" placeholder=\"{{ \'search.search\' | translate}}\" class=\"form-control\" name=\"searchbox\" maxlength=\"50\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\" data-ng-disabled=\"c.searchText.length === 0 || c.searchText === undefined\"><svg class=\"icon search\"><use xlink:href=\"#search\"></use></svg></button></span></form></div><div data-ng-show=\"!c.searching\"><div class=\"search-result-count\" data-translate=\"search.itemsFoundCount\" data-translate-values=\"{total: c.requestBounds.total}\"></div><ul class=\"search-result\"><li data-ng-repeat=\"item in c.data track by $index\"><div class=\"title\"><a data-ui-sref=\"index.contentCategories.contentSubcategories.article({ categoryUUID: item.parent.uuid, articleUUID: item.uuid})\">{{item.name}}</a></div><div class=\"description\"><p data-ng-bind-html=\"item.content\"></p></div></li></ul><br><nav><ul class=\"pagination\"><pager data-total=\"c.requestBounds.total\" data-offset=\"c.dataBounds.offset\" data-limit=\"c.dataBounds.limit\" data-max-buttons=\"5\"></pager></ul></nav></div><div data-ng-show=\"c.searching\"><hr><h4 class=\"text-center\" data-translate=\"search.searching\"></h4><hr></div></div><div class=\"col-sm-2\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/content/upgrowth/upgrowth.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"></categories-header><div class=\"block-content\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content\"></p><upgrowth-categories-content data-categories=\"c.categories\" data-param-name=\"categoryUUID\" data-nested-state-name=\"index.upgrowth.categories\">{{category.name}}</upgrowth-categories-content><br><div class=\"banner-block banner-block_970\"><adsense data-block-type=\"horizontal\" inline-style=\"display:inline-block;width:970px;height:90px\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/core/templates/alertTemplate.html","<div class=\"alert alert-top\" data-ng-class=\"[type ? \'alert-\' + type : null]\"><strong>{{title}}</strong>&nbsp; <span data-ng-bind-html=\"content\"></span></div>");
$templateCache.put("app/components/core/templates/modal-video.html","<div class=\"modal modal-video\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body mh-inherit\"><iframe frameborder=\"0\" allowfullscreen=\"\" data-ng-src=\"{{videoLink | trustResource}}\"></iframe></div></div></div></div>");
$templateCache.put("app/components/doctorSearch/details/doctorDetails.html","<div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block-content\"><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-3\"><figure class=\"clinic-photo\"><image-gallery-wrapper images=\"c.content.images\" gal-width=\"200\" gal-height=\"200\" data-ng-show=\"c.content.images.length > 0\"></image-gallery-wrapper><img class=\"img-responsive\" data-ng-src=\"/assets/images/no-ava-doctor.svg\" data-ng-show=\"c.content.images.length == 0\"></figure></div><div class=\"col-sm-9\"><categories-header data-content-name=\"c.content.lastName + \' \' + c.content.firstName + \' \' + c.content.patronymic\"><share-buttons data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-header><div class=\"block-content clinic-information\"><p><b><span data-ng-show=\"c.content.specializations.length > 0\">{{c.specializations | capitalize}}</span> <span data-ng-show=\"c.content.specializations.length == 0\" translate=\"doctorProfile.noInfo\"></span></b></p><p data-ng-show=\"c.content.education\" data-ng-bind-html=\"c.content.education\"></p><div class=\"row\"><div class=\"col-md-12\"><div><b><span class=\"text-danger\"><svg class=\"icon icon-middle address\"><use xlink:href=\"#address\"></use></svg>&nbsp;</span> <span address-formatter=\"\" country=\"c.content.country.name\" city=\"c.content.city.name\"></span></b></div><br><div><span class=\"text-danger\"><svg class=\"icon icon-middle phone\"><use xlink:href=\"#phone\"></use></svg>&nbsp;</span> <span data-ng-show=\"!c.content.phones || c.content.phones.length == 0\" translate=\"doctorProfile.noInfo\"></span><ul class=\"list-unstyled list-with-icon\" data-ng-show=\"c.content.phones && c.content.phones.length > 0\"><li data-ng-repeat=\"phone in c.content.phones\"><b>{{phone.phone}}</b> <span data-ng-if=\"phone.name\">{{\' - \' + phone.name}}</span></li></ul></div><br><div><span class=\"text-danger\"><svg class=\"icon icon-middle doctor-ambulance\"><use xlink:href=\"#doctor-ambulance\"></use></svg>&nbsp;</span> <b data-ng-show=\"c.content.onHome\" translate=\"doctorProfile.onHome\"></b> <b data-ng-show=\"!c.content.onHome\" translate=\"doctorProfile.notOnHome\"></b></div><br><span data-ng-show=\"c.content.autobiography\" data-ng-bind-html=\"c.content.autobiography | trust\"></span> <span data-ng-show=\"!c.content.autobiography\" translate=\"doctorProfile.noAutobiography\"></span></div></div><hr><div class=\"tabs-custom\" data-bs-active-pane=\"c.activeTab\" data-template=\"app/components/tabs/tabs.html\" data-bs-tabs=\"\"><div ng-repeat=\"tab in tabs\" data-title=\"{{ tab.title }}\" name=\"{{ tab.title }}\" disabled=\"{{ tab.disabled }}\" ng-bind=\"tab.content\" bs-pane=\"\" class=\"valis\"></div></div><div class=\"tab-content\"><div data-ng-show=\"c.activeTab === \'doctorProfile.facilities\'\"><div class=\"search-result-list\" data-ng-show=\"c.content.healthFacilities\"><div class=\"row\"><div class=\"col-sm-12\" data-ng-repeat=\"facility in c.content.healthFacilities\"><div class=\"search-user-profile\"><share-buttons data-only-star=\"true\" data-article=\"facility\" data-type=\"c.facilityFavoriteType\"></share-buttons><figure><a data-ui-sref=\"index.clinics.details({\'uuid\' : facility.uuid})\"><img data-ng-src=\"{{\'api/v1/files/\' + facility.photo + \'?ratio=90\'}}\" alt=\"\" data-ng-show=\"facility.photo\" data-object-fit=\"cover\"> <img data-ng-src=\"/assets/images/clinic-no-photo.png\" alt=\"\" data-ng-show=\"!facility.photo\"></a></figure><div class=\"information\"><a data-ui-sref=\"index.clinics.details({\'uuid\' : facility.uuid})\" class=\"name\">{{facility.name | dot:50}}</a><address>{{(facility.address | dot:60) + \',\'}} <span>{{facility.city}}</span></address><br><working-hours data-ng-show=\"facility.doctorFacilityWorkTime.length!=0\" schedule=\"facility.doctorFacilityWorkTime\"></working-hours></div></div></div></div></div><div translate=\"clinicProfile.noInfo\" data-ng-show=\"!c.content.healthFacilities || c.content.healthFacilities.length == 0\"></div></div><div data-ng-show=\"c.activeTab === \'doctorProfile.achievementsAndPublications\'\"><h4 data-translate=\"{{ \'doctorProfile.achievements\' | translate}}\"></h4><div data-ng-bind-html=\"c.content.achievements | trust\" data-ng-show=\"c.content.achievements\"></div><div translate=\"doctorProfile.noInfo\" data-ng-show=\"!c.content.achievements\"></div><h4 data-translate=\"{{ \'doctorProfile.publications\' | translate}}\"></h4><div data-ng-bind-html=\"c.content.articles | trust\" data-ng-show=\"c.content.articles\"></div><div translate=\"doctorProfile.noInfo\" data-ng-show=\"!c.content.articles\"></div></div><div data-ng-show=\"c.activeTab === \'doctorProfile.articles\'\">В разработке</div><div data-ng-show=\"c.activeTab === \'doctorProfile.comments\'\"><comments data-type=\"7\" data-uuid=\"{{c.content.uuid}}\" no-head=\"true\"></comments></div></div><br></div></div></div></div></div></div></div>");
$templateCache.put("app/components/medics/answers/medics.answers.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\" data-ng-if=\"!c.user.doctor\"><div class=\"block-content\"><button class=\"btn btn-primary btn-block doctor-question-button\" data-ng-click=\"c.askDoctor()\" data-translate=\"medic.askDoctor\"></button></div></div><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.rubrics.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParametersLeft\" data-load-more=\"c.customPagingLeft.loadMore\" data-categories=\"c.customPagingLeft.visibleData\" data-param-name=\"rubricUUID\" data-nested-state-name=\"index.medics.answers\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\">{{c.titleName}}</h1></div><div class=\"block-content\"><ul class=\"block-content-list block-content-list-md no-margin-side\"><li data-ng-repeat=\"item in c.data track by $index\"><a data-ui-sref=\"index.medics.answers.article({\'articleUUID\' : item.uuid })\"><svg class=\"icon hover question-circle\"><use xlink:href=\"#question-circle\"></use></svg><b class=\"text\">{{item.name}}</b></a></li></ul><br><nav><ul class=\"pagination\"><pager data-total=\"c.requestBounds.total\" data-offset=\"c.dataBounds.offset\" data-limit=\"c.dataBounds.limit\"></pager></ul></nav></div></div></div></div>");
$templateCache.put("app/components/medics/questionModal/question.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"doctorQuestionModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"c.close()\" aria-label=\"Close\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"medic.question.title\"></h4></div><div class=\"modal-body\"><form name=\"editForm\" novalidate=\"\"><div class=\"form-group\" data-ng-class=\"{\'has-required\':(editForm.topic.$invalid && editForm.$submitted) }\"><input id=\"doctorQuestion-theme\" type=\"text\" class=\"form-control\" name=\"topic\" data-ng-model=\"c.entity.topic\" placeholder=\"{{\'medic.question.topic\' | translate}}\" maxlength=\"254\" required=\"\"><p data-ng-show=\"editForm.topic.$invalid && editForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"editForm.topic.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"editForm.topic.$error.maxlength\" data-translate=\"general.maxlengthField\" data-translate-values=\"{count:255}\"></span></p><label for=\"doctorQuestion-theme\" class=\"sr-only\"></label></div><div class=\"form-group\" data-ng-class=\"{\'has-required\':(editForm.originalQuestion.$invalid && editForm.$submitted) }\"><textarea name=\"originalQuestion\" id=\"doctorQuestion-message\" rows=\"5\" class=\"form-control no-resize\" data-ng-model=\"c.entity.originalQuestion\" placeholder=\"{{\'medic.question.question\' | translate}}\" maxlength=\"10000\" required=\"\"></textarea><p data-ng-show=\"editForm.originalQuestion.$invalid && editForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"editForm.originalQuestion.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"editForm.originalQuestion.$error.maxlength\" data-translate=\"general.maxlengthField\" data-translate-values=\"{count:10000}\"></span></p><label for=\"doctorQuestion-message\" class=\"sr-only\"></label></div><p class=\"help-block\"><small data-translate=\"medic.question.subInfo\"></small></p></form></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.save()\" data-target=\"#doctorQuestionSuccess\" data-translate=\"general.send\" data-ng-disabled=\"c.isSaving || !editForm.$dirty || (editForm.$submitted && editForm.$invalid)\"></button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"c.close()\" data-translate=\"general.cancel\" data-ng-disabled=\"c.isSaving\"></button></div></div></div></div>");
$templateCache.put("app/components/authentication/login/forgotPassword/forgot.password.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"forgotPassword\"><form name=\"forgotForm\" novalidate=\"\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"$hide()\" aria-label=\"Close\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"authentication.signUp.forgotPassword\"></h4></div><div data-ng-show=\"!c.changedPass\" class=\"modal-body\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': forgotForm.$submitted && (forgotForm.email.$error.email || c.emailNotFound || forgotForm.email.$error.required) }\"><input id=\"forgot-password\" type=\"email\" class=\"form-control\" name=\"email\" required=\"required\" placeholder=\"E-mail\" data-ng-model=\"email\" data-validation-email=\"\"> <label for=\"forgot-password\" class=\"sr-only\"></label><p data-ng-show=\"forgotForm.$submitted && (forgotForm.email.$error.email || forgotForm.email.$error.required)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"forgotForm.$submitted && forgotForm.email.$error.email\" data-translate=\"general.incorrectEmail\"></span> <span data-ng-show=\"forgotForm.$submitted && forgotForm.email.$error.required\" data-translate=\"general.requiredField\"></span></p><div data-ng-show=\"c.emailNotFound\" class=\"alert alert-warning\" role=\"alert\"><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span class=\"alert-text\" data-translate=\"general.notExistEmail\"></span></div></div></div><div data-ng-show=\"c.changedPass\" class=\"modal-body\"><div class=\"alert alert-success\" role=\"alert\"><svg class=\"icon check-circle\"><use xlink:href=\"#check-circle\"></use></svg><span class=\"alert-text\" data-translate=\"general.successEmailReestablished\"></span></div></div><div data-ng-show=\"!c.changedPass\" class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.changePasswordResource(email)\" data-ng-disabled=\"!forgotForm.$dirty || (forgotForm.$submitted && forgotForm.$invalid)\">Отправить</button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"$hide()\">Отмена</button></div><div data-ng-show=\"c.changedPass\" class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"$hide()\">OK</button></div></div></div></form></div>");
$templateCache.put("app/components/authentication/profile/children/children.html","<div class=\"up-my-children\"><div class=\"my-children-control\"><button type=\"button\" id=\"add-new-children\" class=\"btn btn-default\" data-ng-click=\"c.showChildrenModal()\"><svg class=\"icon user-plus\"><use xlink:href=\"#user-plus\"></use></svg><span data-translate=\"userProfile.addChildren\"></span></button></div><div class=\"my-children-content\"><ul class=\"my-children-list list-unstyled\"><li data-ng-repeat=\"item in c.data\"><div class=\"row\"><div class=\"col-xs-9 clearfix\"><figure class=\"my-children-avatar\"><img data-ng-src=\"{{\'api/v1/files/\' + item.avatar}}\" data-ng-show=\"item.avatar\" alt=\"{{\'seo.alt.avatar\' | translate}}\"> <img src=\"assets/images/my-children-no-photo.png\" data-ng-show=\"!item.avatar\" alt=\"{{\'seo.alt.noavatar\' | translate}}\"></figure><div class=\"children-name\">{{item.firstName}}</div><div class=\"children-year\" age-display=\"{{item.birthDate}}\"></div></div><div class=\"col-xs-3\"><div class=\"children-options\"><a href=\"#\" data-ng-click=\"c.showChildrenModal(item)\"><svg class=\"icon edit\"><use xlink:href=\"#edit\"></use></svg></a> <a href=\"#\" data-ng-click=\"c.delete(item)\"><svg class=\"icon user-times\"><use xlink:href=\"#user-times\"></use></svg></a></div></div></div></li></ul></div><div class=\"content-empty\" data-ng-show=\"c.data.length===0\" style=\"text-align: center;\"><img class=\"img-responsive\" style=\"max-width: 330px; display: inline-block; margin: 35px 10% 28px;\" src=\"assets/images/baby_image.svg\" alt=\"{{\'seo.alt.empty\' | translate}}\"><h2 data-translate=\"userProfile.noChildrenYet\"></h2><p data-translate=\"userProfile.noChildrenYetText\"></p><br></div></div><div class=\"banner-block banner-block_970\"><adsense data-block-type=\"horizontal\" inline-style=\"display:inline-block;width:970px;height:90px\"></adsense></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/datepicker.tpl.html","<div class=\"dropdown-menu datepicker\" ng-class=\"\'datepicker-mode-\' + $mode\" style=\"max-width: 320px;\"><table style=\"table-layout: fixed; height: 100%; width: 100%;\"><thead><tr class=\"text-center\"><th><button tabindex=\"-1\" type=\"button\" class=\"btn btn-default pull-left\" ng-click=\"$selectPane(-1)\"><svg class=\"icon hover\"><use xlink:href=\"#chevron-left\"></use></svg></button></th><th colspan=\"{{ rows[0].length - 2 }}\"><button tabindex=\"-1\" type=\"button\" class=\"btn btn-default btn-block text-strong\" ng-click=\"$toggleMode()\"><strong style=\"text-transform: capitalize;\" ng-bind=\"title\"></strong></button></th><th><button tabindex=\"-1\" type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"$selectPane(+1)\"><svg class=\"icon hover\"><use xlink:href=\"#chevron-right\"></use></svg></button></th></tr><tr ng-if=\"showLabels\" ng-bind-html=\"labels\"></tr></thead><tbody><tr ng-repeat=\"(i, row) in rows\" height=\"{{ 100 / rows.length }}%\"><td class=\"text-center\" ng-repeat=\"(j, el) in row\"><button tabindex=\"-1\" type=\"button\" class=\"btn btn-default\" style=\"width: 100%\" ng-class=\"{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}\" ng-click=\"$select(el.date)\" ng-disabled=\"el.disabled\"><span ng-class=\"{\'text-muted\': el.muted}\" ng-bind=\"el.label\"></span></button></td></tr></tbody><tfoot><tr><td colspan=\"{{ rows[0].length }}\"><div class=\"btn-group btn-group-justified\" role=\"group\"><div class=\"btn-group\" role=\"group\" ng-if=\"$hasToday\"><button type=\"button\" class=\"btn btn-default today\" ng-click=\"$setToday()\" ng-disabled=\"isTodayDisabled\"><strong style=\"text-transform: capitalize;\">Today</strong></button></div><div class=\"btn-group\" role=\"group\" ng-if=\"$hasClear\"><button type=\"button\" class=\"btn btn-default clear\" ng-click=\"$clear()\"><strong style=\"text-transform: capitalize;\">Clear</strong></button></div></div></td></tr></tfoot></table></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/doctorsProfile.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block\"><div class=\"block-content\"><div class=\"alert alert-warning alert_center\" data-ng-if=\"c.content.status === 0\" translate=\"doctorProfile.blocked\"></div><div class=\"row doctors-profile\"><div class=\"col-sm-3\"><figure class=\"doctor-photo mb-1\"><img data-object-fit=\"cover\" class=\"img-responsive\" data-ng-src=\"/api/v1/files/{{c.content.photo}}\" data-ng-if=\"c.content.photo\"> <img class=\"img-responsive\" data-ng-src=\"/assets/images/no-ava-doctor.svg\" data-ng-hide=\"c.content.photo\"></figure></div><div class=\"col-sm-9\"><categories-header data-content-name=\"c.content.lastName + \' \' + c.content.firstName + \' \' + c.content.patronymic\"><button type=\"button\" ui-sref=\"index.profile.doctor.edit\" class=\"btn btn-edit\"><svg class=\"icon\"><use xlink:href=\"#pencil\"></use></svg></button></categories-header><div class=\"block-content clinic-information\"><p><b><span data-ng-show=\"c.content.specializations.length > 0\">{{c.specializations | capitalize}}</span> <span data-ng-show=\"c.content.specializations.length == 0\" translate=\"doctorProfile.noInfo\"></span></b></p><p data-ng-show=\"c.content.education\" data-ng-bind-html=\"c.content.education\"></p><div class=\"row\"><div class=\"col-md-12\"><div><b><span class=\"text-danger\"><svg class=\"icon icon-middle address\"><use xlink:href=\"#address\"></use></svg>&nbsp;</span> <span address-formatter=\"\" country=\"c.content.country.name\" city=\"c.content.city.name\"></span></b></div><br><div class=\"phones\"><span class=\"text-danger\"><svg class=\"icon icon-middle phone\"><use xlink:href=\"#phone\"></use></svg>&nbsp;</span> <span data-ng-show=\"!c.content.phones || c.content.phones.length == 0\" translate=\"doctorProfile.noInfo\"></span><ul class=\"list-unstyled list-with-icon\" data-ng-show=\"c.content.phones && c.content.phones.length > 0\"><li data-ng-repeat=\"phone in c.content.phones\"><b>{{phone.phone}}</b> <span data-ng-if=\"phone.name\">{{\' - \' + phone.name}}</span></li></ul></div><br><div><span class=\"text-danger\"><svg class=\"icon icon-middle doctor-ambulance\"><use xlink:href=\"#doctor-ambulance\"></use></svg>&nbsp;</span> <b data-ng-show=\"c.content.onHome\" translate=\"doctorProfile.onHome\"></b> <b data-ng-show=\"!c.content.onHome\" translate=\"doctorProfile.notOnHome\"></b></div><br><span data-ng-show=\"c.content.autobiography\" data-ng-bind-html=\"c.content.autobiography | trust\"></span> <span data-ng-show=\"!c.content.autobiography\" translate=\"doctorProfile.noAutobiography\"></span></div></div><hr><div class=\"tabs-custom\" data-bs-active-pane=\"c.activeTab\" data-template=\"app/components/tabs/tabs.html\" data-bs-tabs=\"\"><div ng-repeat=\"tab in tabs\" data-title=\"{{ tab.title }}\" name=\"{{ tab.title }}\" disabled=\"{{ tab.disabled }}\" ng-bind=\"tab.content\" bs-pane=\"\" class=\"valis\"></div></div><div class=\"tab-content\"><div data-ng-show=\"c.activeTab === \'doctorProfile.facilities\'\"><button type=\"button\" class=\"btn btn-primary mb-1\" data-ng-click=\"c.openClinics()\">+ {{\'general.add\' | translate}}</button><div class=\"search-result-list\" data-ng-show=\"c.content.healthFacilities\"><div class=\"row\"><div class=\"col-sm-12 card\" data-ng-repeat=\"facility in c.content.healthFacilities\"><div class=\"search-user-profile\"><div class=\"card-edit\"><button type=\"button\" class=\"btn btn-edit btn-edit_gray\" data-ng-click=\"c.editClinic($index, facility)\"><svg class=\"icon clock\"><use xlink:href=\"#clock-o\"></use></svg></button> <button type=\"button\" class=\"btn btn-edit btn-edit_gray\" data-ng-click=\"c.removeClinic($index)\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button></div><figure><a data-ui-sref=\"index.clinics.details({\'uuid\' : facility.uuid})\"><img data-ng-src=\"{{\'api/v1/files/\' + facility.photo + \'?ratio=90\'}}\" alt=\"\" data-ng-if=\"facility.photo\" data-object-fit=\"cover\"> <img data-ng-src=\"/assets/images/clinic-no-photo.png\" alt=\"\" data-ng-show=\"!facility.photo\"></a></figure><div class=\"information\"><a data-ui-sref=\"index.clinics.details({\'uuid\' : facility.uuid})\" class=\"name\">{{facility.name | dot:50}}</a><address>{{(facility.address | dot:60) + \',\'}} <span>{{facility.city}}</span></address><br><working-hours data-ng-show=\"facility.doctorFacilityWorkTime.length!=0\" schedule=\"facility.doctorFacilityWorkTime\"></working-hours></div></div></div></div></div><div translate=\"clinicProfile.noInfo\" data-ng-show=\"!c.content.healthFacilities || c.content.healthFacilities.length == 0\"></div></div><div data-ng-show=\"c.activeTab === \'doctorProfile.achievementsAndPublications\'\"><button type=\"button\" ui-sref=\"index.profile.doctor.achievements\" class=\"btn btn-edit btn-edit_gray pull-right\"><svg class=\"icon\"><use xlink:href=\"#pencil\"></use></svg></button><h4 data-translate=\"{{ \'doctorProfile.achievements\' | translate}}\"></h4><div data-ng-bind-html=\"c.content.achievements | trust\" data-ng-show=\"c.content.achievements\"></div><div translate=\"doctorProfile.noInfo\" data-ng-show=\"!c.content.achievements\"></div><h4 data-translate=\"{{ \'doctorProfile.publications\' | translate}}\"></h4><div data-ng-bind-html=\"c.content.articles | trust\" data-ng-show=\"c.content.articles\"></div><div translate=\"doctorProfile.noInfo\" data-ng-show=\"!c.content.articles\"></div></div><div data-ng-show=\"c.activeTab === \'doctorProfile.articles\'\">В разработке</div><div data-ng-show=\"c.activeTab === \'doctorProfile.comments\'\"><comments data-type=\"7\" data-uuid=\"{{c.content.uuid}}\" no-head=\"true\"></comments></div></div><br></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/edit/profile.edit.html","<form name=\"profileForm\" novalidate=\"\"><div class=\"row form-change-data\"><div class=\"col-sm-6 col-md-4 form-group\" data-ng-class=\"{\'has-required\':(profileForm.firstName.$error.required && profileForm.$submitted) || profileForm.firstName.$error.pattern}\"><label>{{\'userProfile.firstName\' | translate}} <sup>*</sup></label> <input required=\"\" type=\"text\" maxlength=\"30\" name=\"firstName\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" data-ng-model=\"c.entity.firstName\" class=\"form-control\"><p data-ng-show=\"(profileForm.firstName.$error.required && profileForm.$submitted) || profileForm.firstName.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"profileForm.firstName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"profileForm.firstName.$error.pattern\" data-translate=\"general.incorrectFirstName\"></span></p></div><div class=\"col-sm-6 col-md-4 form-group\" data-ng-class=\"{\'has-required\': profileForm.$submitted && profileForm.lastName.$error.pattern}\"><label>{{\'userProfile.lastName\' | translate}}</label> <input type=\"text\" maxlength=\"30\" name=\"lastName\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" data-ng-model=\"c.entity.lastName\" class=\"form-control\"><p data-ng-show=\"profileForm.$submitted && profileForm.lastName.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"profileForm.lastName.$error.pattern\" data-translate=\"general.incorrectLastName\"></span></p></div><div class=\"col-sm-6 col-md-4 form-group\" data-ng-class=\"{\'has-required\': (profileForm.email.$error.required && profileForm.$submitted) || profileForm.email.$error.email}\"><label>{{\'userProfile.email\' | translate}} <sup>*</sup></label> <input required=\"\" type=\"email\" maxlength=\"255\" data-validation-email=\"\" name=\"email\" data-ng-model=\"c.entity.email\" data-ng-model-options=\"{ updateOn : \'default blur\', debounce : {\'default\': 500, \'blur\': 0} }\" placeholder=\"me@example.com\" class=\"form-control\"><p data-ng-show=\"(profileForm.email.$error.required && profileForm.$submitted) || profileForm.email.$error.pattern\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"profileForm.email.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"profileForm.email.$error.pattern\" data-translate=\"general.incorrectEmail\"></span></p></div><div class=\"col-sm-6 col-md-4 form-group\" data-ng-class=\"{\'has-required\': profileForm.birthDate.$error.isNotInPast && profileForm.$submitted }\"><label>{{\'userProfile.birthday\' | translate}}</label><birthday-select data-ng-model=\"c.birthDate\" name=\"birthDate\"></birthday-select><p data-ng-show=\"profileForm.birthDate.$error.isNotInPast && profileForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"general.incorrectBirthDate\"></span></p></div><div class=\"col-sm-6 col-md-4 form-group\"><location-select data-is-required=\"true\" data-country-label=\"c.countryLabel\" data-country=\"c.entity.userLocation.country\" data-region-label=\"c.regionLabel\" data-region=\"c.entity.userLocation.region\" data-city-label=\"c.cityLabel\" data-city=\"c.entity.userLocation.city\" data-full-content=\"true\" parent-form=\"profileForm\"></location-select></div><div class=\"col-sm-6 col-md-4 form-group\"><div class=\"form-group\"><label for=\"pregnancy-ages\" data-translate=\"userProfile.pregnancyAge\"></label><select name=\"pregnancy-ages\" class=\"form-control\" data-ng-class=\"{\'empty\': !c.entity.pregnancyAge}\" id=\"pregnancy-ages\" data-ng-model=\"c.entity.pregnancyAge\" data-ng-options=\"pregnancy.uuid as pregnancy.name for pregnancy in c.pregnancyAges\"><option value=\"\" data-translate=\"userProfile.pregnancyAgeNone\"></option></select></div></div><div class=\"col-sm-6 col-md-4 form-group\"><button class=\"btn btn-default\" data-ng-click=\"c.save()\" data-translate=\"userProfile.save\" data-ng-disabled=\"!profileForm.$dirty || (profileForm.$submitted && profileForm.$invalid)\"></button></div></div></form>");
$templateCache.put("app/components/authentication/profile/resetPassword/resetPassword.html","<form name=\"changePassword\" class=\"row form-change-password\" novalidate=\"\"><div class=\"col-sm-4 form-group\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.oldPassword.$error.required || changePassword.oldPassword.$error.pattern || c.invalidOldPassord)}\"><label for=\"up-change-password-old\">{{\'userProfile.oldPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" type=\"password\" class=\"form-control\" id=\"up-change-password-old\" name=\"oldPassword\" maxlength=\"32\" data-ng-model=\"c.data.oldPassword\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" data-ng-change=\"c.oldPasswordChange()\"> <label for=\"up-change-password-old\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.oldPassword.$error.required || changePassword.oldPassword.$error.pattern || c.invalidOldPassord)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.oldPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.oldPassword.$error.pattern\" data-translate=\"general.incorrectPassword\"></span> <span data-ng-show=\"c.invalidOldPassord\" data-translate=\"general.invalidOldPassord\"></span></p></div><div class=\"col-sm-4 form-group\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.newPassword.$error.required || changePassword.newPassword.$error.pattern)}\"><label for=\"up-change-password-new\">{{\'userProfile.newPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" type=\"password\" class=\"form-control\" id=\"up-change-password-new\" maxlength=\"32\" name=\"newPassword\" data-ng-model=\"c.data.newPassword\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\"> <label for=\"up-change-password-new\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.newPassword.$error.required || changePassword.newPassword.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.newPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.newPassword.$error.match\" data-translate=\"general.doesNotMatch\"></span> <span data-ng-show=\"changePassword.newPassword.$error.pattern\" data-translate=\"general.incorrectPassword\"></span></p></div><div class=\"col-sm-4 form-group\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.repeatPassword.$error.required || changePassword.repeatPassword.$error.match)}\"><label for=\"up-change-password-re\">{{\'userProfile.repeatNewPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" type=\"password\" class=\"form-control\" id=\"up-change-password-re\" data-match-validator=\"newPassword\" name=\"repeatPassword\" data-ng-model=\"c.data.repeatPassword\"> <label for=\"up-change-password-re\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.repeatPassword.$error.required || changePassword.repeatPassword.$error.match)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.repeatPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.repeatPassword.$error.match\" data-translate=\"general.doesNotMatch\"></span></p></div><div class=\"col-sm-4 form-group\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.changePassword()\" data-ng-disabled=\"!changePassword.$dirty || (changePassword.$submitted && changePassword.$invalid)\">Сохранить</button></div></form>");
$templateCache.put("app/components/authentication/profile/subscriptions/subscriptions.html","<div class=\"profile-content-empty\">Вы еще никуда не подписались</div>");
$templateCache.put("app/components/authentication/signUp/doctor/doctorSignUp.html","<form name=\"signUpForm\" novalidate=\"\" autocomplete=\"off\"><fieldset><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.email.$error.required || signUpForm.email.$error.email) || c.emailExist}\"><input id=\"r-doctor-email\" required=\"required\" type=\"email\" class=\"form-control\" data-ng-model=\"c.user.email\" maxlength=\"64\" name=\"email\" placeholder=\"{{\'authentication.signUp.email\' | translate}}\" data-validation-email=\"\" autocomplete=\"off\"> <label for=\"r-doctor-email\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.email.$error.required || signUpForm.email.$error.email) || c.emailExist\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.email.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.email.$error.email\" data-translate=\"general.incorrectEmail\"></span> <span data-ng-show=\"c.emailExist\" data-translate=\"general.exisEmail\"></span></p></div></fieldset><fieldset><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.firstName.$error.required || signUpForm.firstName.$error.pattern)}\"><input id=\"r-doctor-name\" type=\"text\" name=\"firstName\" data-ng-model=\"c.user.firstName\" class=\"form-control\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" maxlength=\"30\" placeholder=\"{{\'authentication.signUp.name\' | translate}}\" required=\"required\" autocomplete=\"off\"> <label for=\"r-doctor-name\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.firstName.$error.required || signUpForm.firstName.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.firstName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.firstName.$error.pattern\" data-translate=\"general.incorrectFirstName\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.lastName.$error.required || signUpForm.lastName.$error.pattern)}\"><input id=\"r-doctor-last-name\" name=\"lastName\" type=\"text\" class=\"form-control\" required=\"required\" data-ng-model=\"c.user.lastName\" data-ng-pattern=\"/^[\\w | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" maxlength=\"30\" placeholder=\"{{\'authentication.signUp.lastName\' | translate}}\" autocomplete=\"off\"> <label for=\"r-doctor-last-name\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.lastName.$error.required || signUpForm.lastName.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.lastName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.lastName.$error.pattern\" data-translate=\"general.incorrectLastName\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.patronymic.$error.required || signUpForm.patronymic.$error.pattern)}\"><input id=\"r-doctor-other-name\" name=\"patronymic\" type=\"text\" class=\"form-control\" required=\"required\" data-ng-model=\"c.user.patronymic\" data-ng-pattern=\"/^[\\w | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" maxlength=\"30\" placeholder=\"{{\'authentication.signUp.patronymic\' | translate}}\" autocomplete=\"off\"> <label for=\"r-doctor-other-name\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.patronymic.$error.required || signUpForm.patronymic.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.patronymic.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.patronymic.$error.pattern\" data-translate=\"general.incorrectPatronymic\"></span></p></div></fieldset><fieldset><div class=\"form-group\"><location-select data-is-required=\"true\" data-country=\"c.user.country\" data-city=\"c.user.city\" data-region=\"c.user.region\" data-full-content=\"true\" parent-form=\"signUpForm\"></location-select></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && signUpForm.clinic.$error.required}\"><select data-ng-disabled=\"!c.user.city\" name=\"clinic\" data-ng-options=\"clinic.name for clinic in c.clinics track by clinic.uuid\" class=\"form-control\" id=\"r-doctor-job\" required=\"required\" data-ng-model=\"c.user.department\"><option value=\"\" disabled=\"\">{{ \'authentication.signUp.workPlace\' | translate }}</option></select><label for=\"clinic\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && signUpForm.clinic.$error.required\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.clinic.$error.required\" data-translate=\"general.requiredField\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && signUpForm.specialization.$error.required }\"><select name=\"specialization\" class=\"form-control\" id=\"r-doctor-spec\" data-ng-options=\"spec.name for spec in c.specs track by spec.uuid\" required=\"required\" data-ng-model=\"c.user.specialization\"><option value=\"\" disabled=\"\">{{ \'authentication.signUp.specialization\' | translate }}</option></select><label for=\"specialization\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && signUpForm.specialization.$error.required\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.specialization.$error.required\" data-translate=\"general.requiredField\"></span></p></div></fieldset><fieldset><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.password.$error.required || signUpForm.password.$error.pattern)}\"><input id=\"r-doctor-password\" type=\"password\" name=\"password\" data-ng-model=\"c.user.password\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" maxlength=\"32\" required=\"required\" placeholder=\"{{\'authentication.signUp.password\' | translate}}\" class=\"form-control\" autocomplete=\"off\"> <label for=\"password\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.password.$error.required || signUpForm.password.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.password.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.password.$error.pattern\" data-translate=\"general.incorrectPassword\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.repeatPassword.$error.required || signUpForm.repeatPassword.$error.match)}\"><input placeholder=\"Повторите пароль\" maxlength=\"32\" required=\"required\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" type=\"password\" class=\"form-control\" id=\"r-doctor-password-re\" data-match-validator=\"password\" name=\"repeatPassword\" data-ng-model=\"c.data.repeatPassword\"> <label for=\"r-doctor-password-re\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.repeatPassword.$error.required || signUpForm.repeatPassword.$error.match)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.repeatPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.repeatPassword.$error.match\" data-translate=\"general.doesNotMatch\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\':signUpForm.$submitted && signUpForm.licenseAgreement.$error.required}\"><div class=\"checkbox license-agreement\"><label for=\"r-user-license-agreement\"><input type=\"checkbox\" id=\"r-user-license-agreement\" data-ng-model=\"c.entity.termsOfUse\" required=\"required\" name=\"licenseAgreement\" autocomplete=\"off\"> <span data-translate=\"authentication.signUp.agreement.agree\"></span> <a data-ui-sref=\"index.aboutUs({articleUUID: \'termsOfUse\'})\" target=\"_blank\" data-translate=\"authentication.signUp.agreement.termsOfUse\"></a> и <a data-ui-sref=\"index.aboutUs({articleUUID: \'confidentiality\'})\" target=\"_blank\" data-translate=\"authentication.signUp.agreement.privacyPolicy\"></a></label></div></div><div data-ng-class=\"{\'has-required\':signUpForm.$submitted && signUpForm.licenseAgreement.$error.required}\"><p data-ng-show=\"signUpForm.$submitted && signUpForm.licenseAgreement.$error.required\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.licenseAgreement.$error.required\" data-translate=\"general.requiredField\"></span></p></div></fieldset><div class=\"form-group\"><button data-ng-click=\"c.register(signUpForm)\" type=\"submit\" class=\"btn btn-default btn-block\" data-translate=\"authentication.signUp.register\" data-ng-disabled=\"c.isRegistering || !signUpForm.$dirty || (signUpForm.$submitted && signUpForm.$invalid)\"></button></div></form>");
$templateCache.put("app/components/authentication/signUp/partials/clinicSignUp.html","<fieldset><div class=\"form-group\"><input id=\"r-clinic-email\" type=\"text\" class=\"form-control\" placeholder=\"E-mail\" required=\"required\"> <label for=\"r-clinic-email\" class=\"sr-only\"></label></div></fieldset><fieldset><div class=\"form-group\"><input id=\"r-clinic-name\" type=\"text\" class=\"form-control\" placeholder=\"Название\" required=\"required\"> <label for=\"r-clinic-name\" class=\"sr-only\"></label></div><div class=\"form-group\"><select name=\"r-clinic-type\" class=\"form-control\" id=\"r-clinic-type\"><option value=\"0\">Тип учреждения</option><option value=\"1\">Название типа учреждения 1</option><option value=\"2\">Название типа учреждения 2</option><option value=\"3\">Название типа учреждения 3</option></select><label for=\"r-clinic-type\" class=\"sr-only\"></label></div><div class=\"form-group\"><label for=\"r-clinic-description\" class=\"sr-only\"></label> <textarea name=\"r-clinic-description\" class=\"form-control no-resize\" id=\"r-clinic-description\" placeholder=\"Описание\" rows=\"2\" required=\"required\"></textarea></div></fieldset><fieldset><div class=\"form-group\"><select name=\"r-clinic-country\" class=\"form-control\" id=\"r-clinic-country\"><option value=\"0\">Страна</option><option value=\"1\">Название страны 1</option><option value=\"2\">Название страны 2</option><option value=\"3\">Название страны 3</option></select><label for=\"r-clinic-country\" class=\"sr-only\"></label></div><div class=\"form-group\"><select disabled=\"\" name=\"r-clinic-region\" class=\"form-control\" id=\"r-clinic-region\"><option value=\"0\">Область</option><option value=\"1\">Название области 1</option><option value=\"2\">Название области 2</option><option value=\"3\">Название области 3</option></select><label for=\"r-clinic-region\" class=\"sr-only\"></label></div><div class=\"form-group\"><select disabled=\"\" name=\"r-clinic-city\" class=\"form-control\" id=\"r-clinic-city\"><option value=\"0\">Город</option><option value=\"1\">Название города 1</option><option value=\"2\">Название города 2</option><option value=\"3\">Название города 3</option></select><label for=\"r-clinic-city\" class=\"sr-only\"></label></div></fieldset><fieldset><div class=\"form-group\"><input id=\"r-clinic-password\" type=\"password\" class=\"form-control\" placeholder=\"Пароль\" required=\"required\"> <label for=\"r-clinic-password\" class=\"sr-only\"></label></div><div class=\"form-group\"><input id=\"r-clinic-password-re\" type=\"password\" class=\"form-control\" placeholder=\"Повторите пароль\" required=\"required\"> <label for=\"r-clinic-password-re\" class=\"sr-only\"></label></div><div class=\"form-group\"><div class=\"checkbox license-agreement\"><label for=\"r-clinic-license-agreement\"><input type=\"checkbox\" id=\"r-clinic-license-agreement\"> Я согласен с <a target=\"_blank\" href=\"#\">Условиями использования</a> и <a target=\"_blank\" href=\"#\">Политикой конфиденциальности</a></label></div></div></fieldset><div class=\"form-group\"><button class=\"btn btn-default btn-block\">Зарегистрироваться</button></div>");
$templateCache.put("app/components/authentication/signUp/partials/socialNetworks.html","<ul class=\"list-unstyled social-authorization\"><li><a class=\"fb\" href=\"\" data-ng-click=\"c.facebookInfo()\"><svg class=\"icon facebook\"><use xlink:href=\"#facebook\"></use></svg></a></li><li><a class=\"vk\" href=\"\" data-ng-click=\"c.startVkAuth()\"><svg class=\"icon vk\"><use xlink:href=\"#vk\"></use></svg></a></li><li><a class=\"gg\" href=\"\" data-ng-click=\"c.googlePlusInfo()\"><svg class=\"icon google-plus\"><use xlink:href=\"#google-plus\"></use></svg></a></li><li><a class=\"tw\" href=\"\" data-ng-click=\"c.startOkAuth()\"><svg class=\"icon odnoklassniki\"><use xlink:href=\"#odnoklassniki\"></use></svg></a></li></ul>");
$templateCache.put("app/components/authentication/signUp/partials/userSignUp.html","<form name=\"signUpForm\" novalidate=\"\" autocomplete=\"off\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.firstName.$error.required || signUpForm.firstName.$error.pattern)}\"><input id=\"r-user-name\" type=\"text\" name=\"firstName\" data-ng-model=\"c.user.firstName\" class=\"form-control\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" maxlength=\"30\" placeholder=\"{{\'authentication.signUp.name\' | translate}}\" required=\"required\" autocomplete=\"off\"> <label for=\"r-user-name\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.firstName.$error.required || signUpForm.firstName.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.firstName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.firstName.$error.pattern\" data-translate=\"general.incorrectFirstName\"></span></p></div></div><div class=\"col-sm-6\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.lastName.$error.required || signUpForm.lastName.$error.pattern)}\"><input id=\"r-user-lname\" name=\"lastName\" type=\"text\" class=\"form-control\" data-ng-model=\"c.user.lastName\" data-ng-pattern=\"/^[\\w | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,30}$/\" maxlength=\"30\" placeholder=\"{{\'authentication.signUp.lastName\' | translate}}\" autocomplete=\"off\"> <label for=\"r-user-lname\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.lastName.$error.required || signUpForm.lastName.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.lastName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.lastName.$error.pattern\" data-translate=\"general.incorrectLastName\"></span></p></div></div></div><fieldset><location-select data-is-required=\"true\" data-country=\"c.user.country\" data-city=\"c.user.city\" data-region=\"c.user.region\" parent-form=\"signUpForm\" data-full-content=\"true\"></location-select></fieldset><fieldset><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.email.$error.required || signUpForm.email.$error.email) }\"><input id=\"r-user-email\" type=\"email\" name=\"email\" data-ng-model=\"c.user.email\" data-validation-email=\"\" maxlength=\"64\" placeholder=\"{{\'authentication.signUp.email\' | translate}}\" class=\"form-control\" required=\"required\" autocomplete=\"off\"> <label for=\"r-user-email\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.email.$error.required || signUpForm.email.$error.email)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.email.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.email.$error.email\" data-translate=\"general.incorrectEmail\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.emailRepeat.$error.required || signUpForm.emailRepeat.$error.match) || c.emailExist}\"><input id=\"r-user-re-email\" required=\"required\" type=\"email\" class=\"form-control\" data-ng-model=\"c.user.emailRepeat\" data-match-validator=\"email\" maxlength=\"64\" name=\"emailRepeat\" placeholder=\"{{\'authentication.signUp.emailRepeat\' | translate}}\" autocomplete=\"off\"> <label for=\"r-user-re-email\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.emailRepeat.$error.required || signUpForm.emailRepeat.$error.match) || c.emailExist\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.emailRepeat.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.emailRepeat.$error.match\" data-translate=\"general.doesNotMatch\"></span> <span data-ng-show=\"c.emailExist\" data-translate=\"general.exisEmail\"></span></p></div></fieldset><fieldset><div class=\"form-group\" data-ng-class=\"{\'has-required\': signUpForm.$submitted && (signUpForm.password.$error.required || signUpForm.password.$error.pattern)}\"><input type=\"password\" name=\"password\" data-ng-model=\"c.user.password\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" maxlength=\"32\" required=\"required\" placeholder=\"{{\'authentication.signUp.password\' | translate}}\" class=\"form-control\" autocomplete=\"off\"> <label for=\"password\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && (signUpForm.password.$error.required || signUpForm.password.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.password.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"signUpForm.password.$error.pattern\" data-translate=\"general.incorrectPassword\"></span></p></div><div class=\"form-group\" data-ng-class=\"{\'has-required\':signUpForm.$submitted && signUpForm.licenseAgreement.$error.required}\"><div class=\"checkbox license-agreement\"><label for=\"r-user-license-agreement\"><input type=\"checkbox\" id=\"r-user-license-agreement\" data-ng-model=\"c.entity.termsOfUse\" required=\"required\" name=\"licenseAgreement\" autocomplete=\"off\"> <span data-translate=\"authentication.signUp.agreement.agree\"></span> <a data-ui-sref=\"index.aboutUs({articleUUID: \'termsOfUse\'})\" target=\"_blank\" data-translate=\"authentication.signUp.agreement.termsOfUse\"></a> и <a data-ui-sref=\"index.aboutUs({articleUUID: \'confidentiality\'})\" target=\"_blank\" data-translate=\"authentication.signUp.agreement.privacyPolicy\"></a></label></div></div><div data-ng-class=\"{\'has-required\':signUpForm.$submitted && signUpForm.licenseAgreement.$error.required}\"><p data-ng-show=\"signUpForm.$submitted && signUpForm.licenseAgreement.$error.required\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"signUpForm.licenseAgreement.$error.required\" data-translate=\"general.requiredField\"></span></p></div></fieldset><div class=\"form-group sing-up-recaptcha\" data-ng-class=\"{\'has-required\':signUpForm.$submitted && !c.response }\"><div vc-recaptcha=\"\" id=\"recaptcha\" class=\"\" on-success=\"c.setCaptchaResponse(response)\"></div><label for=\"recaptcha\" class=\"sr-only\"></label><p data-ng-show=\"signUpForm.$submitted && !c.response\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"!c.response\" data-translate=\"general.requiredField\"></span></p></div><div class=\"form-group\"><button data-ng-click=\"c.register(signUpForm)\" type=\"submit\" class=\"btn btn-default btn-block\" data-ng-disabled=\"c.isRegistering || !signUpForm.$dirty || (signUpForm.$submitted && signUpForm.$invalid)\" data-translate=\"authentication.signUp.register\"></button></div></form>");
$templateCache.put("app/components/clinics/search/searchClinicService/searchClinicService.html","<div class=\"form-group\"><ui-select id=\"search-user-services\" data-ng-model=\"searchFormParameters.service\" on-select=\"setValue($item, $model)\"><ui-select-match placeholder=\"{{placeholder}}\"><span data-ng-bind=\"$select.selected.name\"></span> <button class=\"clear\" data-ng-click=\"clear($event)\"><svg class=\"icon\"><use xlink:href=\"#close\"></use></svg></button></ui-select-match><ui-select-choices repeat=\"item in (items | filter: $select.search) track by item.uuid\" refresh=\"search($select.search)\" refresh-delay=\"100\"><span data-ng-bind=\"item.name\"></span></ui-select-choices></ui-select><label for=\"search-user-services\" class=\"sr-only\"></label></div>");
$templateCache.put("app/components/clinics/search/selectClinicDepartment/selectClinicDepartment.html","<div class=\"form-group\"><select name=\"search-user-spec\" class=\"form-control\" id=\"search-user-spec\" data-ng-model=\"value\" data-ng-options=\"value.name for value in values\"><option value=\"\">{{placeholder}}</option></select><label for=\"search-user-spec\" class=\"sr-only\"></label></div>");
$templateCache.put("app/components/clinics/search/selectClinicType/selectClinicType.html","<div class=\"form-group\"><select name=\"search-user-type\" class=\"form-control\" id=\"search-user-type\" data-ng-model=\"value\" data-ng-options=\"value.name for value in values\"><option value=\"\">{{placeholder}}</option></select><label for=\"search-user-type\" class=\"sr-only\"></label></div>");
$templateCache.put("app/components/content/algorithms/algorithm/algorithm-list.template.html","<categories-left-side-list data-paging-total=\"c.algorithms.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"algorithmUuid\" data-nested-state-name=\"index.algorithms.group.algorithm\">{{category.name}}</categories-left-side-list>");
$templateCache.put("app/components/content/algorithms/algorithm/algorithm.template.html","<div class=\"block-controls\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-article=\"c.currentAlgorithm\" data-type=\"c.favoriteType\"></share-buttons></categories-header></div><div class=\"block-content\"><p data-ng-bind-html=\"c.currentAlgorithm.description\"></p><a data-ng-click=\"c.startAlgorithm()\" class=\"btn btn-primary\" data-ng-if=\"!c.userAlgorithm\" style=\"color:#fff\"><svg class=\"icon play-circle-o\"><use xlink:href=\"#play-circle-o\"></use></svg><b data-translate=\"algorithms.start\"></b></a> <a data-ng-click=\"c.continueAlgorithm()\" class=\"btn btn-primary\" data-ng-if=\"c.userAlgorithm\" style=\"color:#fff\"><svg class=\"icon play-circle-o\"><use xlink:href=\"#play-circle-o\"></use></svg><b data-translate=\"algorithms.continue\"></b></a><br><br></div>");
$templateCache.put("app/components/content/algorithms/groups/groups.template.html","<div data-ui-view=\"subContent\" class=\"block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\">{{c.group.name}}</h1></div><div class=\"block-content\"><p data-ng-bind-html=\"c.group.description\"></p><categories-content-list data-categories=\"c.algorithms\" data-param-name=\"algorithmUuid\" data-nested-state-name=\"index.algorithms.group.algorithm\">{{category.name}}</categories-content-list></div></div>");
$templateCache.put("app/components/content/common/categories/categories.template.html","<ul data-ng-class=\"[listClass ? listClass : \'block-content-list\']\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><li data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"active\"><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\"><svg data-ng-if=\"category.childExists === true || category.hasChilds === true\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"category.childExists === false || category.hasChilds === false\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" inject=\"\"></span></a></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul>");
$templateCache.put("app/components/content/common/categories/contentLeftSideList.template.html","<div><div class=\"block-tags\" data-ng-if=\"showAsAgeTags\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\" data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"active\" inject=\"\"></a><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></div><ul class=\"block-content-list\" data-ng-if=\"!showAsAgeTags\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><li data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"active\"><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\"><svg data-ng-if=\"category.childExists === true\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"category.childExists === false\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" inject=\"\"></span></a></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul></div>");
$templateCache.put("app/components/content/common/categories/x.columns.html","<div><div class=\"row content-list-shadow\" data-ng-repeat=\"row in rows\" data-ng-if=\"alphabetSort\"><div data-ng-attr-class=\"{{ \'col-sm-\' + row.columnSize }}\" data-ng-repeat=\"col in row.columns track by $index\"><ul class=\"block-content-list\"><li data-ng-repeat=\"category in col track by $index\" data-ui-sref-active=\"active\"><a data-ng-click=\"$parent.$parent.emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\"><svg data-ng-if=\"category.childExists === true || category.hasChilds === true\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"category.childExists === false || category.hasChilds === false\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" inject=\"\"></span></a></li></ul></div></div><div><ul class=\"block-content-list\"><li data-ui-sref-active=\"active\" data-ng-repeat=\"row in rows\" data-ng-if=\"!alphabetSort\"><a data-ng-click=\"$parent.$parent.emitTransitionEvent()\" data-ui-sref=\"{{ row.href }}\"><svg data-ng-if=\"row.childExists === true || row.hasChilds === true\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"(row.childExists === false && row.hasChilds != true) || (row.hasChilds === false && row.childExists != false)\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" data-ng-bind=\"row.name\"></span></a></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul></div></div>");
$templateCache.put("app/components/content/contentCategories/breadcrumbs/customBreadcrumbs.html","<li data-ng-repeat=\"crumb in c.arrayOfParents\" data-ng-class=\"{ active: $last }\"><a href=\"{{ crumb.href }}\"><span>{{ crumb.name }}</span><svg class=\"icon angle-right\"><use xlink:href=\"#angle-right\"></use></svg></a></li>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/contentSubcategories.html","<div class=\"row\"><div class=\"col-sm-3\" data-ng-show=\"c.rootParentCategories.length > 0\"><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-categories=\"c.rootParentCategories\" data-param-name=\"categoryUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\" data-ng-class=\"{\'col-sm-9\' : c.rootParentCategories.length > 0, \'col-sm-12\': c.rootParentCategories.length === 0}\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"></categories-header><div class=\"block-content\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content | trust\"></p><br><categories-content-list data-column-number=\"1\" data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes\" class=\"article-notes\"></div></div></div></div></div></div>");
$templateCache.put("app/components/content/favorites/favoriteModal/favoritesDelete.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"removeFavorites\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-ng-click=\"c.close()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\">Удалить из избранного</h4></div><div class=\"modal-body\">Вы действительно хотите удалить элемент из избранного?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" data-ng-click=\"c.delete()\">Удалить</button> <button type=\"button\" class=\"btn btn-info\" data-dismiss=\"modal\" data-ng-click=\"c.close()\">Отмена</button></div></div></div></div>");
$templateCache.put("app/components/content/food/productsCategories/productsCategories.html","<products-categories-left-side-list data-list-class=\"block-accordion-list\" data-categories=\"c.categories\" data-param-name=\"productCategoryUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.productsCategories.products\">{{category.name}}</products-categories-left-side-list>");
$templateCache.put("app/components/content/food/productsCategories/productsCategories.template.html","<ul data-ng-class=\"[listClass ? listClass : \'block-content-list\']\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><li data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"active\"><a data-ng-click=\"emitTransitionEvent(category)\" data-ui-sref=\"{{ category.href }}\"><img data-ng-if=\"category.link && !hideImage\" class=\"icon\" data-ng-src=\"{{\'/api/v1/files/\'+category.link}}\" alt=\"\"> <span class=\"text\" inject=\"\"></span></a></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul>");
$templateCache.put("app/components/content/food/searchSupplement/searchSupplement.template.html","<div class=\"block-content content-search\"><form class=\"input-group\"><input id=\"searchBox\" autocomplete=\"off\" data-ng-attr-placeholder=\"{{ \'food.searchBoxPlaceholder\' | translate }}\" type=\"text\" class=\"form-control\" name=\"searchbox\" maxlength=\"50\" data-ng-model-options=\"{ \'debounce\': 700 }\" value=\"{{searchString}}\" data-ng-model=\"searchString\" data-ng-change=\"search(searchString)\" data-ng-focus=\"search(searchString)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"reset(searchString)\" id=\"resetButton\"><svg class=\"icon\" data-ng-show=\"showReset || searchString\"><use xlink:href=\"#close\"></use></svg></button></span></form><div class=\"dropdown dropdown-menu with-arrow\" data-ng-show=\"searchResults && searchResults.length > 0\"><ul id=\"searchResults\" class=\"list-unstyled\"><li data-ng-if=\"requestType === \'supplements\'\" data-ng-repeat=\"result in searchResults track by result.uuid\"><a data-ui-sref=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement({ supplementCategoryUUID: result.category, supplementUUID: result.uuid })\" data-ng-click=\"$parent.$parent.search();\">{{result.index }} {{ result.name }}</a></li><li data-ng-if=\"requestType === \'products\'\" data-ng-repeat=\"result in searchResults track by result.uuid\"><a data-ui-sref=\"index.contentCategories.contentSubcategories.food.productsCategories.products.article({ productCategoryUUID: result.parent.uuid, articleUUID: result.uuid })\" data-ng-click=\"$parent.$parent.search();\">{{result.index }} {{ result.name }}</a></li></ul></div><div class=\"dropdown dropdown-menu with-arrow\" data-ng-show=\"tempSearchString !=undefined && tempSearchString.length!=0 && searchResults !=undefined && searchResults.length == 0 && showReset != null\"><ul class=\"list-unstyled\" data-ng-show=\"!isLoading\"><li><a>{{ \'food.nothingFound\' | translate }}</a></li></ul><ul class=\"list-unstyled\" data-ng-show=\"isLoading\"><li><a>{{ \'food.searching\' | translate }}</a></li></ul></div></div>");
$templateCache.put("app/components/content/food/supplement/supplement.html","<div class=\"default-block-content\"><categories-header data-content-name=\"c.content.index + \', \' + c.content.name\"><share-buttons data-article=\"c.content\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p><b data-translate=\"food.color\"></b>: <span data-ng-bind=\"c.content.color || (\'food.noColor\' | translate)\"></span></p><p><b data-translate=\"food.notes\"></b>: <span data-ng-bind-html=\"c.content.detail | trust\"></span></p><p><b data-translate=\"food.otherNames\"></b>: <span data-ng-show=\"c.content.otherNames\" data-ng-bind-html=\"c.content.otherNames | trust\"></span> <span ng-hide=\"c.content.otherNames\" translate=\"food.noOtherNames\"></span></p><hr><h4><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"food.negatives\"></span></h4><p><span data-ng-bind-html=\"c.content.negatives | trust\"></span></p><hr><h4><svg class=\"icon cutlery\"><use xlink:href=\"#cutlery\"></use></svg><span data-translate=\"food.whichContain\"></span></h4><br><categories-left-side-list data-paging-total=\"c.supplementProducts.length\" data-use-paging=\"true\" data-paging-parameters=\"c.supplementproductsPagingParameters\" data-load-more=\"c.productsPaging.loadMore\" data-categories=\"c.productsPaging.visibleData\" data-parent-param-name=\"productCategoryUUID\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.productsCategories.products.article\">{{category.name}}</categories-left-side-list></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div><categories-footer><share-buttons data-show-place=\"footer\" data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-footer></div></div>");
$templateCache.put("app/components/content/food/supplement/supplements.html","<div class=\"default-block\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"#\"><div class=\"panel-title-name\">{{c.categoryListTitle}}</div></a></h4></div><div class=\"panel-body\"><categories-left-side-list data-list-class=\"block-accordion-list\" data-paging-total=\"c.allCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement\" param-name=\"supplementUUID\"><label>{{category.index}}</label> {{category.name}}</categories-left-side-list></div></div>");
$templateCache.put("app/components/content/food/supplements/supplements.html","<div class=\"default-block\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"#\"><div class=\"panel-title-name\">{{c.categoryListTitle}}</div></a></h4></div><div class=\"panel-body\"><categories-left-side-list data-list-class=\"block-accordion-list\" data-categories=\"c.categories\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements\" param-name=\"supplementCategoryUUID\"><label>{{category.index}}</label> {{category.name}}</categories-left-side-list></div></div>");
$templateCache.put("app/components/content/food/supplementsCategories/supplementsCategories.html","<categories-left-side-list data-list-class=\"block-accordion-list\" data-categories=\"c.categories\" data-param-name=\"supplementCategoryUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements\">{{category.name}}</categories-left-side-list>");
$templateCache.put("app/components/content/medicine/medicineCategories/medicineCategories.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><medicine-search></medicine-search></div><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.customPagingLeft.loadedAllCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParametersLeft\" data-load-more=\"c.customPagingLeft.loadMore\" data-categories=\"c.customPagingLeft.visibleData\" data-param-name=\"categoryUUID\" data-nested-state-name=\"index.medicine.medicineCategories\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\" data-ng-show=\"c.subCategories.length > 0\"><categories-left-side-list data-paging-total=\"c.subCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingSubCategories\" data-load-more=\"c.customPagingSubCategories.loadMore\" data-categories=\"c.customPagingSubCategories.visibleData\" data-param-name=\"categoryUUID\" data-nested-state-name=\"index.medicine.medicineCategories\">{{category.name}}</categories-left-side-list></div><div class=\"col-sm-9\" data-ng-show=\"c.subCategories.length == 0\"><categories-content-list data-categories=\"c.medicines\" data-param-name=\"articleUUID\" data-column-number=\"2\" data-nested-state-name=\"index.medicine.medicineCategories.article\">{{category.name}}</categories-content-list></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div></div></div>");
$templateCache.put("app/components/content/medicine/medicineSearch/medicineSearch.template.html","<div class=\"block-content content-search\"><form class=\"input-group\"><input autocomplete=\"off\" data-ng-attr-placeholder=\"{{\'medicine.medicineName\' | translate}}\" type=\"text\" class=\"form-control\" name=\"searchbox\" maxlength=\"50\" data-ng-model-options=\"{ \'debounce\': 500 }\" data-ng-model=\"searchString\" data-ng-change=\"search(searchString)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"reset\"><svg class=\"icon\"><use xlink:href=\"#close\"></use></svg></button></span></form><div class=\"dropdown-menu with-arrow\" data-ng-show=\"searchResults && searchResults.length > 0 && searchString.length > 0\"><ul class=\"list-unstyled\"><li data-ng-repeat=\"result in searchResults track by result.uuid\"><a data-ui-sref=\"index.medicine.medicineCategories.article({ categoryUUID: result.parent.uuid, articleUUID: result.uuid})\">{{result.index }} {{ result.name }}</a></li></ul></div><div class=\"dropdown dropdown-menu with-arrow\" data-ng-show=\"searchString !=undefined && searchString.length!=0 && searchResults !=undefined && searchResults.length == 0\"><ul class=\"list-unstyled\"><li><a>{{ \'food.nothingFound\' | translate }}</a></li></ul></div></div>");
$templateCache.put("app/components/content/news/article/news.article.html","<div class=\"row\"><div class=\"col-sm-3 hidden-xs hidden-sm\"><div class=\"default-block\"><div class=\"block-content\"><news-categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"uuid\" data-nested-state-name=\"index.news.article\">{{category.name}}</news-categories-left-side-list></div></div></div><div class=\"col-md-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-article=\"c.article\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content block-content_news\"><div class=\"time-news\">{{c.date | date:\'longDate\'}}</div><div class=\"row\"><div class=\"col-sm-9\"><div data-ng-if=\"!c.article.imagesFirst\" class=\"news-gallery\"><image-gallery-wrapper data-images=\"c.images\" data-gal-width=\"500\" data-gal-height=\"375\" data-alt-title=\"c.article.name\" data-scale-mode=\"\'contain\'\" data-aspect-ratio=\"1.3\"></image-gallery-wrapper></div><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content | trust\"></p><div data-ng-if=\"c.article.imagesFirst\" class=\"news-gallery\"><image-gallery-wrapper data-images=\"c.images\" data-gal-width=\"500\" data-gal-height=\"375\" data-alt-title=\"c.article.name\" data-scale-mode=\"\'contain\'\" data-aspect-ratio=\"1.3\"></image-gallery-wrapper></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><categories-footer><share-buttons data-show-place=\"footer\" data-article=\"c.article\" data-type=\"c.favoriteType\"></share-buttons></categories-footer></div></div></div>");
$templateCache.put("app/components/content/news/article/newsCategoriesLeftSide.template.html","<ul class=\"block-content-news\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><li data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"hot\"><div class=\"title\"><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\">{{category.name}}</a></div><div class=\"time\">{{category.date | date:\'longDate\'}}</div><figure data-ng-show=\"category.images[0]\"><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\" data-ng-if=\"!!category.images && category.images.length > 0\"><img class=\"img-responsive\" data-ng-src=\"{{\'api/v1/files/\' + category.images[0].link + \'?ratio=200\'}}\" alt=\"{{!!category.images[0].alt ? category.images[0].alt : category.name}}\" title=\"{{!!category.images[0].title ? category.images[0].title : category.name}}\"></a></figure></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul>");
$templateCache.put("app/components/content/news/newsBlock/newsBlock.html","<div class=\"block-content\"><ul class=\"block-news-list\"><li data-ng-repeat=\"newsItem in news\"><a data-ui-sref=\"index.news.article({uuid: newsItem.uuid })\" class=\"article-title\">{{newsItem.name}}</a><div class=\"article-body\" data-ng-if=\"newsItem.images[0]!=undefined\"><a data-ui-sref=\"index.news.article({uuid: newsItem.uuid })\"><img data-ng-src=\"{{\'api/v1/files/\' + newsItem.images[0].link + \'?ratio=175\'}}\" alt=\"{{!!newsItem.images[0].alt ? newsItem.images[0].alt : newsItem.name}}\" title=\"{{!!newsItem.images[0].alt ? newsItem.images[0].alt : newsItem.name}}\"></a></div></li><li class=\"view-all\"><a data-ui-sref=\"index.news()\" data-translate=\"news.more\"></a></li></ul></div>");
$templateCache.put("app/components/content/upgrowth/categories/categories.html","<div class=\"row\"><div class=\"col-sm-3 hidden-xs\"><div class=\"default-block\"><div class=\"block-content\"><upgrowth-categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"categoryUUID\" data-nested-state-name=\"index.upgrowth.categories\">{{category.name}}</upgrowth-categories-left-side-list><br><div class=\"block-banner banner-block_200\"><adsense data-block-type=\"block200\" inline-style=\"display:inline-block;width:200px;height:200px\"></adsense></div></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-ng-if=\"c.returnedContent.childs.length === 0\" data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content\"></p><categories-content-list data-alphabet-sort=\"false\" data-column-number=\"1\" data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.upgrowth.categories.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes\" class=\"article-notes\"></div></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><categories-footer><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></categories-footer></div></div></div>");
$templateCache.put("app/components/content/upgrowth/categories/upgrowth.categories.template.html","<div><ul class=\"block-content-list\"><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"top\"></load-more><li data-ng-repeat=\"category in readyCategories track by category.uuid\" data-ui-sref-active=\"active\"><a data-ng-click=\"emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\"><svg data-ng-if=\"category.childExists === true\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"category.childExists === false\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" inject=\"\"></span></a></li><load-more data-ng-if=\"usePaging\" data-total=\"pagingTotal\" data-load=\"loadMore\" data-paging-parameters=\"pagingParameters\" data-direction=\"bottom\"></load-more></ul></div>");
$templateCache.put("app/components/content/upgrowth/directive/upgrowth.columns.html","<div class=\"row content-list-shadow\" data-ng-repeat=\"row in rows\"><div data-ng-attr-class=\"{{ \'col-sm-\' + row.columnSize }}\" data-ng-repeat=\"col in row.columns track by $index\"><ul class=\"block-content-list\"><li data-ng-repeat=\"category in col track by $index\" data-ui-sref-active=\"active\"><a data-ng-click=\"$parent.$parent.emitTransitionEvent()\" data-ui-sref=\"{{ category.href }}\"><svg data-ng-if=\"category.asParent\" class=\"icon articles-group\"><use xlink:href=\"#articles-group\"></use></svg><svg data-ng-if=\"!category.asParent\" class=\"icon paragraph\"><use xlink:href=\"#paragraph\"></use></svg><span class=\"text\" inject=\"\"></span></a></li></ul></div></div>");
$templateCache.put("app/components/core/directives/appBadge/appBadge.html","<div class=\"apps-badge-head\"><div class=\"apps-badge-close\" data-ng-click=\"closeBadge()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></div></div><a class=\"apps-badge-inner\" data-ui-sref=\"index.mobileApps\"><div class=\"apps-badge-title\" data-translate=\"mobileApps.badge\"></div></a>");
$templateCache.put("app/components/core/directives/avatarDirective/avatar-template.html","<img data-object-fit=\"cover\" data-ng-if=\"photo\" class=\"img-responsive\" data-ng-src=\"{{avatarPath}}\" alt=\"{{\'seo.alt.avatar\' | translate}}\" context-dropdown=\"app/components/core/directives/avatarDirective/avatarModal/avatar.dropdown.html\"> <img data-ng-hide=\"photo\" class=\"img-responsive\" src=\"/assets/images/user-no-photo.png\" alt=\"{{\'seo.alt.noavatar\' | translate}}\" data-ng-click=\"editAvatar()\"> <input type=\"file\" file-wrapper=\"fileWrapper\" accept=\"image/*\" capture=\"camera\" class=\"sr-only\">");
$templateCache.put("app/components/core/directives/birthdayDirective/birthdayTemplate.html","<div class=\"row\" id=\"birthday-select\"><div class=\"col-xs-3\"><select data-ng-model=\"birthDay\" class=\"form-control\" data-ng-change=\"onDataChange()\" data-ng-options=\"day for day in dayRange\"><option value=\"\" disabled=\"\" data-translate=\"general.Day\"></option></select></div><div class=\"col-xs-5\"><select data-ng-model=\"birthMonth\" class=\"form-control\" data-ng-change=\"onDataChange()\" data-ng-options=\"month for month in months\"><option value=\"\" disabled=\"\" data-translate=\"general.Month\"></option></select></div><div class=\"col-xs-4\"><select data-ng-model=\"birthYear\" class=\"form-control\" data-ng-change=\"onDataChange()\" data-ng-options=\"year for year in yearsRange\"><option value=\"\" disabled=\"\" data-translate=\"general.Year\"></option></select></div></div>");
$templateCache.put("app/components/core/directives/fbWidgetLike/fbWidgetLike.html","<div id=\"fb-root\"></div><div id=\"bottomFacebookBlock\" class=\"fb\" ng-hide=\"!fbLikeShow\"><div id=\"facebookpopup-fanbox\" class=\"fb-container\"><div class=\"fbpTop\"><div class=\"fbTopLogo\"></div><div class=\"fbCloseButton\" ng-click=\"fbLike.close()\"></div><div class=\"fbWhiteLine\"></div><div class=\"facebookpopup-top-title\">Нажмите \"Нравится\",<br>чтобы читать нас в Facebook!</div></div><div class=\"fbTriangle\"></div><div class=\"fb-like-wrapper slider\"><div class=\"fb-like-right\"><div class=\"clearAfterArrows\"></div><div id=\"fbButtonHere\"><div><div class=\"fb-like fb_iframe_widget\" data-width=\"320\" data-layout=\"standard\" data-action=\"like\" data-show-faces=\"true\" data-share=\"false\" data-href=\"https://www.facebook.com/BabyCompy\" fb-xfbml-state=\"rendered\" fb-iframe-plugin-query=\"action=like&amp;app_id=&amp;container_width=320&amp;href=https%3A%2F%2Fwww.facebook.com%2Frebenokbygroup&amp;layout=standard&amp;locale=ru_RU&amp;sdk=joey&amp;share=false&amp;show_faces=true&amp;width=320\"><span style=\"vertical-align: bottom; width: 320px; height: 42px;\"></span></div></div></div></div></div><div class=\"fb-close-bottom\"><button class=\"fb-close-bottom-button\" ng-click=\"fbLike.hide()\">Спасибо, я уже с вами!</button></div></div></div>");
$templateCache.put("app/components/core/directives/imageGalleryWrapper/imageGallery.html","<div class=\"slider-pro\"><div class=\"sp-slides\"><div class=\"sp-slide\" data-ng-repeat=\"img in images\"><img class=\"sp-image\" data-position=\"topCenter\" data-ng-src=\"{{\'api/v1/files/\' + img.link}}\" data-small=\"{{\'api/v1/files/\' + img.link + \'?ratio=400\'}}\" data-medium=\"{{\'api/v1/files/\' + img.link + \'?ratio=800\'}}\" data-large=\"{{\'api/v1/files/\' + img.link}}\" data-retinasmall=\"{{\'api/v1/files/\' + img.link + \'?ratio=800\'}}\" data-retinamedium=\"{{\'api/v1/files/\' + img.link + \'?ratio=1600\'}}\" data-retinalarge=\"{{\'api/v1/files/\' + img.link}}\" alt=\"{{img.alt}}\" title=\"{{img.title}}\"></div></div><div class=\"sp-thumbnails\" data-ng-show=\"images.length > 1\"><img class=\"sp-thumbnail\" data-ng-repeat=\"img in images\" data-ng-src=\"{{\'api/v1/files/\' + img.link + \'?ratio=100\'}}\" data-small=\"{{\'api/v1/files/\' + img.link + \'?ratio=400\'}}\" data-medium=\"{{\'api/v1/files/\' + img.link + \'?ratio=800\'}}\" data-large=\"{{\'api/v1/files/\' + img.link}}\" data-retinasmall=\"{{\'api/v1/files/\' + img.link + \'?ratio=800\'}}\" data-retinamedium=\"{{\'api/v1/files/\' + img.link + \'?ratio=1600\'}}\" data-retinalarge=\"{{\'api/v1/files/\' + img.link}}\" alt=\"{{img.alt}}\" title=\"{{img.title}}\"></div></div>");
$templateCache.put("app/components/core/directives/shareButtons/shareButtons.html","<div><div class=\"dropdown block-share-social\" data-ng-show=\"!onlyStar\"><button class=\"active\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-bs-dropdown=\"\"><svg class=\"icon share-square-o\"><use xlink:href=\"#share-square-o\"></use></svg>&nbsp; <span data-ng-show=\"showPlace === \'footer\'\" data-translate=\"general.share\"></span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu with-arrow\" aria-labelledby=\"dLabel\"><li><a href=\"javascript:void(0);\" data-ng-click=\"shareFB()\" target=\"_blank\"><svg class=\"icon facebook\"><use xlink:href=\"#facebook\"></use></svg>Facebook</a></li><li><a href=\"javascript:void(0);\" data-ng-click=\"shareVK()\" target=\"_blank\"><svg class=\"icon vk\"><use xlink:href=\"#vk\"></use></svg>VKontakte</a></li><li><a href=\"javascript:void(0);\" data-ng-click=\"shareGooglePlus()\" target=\"_blank\"><svg class=\"icon google-plus\"><use xlink:href=\"#google-plus\"></use></svg>Google+</a></li><li><a href=\"javascript:void(0);\" data-ng-click=\"shareOK()\" target=\"_blank\"><svg class=\"icon odnoklassniki\"><use xlink:href=\"#odnoklassniki\"></use></svg>Odnoklassniki</a></li></ul></div><a href=\"javascript:void(0);\" class=\"block-add-bookmarks\" data-ng-class=\"{\'active\' : article.favorite === true }\" data-ng-click=\"selectFavorite()\" data-ng-show=\"!onlyStar\"><svg class=\"icon star-o\"><use xlink:href=\"#star-o\"></use></svg><svg class=\"icon star\"><use xlink:href=\"#star\"></use></svg><span data-ng-show=\"showPlace === \'footer\' && article.favorite === false\" data-translate=\"general.selectAsFavorite\"></span> <span data-ng-show=\"showPlace === \'footer\' && article.favorite === true\" data-translate=\"general.selectedAsfavorite\"></span></a> <a href=\"javascript:void(0);\" class=\"add-bookmarks\" data-ng-class=\"{\'active\' : article.favorite === true }\" data-ng-click=\"selectFavorite()\" data-ng-show=\"onlyStar\"><svg class=\"icon star-o\"><use xlink:href=\"#star-o\"></use></svg><svg class=\"icon star\"><use xlink:href=\"#star\"></use></svg></a></div>");
$templateCache.put("app/components/doctorSearch/search/selectDoctorDepartment/selectDoctorDepartment.html","<div class=\"form-group\"><select name=\"search-user-spec\" class=\"form-control\" id=\"search-user-spec\" data-ng-model=\"value\" data-ng-options=\"value.name for value in values\"><option value=\"\">{{placeholder}}</option></select><label for=\"search-user-spec\" class=\"sr-only\"></label></div>");
$templateCache.put("app/components/medics/answers/article/article.html","<div class=\"row\"><div class=\"col-sm-3 hidden-xs\"><div class=\"default-block\" data-ng-if=\"!c.user.doctor\"><div class=\"block-content\"><button class=\"btn btn-primary btn-block doctor-question-button\" data-translate=\"medic.askDoctor\" data-ng-click=\"c.askDoctor()\"></button></div></div><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.medics.answers.article\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content default-block-content-comments\"><div class=\"block-controls\"><categories-header data-content-name=\"c.content.name\"><header-title><svg class=\"icon hover question-circle\"><use xlink:href=\"#question-circle\"></use></svg><span data-ng-bind=\"c.content.name\"></span></header-title><share-buttons data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-header></div><div class=\"block-content\"><div class=\"doctor-question-massage\" data-ng-bind-html=\"c.content.description | trust\"></div></div><hr><div class=\"block-content\"><h2><svg class=\"icon info-circle\"><use xlink:href=\"#info-circle\"></use></svg><span data-translate=\"medic.answers.answers\"></span></h2><div class=\"row\"><div class=\"col-sm-1\"><figure class=\"doctor-question-figure\"><img class=\"img-responsive\" src=\"assets/images/user-no-photo.png\" alt=\"{{\'seo.alt.nophoto\' | translate}}\" data-ng-show=\"!c.doctor.photo\"> <img class=\"img-responsive\" data-ng-src=\"{{\'api/v1/files/\' + c.doctor.photo}}\" alt=\"{{\'seo.alt.photo\' | translate}}\" data-ng-show=\"c.doctor.photo\"></figure></div><div class=\"col-sm-11\"><div class=\"doctor-question-answer\" data-ng-bind-html=\"c.content.answer | trust\"></div></div></div><categories-footer><share-buttons data-show-place=\"footer\" data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-footer><comments data-type=\"8\" data-uuid=\"{{$state.params.articleUUID}}\"></comments></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/children/edit/children.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"changeMyChildren\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"c.close()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"userProfile.addChildren\" data-ng-show=\"!c.entity.uuid\"></h4><h4 class=\"modal-title\" data-translate=\"userProfile.editChildren\" data-ng-show=\"c.entity.uuid\"></h4></div><div class=\"modal-body\"><div class=\"cropper-image-height\" data-ng-show=\"c.imageEdit\"><img data-ng-src=\"{{c.avatarService.dataUrl}}\" width=\"300\" data-ng-cropper=\"\" data-ng-cropper-show=\"c.avatarService.showEvent\" data-ng-cropper-hide=\"c.avatarService.hideEvent\" data-ng-cropper-options=\"c.avatarService.options\" alt=\"{{seo.alt.avatar | translate}}\"></div><form class=\"form-change-my-children\" name=\"childEditForm\" data-ng-show=\"!c.imageEdit\"><div class=\"form-group\"><figure class=\"children-avatar-upload\"><img data-ng-src=\"{{c.avatarService.croppedImage}}\" data-ng-show=\"c.avatarService.croppedImage\" context-dropdown=\"app/components/core/directives/avatarDirective/avatarModal/avatar.dropdown.html\" alt=\"{{seo.alt.avatar | translate}}\"><avatar data-ng-if=\"!c.avatarService.croppedImage && c.entity.avatar\" data-photo=\"c.entity.avatar\"></avatar><span data-ng-show=\"!c.avatarService.croppedImage && !c.entity.avatar\" class=\"avatar-upload\" data-translate=\"userProfile.childAvatarButton\" data-ng-click=\"c.editAvatar()\"></span></figure><label for=\"children-modal-data-avatar\" class=\"sr-only\"><input id=\"children-modal-data-avatar\" type=\"file\" file-wrapper=\"c.fileWrapper\" accept=\"image/*\" capture=\"camera\" class=\"sr-only\"></label></div><div class=\"form-group\" data-ng-class=\"{\'has-required\':(childEditForm.firstName.$invalid && childEditForm.$submitted) }\"><label for=\"children-modal-data-name\"><span data-translate=\"userProfile.firstName\"></span> <sup>*</sup></label> <input required=\"\" type=\"text\" maxlength=\"30\" name=\"firstName\" data-ng-pattern=\"/^[\\w\\d | А-Яа-я\\s\\-\\u0080-\\u00FF]{2,32}$/\" data-ng-model=\"c.entity.firstName\" class=\"form-control\" id=\"children-modal-data-name\" placeholder=\"{{ \'userProfile.childNamePlaceholder\' | translate}}\"><p data-ng-show=\"childEditForm.firstName.$invalid && childEditForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"childEditForm.firstName.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"childEditForm.firstName.$error.pattern\" data-translate=\"general.incorrectFirstName\"></span></p></div><fieldset><label><span data-translate=\"userProfile.birthday\"></span><sup>*</sup></label><div class=\"form-group\" data-ng-class=\"{\'has-required\': childEditForm.birthDate.$invalid && childEditForm.$submitted }\"><birthday-select data-ng-model=\"c.birthDate\" name=\"birthDate\" required=\"\"></birthday-select><p data-ng-show=\"childEditForm.birthDate.$invalid && childEditForm.$submitted\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-translate=\"general.incorrectBirthDate\" data-ng-show=\"childEditForm.birthDate.$error.isNotInPast\"></span> <span data-translate=\"general.requiredField\" data-ng-show=\"childEditForm.birthDate.$error.required\"></span></p></div></fieldset></form></div><div class=\"modal-footer\" data-ng-show=\"!c.imageEdit\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.save()\" data-ng-disabled=\"(!childEditForm.$dirty && !c.avatarService.croppedImage) || (childEditForm.$submitted && childEditForm.$invalid)\"><span data-translate=\"general.save\"></span> <i class=\"fa fa-spinner fa-spin\" data-ng-show=\"c.isSaving\"></i></button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"c.close()\" data-translate=\"general.cancel\"></button></div><div class=\"modal-footer\" data-ng-show=\"c.imageEdit\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.applyImage()\" data-translate=\"general.apply\"></button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"c.cancelImage()\" data-translate=\"general.cancel\"></button></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/edit/doctorsProfile-achievements.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block-content doctors-profile doctors-profile-edit\"><div class=\"block-controls\"><h1 class=\"block-controls-name\" translate=\"doctorProfile.achievementsAndPublications\"></h1></div><div class=\"block-content clearfix\"><form><div class=\"form-group height100 d-flex\"><label translate=\"doctorProfile.achievements\"></label> <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"c.content.achievements\"></textarea> <label class=\"validation\" ng-show=\"c.submited && c.achievementsTooLong\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.tooLong\' | translate}}</label></div><div class=\"form-group height100 d-flex\"><label translate=\"doctorProfile.publications\"></label> <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"c.content.articles\"></textarea> <label class=\"validation\" ng-show=\"c.submited && c.articlesTooLong\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.tooLong\' | translate}}</label></div></form><hr><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"c.submit()\" ng-class=\"{\'disabled\': !c.dataChanged}\" translate=\"userProfile.save\"></button> <button type=\"button\" class=\"btn btn-success\" ui-sref=\"index.profile.doctor\" translate=\"general.cancel\"></button></div></div></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/edit/doctorsProfile-edit.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block doctors-profile doctors-profile-edit\"><div class=\"alert alert-warning alert_center\" data-ng-if=\"c.content.status === 0\" translate=\"doctorProfile.blocked\"></div><div class=\"block-controls\"><h1 class=\"block-controls-name mb-0\" translate=\"userProfile.editProfile\"></h1></div><div class=\"block-content row\"><div class=\"col-sm-3 col-xs-12 mb-1\"><figure class=\"doctor-photo\"><avatar data-photo=\"c.content.photo\"></avatar></figure></div><div class=\"col-sm-9 col-xs-12\"><form class=\"clearfix\" novalidate=\"\" name=\"dataForm\"><div class=\"row\"><div class=\"name col-sm-6\"><div class=\"form-group\"><label class=\"required\">{{\'authentication.signUp.name\' | translate}}</label> <input type=\"text\" data-ng-model=\"c.content.firstName\" class=\"form-control form-control-sm\" name=\"firstName\" maxlength=\"45\" required=\"\"> <label class=\"validation\" ng-show=\"c.submited && dataForm.firstName.$invalid\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.requiredField\' | translate}}</label></div><div class=\"form-group\"><label class=\"required\">{{\'authentication.signUp.patronymic\' | translate}}</label> <input type=\"text\" data-ng-model=\"c.content.patronymic\" class=\"form-control form-control-sm\" name=\"patronymic\" maxlength=\"45\" required=\"\"> <label class=\"validation\" ng-show=\"c.submited && dataForm.patronymic.$invalid\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.requiredField\' | translate}}</label></div><div class=\"form-group\"><label class=\"required\">{{\'authentication.signUp.lastName\' | translate}}</label> <input type=\"text\" data-ng-model=\"c.content.lastName\" class=\"form-control form-control-sm\" name=\"lastName\" maxlength=\"45\" required=\"\"> <label class=\"validation\" ng-show=\"c.submited && dataForm.lastName.$invalid\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.requiredField\' | translate}}</label></div></div></div><div class=\"row\"><div class=\"form-group birthday col-sm-3\"><label>{{\'userProfile.birthday\' | translate}}</label><div class=\"input-with-icon\"><svg class=\"icon\"><use xlink:href=\"#calendar2\"></use></svg><input id=\"user-date\" class=\"form-control form-control-sm\" type=\"text\" options=\"{singleDatePicker: true}\" data-ng-model=\"c.content.birthday\" data-date-format=\"yyyy-MM-dd\" model-date-format=\"yyyy-MM-dd\" ng-change=\"c.dateChanged()\" data-template=\"app/components/authentication/profile/doctorsProfile/datepicker.tpl.html\" date-type=\"string\" data-container=\"body\" data-autoclose=\"1\" bs-datepicker=\"\"></div><label class=\"validation\" ng-show=\"c.dateError\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.incorrectBirthDate\' | translate}}</label></div></div><div class=\"mb-1\"><label class=\"required\" translate=\"authentication.signUp.specialization\"></label><div class=\"well well-sm-h clearfix mb-0\"><span data-ng-repeat=\"spec in c.content.specializations\">{{$last ? spec.name : spec.name + \', \'}}</span> <button type=\"button\" class=\"btn btn-text pull-right\" data-ng-click=\"c.openSpecModal()\"><svg class=\"icon\"><use xlink:href=\"#ellipsis-h\"></use></svg></button></div><label class=\"validation\" ng-show=\"c.submited && c.content.specializations.length == 0\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.requiredField\' | translate}}</label></div><div class=\"form-group\"><label>{{\'doctorProfile.education\' | translate}}</label> <textarea type=\"text\" data-ng-model=\"c.content.education\" class=\"form-control no-resize-h\" name=\"education\" maxlength=\"150\"></textarea></div><location-select data-is-required=\"true\" parent-form=\"dataForm\" data-country-label=\"true\" data-country=\"c.content.country\" data-country-required=\"c.validation.country\" data-region-required=\"c.validation.region\" data-city-required=\"c.validation.city\" data-region-label=\"true\" data-region=\"c.content.region\" data-city-label=\"true\" data-city=\"c.content.city\" data-full-content=\"true\" data-inline-view=\"true\" container-class=\"d-flex d-flex-row\"></location-select><div class=\"phones mb-1\"><label class=\"d-block\" translate=\"clinicProfile.phones\"></label><div data-ng-repeat=\"phone in c.content.phones\"><div class=\"form-group row col-xs-11 pl-0\"><div class=\"col-sm-4 col-xs-6\"><input type=\"text\" data-ng-model=\"phone.phone\" class=\"form-control form-control-sm phone\" maxlength=\"20\"></div><div class=\"col-sm-8 col-xs-6\"><input type=\"text\" data-ng-model=\"phone.name\" class=\"form-control form-control-sm name\" maxlength=\"255\"></div></div><button type=\"button\" class=\"close col-xs-1 text-left pl-0\" data-ng-click=\"c.removePhone($index)\"><svg class=\"icon\"><use xlink:href=\"#close\"></use></svg></button></div><button type=\"button\" class=\"btn btn-text d-block clear-b\" data-ng-click=\"c.addPhone()\">+ {{\'general.add\' | translate}}</button> <label class=\"validation d-b\" ng-show=\"c.phoneDublicated\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.phonesDublicated\' | translate}}</label></div><div class=\"row\"><div class=\"form-group email col-sm-4\"><label class=\"required\">{{\'algorithms.mail\' | translate}}</label> <input type=\"email\" data-ng-model=\"c.content.email\" class=\"form-control form-control-sm\" name=\"email\" maxlength=\"70\" ng-pattern=\"c.emailPattern\" required=\"\"> <label class=\"validation\" ng-show=\"c.submited && dataForm.email.$error.required\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.requiredField\' | translate}}</label> <label class=\"validation\" ng-show=\"c.submited && dataForm.email.$error.pattern\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.incorrectEmail\' | translate}}</label> <label class=\"validation\" ng-show=\"c.submited && c.emailExists\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.exisEmail\' | translate}}</label></div></div><div class=\"well well-sm-h atHome\"><div class=\"checkbox-custom\" data-ng-class=\"{\'checkbox-custom-active\': c.content.onHome}\"><input type=\"checkbox\" id=\"read\"> <label for=\"read\" class=\"font-regular\" data-ng-click=\"c.content.onHome = !c.content.onHome\"><svg class=\"icon\"><use xlink:href=\"#check\"></use></svg>{{\'doctorProfile.onHomeI\'| translate}}</label></div></div><div class=\"form-group height100 autobiography d-f f-d-c\"><label translate=\"doctorProfile.autobiography\"></label> <textarea ui-tinymce=\"tinymceOptions\" ng-model=\"c.content.autobiography\"></textarea> <label class=\"validation\" ng-show=\"c.aboutTooLong\"><svg class=\"icon\"><use xlink:href=\"#info-circle\"></use></svg>{{\'general.tooLong\' | translate}}</label></div><hr><div class=\"text-right\"><button type=\"submit\" class=\"btn btn-primary\" data-ng-click=\"c.submit()\" ng-class=\"{\'disabled\': !c.dataChanged}\" translate=\"userProfile.save\"></button> <button type=\"button\" class=\"btn btn-success\" data-ng-click=\"c.cancel()\" translate=\"general.cancel\"></button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/modals/clinics-modal.html","<div class=\"modal modal-small modal-small_h doctors-edit\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$hide()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title mb-1\" translate=\"doctorProfile.addClinic\"></h4><div class=\"form-group\"><input type=\"text\" blur-and-focus=\"doctors.clinicsFound\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'clinicSearch.clinicName\' | translate}}\" data-ng-model=\"c.filterClinic.name\" class=\"form-control form-control-sm\" name=\"name\" maxlength=\"150\"></div><div class=\"form-group mb-1\"><div class=\"select-custom\"><select class=\"form-control form-control-sm\" data-ng-class=\"{\'empty\': !c.filterClinic.type}\" data-ng-options=\"spec.uuid as spec.name for spec in c.cliicTypes\" data-ng-model=\"c.filterClinic.type\"><option value=\"\" translate=\"clinicSearch.clinicType\"></option></select></div></div><div class=\"form-group mb-0\"><div class=\"select-custom\"><select class=\"form-control form-control-sm\" data-ng-class=\"{\'empty\': !c.filterClinic.country}\" data-ng-options=\"item.uuid as item.name for item in c.countries\" data-ng-model=\"c.filterClinic.country\"><option value=\"\" translate=\"selectLocationLabel.countryLabel\"></option></select></div></div></div><div class=\"modal-body\" load-on-scroll=\"c.getClinics({addOffset: true, filter: c.filterClinic})\"><div class=\"search-result-list clinics-modal\"><div class=\"row\"><div class=\"col-sm-12 card\" data-ng-if=\"c.hideClinic(clinic.uuid)\" data-ng-repeat=\"clinic in c.clinics\"><div class=\"search-user-profile\" data-ng-click=\"c.addClinic(clinic)\"><figure><a href=\"#\"><img data-ng-src=\"{{\'api/v1/files/\' + clinic.photo + \'?ratio=90\'}}\" alt=\"\" data-ng-show=\"clinic.photo\" data-object-fit=\"cover\"> <img data-ng-src=\"/assets/images/clinic-no-photo.png\" alt=\"\" data-ng-show=\"!clinic.photo\"></a></figure><div class=\"information\"><span class=\"name\">{{clinic.name | dot:50}}</span><address>{{(clinic.address | dot:60) + \',\'}} <span>{{clinic.city}}</span></address></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"$hide()\">{{\'general.cancel\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/modals/specs-modal.html","<div class=\"modal modal-small\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$hide()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title mb-0\" translate=\"authentication.signUp.specialization\"></h4></div><div class=\"modal-body\"><div class=\"checkbox-custom d-block\" data-ng-repeat=\"spec in c.specs\" data-ng-class=\"{\'checkbox-custom-active\': c.itemSpecializations[spec.uuid]}\"><input type=\"checkbox\"> <label class=\"font-normal\" data-ng-click=\"c.setSpec(spec)\"><svg class=\"icon\"><use xlink:href=\"#check\"></use></svg>{{spec.name}}</label></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"c.saveSpecs()\">{{\'general.save\' | translate}}</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"$hide()\">{{\'general.cancel\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/modals/workTime.html","<div class=\"modal modal-small healthFacilities-edit\"><div class=\"modal-dialog modal-small\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$hide()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" translate=\"clinicProfile.changeWorkingTime\"></h4></div><div class=\"modal-body\"><div class=\"well table-responsive\"><table class=\"workingHours table-sm\" data-ng-if=\"c.showTime\"><tbody><tr data-ng-repeat=\"day in c.currentClinic.worktime\"><td><div class=\"checkbox-custom f-l\" data-ng-class=\"{\'checkbox-custom-active\': !day.holiday}\"><input type=\"checkbox\" id=\"read\"> <label for=\"read\" class=\"font-regular\" data-ng-click=\"day.holiday = !day.holiday\"><svg class=\"icon check\"><use xlink:href=\"#check\"></use></svg>{{\'clinicProfile.workingHoursFull.\' + day.day | translate}}</label></div></td><td><input type=\"text\" class=\"form-control form-control-sm hours\" name=\"hours\" data-ng-disabled=\"day.holiday\" ng-model=\"day.startTime\" ui-timepicker=\"timePickerOptions\"> - <input type=\"text\" class=\"form-control form-control-sm hours\" name=\"hours\" data-ng-disabled=\"day.holiday\" ng-model=\"day.endTime\" ui-timepicker=\"timePickerOptions\"></td><td><span class=\"text-muted\" data-ng-show=\"day.startTime === day.endTime && !day.holiday\">{{\'clinicProfile.workingHours.dayAndNight\' | translate}}</span> <span class=\"text-muted\" data-ng-show=\"day.holiday\">{{\'clinicProfile.workingHours.dayOff\' | translate}}</span></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-ng-class=\"{\'disabled\': c.loading}\" data-ng-click=\"c.saveClinicTime()\">{{\'algorithms.save\' | translate}}</button> <button type=\"button\" class=\"btn btn-secondary\" ng-click=\"$hide()\">{{\'general.cancel\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/authentication/profile/doctorsProfile/settings/doctorsProfile-settings.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"default-block-content\"><div class=\"alert alert-warning alert_center\" data-ng-if=\"c.status === 0\" translate=\"doctorProfile.blocked\"></div><div class=\"block-controls\"><h1 class=\"block-controls-name block-controls-name_regular\" translate=\"doctorProfile.settings\"></h1></div><div class=\"block-content clearfix\"><div class=\"row\"><form name=\"changePassword\" class=\"form-change-password col-sm-6 mb-1\" novalidate=\"\"><h4 class=\"mt-0 mb-1 font-bold\" translate=\"userProfile.changePassword\"></h4><div class=\"row\"><div class=\"form-group col-sm-10\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.oldPassword.$error.required || changePassword.oldPassword.$error.pattern || c.invalidOldPassord)}\"><label for=\"up-change-password-old\">{{\'userProfile.oldPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" type=\"password\" class=\"form-control\" id=\"up-change-password-old\" name=\"oldPassword\" maxlength=\"32\" data-ng-model=\"c.data.oldPassword\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\"> <label for=\"up-change-password-old\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.oldPassword.$error.required || changePassword.oldPassword.$error.pattern || c.invalidOldPassord)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.oldPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.oldPassword.$error.pattern\" data-translate=\"general.incorrectPassword\"></span> <span data-ng-show=\"c.invalidOldPassord\" data-translate=\"general.invalidOldPassord\"></span></p></div><div class=\"form-group col-sm-10\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.newPassword.$error.required || changePassword.newPassword.$error.pattern)}\"><label for=\"up-change-password-new\">{{\'userProfile.newPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" type=\"password\" class=\"form-control\" id=\"up-change-password-new\" maxlength=\"32\" name=\"newPassword\" data-ng-model=\"c.data.newPassword\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\"> <label for=\"up-change-password-new\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.newPassword.$error.required || changePassword.newPassword.$error.pattern)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.newPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.newPassword.$error.match\" data-translate=\"general.doesNotMatch\"></span> <span data-ng-show=\"changePassword.newPassword.$error.pattern\" data-translate=\"general.incorrectPassword\"></span></p></div><div class=\"form-group col-sm-10\" data-ng-class=\"{\'has-required\': changePassword.$submitted && (changePassword.repeatPassword.$error.required || changePassword.repeatPassword.$error.match)}\"><label for=\"up-change-password-re\">{{\'userProfile.repeatNewPassword\' | translate}} <sup>*</sup></label> <input required=\"required\" data-ng-pattern=\"/^((?!(_){6,32})[\\w]{6,32})$/\" type=\"password\" class=\"form-control\" id=\"up-change-password-re\" data-match-validator=\"newPassword\" name=\"repeatPassword\" data-ng-model=\"c.data.repeatPassword\"> <label for=\"up-change-password-re\" class=\"sr-only\"></label><p data-ng-show=\"changePassword.$submitted && (changePassword.repeatPassword.$error.required || changePassword.repeatPassword.$error.match)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"changePassword.repeatPassword.$error.required\" data-translate=\"general.requiredField\"></span> <span data-ng-show=\"changePassword.repeatPassword.$error.match\" data-translate=\"general.doesNotMatch\"></span></p></div></div><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.changePassword()\" data-ng-disabled=\"!changePassword.$dirty || (changePassword.$submitted && changePassword.$invalid)\">Сохранить</button></form><div class=\"col-sm-6\"><h4 class=\"mt-0 mb-1 font-bold\" translate=\"doctorProfile.profileVisibility\"></h4><span class=\"switch\" translate=\"doctorProfile.hide\" data-ng-class=\"{\'switch-on\': c.hidden, \'switch-disabled\': c.status === 0}\" data-ng-click=\"c.hideProfile()\"></span><p translate=\"doctorProfile.hidden\"></p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/confirmStartModal/algorithm.startAlgorithmConfirm.modal.template.html","<div class=\"modal\" tabindex=\"-1\" id=\"startAlgorithmConfirmModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-ng-click=\"c.close()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"algorithms.unauthAlgorithmStartConfirm.title\"></h4></div><div class=\"modal-body\"><p class=\"p-r-1_sm-up mb-0\" data-dynamic-content=\"c.message\"></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" data-ng-click=\"c.ok()\" data-translate=\"general.ok\"></button></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/navigation/controls.template.html","<div class=\"algorithms-controls\"><br><div class=\"left-controls\"><a class=\"btn btn-secondary\" data-ng-if=\"!!api.back\" data-ng-click=\"api.moveBackwards()\" data-ng-class=\"api.button_clicked() ? \'disabled\' : \'\'\"><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><span data-translate=\"algorithms.back\"></span></a> <a class=\"btn btn-primary\" style=\"color:#fff\" data-ng-if=\"!!api.continue\" data-ng-click=\"api.moveForward()\" data-ng-class=\"api.button_clicked() ? \'disabled\' : \'\'\"><b data-translate=\"algorithms.continue\"></b><svg class=\"icon chevron-right\"><use xlink:href=\"#chevron-right\"></use></svg></a></div><div class=\"right-controls\"><a class=\"btn btn-secondary\" data-ng-if=\"api.logged\" data-ng-click=\"api.saveAlgorithm()\" data-ng-class=\"api.button_clicked() ? \'disabled\' : \'\'\"><svg class=\"icon floppy-o\"><use xlink:href=\"#floppy-o\"></use></svg><span data-translate=\"algorithms.save\"></span></a> <a class=\"btn btn-secondary\" data-ng-if=\"!!api.back\" data-ng-click=\"(api.button_clicked() && !api.restart_close_active()) || confirmDeletingHistory(true)\" data-ng-disabled=\"api.button_clicked() && !api.restart_close_active()\"><svg class=\"icon rotate-left\"><use xlink:href=\"#rotate-left\"></use></svg><span data-translate=\"algorithms.restart\"></span></a> <a class=\"btn btn-secondary\" data-ng-click=\"(api.button_clicked() && !api.restart_close_active()) || confirmDeletingHistory(false)\" data-ng-disabled=\"api.button_clicked() && !api.restart_close_active()\"><svg class=\"icon remove\"><use xlink:href=\"#close\"></use></svg><span data-translate=\"algorithms.finish\"></span></a></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/navigation/step.header.template.html","<div class=\"block-controls\"><h1 class=\"block-controls-name\">{{title}}</h1><div class=\"block-controls-icon\"><a data-ng-if=\"!!api.logged\" class=\"btn btn-primary-circle\" data-ng-click=\"api.button_clicked() || api.saveAlgorithm()\" data-ng-disabled=\"api.button_clicked()\" style=\"color:#fff\"><svg class=\"icon floppy-o\"><use xlink:href=\"#floppy-o\"></use></svg></a> <a data-ng-if=\"!!api.back\" class=\"btn btn-primary-circle\" data-ng-click=\"(api.button_clicked() && !api.restart_close_active()) || confirmDeletingHistory(true)\" data-ng-disabled=\"api.button_clicked() && !api.restart_close_active()\" style=\"color:#fff\"><svg class=\"icon rotate-left\"><use xlink:href=\"#rotate-left\"></use></svg></a> <a class=\"btn btn-primary-circle\" data-ng-click=\"(api.button_clicked() && !api.restart_close_active()) || confirmDeletingHistory(false)\" data-ng-disabled=\"api.button_clicked() && !api.restart_close_active()\" style=\"color:#fff\"><svg class=\"icon remove\"><use xlink:href=\"#close\"></use></svg></a></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/step/step.template.html","<div class=\"default-block-content\"><step-header data-api=\"c.api\" data-title=\"c.step.name\" data-algorithm=\"c.algorithmDetail.name\"></step-header><div class=\"row\"><div class=\"col-sm-9\"><div class=\"block-content\"><p data-dynamic-content=\"c.step.description\"></p><step-recommendation data-ng-if=\"c.step && c.step.recommendations && c.step.recommendations.length > 0\" data-recommendations=\"c.step.recommendations\" data-selected-recommendations=\"c.selectedRecommendations\"></step-recommendation><recommendation-history data-ng-if=\"c.step.showPlan && !!c.allSelectedRecommendations && c.allSelectedRecommendations.length > 0\" data-selected-recommendations=\"c.allSelectedRecommendations\" data-useralgorithm=\"c.algorithmDetail.userAlgorithm\" data-step=\"c.step\"></recommendation-history><substep-list data-ng-if=\"c.step.substeps && c.step.substeps.length>1\" data-substeps=\"c.step.substeps\" data-api=\"c.api\"></substep-list><step-article data-ng-if=\"c.step && c.step.articles && c.step.articles.length>0\" data-articles=\"c.step.articles\"></step-article><algorithm-controls data-api=\"c.api\" data-algorithm=\"c.algorithmDetail.name\"></algorithm-controls><br><br></div></div><div class=\"col-sm-3\"><div class=\"block-content\"><div class=\"block-banner banner-block_200\"><adsense data-block-type=\"block200\" inline-style=\"display:inline-block;width:200px;height:200px\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/groups/detail/groups.detail.template.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><div class=\"block-content\" data-ui-view=\"sideMenu\"><categories-left-side-list data-paging-total=\"c.groups.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"groupUuid\" data-nested-state-name=\"index.algorithms.group\">{{category.name}}</categories-left-side-list></div><div class=\"block-banner\"><div class=\"block-banner banner-block_200\"><adsense data-block-type=\"block200\" inline-style=\"display:inline-block;width:200px;height:200px\"></adsense></div></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><div data-ui-view=\"subContent\" class=\"block-content\"><div class=\"block-controls\"><h1 class=\"block-controls-name\">{{c.group.name}}</h1></div><div class=\"block-content\"><p data-ng-bind-html=\"c.group.description\"></p><categories-content-list data-categories=\"c.algorithms\" data-param-name=\"algorithmUuid\" data-nested-state-name=\"index.algorithms.group.algorithm\">{{category.name}}</categories-content-list></div></div></div></div></div>");
$templateCache.put("app/components/content/common/categories/footer/footer.html","<div><div data-ng-transclude=\"\" class=\"block-footer-controls\"></div></div>");
$templateCache.put("app/components/content/common/categories/header/header.html","<div class=\"block-controls\"><h1 class=\"block-controls-name\" data-ng-show=\"contentName\" data-ng-transclude=\"title\">{{contentName}}</h1><h1 class=\"block-controls-name\" data-ng-show=\"!contentName\">Cat</h1><div data-ng-transclude=\"\" class=\"block-controls-icon\"></div></div>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/article/article.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-left-side-list></div><div class=\"block-banner banner-block_200\"><adsense data-block-type=\"block200\" inline-style=\"inline-block;width:200px;height:200px;\"></adsense></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-ng-if=\"c.returnedContent.childs.length === 0\" data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content | trust\"></p><categories-content-list data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-column-number=\"1\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes | trust\" class=\"article-notes\"></div></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><categories-footer data-ng-if=\"c.returnedContent.childs.length === 0\"><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></categories-footer></div></div></div>");
$templateCache.put("app/components/content/contentCategories/pregnancyCalendar/calendar/calendar.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-categories=\"c.rootCategories\" data-param-name=\"articleUUID\" data-pregnancy-calendar=\"true\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header content-name=\"c.content.name\"></categories-header><div class=\"block-content\"><p data-ng-bind-html=\"c.content.content\"></p><div class=\"pregnancy-сalendar\" calendar-links=\"pregnancy-сalendar-links\"><div class=\"level-group-one big\"><svg class=\"icon week05-revert\"><use xlink:href=\"#week05-revert\"></use></svg></div><div class=\"level-group-one small\"><svg class=\"icon week08-revert\"><use xlink:href=\"#week08-revert\"></use></svg></div><div class=\"level-group-two big\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg></div><div class=\"level-group-two small\"><svg class=\"icon week10-revert\"><use xlink:href=\"#week10-revert\"></use></svg></div><div class=\"level-group-two small-two\"><svg class=\"icon week12-revert\"><use xlink:href=\"#week12-revert\"></use></svg></div><div class=\"level-group-three small\"><svg class=\"icon week13-revert\"><use xlink:href=\"#week13-revert\"></use></svg></div><div class=\"level-group-three big\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg></div><a class=\"pregnancy-сalendar-week week-1 level-one\"><svg class=\"icon week01\"><use xlink:href=\"#week01\"></use></svg><div class=\"week-name\">1-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-2 level-one\"><svg class=\"icon week02\"><use xlink:href=\"#week02\"></use></svg><div class=\"week-name\">2-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-3 level-one\"><svg class=\"icon week03\"><use xlink:href=\"#week03\"></use></svg><div class=\"week-name\">3-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-4 level-one\"><svg class=\"icon week04\"><use xlink:href=\"#week04\"></use></svg><div class=\"week-name\">4-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-5 level-one\"><svg class=\"icon week05\"><use xlink:href=\"#week05\"></use></svg><div class=\"week-name\">5-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-6 level-one\"><svg class=\"icon week06\"><use xlink:href=\"#week06\"></use></svg><div class=\"week-name\">6-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-7 level-one\"><svg class=\"icon week07\"><use xlink:href=\"#week07\"></use></svg><div class=\"week-name\">7-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-8 level-one\"><svg class=\"icon week08\"><use xlink:href=\"#week08\"></use></svg><div class=\"week-name\">8-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-9 level-one\"><svg class=\"icon week08\"><use xlink:href=\"#week08\"></use></svg><div class=\"week-name\">9-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-10 level-one\"><svg class=\"icon week09\"><use xlink:href=\"#week09\"></use></svg><div class=\"week-name\">10-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-11 level-one\"><svg class=\"icon week09\"><use xlink:href=\"#week09\"></use></svg><div class=\"week-name\">11-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-12 level-one\"><svg class=\"icon week09\"><use xlink:href=\"#week09\"></use></svg><div class=\"week-name\">12-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-13 level-one\"><svg class=\"icon week09\"><use xlink:href=\"#week09\"></use></svg><div class=\"week-name\">13-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-14 level-two\"><svg class=\"icon week10\"><use xlink:href=\"#week10\"></use></svg><div class=\"week-name\">14-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-15 level-two\"><svg class=\"icon week10\"><use xlink:href=\"#week10\"></use></svg><div class=\"week-name\">15-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-16 level-two\"><svg class=\"icon week10\"><use xlink:href=\"#week10\"></use></svg><div class=\"week-name\">16-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-17 level-two\"><svg class=\"icon week10\"><use xlink:href=\"#week10\"></use></svg><div class=\"week-name\">17-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-18 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">18-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-19 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">19-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-20 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">20-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-21 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">21-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-22 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">22-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-23 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">23-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-24 level-two\"><svg class=\"icon week11\"><use xlink:href=\"#week11\"></use></svg><div class=\"week-name\">24-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-25 level-two\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">25-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-26 level-two\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">26-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-27 level-two\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">27-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-28 level-three\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">28-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-29 level-three\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">29-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-30 level-three\"><svg class=\"icon week12\"><use xlink:href=\"#week12\"></use></svg><div class=\"week-name\">30-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-31 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">31-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-32 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">32-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-33 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">33-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-34 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">34-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-35 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">35-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-36 level-three\"><svg class=\"icon week13\"><use xlink:href=\"#week13\"></use></svg><div class=\"week-name\">36-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-37 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">37-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-38 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">38-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-39 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">39-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-40 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">40-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-41 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">41-я<br>неделя</div></a> <a class=\"pregnancy-сalendar-week week-42 level-three\"><svg class=\"icon week14\"><use xlink:href=\"#week14\"></use></svg><div class=\"week-name\">42-я<br>неделя</div></a></div></div></div></div></div>");
$templateCache.put("app/components/content/contentCategories/pregnancyCalendar/trimesters/trimesters.html","<div class=\"row\"><div class=\"col-sm-3\"><trimesters-list data-week-number=\"c.weekNumber\"></trimesters-list></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.categoryTitle(c.weekNumber)\"><share-buttons data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content\"></p><categories-content-list data-categories=\"c.categories\" data-param-name=\"timesterArticleUUID\" data-column-number=\"1\" data-nested-state-name=\"index.contentCategories.contentSubcategories.calendar.trimesters.article\">{{category.name}}</categories-content-list><hr data-ng-show=\"c.additionalCategories.length > 0\"><h4 data-translate=\"pregnancy.similarArticles\"></h4><categories-content-list data-alphabet-sort=\"true\" data-not-more=\"true\" data-categories=\"c.similarCategories\" data-param-name=\"timesterArticleUUID\" data-column-number=\"1\" data-nested-state-name=\"index.contentCategories.contentSubcategories.calendar.trimesters.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes\" class=\"article-notes\"></div></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><div class=\"block-footer\"><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></div></div></div></div>");
$templateCache.put("app/components/content/contentCategories/pregnancyCalendar/trimestersList/trimestersList.template.html","<div class=\"panel-group block-accordion\" id=\"pregnancy-calendar-trimester\" aria-multiselectable=\"true\" data-ng-model=\"activePanel\" data-bs-collapse=\"\"><div class=\"default-block panel panel-block-accordion\" data-ng-repeat=\"value in trimesters track by $index\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a aria-expanded=\"true\" data-bs-collapse-toggle=\"\" data-ng-class=\"activePanel === $index ? \'\' : \'collapsed\'\"><div class=\"panel-title-name\">{{formatTrimesterName($index + 1)}}</div><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></a></h4></div><div class=\"panel-collapse collapse in\" data-bs-collapse-target=\"\"><div class=\"panel-body\"><ul class=\"block-accordion-list\"><li data-ng-repeat=\"week in value\" data-ui-sref-active=\"active\"><a data-ui-sref=\"index.contentCategories.contentSubcategories.calendar.trimesters({ weekNumber: week.uuid })\"><svg data-ng-attr-class=\"{{\'icon \' + trimesterIconClassName(week) }}\"><use data-ng-href=\"{{\'#\' + trimesterIconClassName(week)}}\" xlink:href=\"\"></use></svg><span class=\"text\">{{ formatWeekName(week) }}</span></a></li></ul></div></div></div></div>");
$templateCache.put("app/components/content/food/productsCategories/products/products.html","<div class=\"default-block\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><a data-ng-class=\"c.toggleSupplement === 0 ? \'collapsed\' : \'\' || c.toggleSupplement === false ? \'collapsed\' : \'\'\"><div class=\"panel-title-name\">{{c.productCategoryName}}</div><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></a></h4></div><div class=\"panel-body\" data-bs-collapse-target=\"\" data-ng-class=\"c.toggleSupplement == false ? \'in\' : \'\'\"><products-categories-left-side-list data-categories=\"c.categories\" data-list-class=\"block-accordion-list\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.productsCategories.products\" param-name=\"productCategoryUUID\"><label>{{category.index}}</label> {{category.name}}</products-categories-left-side-list></div></div>");
$templateCache.put("app/components/content/food/supplements/details/details.html","<div class=\"default-block-content\"><categories-header data-content-name=\"c.content.name\"></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-bind-html=\"c.content.description\"></p><categories-left-side-list data-paging-total=\"c.allCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"supplementUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement\"><label>{{category.index}}</label> {{category.name}}</categories-left-side-list></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/content/medicine/medicineCategories/article/article.html","<div class=\"row\"><div class=\"col-sm-3\"><div class=\"default-block\"><medicine-search></medicine-search></div><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.customPaging.loadedAllCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.medicine.medicineCategories.article\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.content.name\"><share-buttons data-article=\"c.content\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><hr><h5 data-translate=\"medicine.indicators\"></h5><p data-ng-bind-html=\"c.content.indicators\"></p><hr><h5 data-translate=\"medicine.modeApplication\"></h5><p data-ng-bind-html=\"c.content.modeApplication\"></p><hr><h5 data-translate=\"medicine.formRelease\"></h5><p data-ng-bind-html=\"c.content.formRelease\"></p><hr><h5 data-translate=\"medicine.storageConditions\"></h5><p data-ng-bind-html=\"c.content.storageConditions\"></p><hr><h5 data-translate=\"medicine.composition\"></h5><p data-ng-bind-html=\"c.content.composition\"></p><hr><h5 data-translate=\"medicine.additionally\"></h5><p data-ng-bind-html=\"c.content.additionally\"></p><hr><h5 data-translate=\"medicine.contraindications\"></h5><p data-ng-bind-html=\"c.content.contraindications\"></p><hr><h5 data-translate=\"medicine.pharmacologicalAction\"></h5><p data-ng-bind-html=\"c.content.pharmacologicalAction\"></p><hr><h5 data-translate=\"medicine.sideEffects\"></h5><p data-ng-bind-html=\"c.content.sideEffects\"></p><hr><h5 data-translate=\"medicine.pregancyAffection\"></h5><p data-ng-bind-html=\"c.content.pregnancy\"></p><hr><h5 data-translate=\"medicine.interaction\"></h5><p data-ng-bind-html=\"c.content.interaction\"></p><hr><h5 data-translate=\"medicine.overdose\"></h5><p data-ng-bind-html=\"c.content.overdose\"></p><hr><h5 data-translate=\"medicine.attention\"></h5><p data-ng-bind-html=\"c.content.attention\"></p><hr><h5 data-translate=\"medicine.synonyms\"></h5><p data-ng-bind-html=\"c.content.synonyms\"></p><hr></div><h5 data-translate=\"medicine.similar\"></h5><categories-content-list data-categories=\"c.similar\" data-param-name=\"articleUUID\" data-parent-param-name=\"categoryUUID\" data-column-number=\"1\" data-nested-state-name=\"index.medicine.medicineCategories.article\">{{category.name}}</categories-content-list></div></div></div>");
$templateCache.put("app/components/content/upgrowth/categories/article/article.html","<div class=\"row\"><div class=\"col-sm-3 hidden-xs\"><div class=\"default-block\"><div class=\"block-content\"><categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.upgrowth.categories.article\">{{category.name}}</categories-left-side-list></div></div></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content\"></p><categories-content-list data-alphabet-sort=\"false\" data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.upgrowth.categories.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes\" class=\"article-notes\"></div></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><categories-footer><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></categories-footer></div></div></div>");
$templateCache.put("app/components/core/directives/avatarDirective/avatarModal/avatar.dropdown.html","<ul class=\"dropdown-menu\" style=\"opacity: 0\"><li><a href=\"#\" data-translate=\"userProfile.photoDropdown.edit\" data-ng-click=\"editAvatar()\"></a></li><li><a href=\"#\" data-translate=\"userProfile.photoDropdown.delete\" data-ng-click=\"removeAvatar()\"></a></li></ul>");
$templateCache.put("app/components/core/directives/avatarDirective/avatarModal/avatar.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"changeMyChildren\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"c.close()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"userProfile.editAvatar\"></h4></div><div class=\"modal-body\"><div class=\"cropper-image-height\"><img data-ng-src=\"{{c.avatarService.dataUrl}}\" width=\"300\" data-ng-cropper=\"\" data-ng-cropper-show=\"c.avatarService.showEvent\" data-ng-cropper-hide=\"c.avatarService.hideEvent\" data-ng-cropper-options=\"c.avatarService.options\" alt=\"Avatar\"></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.save()\"><span data-translate=\"general.save\"></span> <i class=\"fa fa-spinner fa-spin\" data-ng-show=\"c.isSaving\"></i></button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"c.close()\" data-translate=\"general.cancel\"></button></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/article/step.article.template.html","<div class=\"block-content\" id=\"articles\"><div class=\"panel-group\" data-bs-collapse=\"\" data-allow-multiple=\"true\" data-start-collapsed=\"true\" aria-multiselectable=\"true\"><div class=\"panel panel-information\" data-ng-repeat=\"article in articles\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><a data-ng-class=\"article.collapsed ? \'\' : \'collapsed\'\" data-ng-click=\"collapseArticle(article)\"><svg class=\"icon info-circle\"><use xlink:href=\"#info-circle\"></use></svg><b>{{article.name}}</b> <span class=\"panel-chevron\"><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></span></a></h4></div><div data-bs-collapse-target=\"\"><div class=\"panel-body\"><p data-ng-bind-html=\"article.description\"></p></div></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/recommendation/step.recommendation.template.html","<div class=\"block-content\" id=\"recommendations\"><div class=\"panel-group\" data-bs-collapse=\"\" data-start-collapsed=\"true\" data-allow-multiple=\"true\" aria-multiselectable=\"true\" data-ng-show=\"unneccessaryRecommendations.length>0\"><h5 class=\"text-uppercase\" data-translate=\"algorithms.unrequiredRecommendations\"></h5><div class=\"panel panel-information\" data-ng-repeat=\"recommendation in unneccessaryRecommendations\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><span class=\"panel-controls checkbox custom\"><input type=\"checkbox\" class=\"sr-only\" id=\"{{unRecId + recommendation.uuid}}\" value=\"{{recommendation.uuid}}\" data-name=\"{{recommendation.name}}\" aria-label=\"...\" data-ng-checked=\"recommendation.checked\"> <label for=\"{{unRecId + recommendation.uuid}}\"><svg class=\"icon check\"><use xlink:href=\"#check\"></use></svg></label></span> <a data-ng-class=\"recommendation.collapsed ? \'\' : \'collapsed\'\" data-ng-click=\"collapseRecommendation(recommendation)\">{{recommendation.name}} <span class=\"panel-chevron\"><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></span></a></h4></div><div data-bs-collapse-target=\"\"><div class=\"panel-body\"><blockquote class=\"blockquote-danger\"><p data-ng-bind-html=\"recommendation.description\"></p></blockquote></div></div></div></div><div class=\"panel-group\" data-bs-collapse=\"\" data-start-collapsed=\"true\" data-allow-multiple=\"true\" aria-multiselectable=\"true\" data-ng-show=\"requiredRecommendations.length>0\"><h5 class=\"text-uppercase\" data-translate=\"algorithms.requiredRecommendations\"></h5><div class=\"panel panel-information\" data-ng-repeat=\"recommendation in requiredRecommendations\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><span class=\"panel-controls checkbox custom\"><input type=\"checkbox\" checked=\"\" disabled=\"\" class=\"sr-only\" id=\"{{recId + recommendation.uuid}}\" value=\"{{recommendation.uuid}}\" data-name=\"{{recommendation.name}}\"> <label for=\"{{recId + recommendation.uuid}}\"><svg class=\"icon check\"><use xlink:href=\"#check\"></use></svg></label></span> <a data-bs-collapse-toggle=\"\" data-ng-class=\"recommendation.collapsed ? \'\' : \'collapsed\'\" data-ng-click=\"collapseRecommendation(recommendation)\">{{recommendation.name}} <span class=\"panel-chevron\"><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></span></a></h4></div><div data-bs-collapse-target=\"\"><div class=\"panel-body\"><blockquote class=\"blockquote-danger\"><p data-ng-bind-html=\"recommendation.description\"></p></blockquote></div></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/recommendationHistory/step.recommendationHistory.template.html","<div class=\"panel-group\" id=\"recommendationHistory\"><div><div><div class=\"panel panel-information\" data-ng-repeat=\"recommendation in selectedRecommendations\"><selected-recommendation data-recommendation=\"recommendation\"></selected-recommendation></div></div></div><br><div class=\"left-controls\"><a class=\"btn btn-primary\" style=\"color:#fff\" data-ng-click=\"printRecommendations()\"><svg class=\"icon print\"><use xlink:href=\"#print\"></use></svg><span data-translate=\"algorithms.print\"></span></a> <a class=\"btn btn-primary\" style=\"color:#fff\" data-ng-click=\"openEmailModal()\" data-ng-class=\"api.email_sent() ? \'disabled\' : \'\'\"><svg class=\"icon envelope\"><use xlink:href=\"#envelope\"></use></svg><span data-translate=\"algorithms.mail\"></span></a></div><br></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/recommendationHistory/step.selectedRecommendation.template.html","<div><div class=\"panel-heading\" aria-multiselectable=\"true\"><h4 class=\"panel-title\"><span class=\"panel-controls checkbox custom\"><input type=\"checkbox\" checked=\"\" disabled=\"\" class=\"sr-only\" id=\"blankCheckboxOne\"> <label for=\"blankCheckboxOne\"><svg class=\"icon check\"><use xlink:href=\"#check\"></use></svg></label></span> <a data-ng-class=\"recommendation.collapsed ? \'\':\'collapsed\'\" data-ng-click=\"collapseRecommendation(recommendation)\">{{recommendation.name}} <span class=\"panel-chevron\"><svg class=\"icon chevron-left\"><use xlink:href=\"#chevron-left\"></use></svg><svg class=\"icon chevron-down\"><use xlink:href=\"#chevron-down\"></use></svg></span></a></h4></div><div data-ng-class=\"recommendation.collapsed ? \'collapse am-collapse in\' : \'collapse am-collapse\'\"><div class=\"panel-body\"><blockquote class=\"blockquote-danger\"><p data-ng-bind-html=\"recommendation.description\"></p></blockquote></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/substeps/substepList.template.html","<ul class=\"answer-list\"><li data-ng-repeat=\"step in substeps\"><button class=\"btn answer-btn\" data-ng-click=\"api.moveToSubstep(step.uuid)\" data-ng-class=\"api.button_clicked() ? \'disabled\' : \'\'\"><span>{{alphabetValue($index)}} .</span>{{step.name}}</button></li></ul>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/article/details/article-content.html","<p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content | trust\"></p><categories-content-list data-categories=\"c.categories\" data-param-name=\"articleUUID\" data-column-number=\"1\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes | trust\" class=\"article-notes\"></div></div>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/article/details/article-footer.html","<categories-footer data-ng-if=\"c.returnedContent.childs.length === 0\"><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></categories-footer>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/article/details/article-head.html","<categories-header data-content-name=\"c.titleName\"><share-buttons data-ng-if=\"c.returnedContent.childs.length === 0\" data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header>");
$templateCache.put("app/components/content/contentCategories/contentSubcategories/article/details/article-list.html","<categories-left-side-list data-paging-total=\"c.parentCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"articleUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.article\">{{category.name}}</categories-left-side-list>");
$templateCache.put("app/components/content/contentCategories/pregnancyCalendar/trimesters/article/article.html","<div class=\"row\"><div class=\"col-sm-3\"><trimesters-list data-week-number=\"c.weekNumber\"></trimesters-list></div><div class=\"col-sm-9\"><div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"><share-buttons data-ng-if=\"c.returnedContent.childs.length === 0\" data-article=\"c.returnedContent\" data-type=\"c.favoriteType\"></share-buttons></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><p data-ng-show=\"c.content\" data-ng-bind-html=\"c.content\"></p><br><categories-content-list data-alphabet-sort=\"false\" data-categories=\"c.categories\" data-param-name=\"timesterArticleUUID\" data-column-number=\"1\" data-pregnancy-calendar=\"true\" data-nested-state-name=\"index.contentCategories.contentSubcategories.calendar.trimesters.article\">{{category.name}}</categories-content-list><div data-ng-show=\"c.notes\" class=\"text-muted\"><div data-ng-bind-html=\"c.notes\" class=\"article-notes\"></div></div></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div><categories-footer data-ng-if=\"c.returnedContent.childs.length === 0\"><share-buttons data-article=\"c.returnedContent\" data-show-place=\"footer\" data-type=\"c.favoriteType\"></share-buttons></categories-footer></div></div></div>");
$templateCache.put("app/components/content/food/productsCategories/products/articles/articleCategories.html","<div class=\"default-block\"><div class=\"panel-heading\" data-bs-collapse-toggle=\"\"><h4 class=\"panel-title\"><a><div class=\"panel-title-name\">{{c.categoryName}}</div></a></h4></div><div class=\"panel-body\"><products-list data-list-class=\"block-accordion-list\" data-paging-total=\"c.allCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"productCategoryUUID\" data-hide-image=\"true\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.productsCategories.products\"><label>{{category.index}}</label>{{category.name}}</products-list></div></div>");
$templateCache.put("app/components/content/food/productsCategories/products/articles/articleContent.html","<div class=\"default-block-content\"><div class=\"row\"><div class=\"col-sm-3\"><figure class=\"default-photo-block\"><img data-ng-if=\"c.content.image\" class=\"img-cover\" data-ng-src=\"{{\'api/v1/files/\' + c.content.image + \'?ratio=200\'}}\" alt=\"{{\'seo.alt.photo\' | translate}}\"> <img data-ng-if=\"!c.content.image\" class=\"img-responsive\" src=\"../assets/images/no-photo.png\" alt=\"{{\'seo.alt.nophoto\' | translate}}\"></figure></div><div class=\"col-sm-9\"><div class=\"block-controls\"><categories-header data-content-name=\"c.content.name\"><share-buttons data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-header><p><b data-translate=\"food.products.tradeMark\"></b>: <span data-ng-bind-html=\"c.content.tradeMark.name || (\'food.noOtherNames\' | translate)\"></span></p><p><b data-translate=\"food.products.country\"></b>: <span data-ng-bind-html=\"c.content.country.name || (\'food.noOtherNames\' | translate)\"></span></p><hr><h4><svg class=\"icon heartbeat\"><use xlink:href=\"#heartbeat\"></use></svg><span data-translate=\"food.products.nutritionFact\"></span></h4><p><b data-translate=\"food.products.protein\"></b>: <span data-ng-if=\"c.content.nutritionFact.protein\">{{ c.content.nutritionFact.protein + (\'food.products.gram\' | translate) }}</span> <span data-ng-if=\"!c.content.nutritionFact.protein\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span><br><b data-translate=\"food.products.fats\"></b>: <span data-ng-if=\"c.content.nutritionFact.fats\">{{ c.content.nutritionFact.fats + (\'food.products.gram\' | translate) }}</span> <span data-ng-if=\"!c.content.nutritionFact.fats\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span><br><b data-translate=\"food.products.carbohydrate\"></b>: <span data-ng-if=\"c.content.nutritionFact.carbohydrate\">{{ c.content.nutritionFact.carbohydrate + (\'food.products.gram\' | translate) }}</span> <span data-ng-if=\"!c.content.nutritionFact.carbohydrate\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span><br><b data-translate=\"food.products.calories\"></b>: <span data-ng-if=\"c.content.nutritionFact.calories\">{{ c.content.nutritionFact.calories + (\'food.products.caloriesMeasurement\' | translate) }}</span> <span data-ng-if=\"!c.content.nutritionFact.calories\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span></p><hr><h4><svg class=\"icon info-circle\"><use xlink:href=\"#info-circle\"></use></svg><span data-translate=\"food.products.composition\"></span></h4><p><span data-ng-bind-html=\"c.content.composition | trust\"></span> <span data-ng-if=\"!c.content.composition\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span></p><hr><h4><svg class=\"icon exclamation-triangle\"><use xlink:href=\"#exclamation-triangle\"></use></svg><span data-translate=\"food.products.supplements\"></span></h4><div data-ng-repeat=\"value in c.content.supplements\"><br><p><a data-ui-sref=\"index.contentCategories.contentSubcategories.food.supplementsCategories.supplements.supplement({supplementUUID: value.uuid, supplementCategoryUUID: value.parent.uuid })\"><b data-ng-bind-html=\"value.name | trust\"></b></a></p><p data-ng-bind-html=\"value.negatives | trust\"></p></div><p data-ng-if=\"!!!c.content.supplements || c.content.supplements.length == 0\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></p><hr><h4><svg class=\"icon calendar2\"><use xlink:href=\"#calendar2\"></use></svg><span data-translate=\"food.products.storeCondition\"></span></h4><p><span data-ng-bind-html=\"c.content.storeCondition | trust\"></span> <span data-ng-if=\"!c.content.storeCondition\" data-ng-bind-html=\"(\'food.noOtherNames\' | translate)\"></span></p></div></div></div><categories-footer><share-buttons data-show-place=\"footer\" data-type=\"c.favoriteType\" data-article=\"c.content\"></share-buttons></categories-footer></div>");
$templateCache.put("app/components/content/food/productsCategories/products/details/details.html","<div class=\"default-block-content\"><categories-header data-content-name=\"c.titleName\"></categories-header><div class=\"block-content\"><div class=\"row\"><div class=\"col-sm-9\"><products-list data-paging-total=\"c.allCategories.length\" data-use-paging=\"true\" data-paging-parameters=\"c.pagingParameters\" data-load-more=\"c.customPaging.loadMore\" data-categories=\"c.customPaging.visibleData\" data-param-name=\"productCategoryUUID\" data-nested-state-name=\"index.contentCategories.contentSubcategories.food.productsCategories.products\" data-selected-category=\"c.titleName\" data-hide-image=\"true\"><label>{{category.index}}</label>{{category.name}}</products-list></div><div class=\"col-sm-3\"><div class=\"block-banner banner-block_160\"><adsense data-block-type=\"vertical\" inline-style=\"inline-block;width:160px;height:600px;\"></adsense></div></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/recommendationHistory/confirmModal/algorithm.restartCloseConfirm.modal.template.html","<div class=\"modal\" tabindex=\"-1\" id=\"restartCloseConfirmModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-ng-click=\"c.close()\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"medicine.attention\"></h4></div><div class=\"modal-body\"><p class=\"p-r-1_sm-up\" data-ng-if=\"!!!api.last_step\" data-translate=\"algorithms.deleteConfirm\"></p><span data-ng-if=\"!!api.last_step\" data-translate=\"algorithms.deleteConfirmLastStep\" data-translate-values=\"{algorithm: algorithm}\"></span></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" data-ng-click=\"c.ok()\" data-translate=\"general.ok\"></button> <button type=\"button\" class=\"btn btn-info\" data-dismiss=\"modal\" data-ng-click=\"c.close()\" data-translate=\"general.cancel\"></button></div></div></div></div>");
$templateCache.put("app/components/content/algorithms/algorithm/content/recommendationHistory/emailModal/step.recommendationHistoryEmail.modal.html","<div class=\"modal\" tabindex=\"-1\" id=\"algorithmsEmail\"><form name=\"algorithmEmailForm\" novalidate=\"\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-ng-click=\"$hide()\" aria-label=\"Close\"><svg class=\"icon close\"><use xlink:href=\"#close\"></use></svg></button><h4 class=\"modal-title\" data-translate=\"algorithms.emailModal\"></h4></div><div class=\"modal-body\" data-ng-if=\"!c.email_sent\"><div class=\"form-group\" data-ng-class=\"{\'has-required\': algorithmEmailForm.$submitted && (algorithmEmailForm.email.$error.email || c.emailNotFound || algorithmEmailForm.email.$error.required) }\"><input id=\"algorithm-email\" type=\"email\" class=\"form-control\" name=\"email\" required=\"required\" placeholder=\"E-mail\" data-ng-model=\"c.email\" data-validation-email=\"\"> <label for=\"algorithm-email\" class=\"sr-only\"></label><p data-ng-show=\"algorithmEmailForm.$submitted && (algorithmEmailForm.email.$error.email || algorithmEmailForm.email.$error.required)\" class=\"help-block\"><svg class=\"icon exclamation-circle\"><use xlink:href=\"#exclamation-circle\"></use></svg><span data-ng-show=\"algorithmEmailForm.$submitted && algorithmEmailForm.email.$error.email || c.wrongEmailFormat\" data-translate=\"general.incorrectEmail\"></span> <span data-ng-show=\"algorithmEmailForm.$submitted && algorithmEmailForm.email.$error.required\" data-translate=\"general.requiredField\"></span></p></div></div><div class=\"modal-body\" data-ng-if=\"c.email_sent\"><div class=\"alert alert-success\" role=\"alert\"><svg class=\"icon check-circle\"><use xlink:href=\"#check-circle\"></use></svg><span class=\"alert-text\" data-translate=\"general.successEmailSent\"></span></div></div><div class=\"modal-footer\" data-ng-if=\"!c.email_sent\"><button type=\"submit\" class=\"btn btn-default\" data-ng-click=\"c.sendUserEmail()\" data-ng-disabled=\"!!!c.email || c.email === \'\'\">Отправить</button> <button type=\"button\" class=\"btn btn-info\" data-ng-click=\"$hide()\">Отмена</button></div><div class=\"modal-footer\" data-ng-if=\"c.email_sent\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"$hide()\">OK</button></div></div></div></form></div>");}]);